import {DayOfWeek} from "@fluentui/react";
// ../../OnixWeb.Domain/Models/QueryCase.cs
export interface QueryCase {
    equals?: any;
    greaterThan?: any;
    lessThan?: any;
    greaterThanOrEqual?: any;
    lessThanOrEqual?: any;
    anyOf?: object[];
    startsWith?: any;
    notEquals?: any;
    truthy?: boolean;
    isNull?: boolean;
}

// ../../OnixWeb.Domain/Models/IBackupEventLogEntry.cs
export interface IBackupEventLogEntry extends ATenantOwned {
    id: number;
    computerId: number;
    computer: IBackupEventLogComputer;
    backupSet: string;
    backupScheduledTime: Date;
    backupStartTime: Date;
    note: string;
    backupEndTime: string;
    version: string;
    ref: string;
    releaseDate: Date;
    filesConsideredForBackup: string;
    filesBackedUpNow: string;
    couldNotBeCompleted: string;
}

// ../../OnixWeb.Domain/Models/Subject.cs
export interface Subject extends ATenantOwnedPantheonResource {
    id: number;
    shortName: string;
    longName: string;
    address: string;
    country: Country;
    countryId?: number;
    contactName: string;
    phone: string;
    mail: string;
    VATIDPrefix: string;
    VATID: string;
}

// ../../OnixWeb.Domain/Models/TeamViewerSession.cs
export interface TeamViewerSession extends ATenantOwned {
    id: string;
    userId: string;
    username: string;
    deviceId: string;
    deviceName: string;
    groupId: string;
    groupName: string;
    startDate: Date;
    endDate: Date;
    currency: string;
    billingState: string;
    contactId: string;
    duration: number;
    supportTicket: SupportTicket;
    supportTicketId?: number;
    supportTicketTimeLog: SupportTicketTimeLog;
    supportTicketTimeLogId?: number;
    notes: string;
    dismissed: boolean;
    applicationUserId: string;
    applicationUser: ApplicationUser;
}

// ../../OnixWeb.Domain/Models/ChangePasswordModel.cs
export interface ChangePasswordModel {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

// ../../OnixWeb.Domain/Models/EInvoiceQueueAuditEntry.cs
export interface EInvoiceQueueAuditEntry {
    id: string;
    dispatchId: string;
    createdAt: string;
    actorUserId?: string;
    leaseOwner?: string;
    fromState: EInvoiceQueueState;
    toState: EInvoiceQueueState;
    stage: EInvoiceStage;
    version: number;
    reasonCode?: string;
    operatorReason?: string;
    operatorDocumentKey?: string;
    operatorExternalId?: string;
}

// ../../OnixWeb.Domain/Models/SqlTemplate.cs
export interface SqlTemplate extends ATenantOwned {
    id: number;
    name: string;
    category: string;
    description: string;
    sqlText: string;
    isPinned: boolean;
}

// ../../OnixWeb.Domain/Models/SupportTicketTodo.cs
export interface SupportTicketTodo extends ATenantOwned {
    id: number;
    ticketId: number;
    ticket: SupportTicket;
    dateTime: Date;
    note: string;
    notified: boolean;
    user: ApplicationUser;
    userId: string;
}

// ../../OnixWeb.Domain/Models/THrSetTrvlStatus.cs
export interface THrSetTrvlStatus {
    acName: string;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    acChange: string;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/AresDeploymentGroupCompanyMapping.cs
export interface AresDeploymentGroupCompanyMapping extends ATenantOwned {
    id: number;
    aresDeploymentGroupId: number;
    aresDeploymentGroup: AresDeploymentGroup;
    companyId: number;
    company: Company;
    installationStepPoints: AresDeploymentInstallationStepPoint[];
    isAresActive?: boolean;
    lastAresActivityCheckAt?: Date;
    lastAresActivityCheckResult: string;
    deploymentEnvironment: AresDeploymentEnvironment;
}

// ../../OnixWeb.Domain/Models/HasCreatedOnAndModifiedOn.cs
export interface HasCreatedOnAndModifiedOn {
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Models/ApplicationUserWakaMachine.cs
export interface ApplicationUserWakaMachine extends ATenantOwned {
    id: number;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    machineId: string;
    displayName?: string;
    hostName?: string;
}

// ../../OnixWeb.Domain/Models/SupportAiRunEvent.cs
export interface SupportAiRunEvent extends HasAuditFields {
    id: number;
    runId: number;
    sequence: number;
    eventType: SupportAiRunEventTypeEnum;
    phase: SupportAiRunPhaseEnum;
    title: string;
    message: string;
    toolCallId?: number;
    payloadJson?: string;
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export interface DocumentDraft {
    id: string;
    companySettingsId?: number;
    applicationUserId: string;
    applicationUser?: ApplicationUser;
    documentTypeId: number;
    documentType?: DocumentType;
    kind: DocumentDraftKind;
    status: DocumentDraftStatus;
    origin: DocumentDraftOrigin;
    hiddenFromOtvoreno: boolean;
    submissionUid: string;
    sourceAcKey?: string;
    sourceRelation: DocumentRelationKind;
    documentPairId?: number;
    customerAcSubject?: string;
    thirdPartyAcSubject?: string;
    departmentAcSubject?: string;
    warehouseAcSubject?: string;
    paymentMethodCode?: string;
    documentDate?: Date;
    dueDate?: Date;
    dueDateManual: boolean;
    note?: string;
    contactName?: string;
    contactEmail?: string;
    contactEmailAuto: boolean;
    deliveryMethodCode?: string;
    deliveryDeadlineDays?: number;
    acDoc1?: string;
    adDateDoc1?: Date;
    acDoc2?: string;
    adDateDoc2?: Date;
    syncPackaging: boolean;
    expectedTotal?: number;
    issuedAcKey?: string;
    issuedAt?: Date;
    lastError?: string;
    lastErrorCode?: string;
    issuingStartedAt?: Date;
    createdAt: Date;
    updatedAt: Date;
    version: number;
    items: DocumentDraftItem[];
    fieldValues: DocumentDraftFieldValue[];
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export interface DocumentDraftItem {
    id: string;
    documentDraftId: string;
    documentDraft?: DocumentDraft;
    lineNo: number;
    acIdent: string;
    nameSnapshot?: string;
    unit?: string;
    unit2?: string;
    unitToUnit2?: number;
    quantity: number;
    packageQuantity?: number;
    price: number;
    priceIsGross: boolean;
    priceSource: DocumentDraftPriceSource;
    rebate1: number;
    rebate2: number;
    rebate3: number;
    note?: string;
    serials: DocumentDraftItemSerial[];
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export interface DocumentDraftItemSerial {
    id: string;
    documentDraftItemId: string;
    documentDraftItem?: DocumentDraftItem;
    serialNumber: string;
    quantity: number;
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export interface DocumentDraftFieldValue {
    id: string;
    documentDraftId: string;
    documentDraft?: DocumentDraft;
    arbitraryFieldId: number;
    fieldNameSnapshot?: string;
    textValue?: string;
    numberValue?: number;
    dateValue?: Date;
    boolValue?: boolean;
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export interface DocumentRelation {
    id: string;
    companySettingsId?: number;
    documentTypeId: number;
    documentType?: DocumentType;
    sourceAcKey: string;
    targetAcKey: string;
    relation: DocumentRelationKind;
    createdAt: Date;
    applicationUserId: string;
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export interface DocumentEmailDispatch {
    id: string;
    companySettingsId?: number;
    applicationUserId: string;
    documentTypeId: number;
    documentType?: DocumentType;
    acKey: string;
    to: string;
    cc?: string;
    subject: string;
    message?: string;
    copyToSender: boolean;
    pdfBytes?: number[];
    pdfSha256: string;
    pdfFileName?: string;
    status: DocumentEmailDispatchStatus;
    attempts: number;
    error?: string;
    createdAt: Date;
    sendingStartedAt?: Date;
    sentAt?: Date;
    version: number;
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export enum DocumentDraftKind {
    Move = 0,
    Order = 1,
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export enum DocumentDraftStatus {
    Open = 0,
    Issuing = 1,
    Issued = 2,
    NotIssued = 3,
    Discarded = 4,
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export enum DocumentDraftOrigin {
    Web = 0,
    OnixPhone = 1,
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export enum DocumentRelationKind {
    None = 0,
    Repeat = 1,
    Storno = 2,
    Modify = 3,
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export enum DocumentDraftPriceSource {
    Pantheon = 0,
    Contract = 1,
    Manual = 2,
}

// ../../OnixWeb.Domain/Models/DocumentDraft.cs
export enum DocumentEmailDispatchStatus {
    Queued = 0,
    Sending = 1,
    Sent = 2,
    Failed = 3,
    Uncertain = 4,
}

// ../../OnixWeb.Domain/Models/SupportAiRunCheckpoint.cs
export interface SupportAiRunCheckpoint extends ATenantOwned {
    id: number;
    threadId: number;
    runId: number;
    sequence: number;
    reason: SupportAiCheckpointReason;
    summary: string;
    evidenceSnapshotJson?: string;
    openHypothesesJson?: string;
    pendingQuestionsJson?: string;
    suggestedNextStepsJson?: string;
    sourceEventSequence?: number;
}

// ../../OnixWeb.Domain/Models/OnixClrInstallation.cs
export interface OnixClrInstallation extends ATenantOwned {
    id: number;
    server: string;
    database: string;
    instance: string;
    edition: string;
    version: string;
    machineUID: string;
    allowed?: boolean;
}

// ../../OnixWeb.Domain/Models/OnixPhoneFunctionalityActivity.cs
export interface OnixPhoneFunctionalityActivity extends ATenantOwned {
    id: number;
    occurredOnUtc: Date;
    occurredOnLocal: Date;
    periodYear: number;
    periodMonth: number;
    companySettingsNameSnapshot: string;
    companySettingsConnectionNameSnapshot: string;
    grunfCompanyId?: number;
    grunfCompanyNameSnapshot: string;
    grunfAccountingCompanyId?: number;
    grunfAccountingCompanyNameSnapshot: string;
    userId: string;
    user: ApplicationUser;
    userNameSnapshot: string;
    userDisplayNameSnapshot: string;
    userEmailSnapshot: string;
    pantheonAnUserId?: number;
    pantheonAcUserId: string;
    documentTypeId?: number;
    documentType: DocumentType;
    documentTypeCode: string;
    documentTypeName: string;
    functionality?: DocumentFunctionalityEnum;
    sourceTable: string;
    counterKey: string;
    action: OnixPhoneFunctionalityActivityActionEnum;
    quantity: number;
    relatedAcKey: string;
    relatedAnNo?: number;
    relatedAnQid?: number;
    relatedDocumentPrimaryKey: string;
    relatedRecordPrimaryKey: string;
    relatedDocumentTypeCode: string;
    sourceAcKey: string;
    sourceAnNo?: number;
    sourceDocumentPrimaryKey: string;
    documentPairId?: number;
    batchId?: string;
    clientSource: string;
    metadataJson: string;
}

// ../../OnixWeb.Domain/Models/MobileSettings.cs
export interface MobileSettings extends ATenantOwned {
    userId: string;
    user: ApplicationUser;
    bluetoothPrinterName: string;
    bluetoothPrinterType: string;
    bluetoothPrinterAddress: string;
    thermalPrinterPrintVerticalPDF417?: boolean;
    bluetoothPrinterPaperWidth?: number;
    useDarkTheme: boolean;
    useListViewOnPickers: boolean;
    useTabletMode?: boolean;
    useOnlyShortcuts: boolean;
    useDocumentTypeCodesInTitles?: boolean;
    bluetoothPrinterBoldMode?: boolean;
    bluetoothPrinterPrintSpeed?: number;
    bluetoothPrinterArbitrarySettings?: Record<string, string>;
    useWiderColumns?: boolean;
    featureFlag?: boolean;
    detailedLogging?: boolean;
    a4PrinterURL?: string;
    useFilteredOfflineCodebooks?: boolean;
    mobileMenuV3?: boolean;
    useKeyboardBarcodeScanner?: boolean;
    language?: string;
    userMobileMenuV4?: boolean;
}

// ../../OnixWeb.Domain/Models/OfficialVehicle.cs
export interface OfficialVehicle extends ATenantOwnedPantheonResource {
    id: number;
    registration: string;
    makeAndModel: string;
    isDeactivated: boolean;
}

// ../../OnixWeb.Domain/Models/SupportAbsence.cs
export interface SupportAbsence extends ATenantOwned {
    id: number;
    userId: string;
    user: ApplicationUser;
    dateFrom: Date;
    dateTo: Date;
    type: SupportAbsenceTypeEnum;
    title: string;
    note: string;
    isHalfDay: boolean;
    halfDayPeriod: SupportAbsenceHalfDayPeriodEnum;
    timeFrom?: number;
    timeTo?: number;
}

// ../../OnixWeb.Domain/Models/CompanyRunbookNote.cs
export interface CompanyRunbookNote extends ATenantOwned {
    id: number;
    companyId: number;
    company: Company;
    title: string;
    content: string;
    tags: string;
    uniqueClientId: string;
    attachments: SavedFile[];
}

// ../../OnixWeb.Domain/Models/OnixClrUsageCounter.cs
export interface OnixClrUsageCounter extends HasAuditFields {
    id: number;
    onixClrInstallationId: number;
    onixClrInstallation: OnixClrInstallation;
    periodYear: number;
    periodMonth: number;
    aresDeploymentGroupId: string;
    action: string;
    count: number;
    firstSeenUtc: Date;
    lastSeenUtc: Date;
}

// ../../OnixWeb.Domain/Models/SupportAiThreadQuestion.cs
export interface SupportAiThreadQuestion extends ATenantOwned {
    id: number;
    threadId: number;
    askedByRunId: number;
    status: SupportAiThreadQuestionStatus;
    question: string;
    whyNeeded: string;
    answer?: string;
    answeredByUserId?: string;
    answeredOn?: Date;
}

// ../../OnixWeb.Domain/Models/ItemGroup.cs
export interface ItemGroup extends ATenantOwned {
    id: number;
    name: string;
    itemGroupItems: ItemGroupItem[];
    itemGroupMaterials: MarservisItemGroupMaterial[];
}

// ../../OnixWeb.Domain/Models/ApplicationUserWakaProjectMap.cs
export interface ApplicationUserWakaProjectMap extends ATenantOwned {
    id: number;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    externalProjectName: string;
    internalProjectId?: number;
    internalProject?: Project;
    active: boolean;
}

// ../../OnixWeb.Domain/Models/CompanySettingsDatabaseHealth.cs
export interface CompanySettingsDatabaseHealth extends HasAuditFields {
    id: number;
    companySettingsId: number;
    companySettings: CompanySettings;
    consecutiveFailureCount: number;
    failureScore: number;
    firstFailureAt?: Date;
    lastFailureAt?: Date;
    lastSuccessAt?: Date;
    backoffUntil?: Date;
    lastFailureJob: string;
    lastFailureType: string;
    lastFailureMessage: string;
}

// ../../OnixWeb.Domain/Models/AresDeploymentOnixPhoneSettings.cs
export interface AresDeploymentOnixPhoneSettings extends ATenantOwned {
    id: number;
    aresDeploymentGroupId: number;
    aresDeploymentGroup: AresDeploymentGroup;
}

// ../../OnixWeb.Domain/Models/ContactCompany.cs
export interface ContactCompany extends ATenantOwned {
    id: number;
    contact: Contact;
    company: Company;
    companyId?: number;
    contactId?: number;
    isPrimary: boolean;
}

// ../../OnixWeb.Domain/Models/OxIOSPerSubject.cs
export interface OxIOSPerSubject {
    acSubject: string;
    acName2: string;
    acLinkDoc: string;
    acHrfiskalNumber: string;
    anDebit: number;
    anCredit: number;
    saldo: number;
    adDateInv: Date;
    adDateDue: Date;
    acCurrency: string;
}

// ../../OnixWeb.Domain/Models/RatesAPIV3Response.cs
export interface RatesAPIV3Response {
    brojTecajnice: string;
    datumPrimjene: string;
    drzava: string;
    drzavaIso: string;
    sifraValute: string;
    valuta: string;
    jedinica?: number;
    kupovniTecaj: string;
    srednjiTecaj: string;
    prodajniTecaj: string;
}

// ../../OnixWeb.Domain/Models/SupportTicketSearchDocument.cs
export interface SupportTicketSearchDocument extends ATenantOwned {
    id: number;
    supportTicketId: number;
    supportTicket: SupportTicket;
    titleText: string;
    problemText: string;
    searchText: string;
    sourceModifiedOn?: Date;
}

// ../../OnixWeb.Domain/Models/SendEmailRequestModel.cs
export interface SendEmailRequestModel {
    email: string;
    title: string;
    message: string;
    honeypot: string;
}

// ../../OnixWeb.Domain/Models/VOPSetItem.cs
export interface VOPSetItem {
    acIdent: string;
    acName: string;
    acClassif: string;
    anRtprice: number;
    anSaleprice: number;
    acdept: string;
    anVAT: number;
    acShowDays: string;
    anExcise: number;
    anExciseP: number;
    acCustTariff: string;
    anExcisePercent?: number;
    anExciseValue?: number;
    dutyAcSetOfTax: string;
    dutyName: string;
}

// ../../OnixWeb.Domain/Models/DocumentTypePair.cs
export interface DocumentTypePair extends DocumentTypeBase {
    from: DocumentType;
    fromId: number;
    to: DocumentType;
    toId: number;
    functionality: DocumentPairFunctionalityEnum;
    applicationUser: ApplicationUser;
    applicationUserId: string;
    filterByUserOnAcIssuer: boolean;
    filterByUserOnAcReceiver: boolean;
}

// ../../OnixWeb.Domain/Models/SupportTicketAction.cs
export interface SupportTicketAction extends ATenantOwned {
    id: number;
    ticketId: number;
    ticket: SupportTicket;
    kind: SupportTicketActionKind;
    workOutcome?: SupportWorkOutcome;
    summary: string;
    note?: string;
    createdByUserId: string;
    createdByUser: ApplicationUser;
    accountableUserId?: string;
    accountableUser?: ApplicationUser;
    supportGroupId?: number;
    supportGroup?: SupportGroup;
    dueOn?: Date;
    waitingFor?: string;
    waitingReason?: string;
    followUpOn?: Date;
    reviewerUserId?: string;
    reviewerUser?: ApplicationUser;
    requestedDecision?: string;
    relatedActionId?: number;
    relatedAction?: SupportTicketAction;
    supportTicketTimeLogId?: number;
    supportTicketTimeLog?: SupportTicketTimeLog;
    taskMessageId?: number;
    taskMessage?: SupportTicketMessage;
    evidence?: string;
}

// ../../OnixWeb.Domain/Models/CompanyDatalabReferenceLink.cs
export interface CompanyDatalabReferenceLink extends ATenantOwned {
    id: number;
    companyId: number;
    company: Company;
    datalabReferenceCompanyId?: number;
    datalabReferenceCompany?: DatalabReferenceCompany;
    status: CompanyDatalabReferenceLinkStatusEnum;
    suggestedScore?: number;
    suggestedReason?: string;
    isManual: boolean;
    reviewedById?: string;
    reviewedAt?: Date;
    lastSuggestedAt?: Date;
}

// ../../OnixWeb.Domain/Models/SupportAiKnowledgeEntry.cs
export interface SupportAiKnowledgeEntry extends ATenantOwned {
    id: number;
    scopeType: SupportAiKnowledgeScopeType;
    companyId?: number;
    sourceType: SupportAiKnowledgeSourceType;
    reviewStatus: SupportAiKnowledgeReviewStatus;
    title: string;
    content: string;
    tags?: string;
    triggerTerms?: string;
    sourceRunId?: number;
    active: boolean;
}

// ../../OnixWeb.Domain/Models/ContactPhone.cs
export interface ContactPhone extends ATenantOwned {
    id: number;
    phoneNumber: string;
    contact: Contact;
    contactId?: number;
}

// ../../OnixWeb.Domain/Models/DocumentTypeBase.cs
export interface DocumentTypeBase extends ATenantOwned {
    id: number;
    acLinkDocName1?: string;
    acLinkDocName2?: string;
    acIssuer?: string;
    acReceiver?: string;
    acIssuerName?: string;
    acReceiverName?: string;
    acName3?: string;
    acType?: string;
    visualAttributes?: string;
    visualAttributesOverview?: string;
    groupAllDocumentTypesAtThisPoint: boolean;
    groupAllCreatingDocumentTypesAtThisPoint: boolean;
    showAcDeliveryMobileFilterOnDocumentList: boolean;
    showAcDeliveryOnDocumentList: boolean;
    skipConfirmationOnShortcuts: boolean;
    multipleEndDocumentsCaseToPickEndDocument?: string;
    pickingShowConfirmationOnPick: boolean;
    filterByAcDelivery: boolean;
    filterByAcVerifyStatus?: string;
    filterByAcVerifiedPrices?: string;
    filterByAcDept?: string;
    filterByAcDeptOut?: string;
    filterByAcType?: string;
    filterReceiversByAcFieldSa?: string;
    printTicketNameOverride?: string;
    showDeliveryMethod: boolean;
    showModifierCharacterPicker: boolean;
    modifierCharacterLabel?: string;
    showPaymentMethod: boolean;
    showDeliveryDeadlineDays: boolean;
    showAcDeptMobileFilterOnDocumentList: boolean;
    disallowChangingCustomer: boolean;
    disallowPickingCustomer: boolean;
    defaultToThisCustomer?: string;
    defaultPaymentMethod?: string;
    useDeadlineDateOnOverview: boolean;
    dateFilterType?: DateFilterType;
    groupDocumentTypesFromWhichThisDocumentTypeIsCreated: boolean;
    warehouseName?: string;
    acWorkPlace?: string;
    acFiscalDevice?: string;
    acName?: string;
    warehouseOverviewShowOnlyInStock: boolean;
    hideWarehouseOverview?: boolean;
    articleSearchShowOnlyInStock: boolean;
    articleSearchInitiallyLoadAll: boolean;
    articleSearchRepeatLastSearch: boolean;
    articleSearchShowOnlyWhereAcFieldsAIs?: string;
    articleSearchAllowSearchingByClassification: boolean;
    articleSearchShowOnlyWhereAcSetOfItemIs?: string;
    articleDontShowStockAnyWhere: boolean;
    articleDontShowPriceAnyWhere: boolean;
    articleSearchShowOnlyWhereAcClassifIsIn?: string;
    itemListShowDetailed: boolean;
    documentOnCreateMakePDF: boolean;
    documentOnCreateMakeBluetoothPrint: boolean;
    stockViewLoadAllOnOpen: boolean;
    stockViewShowOnlyInStock: boolean;
    addingItemWarnIfQuantityMoreThanAvailable: boolean;
    bluetoothPrintCopiesNumber: number;
    cacheDuration: number;
    cacheUseCacheForAnyResource: boolean;
    cacheUseForArticleSearch: boolean;
    cacheUseForCustomerSearch: boolean;
    cacheUseForWarehouseSearch: boolean;
    workOrderPrintSpecificationDuration: boolean;
    syncPackagingWhenAddingNewItem: boolean;
    quantityDecimalPlaces: number;
    adminDocumentOnCreateMakeWarehouseReservation: boolean;
    adminAllowChangingItemPrice: boolean;
    adminItemQuantityMustBeInStock: boolean;
    adminCanEditDocumentAfterSaving: boolean;
    adminUseSerialNumberForItems: boolean;
    adminDeleteItemsAfterDocumentIsSaved: boolean;
    adminSavedRebatesForFinalRebate: boolean;
    adminSendDocumentToCompanyDocumentEmail: boolean;
    adminUseAnWsPrice: boolean;
    adminIgnoreRebate1: boolean;
    adminIgnoreRebate2: boolean;
    adminIgnoreRebate3: boolean;
    adminEmphasizeInStock: boolean;
    adminShowDailyIncome: boolean;
    adminShowSubjectAdd: boolean;
    create: boolean;
    update: boolean;
    delete: boolean;
    read: boolean;
    allowModifyExistingDocuments: boolean;
    adminUseGenericDocumentsForMoveAndOrder: boolean;
    adminDefaultAcPriceRate?: string;
    adminForceAcPriceRate?: string;
    ifAcPayMethodChooseThisDocumentType?: string;
    jumpToEditAfterScanningItemWithBarcode: boolean;
    forceShowAvailableOnStock: boolean;
    warehousePositionTHeSetItemFieldName?: string;
    requireASignature: boolean;
    acStatusIn?: string;
    documentNote?: string;
    hideWorkOrderSpecications?: boolean;
    hideWorkOrderReception?: boolean;
    hideWorkOrderReclamations?: boolean;
    hideWorkOrderMaterials?: boolean;
    hideWorkOrderImages?: boolean;
    hideWorkOrderServices?: boolean;
    hideWorkOrderPlaceFromTo?: boolean;
    workOrderSpecificationTimeNotRequired?: boolean;
    workOrderSpecificationPrefillTime?: boolean;
    workOrderCanBeUnlocked?: boolean;
    workOrderUnlockableStatus?: string;
    manualWorkOrderMaterial?: string;
    showAllDocumentsNotOnlyAnUserIns?: boolean;
    historyViewIgnoredFilters?: string;
    warehouseShowPrices?: boolean;
    isDisabled?: boolean;
    mustFiscalize?: boolean;
    recommendToMakeCodebooksOffline?: boolean;
    acFieldSFLabel?: string;
    useSquareArticlePicker?: boolean;
    newNewDocumentInputType?: boolean;
    adminSerialNumbersAreNotAutomated?: boolean;
    isRetail?: boolean;
    documentTopAdditionalText?: string;
    showAllItemsIgnoringWarehouse?: boolean;
    reverseItemsList?: boolean;
    ignoreQuantityInWholeDocument?: boolean;
    hideDocumentElements?: string;
    hideDocumentItemElements?: string;
    serialNumberDirectionIsInput?: boolean;
    arbitraryField1Label?: string;
    arbitraryField1Value?: string;
    arbitraryField1Location?: string;
    arbitraryFields: DocumentTypeArbitraryField[];
    showContactEntry?: boolean;
    printDocumentTitleOverride?: string;
    appendToItemIfExists?: boolean;
    showAdDate?: boolean;
    showAcDoc1?: boolean;
    showAdDateDoc1?: boolean;
    showAcDoc2?: boolean;
    showAdDateDoc2?: boolean;
    copyOnlyLeftOverQuantity?: boolean;
    copyOnlyThoseWithLeftOverQuantity0?: boolean;
    ifCopyingFromOrderUpdateLeftOverQuantity?: boolean;
    makeDocumentLinks?: boolean;
    documentLinkType?: string;
    documentLinkTypeA?: string;
    documentLinkTypeB?: string;
    hideClerkFieldOnPrint?: boolean;
    clerkFieldOnPrint?: string;
    hideAcceptedByFieldOnPrint?: boolean;
    acceptedByFieldOnPrint?: string;
    hidePayMethodOnPrint?: boolean;
    hideDataForPaymentOnPrint?: boolean;
    showAcDoc1OnPrint?: boolean;
    showAdDateDoc1OnPrint?: boolean;
    showAcDoc2OnPrint?: boolean;
    showAdDateDoc2OnPrint?: boolean;
    hideCurrencyDateOnPrint?: boolean;
    hideVATRecapitulationOnPrint?: boolean;
    alwaysUpdatePriceAndRebateFromClient?: boolean;
    defaultQuantity?: number;
    transferAcDoc1WhenCopying?: boolean;
    transferAdDateDoc1WhenCopying?: boolean;
    transferAcDoc2WhenCopying?: boolean;
    transferAdDateDoc2WhenCopying?: boolean;
    showAcIdentOnPrint?: boolean;
    allowManualVerifyFromDocumentOverview?: boolean;
    sendDocumentPDFToContactUsingCompanyOutboundEmail?: boolean;
    storeContactEmailArbitraryInField?: string;
    showContactEmailEntry?: boolean;
    fillReferentLineWithUserOnPrint?: boolean;
    treatIdentAsBarcode?: boolean;
    classifsWhichDontRequireScanningForPicking?: string;
    classifs2WhichDontRequireScanningForPicking?: string;
    acSetOfsWhichDontRequireScanningForPicking?: string;
    copyingFromAnotherIsAShadowCopy?: boolean;
    changeSourceDocumentStatusTo?: string;
    allowSelectingMultipleDocumentsToCreateFrom?: boolean;
    accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: boolean;
    visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: boolean;
    ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: boolean;
    hideLeftOverQuantityOnPicking?: boolean;
    documentOnCreateMakeA4Print?: boolean;
    deliveryIsRequired?: boolean;
    labelDefinitionLocations: LabelDefinitionLocation[];
    allowSigningAfterDocumentIsSaved?: boolean;
    dontSaveIndividualPDFPages?: boolean;
    onlyShowSubjectsWhereLoggedInUserIsReferent?: boolean;
    TMNAnClassifIcationQid?: number;
    TMNAnStorageQid?: number;
    TMNAnMailBoxQid?: number;
    TMNAcDefaultSubject?: string;
    TMNAcDefaultStatus?: string;
    dmsAcStatusIn?: string;
    updateHeadAndDeleteAllItemsOnCopy?: boolean;
    showNumberOfUnlinkedDocuments?: boolean;
    changeDocumentStatusAfterCreated?: string;
    generatePrintTimeOnCreate: boolean;
    showDepartmentAsReceiver: boolean;
    showDepartmentOutAsReceiver: boolean;
    defaultMoveDocumentSortField?: THeMovePagedSortField;
    defaultMoveDocumentSortAscending?: boolean;
    defaultOrderDocumentSortField?: THeOrderPagedSortField;
    defaultOrderDocumentSortAscending?: boolean;
    defaultWoexDocumentSortField?: THfWoexPagedSortField;
    defaultWoexDocumentSortAscending?: boolean;
    skipGS1BarcodeCheck: boolean;
    existingInventoryCheckDays?: number;
    transferEnteredItemQuantityToSerialNumber?: boolean;
    hideQuantityEntry?: boolean;
    showPackageQuantityEntryField?: boolean;
    prioritisePackageQuantityEntryField?: boolean;
    disallowChangingItemQuantityOnSerialInput?: boolean;
    transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: boolean;
    prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: boolean;
    showCustomerOverview?: boolean;
    showCustomerName2AsPrimaryOnHeader?: boolean;
    allowSavingGeodecodedLocation?: boolean;
    showItemPicturesOnPrint?: boolean;
    useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: boolean;
    disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: boolean;
    hideNoteInNonHistoricalView?: boolean;
    customerCodeIsGenerated?: boolean;
    customerCodeFromAcSkis?: boolean;
    customerCodeAllowedKeys?: string;
    completeDeliveryStatus?: string;
    partialDeliveryStatus?: string;
    sendLeftoverShadowsWithZero?: boolean;
    highlightArticlePickerTextOnNextOpen?: boolean;
    insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: boolean;
    insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: boolean;
    showItemAnNetWeightOnPrint?: boolean;
    showItemAcCustomsTariffOnPrint?: boolean;
    showQuantityPerUnitOfMeasureOnPrint?: boolean;
    showItalianLabelsOnPrint?: boolean;
    showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: string;
    showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: string;
    showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: string;
    showQuantityTotalOnPrint?: boolean;
    middleSignatureTextOnPrint?: string;
    useVerySmallMobileInterface?: boolean;
    showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: boolean;
    makeSerialStockCheck?: boolean;
    whenAddingSubjectSetAnClerkToCurrentUser?: boolean;
    defaultSubjectDaysForPaymentOnAdd?: number;
    defaultSubjectPaymentMethodOnAdd?: string;
    allowDMSConfirmation?: boolean;
    initiallyShowOnlyUnconfirmedDMSDocuments?: boolean;
    showOnlyDMSDocumentsAssignedToMe?: boolean;
    articleSearchShowOnlyWhereAcFieldsBIs?: string;
    articleSearchShowOnlyWhereAcFieldsCIs?: string;
    articleSearchShowOnlyWhereAcFieldsDIs?: string;
    articleSearchShowOnlyWhereAcFieldsEIs?: string;
    articleSearchShowOnlyWhereAcFieldsFIs?: string;
    articleSearchShowOnlyWhereAcFieldsGIs?: string;
    articleSearchShowOnlyWhereAcFieldsHIs?: string;
    articleSearchShowOnlyWhereAcFieldsIIs?: string;
    articleSearchShowOnlyWhereAcFieldsJIs?: string;
    articleSearchShowOnlyWhereAnFieldnAIs?: number;
    articleSearchShowOnlyWhereAnFieldnBIs?: number;
    articleSearchShowOnlyWhereAnFieldnCIs?: number;
    articleSearchShowOnlyWhereAnFieldnDIs?: number;
    articleSearchShowOnlyWhereAnFieldnEIs?: number;
    articleSearchShowOnlyWhereAnFieldnFIs?: number;
    articleSearchShowOnlyWhereAnFieldnGIs?: number;
    articleSearchShowOnlyWhereAnFieldnHIs?: number;
    articleSearchShowOnlyWhereAnFieldnIIs?: number;
    articleSearchShowOnlyWhereAnFieldnJIs?: number;
    articleSearchShowOnlyWhereAdFielddAIs?: Date;
    articleSearchShowOnlyWhereAdFielddBIs?: Date;
    articleSearchShowOnlyWhereAdFielddCIs?: Date;
    articleSearchShowOnlyWhereAdFielddDIs?: Date;
    showLineNoteOnPrint: boolean;
    thermalPrintCompanyNameFontSize?: number;
    thermalPrintCompanyNameFontSizeWidth?: number;
    thermalPrintCompanyNameFontSizeHeight?: number;
    thermalPrintShowCompanyImage: boolean;
    showOnlyArticlesWithCustomerContractPrice: boolean;
    defaultCustomerType?: string;
    defaultCustomerTypeFilter?: string;
    showArticlesGroupedByCodeButSeparate?: boolean;
    doNotFilterDailyRecapByUserId?: boolean;
    disableUsingShadowItemAsItemBase?: boolean;
    showLastNOrdersForCustomer?: number;
    showOnlyWOWhereCurrentUserSpecExists?: boolean;
    showWOWorkersEntry?: boolean;
    warehouseViewFixedAcSubject?: string;
    tHrPrsnForOnlyOnixPhoneUsers?: boolean;
    showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: boolean;
    filterByCurrentUserIdIsAnSigner1?: boolean;
    companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: boolean;
    showSerialNumberSearchForWorkOrders?: boolean;
    showCostBearerOnWorkOrders?: boolean;
    onlyCostBearerNoReceiverOrCustomerPickingAllowed?: boolean;
    showReceiverOnWorkOrders?: boolean;
    showBuyerOnWorkOrders?: boolean;
    showInventoryNumberOnWorkOrders?: boolean;
    showAttachSSCCButton?: boolean;
    customContractPriceFilter?: boolean;
    pdfSignWithoutGeneration?: boolean;
    palletEntry?: boolean;
    subjectFieldForSSCCRequirementCheck?: string;
    subjectFieldValueForSSCCRequirementCheck?: string;
    companyEmailPDFCC?: string;
    companyEmailPDFBCC?: string;
    companyEmailDefaultEmail?: string;
    showOnlyDocumentsWhereAnClerkIsCurrentUser?: boolean;
    showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: boolean;
    showAnClerkAndAnNoteClerkIsOROperation?: boolean;
    alwaysShowTheseAcSetOfItem?: string;
    adDateDoc1PDFLabel?: string;
    adDateDoc2PDFLabel?: string;
    showDoc12AndTheirDatesOnDocumentList?: boolean;
    headerClerkPDFLabel?: string;
    adDateDoc1EntryIsTimeOnly?: boolean;
    adDateDoc2EntryIsTimeOnly?: boolean;
    orderAcWarehouseIsCopiedToMoveAcIssuer?: boolean;
    orderAcWarehouseIsCopiedToMoveAcReceiver?: boolean;
    allowChangingWarehouse?: boolean;
    filterOrdersByThisAcWarehouse?: string;
    filterMovesByThisAcIssuer?: string;
    filterMovesByThisAcReceiver?: string;
    acDocsOrderingOnPDF?: string;
    horizontalDoc12AndDates?: boolean;
    showAcDescrOnPDFs?: boolean;
    allowGenericDocumentTypeImageAttachments?: boolean;
    showCustomersAcName2OnThermalPrint?: boolean;
    DMSListFilterOnDefaultClassification?: boolean;
    keepAdDateDoc1And2Unrounded?: boolean;
    hideDMSMetadataEntryFields?: boolean;
    showAllDMSDocumentsForURAClassifications?: boolean;
    disallowManualWarehouseSearch?: boolean;
    hideWarehouseSupplier?: boolean;
    hideWarehouseItemActions?: boolean;
    allowDMSCRUDOnlyForUsersFiles?: boolean;
    allowPullingDMSEInvoicesFromService?: boolean;
    allowDMSReclassification?: boolean;
    cardPaymentProvider?: CardPaymentProvider;
    saveUnsignedAsSignedPDF?: boolean;
    showDMSXMLItems?: boolean;
    allowDMSXMLItemArticlePicking?: boolean;
    allowDMSXMLItemDepartmentPicking?: boolean;
    allowDMSXMLItemCostBearerPicking?: boolean;
    subjectDocumentListDocumentType?: string;
}

// ../../OnixWeb.Domain/Models/UnreadUserSupportTicketMessage.cs
export interface UnreadUserSupportTicketMessage {
    userId: string;
    user: ApplicationUser;
    messageId: number;
    message: SupportTicketMessage;
    type: NotificationType;
}

// ../../OnixWeb.Domain/Models/UnreadUserSupportTicketMessage.cs
export enum NotificationType {
    NewTask = 0,
    AgentFinishedTaskOnTicket = 1,
    ContactResponded = 2,
    UserMentionedYou = 3,
    ChatGPTTicketRecommendation = 4,
    AiInvestigationUpdate = 5,
    NewSupportTicket = 6,
}

// ../../OnixWeb.Domain/Models/SupportAiThreadDatabaseGrant.cs
export interface SupportAiThreadDatabaseGrant extends ATenantOwned {
    id: number;
    threadId: number;
    companyId: number;
    databaseName: string;
    grantedByUserId: string;
    grantedOn: Date;
    revokedOn?: Date;
    reason?: string;
}

// ../../OnixWeb.Domain/Models/DocumentTypeDocumentTypeLink.cs
export interface DocumentTypeDocumentTypeLink {
    documentTypeId: number;
    documentTypeLinkId: number;
    documentType: DocumentType;
    documentTypeLink: DocumentTypeLink;
}

// ../../OnixWeb.Domain/Models/ItemGroupItem.cs
export interface ItemGroupItem extends ATenantOwned {
    id: number;
    item: Item;
    itemId: number;
    itemGroup: ItemGroup;
    itemGroupId: number;
}

// ../../OnixWeb.Domain/Models/SupportTicketStatusTransition.cs
export interface SupportTicketStatusTransition extends ATenantOwned {
    id: number;
    supportTicketId: number;
    oldStatus: SupportStatusEnum;
    newStatus: SupportStatusEnum;
}

// ../../OnixWeb.Domain/Models/ATenantOwned.cs
export interface ATenantOwned extends HasAuditFields {
    companySettingsId?: number;
    companySettings: CompanySettings;
}

// ../../OnixWeb.Domain/Models/MarservisItemGroupMaterial.cs
export interface MarservisItemGroupMaterial extends ATenantOwned {
    id: number;
    itemGroupId: number;
    itemGroup: ItemGroup;
    materialId: number;
    material: MarservisMaterial;
}

// ../../OnixWeb.Domain/Models/MarservisSavedFile.cs
export interface MarservisSavedFile {
    id: number;
    workOrderId: string;
    name: string;
    description: string;
}

// ../../OnixWeb.Domain/Models/TrimAcKey.cs
export interface TrimAcKey {
    acKey: string;
}

// ../../OnixWeb.Domain/Models/SupportTicketStatusLinkModel.cs
export interface SupportTicketStatusLinkModel {
    title: string;
    link: string;
}

// ../../OnixWeb.Domain/Models/TravelWarrantPDFModel.cs
export interface TravelWarrantPDFModel {
    travelWarrant: TravelWarrantPDFWarrant;
    user: ApplicationUser;
    allowanceConversion: number;
    travelKilometersConversion: number;
}

// ../../OnixWeb.Domain/Models/PortalContactLink.cs
export interface PortalContactLink {
    id: number;
    userId: string;
    portalAccount: PortalAccount;
    grunfContactId: number;
    grunfContactEmailId: number;
    contactDisplayName: string;
    grunfCompanyIds: string;
    linkedAt: Date;
    revokedAt?: Date;
}

// ../../OnixWeb.Domain/Models/SavedFileContent.cs
export interface SavedFileContent {
    id: string;
    content: number[];
}

// ../../OnixWeb.Domain/Models/LabelDefinition.cs
export interface LabelDefinition extends ATenantOwned {
    id: number;
    name: string;
    manufacturer: string;
    manufacturerId: string;
    continuousOrSingleSheet: LabelContinuousOrSingleSheetEnum;
    lHDist: number;
    lVDist: number;
    lWidth: number;
    lHeight: number;
    lLeft: number;
    lUpper: number;
    nCols: number;
    nRows: number;
    lPWidth: number;
    lPHeight: number;
}

// ../../OnixWeb.Domain/Models/LabelDefinition.cs
export enum LabelContinuousOrSingleSheetEnum {
    Continuous = 0,
    SingleSheet = 1,
}

// ../../OnixWeb.Domain/Models/SupportTicketBranch.cs
export interface SupportTicketBranch extends ATenantOwned {
    id: number;
    sourceMessageId: number;
    sourceMessage: SupportTicketMessage;
    relatedTicketId: number;
    relatedTicket: SupportTicket;
}

// ../../OnixWeb.Domain/Models/DocumentTypeLinkDocumentType.cs
export interface DocumentTypeLinkDocumentType {
    documentTypeId: number;
    documentTypeLinkId: number;
    documentType: DocumentType;
    documentTypeLink: DocumentTypeLink;
}

// ../../OnixWeb.Domain/Models/TrimAcKeyAndAcWarehouse.cs
export interface TrimAcKeyAcWarehouse {
    acKey: string;
    acWarehouse: string;
}

// ../../OnixWeb.Domain/Models/VOPSetDept.cs
export interface VOPSetDept {
    acSubject: string;
}

// ../../OnixWeb.Domain/Models/FiscalizationQueueEntry.cs
export interface FiscalizationQueueEntry {
    id: number;
    documentType: DocumentType;
    documentTypeId: number;
    acKey: string;
    UID: string;
    ZKI: string;
    jir: string;
    fiscalInternalNumber: string;
    fiscalSequenceNumber?: number;
    fiscalYear?: number;
    fiscalBaseAmount?: number;
    fiscalTotal?: number;
    fiscalizationError: string;
    systemError: string;
    fiscalized: boolean;
    XML: string;
    requestData: string;
    alreadyTriedFiscalizing: boolean;
    fiscalDataSource: FiscalDataSource;
}

// ../../OnixWeb.Domain/Models/FiscalizationQueueEntry.cs
export enum FiscalDataSource {
    Client = 0,
    Server = 1,
}

// ../../OnixWeb.Domain/Models/AssignedAsOwnerOnATicketModel.cs
export interface AssignedAsOwnerOnATicketModel {
    desktopLink: string;
    link: string;
    id: number;
    title: string;
}

// ../../OnixWeb.Domain/Models/AiInvestigationUpdateModel.cs
export interface AiInvestigationUpdateModel {
    link: string;
    desktopLink: string;
    ticketTitle: string;
    ticketId?: number;
    companyId?: number;
    companyName?: string;
    threadTitle?: string;
    runId: number;
    status: string;
    summary: string;
    target?: string;
}

// ../../OnixWeb.Domain/Models/SupportAiMemoryCard.cs
export interface SupportAiMemoryCard extends ATenantOwned {
    id: number;
    scopeType: SupportAiKnowledgeScopeType;
    companyId?: number;
    issueFamily?: string;
    moduleOrProcess?: string;
    summary: string;
    symptomsJson?: string;
    evidencePatternsJson?: string;
    usefulQueriesJson?: string;
    recommendedActionsJson?: string;
    sourceKnowledgeEntryId: number;
    sourceRunId?: number;
    active: boolean;
}

// ../../OnixWeb.Domain/Models/SupportTicketNotificationEmailThread.cs
export interface SupportTicketNotificationEmailThread extends ATenantOwned {
    id: number;
    ticketId: number;
    userId: string;
    subject: string;
    rootMessageId: string;
    lastMessageId: string;
    lastSentOn?: Date;
}

// ../../OnixWeb.Domain/Models/DatalabReleaseLockdownRun.cs
export interface DatalabReleaseLockdownRun extends ATenantOwned {
    id: number;
    companyId: number;
    company: Company;
    companyDatalabReferenceLinkId?: number;
    companyDatalabReferenceLink?: CompanyDatalabReferenceLink;
    status: DatalabReleaseLockdownRunStatusEnum;
    jobId?: string;
    triggeredById?: string;
    startedOn?: Date;
    completedOn?: Date;
    processedPopupCount: number;
    deletedEntryCount: number;
    saveTriggered: boolean;
    summaryLog?: string;
    errorText?: string;
}

// ../../OnixWeb.Domain/Models/BlobCleaning.cs
export interface BlobCleaning {
    id: number;
    date: Date;
    purgedCount: number;
}

// ../../OnixWeb.Domain/Models/ExpenseBearer.cs
export interface ExpenseBearer extends ATenantOwnedPantheonResource {
    id: number;
    bearer: string;
    name: string;
    consignee: string;
    receiver: string;
    active: boolean;
    country: string;
    place: string;
    currency: string;
    allowance: number;
    group: string;
}

// ../../OnixWeb.Domain/Models/CompanyEmailForward.cs
export interface CompanyEmailForward extends ATenantOwned {
    id: number;
    context: CompanyEmailForwardContextEnum;
    receivingEmail: string;
    CC: string;
    BCC: string;
    titleFormat: string;
    titleParams: string;
    bodyFormat: string;
    bodyParams: string;
    isBodyHtml: boolean;
    documentTypeId?: number;
    documentType?: DocumentType;
    documentItemsFilterSQL?: string;
    documentFilterSQL?: string;
    documentTypeParams?: string;
}

// ../../OnixWeb.Domain/Models/PortalAccount.cs
export interface PortalAccount {
    userId: string;
    user: ApplicationUser;
    verifiedEmail: string;
    verifiedVia: PortalVerificationMethod;
    createdAt: Date;
    termsAcceptedAt?: Date;
    lastResolvedAt?: Date;
    autoAttachedCompanySettingsId?: number;
    contactLinks: PortalContactLink[];
}

// ../../OnixWeb.Domain/Models/ExternalAuthTicket.cs
export interface ExternalAuthTicket {
    id: number;
    ticketHash: string;
    externalIdentityId: number;
    externalIdentity: ExternalIdentity;
    createdAt: Date;
    expiresAt: Date;
    consumedAt?: Date;
}

// ../../OnixWeb.Domain/Models/MarservisWorkOrderItem.cs
export interface MarservisWorkOrderItem extends ATenantOwned {
    id: number;
    workOrder: MarservisWorkOrder;
    workOrderId: string;
    billableTime: number;
    user: ApplicationUser;
    userId: string;
    item?: Item;
    itemId?: number;
    itemGroup?: ItemGroup;
    itemGroupId?: number;
    deadlineDate?: Date;
    note: string;
    status: MarservisWorkOrderItemStatusEnum;
    works: MarservisWorkOrderItemWork[];
    items: MarservisWorkOrderItemItem[];
}

// ../../OnixWeb.Domain/Models/AresDeploymentGroupSnapshot.cs
export interface AresDeploymentGroupSnapshot extends ATenantOwned {
    id: number;
    aresDeploymentGroupId: number;
    aresDeploymentGroup: AresDeploymentGroup;
    versionNo: number;
    name: string;
    notes: string;
    sourceHash: string;
    snapshotTakenAt: Date;
    isTesting: boolean;
    isStaging: boolean;
    isProduction: boolean;
    pullCount: number;
    lastPulledAt?: Date;
    installCount: number;
    lastInstalledAt?: Date;
    payloadJson: string;
}

// ../../OnixWeb.Domain/Models/ClientServerStatus.cs
export interface ClientServerStatus extends HasAuditFields {
    serverName: string;
    serverIP: string;
    status: string;
    pingTime: Date;
    workHoursCheckError: string;
    notificationEmail?: string;
    workHours: ClientServerWorkHours[];
}

// ../../OnixWeb.Domain/Models/OnixDMSPantheonConnectionBlock.cs
export interface OnixPantheonDMSConnectionBlock {
    headPerTravelWarrant: boolean;
}

// ../../OnixWeb.Domain/Models/SupportGroupMember.cs
export interface SupportGroupMember extends ATenantOwned {
    supportGroupId: number;
    supportGroup: SupportGroup;
    userId: string;
    user: ApplicationUser;
}

// ../../OnixWeb.Domain/Models/AresDeploymentGroupInstallationStep.cs
export interface AresDeploymentGroupInstallationStep extends ATenantOwned {
    id: number;
    aresDeploymentGroupId: number;
    aresDeploymentGroup: AresDeploymentGroup;
    aresDeploymentInstallationStepPoints: AresDeploymentInstallationStepPoint[];
    order?: number;
    variableName: string;
    variableType: InstallationVariableType;
    duration?: number;
    description?: string;
    resetsOnInvoicing: boolean;
    sumType?: InvoiceSumType;
    triggerType?: DeploymentGroupStepTriggerType;
}

// ../../OnixWeb.Domain/Models/WikiEntryCategory.cs
export interface WikiEntryCategory extends ATenantOwned {
    id: number;
    name: string;
    description: string;
    parentId?: number;
    parent?: WikiEntryCategory;
    children: WikiEntryCategory[];
    wikiEntries: WikiEntry[];
    order?: number;
}

// ../../OnixWeb.Domain/Models/SupportAiThreadItem.cs
export interface SupportAiThreadItem extends ATenantOwned {
    id: number;
    threadId: number;
    runId?: number;
    sequence: number;
    revision: number;
    parentItemId?: number;
    kind: SupportAiThreadItemKind;
    status: SupportAiThreadItemStatus;
    role?: SupportAiThreadItemRole;
    phase?: SupportAiThreadItemPhase;
    sourceKey?: string;
    providerItemId?: string;
    toolCallId?: number;
    questionId?: number;
    title?: string;
    body?: string;
    summary?: string;
    payloadJson?: string;
    errorCode?: string;
    startedOn?: Date;
    completedOn?: Date;
    attachments: SavedFile[];
}

// ../../OnixWeb.Domain/Models/FTPConnectionBlock.cs
export interface FTPConnectionBlock {
    URL: string;
    username: string;
    password: string;
    workingDirectory: string;
    replaceWorkingDirectoryWhenSavingAs: string;
    windows: boolean;
}

// ../../OnixWeb.Domain/Models/CompanySqlTask.cs
export interface CompanySqlTask extends ATenantOwned {
    id: number;
    name: string;
    companyId: number;
    company: Company;
    sqlText: string;
    scheduleMode: SqlTaskScheduleMode;
    cronExpression: string;
    scheduledFor?: Date;
    scheduleConfig: string;
    scheduleDescription: string;
    enabled: boolean;
    runsExecuted: number;
    maxRuns?: number;
    lastRunAt?: Date;
    lastRunSucceeded?: boolean;
    lastRunError: string;
    nextRunAt?: Date;
    hangfireRecurringJobId: string;
    hangfireScheduledJobId: string;
    connectionString: string;
    timeZoneId: string;
}

// ../../OnixWeb.Domain/Models/PortalTicketReadState.cs
export interface PortalTicketReadState {
    userId: string;
    user: ApplicationUser;
    grunfTicketId: number;
    lastSeenMessageId: number;
    seenAt: Date;
}

// ../../OnixWeb.Domain/Models/HasAdTimeInsAndAdTimeChg.cs
export interface HasAdTimeInsAndAdTimeChgWithUser extends HasAdTimeInsAndAdTimeChgWithoutUser {
    anUserIns?: number;
}

// ../../OnixWeb.Domain/Models/RatesAPIV1Response.cs
export interface RatesAPIV1Response {
    brojtečajnice: string;
    datumprimjene: string;
    država: string;
    šifravalute: string;
    valuta: string;
    jedinica: number;
    kupovnizadevize: string;
    srednjizadevize: string;
    prodajnizadevize: string;
}

// ../../OnixWeb.Domain/Models/EInvoiceQueueEntry.cs
export interface EInvoiceQueueEntry {
    id: string;
    companySettingsId: number;
    documentUid: string;
    actorUserId: string;
    configurationOwnerUserId: string;
    connectionName: string;
    tenant: OnixTenant;
    documentTypeId: number;
    pantheonTable: PantheonDocumentTable;
    acKey?: string;
    acDocType?: string;
    pairId?: number;
    sourceAcKey?: string;
    businessSha256?: string;
    pdfArtifactId?: string;
    pdfFileQId?: number;
    pdfFilename?: string;
    pdfSha256?: string;
    pdfByteLength?: number;
    maxPdfBytes: number;
    maxRequestBytes?: number;
    documentQId?: number;
    sourceFileQId?: number;
    xmlSha256?: string;
    state: EInvoiceQueueState;
    stage: EInvoiceStage;
    isSafeRetry: boolean;
    externalSendPaused: boolean;
    commitAttempts: number;
    pdfAttempts: number;
    xmlAttempts: number;
    exchangeAttempts: number;
    fiscalizationAttempts: number;
    createdAt: string;
    updatedAt: string;
    issuedAt?: string;
    firstFailureAt?: string;
    firstTechnicalInterruptionAt?: string;
    nextAttemptAt?: string;
    leaseOwner?: string;
    leaseExpiresAt?: string;
    version: number;
    reasonCode?: string;
    rawStatus?: string;
    exchange: EInvoiceExchangeOutcome;
    exchangeStartedAt?: string;
    exchangeAcceptedAt?: string;
    externalId?: string;
    fiscalization: EInvoiceFiscalizationOutcome;
    fiscalizedAt?: string;
    fiscalizationEvidence?: string;
}

// ../../OnixWeb.Domain/Models/OpenAISession.cs
export interface OpenAISession extends ATenantOwned {
    id: number;
    userId: string;
    title: string;
    user: ApplicationUser;
    messages: OpenAISessionMessage[];
}

// ../../OnixWeb.Domain/Models/HasAdTimeInsAndAdTimeChgWithoutUser.cs
export interface HasAdTimeInsAndAdTimeChgWithoutUser {
    adTimeChg?: Date;
    adTimeIns?: Date;
}

// ../../OnixWeb.Domain/Models/AresDeploymentAresCompanyCurrentVersion.cs
export interface AresDeploymentAresCompanyCurrentVersion extends ATenantOwned {
    id: number;
    aresAcKey: string;
    aresDeploymentAresId: number;
    aresDeploymentAres: AresDeploymentAres;
    aresVersion?: number;
    forPantheonVersion?: number;
    company: Company;
    companyId: number;
}

// ../../OnixWeb.Domain/Models/EvidencijaRVPoz.cs
export interface EvidencijaRVPoz {
    id: number;
    acWorker: string;
    adDate: Date;
    acET: string;
    anHour?: number;
    anMin?: number;
    acNote: string;
    acCostDrv: string;
}

// ../../OnixWeb.Domain/Models/EmailTestingRequest.cs
export interface EmailTestingRequest extends ATenantOwned {
    id: number;
    host: string;
    ports: number[];
    username: string;
    password: string;
    success?: boolean;
    running: boolean;
    completed: boolean;
    message: string;
    requestUserId: string;
    requestUser: ApplicationUser;
    results: EmailTestingResult[];
}

// ../../OnixWeb.Domain/Models/ApplicationUserExternalIdentity.cs
export interface ApplicationUserExternalIdentity {
    id: number;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    externalIdentityId: number;
    externalIdentity: ExternalIdentity;
    createdAt: Date;
    lastUsedAt?: Date;
    createdByUserId?: string;
    createdByUser?: ApplicationUser;
}

// ../../OnixWeb.Domain/Models/SupportOpenAIExecution.cs
export interface SupportOpenAIExecution {
    id: number;
    ticketId?: number;
    ticket?: SupportTicket;
    messageId?: number;
    message?: SupportTicketMessage;
    forUserId?: string;
    forUser?: ApplicationUser;
    openAIMessage: string;
    openAIResponse: string;
    context: SupportOpenAIExecutionContextEnum;
    openAIRequest: string;
}

// ../../OnixWeb.Domain/Models/Synchronization.cs
export interface Synchronization extends ATenantOwned {
    id: number;
    resource: string;
    time: Date;
    added: number;
    updated: number;
    deleted: number;
}

// ../../OnixWeb.Domain/Models/PagingModel.cs
export interface PagingModel {
    page: number;
    count: number;
}

// ../../OnixWeb.Domain/Models/AssignedAsAgentOnATicketModel.cs
export interface AssignedAsAgentOnATicketModel {
    desktopLink: string;
    link: string;
    id: number;
    title: string;
}

// ../../OnixWeb.Domain/Models/UnassignedTicketDto.cs
export interface UnassignedTicketDto {
}

// ../../OnixWeb.Domain/Models/CompanyMeshCentralGroupMapping.cs
export interface CompanyMeshCentralGroupMapping extends ATenantOwned {
    id: number;
    companyId: number;
    company: Company;
    meshCentralGroupId: string;
    meshCentralGroupName: string;
    meshCentralServerDeviceId?: string;
    meshCentralServerDeviceName?: string;
    mssqlPort?: number;
    lastSeenAt?: Date;
}

// ../../OnixWeb.Domain/Models/SupportTicket.cs
export interface SupportTicket extends ATenantOwned {
    id: number;
    user: ApplicationUser;
    userId: string;
    temporaryOwner: ApplicationUser;
    temporaryOwnerId?: string;
    supportGroup: SupportGroup;
    supportGroupId?: number;
    status: SupportStatusEnum;
    dateDue?: Date;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    type: string;
    supportTicketTimeLogs: SupportTicketTimeLog[];
    supportTicketMessages: SupportTicketMessage[];
    supportTicketTodos: SupportTicketTodo[];
    title: string;
    contactCompanyCompany: Company;
    contactCompanyContact: Contact;
    contactCompanyContactId?: number;
    contactCompanyCompanyId?: number;
    contactEmail: ContactEmail;
    contactEmailId?: number;
    reportedByApplicationUser: ApplicationUser;
    reportedByApplicationUserId?: string;
    project: Project;
    projectId?: number;
    messagesDeleted: boolean;
    offerTypeDefault: boolean;
    offerNumber?: string;
    showProjectFeatures: boolean;
    teamViewerSessions: TeamViewerSession[];
    wakaTimeWorklogs: WakaTimeWorklog[];
    originalSender: string;
    supportOpenAIExecutions: SupportOpenAIExecution[];
    pantheonVersionId?: number;
    pantheonVersion?: PantheonVersion;
    problemSubmissionSourceKey?: string;
}

// ../../OnixWeb.Domain/Models/TravelWarrantPDFWarrant.cs
export interface TravelWarrantPDFWarrant {
    id: string;
    companyImage: number[];
    companyName: string;
    companyPrtTextA: string;
    firstName: string;
    lastName: string;
    place?: string;
    countryName?: string;
    officialVehicleMakeAndModel: string;
    personalVehicleMakeAndModel: string;
    vehicle: string;
    officialVehicleRegistration: string;
    personalVehicleRegistration: string;
    driver: string;
    note: string;
    travelStartDateTime?: Date;
    travelEndDateTime?: Date;
    travelStartMeter?: number;
    travelEndMeter?: number;
    travelHours: number;
    perDiems: number;
    coDrivers: string;
    currency: string;
    allowance?: number;
    downPayment?: number;
    downPaymentConversion?: number;
    items: TravelWarrantPDFItem[];
    kilometersTraveled: number;
    usesPersonalVehicle: boolean;
    travelKilometer: TravelKilometers;
    date: Date;
    companyAddress: string;
    allowanceConversion: number;
    travelKilometerConversion: number;
}

// ../../OnixWeb.Domain/Models/ClientServerHostAssignment.cs
export interface ClientServerHostAssignment extends ATenantOwned {
    id: number;
    serverName: string;
    clientServer: ClientServerStatus;
    companyId: number;
    company: Company;
    companyTeamViewerDeviceId?: number;
    companyTeamViewerDevice?: CompanyTeamViewerDevice;
    companyMeshCentralGroupMappingId?: number;
    companyMeshCentralGroupMapping?: CompanyMeshCentralGroupMapping;
    meshCentralDeviceId?: string;
    meshCentralDeviceName?: string;
    teamViewerOnline?: boolean;
    meshCentralOnline?: boolean;
    hostOnline?: boolean;
    hostCheckedOn?: Date;
    hostCheckError?: string;
}

// ../../OnixWeb.Domain/Models/TravelWarrantItem.cs
export interface TravelWarrantItem extends ATenantOwned {
    id: number;
    travelWarrant: TravelWarrant;
    travelWarrantId: string;
    date: Date;
    costType: TravelWarrantCostType;
    costTypeId?: number;
    note: string;
    value: number;
    currency: Currency;
    currencyId: number;
    conversion: number;
    hasBackingInvoice: boolean;
    notForPayment: boolean;
    files: SavedFile[];
    anCostNo?: number;
    anNo?: number;
    forPeriod?: Date;
}

// ../../OnixWeb.Domain/Models/Company.cs
export interface Company extends ATenantOwnedPantheonResource {
    id: number;
    name: string;
    description: string;
    notes: string;
    connectionSettings: string;
    myEInvoiceSettings: string;
    pantheonAcSubject: string;
    notOurCustomer: boolean;
    contactCompanies: ContactCompany[];
    companyTeamViewerContacts: CompanyTeamViewerContact[];
    companyTeamViewerDevices: CompanyTeamViewerDevice[];
    companyMeshCentralGroupMappings: CompanyMeshCentralGroupMapping[];
    companyDatalabReferenceLinks: CompanyDatalabReferenceLink[];
    datalabReleaseLockdownRuns: DatalabReleaseLockdownRun[];
    aresDeploymentAresCompanyCurrentVersions: AresDeploymentAresCompanyCurrentVersion[];
    aresDeploymentGroupCompanyMappings: AresDeploymentGroupCompanyMapping[];
    companyMachineUids: CompanyMachineUid[];
    pantheonStatus: string;
    pantheonSubscriber: boolean;
    pantheonBuyerType: string;
    pantheonBuyerTypeName: string;
    pantheonConnectionString: string;
    linkedCompanySettingsId?: number;
    linkedCompanySettings?: CompanySettings;
    shouldHaveIBackup: boolean;
    iBackupEventLogComputers: IBackupEventLogComputer[];
    grunfAresSyncToken: string;
    alternateMainServerPrefix?: string;
    accountingCompanyId?: number;
    accountingCompany?: Company;
    companyRunbookNotes: CompanyRunbookNote[];
}

// ../../OnixWeb.Domain/Models/PersonalVehicle.cs
export interface PersonalVehicle extends ATenantOwned {
    id: number;
    registration: string;
    makeAndModel: string;
    applicationUser: ApplicationUser;
    applicationUserId: string;
}

// ../../OnixWeb.Domain/Models/PantheonUser.cs
export interface PantheonUser extends ATenantOwned {
    userId: string;
    user: ApplicationUser;
    pantheonAnUserId: number;
    pantheonAcName: string;
    pantheonAcRegNo: string;
    pantheonAcWorker: string;
    pantheonAcUserId: string;
    pantheonPrsnStatus: boolean;
    pantheonAcDelivery: string;
    pantheonSignature: number[];
    pantheonPIN: string;
    encodedUserId?: string;
}

// ../../OnixWeb.Domain/Models/THeSetSubjType.cs
export interface THeSetSubjType {
    acSubjType: string;
    acType: string;
    acName: string;
    tHeSetSubjAcSubjTypeBuyerNavigations: THeSetSubj[];
}

// ../../OnixWeb.Domain/Models/TrimTHeMoveRmaworkSpec.cs
export interface TrimTHeMoveRmaworkSpec {
    acKey: string;
    anNo: number;
    acWorker: string;
    adWorkStart?: Date;
    adWorkEnd?: Date;
    adTravelStart?: Date;
    adTravelEnd?: Date;
    anMileage?: number;
    anUserIns?: number;
    anUserChg?: number;
    acIdent: string;
    acNote: string;
    anQid: number;
    anWork?: number;
    acNote2: string;
    acKeyNavigation: THeMove;
}

// ../../OnixWeb.Domain/Models/AresDeploymentWorkflowDefinition.cs
export interface AresDeploymentWorkflowDefinition extends ATenantOwned {
    id: number;
    aresDeploymentGroupId: number;
    aresDeploymentGroup: AresDeploymentGroup;
    acIdentify: string;
    acName: string;
}

// ../../OnixWeb.Domain/Models/KanbanTasks.cs
export interface KanbanTasks {
    id: number;
    htmlContent: string;
}

// ../../OnixWeb.Domain/Models/PantheonDbObjectDoc.cs
export interface PantheonDbObjectDoc extends HasAuditFields {
    id: number;
    kind: string;
    schemaName?: string;
    objectName: string;
    objectNameNormalized: string;
    fullName: string;
    fullNameNormalized: string;
    objectKey: string;
    canonicalUrl?: string;
    sourceHash: string;
    sourcePath?: string;
    docJson: string;
    fullText: string;
}

// ../../OnixWeb.Domain/Models/DatalabReferenceCompany.cs
export interface DatalabReferenceCompany extends ATenantOwned {
    id: number;
    displayName: string;
    normalizedName: string;
    detailUrl: string;
    remoteKey: string;
    firstSyncedAt: Date;
    lastSyncedAt: Date;
    companyDatalabReferenceLinks: CompanyDatalabReferenceLink[];
}

// ../../OnixWeb.Domain/Models/WorkRecordPeriod.cs
export interface WorkRecordPeriod extends ATenantOwned {
    id: number;
    year: number;
    month: number;
    description: string;
    workRecords: WorkRecord[];
    applicationUserId: string;
    applicationUser: ApplicationUser;
    finalized: boolean;
    readyToFinalize: boolean;
}

// ../../OnixWeb.Domain/Models/EmailTestingResult.cs
export interface EmailTestingResult extends ATenantOwned {
    id: number;
    host: string;
    port: number;
    username: string;
    password: string;
    success: boolean;
    message: string;
    forceTls: boolean;
    option: any;
    emailTestingRequestId: number;
    EHLO: boolean;
    emailTestingRequest: EmailTestingRequest;
}

// ../../OnixWeb.Domain/Models/SupportAiToolCall.cs
export interface SupportAiToolCall extends HasAuditFields {
    id: number;
    runId: number;
    eventSequence: number;
    toolName: string;
    status: SupportAiToolCallStatusEnum;
    argumentsJson?: string;
    resultJson?: string;
    displaySummary: string;
    startedOn?: Date;
    completedOn?: Date;
    error?: string;
}

// ../../OnixWeb.Domain/Models/PantheonVersions.cs
export interface PantheonVersion extends ATenantOwned {
    id: number;
    version: string;
    group: string;
    downloadPath: string;
    versionFormatted: string;
}

// ../../OnixWeb.Domain/Models/WorkRecord.cs
export interface WorkRecord extends ATenantOwned {
    id: number;
    costBearer: string;
    costBearerName: string;
    subject: string;
    description: string;
    workRecordCostTypeId?: number;
    workRecordPeriodId?: number;
    workRecordCostType: WorkRecordCostType;
    workHours: WorkRecordWorkHours[];
    workRecordPeriod: WorkRecordPeriod;
}

// ../../OnixWeb.Domain/Models/McpApiKey.cs
export interface McpApiKey {
    id: number;
    kind: McpApiKeyKind;
    name: string;
    keyHash: string;
    keyPrefix: string;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    companySettingsId: number;
    canWriteInternalNotes: boolean;
    canWriteTimeLogs: boolean;
    canWriteCodexActivity: boolean;
    canExecuteDebugSql: boolean;
    canReadRuntimeLogs: boolean;
    canManagePantheonDocs: boolean;
    canManageCompanyDbPantheonUsers: boolean;
    canManageSupportAiKnowledge: boolean;
    canAccessAllCompanySettings: boolean;
    canManageOnixPhoneUserTasks: boolean;
    canManageOnixPhoneUsers: boolean;
    createdAt: Date;
    expiresAt?: Date;
    lastUsedAt?: Date;
    revokedAt?: Date;
}

// ../../OnixWeb.Domain/Models/TOpMoveItem.cs
export interface TOpMoveItem {
    ackey: string;
    anno: number;
    acPicture: number[];
}

// ../../OnixWeb.Domain/Models/CurrencyConversion.cs
export interface CurrencyConversion {
    from: string;
    to: string;
    rate: number;
    date: Date;
    middle: number;
    buying: number;
    selling: number;
}

// ../../OnixWeb.Domain/Models/HitnoAlertNotificationState.cs
export interface HitnoAlertNotificationState {
    itemKeys: string[];
}

// ../../OnixWeb.Domain/Models/HasAuditFields.cs
export interface HasAuditFields{
    modifiedBy: string;
    createdBy: string;
    modifiedById: string;
    createdById: string;
    modifiedOn?: Date;
    createdOn?: Date;
}

// ../../OnixWeb.Domain/Models/MarservisWorkOrderItemWorkMaterial.cs
export interface MarservisWorkOrderItemWorkMaterial extends ATenantOwned {
    id: number;
    workOrderItemWorkId: number;
    workOrderItemWork: MarservisWorkOrderItemWork;
    materialId: number;
    material: MarservisMaterial;
    quantity: number;
}

// ../../OnixWeb.Domain/Models/UserWebPreferences.cs
export interface UserWebPreferences {
    applicationUserId: string;
    applicationUser?: ApplicationUser;
    theme?: WebThemePreference;
    sidebarMode: WebSidebarMode;
    sidebarCollapsed: boolean;
    language?: string;
    updatedAt: Date;
}

// ../../OnixWeb.Domain/Models/UserWebPreferences.cs
export interface UserDocumentTypeListPreference {
    applicationUserId: string;
    applicationUser?: ApplicationUser;
    documentTypeId: number;
    documentType?: DocumentType;
    dateRange?: DateFilterType;
    dateFrom?: Date;
    dateTo?: Date;
    keyFrom?: string;
    keyTo?: string;
    customerAcSubject?: string;
    departmentAcSubject?: string;
    onlyMine?: boolean;
    lastOpenedAt?: Date;
}

// ../../OnixWeb.Domain/Models/PantheonSession.cs
export interface PantheonSession extends ATenantOwned {
    id: number;
    clientSessionId: string;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    pantheonIniId?: number;
    pantheonIni: PantheonINI;
    pantheonCompanyName: string;
    status: string;
    startedAt: Date;
    endedAt: Date;
    duration: number;
    note: string;
    dismissed: boolean;
    supportTicketId?: number;
    supportTicket: SupportTicket;
    supportTicketTimeLogId?: number;
    supportTicketTimeLog: SupportTicketTimeLog;
}

// ../../OnixWeb.Domain/Models/ContactEmail.cs
export interface ContactEmail extends ATenantOwned {
    id: number;
    email: string;
    isPrimary: boolean;
    suppressNotificationEmails: boolean;
    contactId: number;
    contact: Contact;
}

// ../../OnixWeb.Domain/Models/ApplicationRole.cs
export interface ApplicationRole{
    userRoles: ApplicationUserRole[];
}

// ../../OnixWeb.Domain/Models/ClientServerStatusStatus.cs
export interface ClientServerStatusStatus {
    hourlyFailedJobs: number;
    enqueuedJobs: number;
}

// ../../OnixWeb.Domain/Models/DocumentType.cs
export interface DocumentType extends DocumentTypeBase {
    user: ApplicationUser;
    userId: string;
    type: string;
    functionality: DocumentFunctionalityEnum;
    sendB2BAsEInvoice: boolean;
    fromPairs: DocumentTypePair[];
    toPairs: DocumentTypePair[];
    fiscalizationQueueEntry: FiscalizationQueueEntry[];
    linkTo: DocumentTypeLink[];
    linkFrom: DocumentTypeLink[];
    companyEmailForwards: CompanyEmailForward[];
    pantheonTable: PantheonDocumentTable;
    pantheonDirection: PantheonDocumentDirectionEnum;
}

// ../../OnixWeb.Domain/Models/TenantCurrencyConversions.cs
export interface TenantCurrencyConversions extends ATenantOwnedPantheonResource {
    id: number;
    from: string;
    to: string;
    rate: number;
    date: Date;
    middle: number;
    buying: number;
    selling: number;
}

// ../../OnixWeb.Domain/Models/EvidencijaRV.cs
export interface EvidencijaRV {
    id: number;
    acWorker: string;
    adDateOd?: Date;
    adDateDo?: Date;
    adTimeOd?: Date;
    adTimeDo?: Date;
    acET: string;
    anHour?: number;
    anMin?: number;
    acNote: string;
}

// ../../OnixWeb.Domain/Models/VOPSetItemCateg.cs
export interface VOPSetItemCateg {
    acClassif: string;
    acdept: string;
}

// ../../OnixWeb.Domain/Models/SupportTicketTimeLog.cs
export interface SupportTicketTimeLog extends ATenantOwned {
    id: number;
    agent: ApplicationUser;
    agentId: string;
    date: Date;
    time: number;
    billableTime: number;
    billable: boolean;
    invoice: boolean;
    workOutsideWorkingHours: boolean;
    note: string;
    technicalNote: string;
    ticket: SupportTicket;
    ticketId?: number;
    type: string;
    projectPhase: string;
    codexTaskId?: string;
    codexCumulativeDurationMs?: number;
    codexSnapshotAtUtc?: Date;
    exportedOn?: Date;
}

// ../../OnixWeb.Domain/Models/OnixPhoneUserTaskQueue.cs
export interface OnixPhoneUserTaskQueue extends ATenantOwned {
    id: number;
    userId: string;
    user: ApplicationUser;
    task: OnixPhoneUserTaskEnum;
    taskData: string;
    isCompleted: boolean;
    failed: boolean;
    campaignId: string;
    response: string;
    nofityAdminOnCompletion: boolean;
    validFrom?: Date;
    validTo?: Date;
}

// ../../OnixWeb.Domain/Models/PortalUpload.cs
export interface PortalUpload {
    id: string;
    userId: string;
    user: ApplicationUser;
    fileName: string;
    contentType: string;
    size: number;
    content: number[];
    createdAt: Date;
}

// ../../OnixWeb.Domain/Models/ATenantOwnedPantheonSyncResource.cs
export interface ATenantOwnedPantheonSyncResource extends ATenantOwned {
    pantheonId: string;
    synced: Date;
    syncStatus: string;
    syncErrorStack: string;
    syncFailed: boolean;
}

// ../../OnixWeb.Domain/Models/SupportAiRun.cs
export interface SupportAiRun extends ATenantOwned {
    id: number;
    ticketId?: number;
    threadId?: number;
    continuedFromRunId?: number;
    status: SupportAiRunStatusEnum;
    pauseReason?: SupportAiRunPauseReason;
    currentPhase: SupportAiRunPhaseEnum;
    lastEventSequence: number;
    startedOn?: Date;
    completedOn?: Date;
    cancelRequestedOn?: Date;
    apiKeySnapshot?: string;
    configurationSnapshotJson?: string;
    targetSnapshotJson?: string;
    investigationConnectionStringSnapshot?: string;
    investigationTransportSnapshotJson?: string;
    providerResponseId?: string;
    previousProviderResponseId?: string;
    providerInputItemsJson?: string;
    providerOutputItemsJson?: string;
    providerCompactionItemJson?: string;
    providerUsageJson?: string;
    promptVersion?: string;
    toolCatalogVersion?: string;
    conclusionSummary?: string;
    conclusionRecommendedNextAction?: string;
    conclusionConfidence?: string;
    conclusionEvidenceJson?: string;
    conclusionFollowUpQuestionsJson?: string;
    lastError?: string;
}

// ../../OnixWeb.Domain/Models/MentionedOnATicketModel.cs
export interface MentionedOnATicketModel {
    link: string;
    desktopLink: string;
    reporter: string;
    message: string;
    ticket: string;
    id: number;
    ticketId?: number;
    remoteContentSavedFileId?: number;
}

// ../../OnixWeb.Domain/Models/TravelKilometers.cs
export interface TravelKilometers extends ATenantOwnedPantheonResource {
    id: number;
    currency: string;
    kilometers?: number;
    price?: number;
    date?: Date;
}

// ../../OnixWeb.Domain/Models/VOpCashReg.cs
export interface VOpCashReg {
    acDoctype: string;
    ackey: string;
    addate?: Date;
    acSubject: string;
    anPaid: number;
}

// ../../OnixWeb.Domain/Models/TicketTaskFinishedModel.cs
export interface TicketTaskFinishedModel {
    id: number;
    ticketId?: number;
    title: string;
    message: string;
    user: ApplicationUser;
    agent: ApplicationUser;
    link: string;
    remoteContentSavedFileId?: number;
    desktopLink: string;
}

// ../../OnixWeb.Domain/Models/Currency.cs
export interface Currency extends ATenantOwnedPantheonResource {
    id: number;
    code: string;
    longName: string;
    name: string;
    unit: number;
}

// ../../OnixWeb.Domain/Models/HitnoAlertModel.cs
export interface HitnoAlertModel {
    newCount: number;
    totalCount: number;
    link: string;
    desktopLink: string;
    items: HitnoAlertItemModel[];
}

// ../../OnixWeb.Domain/Models/MarservisMaterial.cs
export interface MarservisMaterial extends ATenantOwned {
    id: number;
    name: string;
    unitOfMeasure: string;
    normalizedName: string;
    normalizedUnitOfMeasure: string;
    itemGroupMaterials: MarservisItemGroupMaterial[];
    workUsages: MarservisWorkOrderItemWorkMaterial[];
}

// ../../OnixWeb.Domain/Models/CompanyMachineUid.cs
export interface CompanyMachineUid extends ATenantOwned {
    id: number;
    machineUID: string;
    database: string;
    companyId: number;
    company: Company;
}

// ../../OnixWeb.Domain/Models/TrimWorkOrderTHeDocs.cs
export interface TrimWorkOrderTHeDocs extends THeDocs {
    acAppl: string;
    anKey: number;
    acLnkKey: string;
    acName: string;
    acUrl: string;
    acTypeDocu: string;
    adDateValid?: Date;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    acForeignIdentifier: string;
    acLnkKeyOrd: string;
    anQid: number;
    acPerKey: string;
    acPicture: number[];
    acPhoneUID: string;
}

// ../../OnixWeb.Domain/Models/ATenantOwnedPantheonResource.cs
export interface ATenantOwnedPantheonResource extends ATenantOwned {
    pantheonId: string;
    synced: Date;
    syncStatus: string;
    syncFailed: boolean;
}

// ../../OnixWeb.Domain/Models/SupportGroup.cs
export interface SupportGroup extends ATenantOwned {
    id: number;
    name: string;
    receivesProblemSubmissions: boolean;
    members: SupportGroupMember[];
    supportTickets: SupportTicket[];
}

// ../../OnixWeb.Domain/Models/MarservisWorkOrderItemWorkWithoutFilesReturnDto.cs
export interface MarservisWorkOrderItemWorkWithoutFilesReturnDto {
    id: number;
    workOrderItemId: number;
    time: number;
    date: Date;
    cause: string;
    remedy: string;
    note: string;
    materials: string;
    materialUsages?: MarservisWorkOrderItemWorkMaterialInputDto[];
    materialUsageDetails: MarservisWorkOrderItemWorkMaterialReturnDto[];
}

// ../../OnixWeb.Domain/Models/WakaTimeCommit.cs
export interface WakaTimeCommit extends ATenantOwned {
    id: number;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    externalProjectName: string;
    internalProjectId?: number;
    internalProject?: Project;
    hash: string;
    message?: string;
    branch?: string;
    htmlUrl?: string;
    repositoryProvider?: string;
    repositoryFullName?: string;
    authorName?: string;
    authorEmail?: string;
    authorUsername?: string;
    committerName?: string;
    committerEmail?: string;
    committerUsername?: string;
    authorDate?: Date;
    committerDate?: Date;
    totalSeconds: number;
    contextOnly: boolean;
    wakaTimeWorklogId?: number;
    wakaTimeWorklog?: WakaTimeWorklog;
}

// ../../OnixWeb.Domain/Models/MarservisWorkOrderItemWork.cs
export interface MarservisWorkOrderItemWork extends ATenantOwned {
    id: number;
    workOrderItem: MarservisWorkOrderItem;
    workOrderItemId: number;
    time: number;
    date: Date;
    cause: string;
    remedy: string;
    note: string;
    materials: string;
    files: SavedFile[];
    materialUsages: MarservisWorkOrderItemWorkMaterial[];
    materialUsageDetails: MarservisWorkOrderItemWorkMaterialReturnDto[];
}

// ../../OnixWeb.Domain/Models/MaintenanceWindowNotice.cs
export interface MaintenanceWindowNotice {
    id: number;
    campaignId: string;
    state: string;
    message: string;
    startUtc: Date;
    endUtc: Date;
    createdAtUtc: Date;
    createdById: string;
    recipients: MaintenanceWindowNoticeRecipient[];
}

// ../../OnixWeb.Domain/Models/ContactRespondedOnATicketModel.cs
export interface ContactRespondedOnATicketModel {
    desktopLink: string;
    message: string;
    link: string;
    contact: string;
    id: number;
    ticketId?: number;
    title: string;
    user: ApplicationUser;
    remoteContentSavedFileId?: number;
    statusLinks: SupportTicketStatusLinkModel[];
}

// ../../OnixWeb.Domain/Models/SupportAiThreadMessage.cs
export interface SupportAiThreadMessage extends ATenantOwned {
    id: number;
    threadId: number;
    runId?: number;
    questionId?: number;
    authorKind: SupportAiVisibleMessageAuthorKind;
    kind: SupportAiVisibleMessageKind;
    body: string;
    secondaryBody?: string;
    payloadJson?: string;
    sourceKey?: string;
    firstUsedByRunId?: number;
    attachments: SavedFile[];
}

// ../../OnixWeb.Domain/Models/AnalysisBalanceForCustomerDto.cs
export interface AnalysisBalanceForCustomerDto {
    due: number;
    period: number;
}

// ../../OnixWeb.Domain/Models/SingleInt.cs
export interface SingleInt {
    value: number;
}

// ../../OnixWeb.Domain/Models/TravelWarrant.cs
export interface TravelWarrant extends ATenantOwnedPantheonSyncResource {
    id: string;
    documentNumber: number;
    date: Date;
    note: string;
    returnNote: string;
    status: TravelWarrantStatus;
    place: string;
    driver: string;
    coDrivers: string;
    vehicle: string;
    travelStartDateTime?: Date;
    travelEndDateTime?: Date;
    travelStartMeter?: number;
    travelEndMeter?: number;
    downPayment?: number;
    downPaymentCurrency?: Currency;
    downPaymentCurrencyId?: number;
    downPaymentConversion?: number;
    placeOfDeparture: string;
    expenseBearer: ExpenseBearer;
    expenseBearerId?: number;
    expenseBearerAllowance: number;
    expenseBearerCurrency: string;
    expenseBearerAllowanceConversion: number;
    country: Country;
    countryId?: number;
    countryAllowance: number;
    countryAllowanceCurrency: string;
    countryAllowanceConversion: number;
    officialVehicle: OfficialVehicle;
    officialVehicleId?: number;
    personalVehicle: PersonalVehicle;
    personalVehicleId?: number;
    applicationUser: ApplicationUser;
    applicationUserId: string;
    travelKilometersConversion: number;
    onixPantheonDMSId?: number;
    lastOpenedAt?: Date;
    lastSentToPantheonAt?: Date;
    lastClosedAt?: Date;
    lastSentToFinalizeAt?: Date;
    pantheonStatus?: string;
    travelWarrantItems: TravelWarrantItem[];
    travelHours: number;
    perDiems: number;
    kilometersTraveled: number;
}

// ../../OnixWeb.Domain/Models/PantheonINI.cs
export interface PantheonINI extends ATenantOwned {
    id: number;
    companyId?: number;
    company: Company;
    INI: string;
    pantheonVersionId?: number;
    pantheonVersion: PantheonVersion;
    note: string;
    license?: PantheonLicense;
    userName: string;
    password: string;
    useMeshCentral: boolean;
    meshCentralGroupId?: string;
    meshCentralGroupName?: string;
    meshCentralServerDeviceId?: string;
    meshCentralServerDeviceName?: string;
    meshCentralSqlPort?: number;
}

// ../../OnixWeb.Domain/Models/TravelWarrantCostType.cs
export interface TravelWarrantCostType extends ATenantOwnedPantheonResource {
    id: number;
    docType: string;
    type: number;
    name: string;
    isDeactivated: boolean;
}

// ../../OnixWeb.Domain/Models/AresDeploymentGroup.cs
export interface AresDeploymentGroup extends ATenantOwned {
    id: number;
    name: string;
    description: string;
    activityCheckSql: string;
    areses: AresDeploymentAres[];
    onixPhoneSettings: AresDeploymentOnixPhoneSettings[];
    installationSteps: AresDeploymentGroupInstallationStep[];
    workflowDefinitions: AresDeploymentWorkflowDefinition[];
    snapshots: AresDeploymentGroupSnapshot[];
    isInvoicedToAccounting: boolean;
    isPublic: boolean;
    minPantheonBuildNo?: number;
    maxPantheonBuildNo?: number;
    isBackgroundInstallable: boolean;
    lastAresTestRunHash: string;
    lastAresTestRunAt?: Date;
    lastAresTestRunPassed?: boolean;
    lastAresTestRunMessage: string;
    lastAresTestCompanySettingsId?: number;
    lastSuccessfulAresTestHash: string;
    lastSuccessfulAresTestRunAt?: Date;
}

// ../../OnixWeb.Domain/Models/CompanySettings.cs
export interface CompanySettings extends HasAuditFields {
    id: number;
    externalId?: string;
    grunfCompanyId?: number;
    connectionName: string;
    tenant?: OnixTenant;
    supportEmailAddress: string;
    supportEmailPassword: string;
    supportIBackupEmailAddress: string;
    supportIBackupEmailPassword: string;
    supportRedirectAllToSender: boolean;
    supportAutoReplyOnNewTicket: boolean;
    supportAutoReplyOnNewTicketSubject?: string;
    supportAutoReplyOnNewTicketBody?: string;
    aiSupportApiKey?: string;
    aiSupportTriageModel?: string;
    aiSupportInvestigationModel?: string;
    aiSupportReasoningEffort?: string;
    aiSupportVerbosity?: string;
    aiSupportRunBudgetMode: AiSupportRunBudgetMode;
    aiSupportMaxToolRounds?: number;
    aiSupportMaxInputTokensPerTurn?: number;
    aiSupportMaxOutputTokensPerTurn?: number;
    aiSupportDefaultTimeoutMinutes?: number;
    travelKilometers: TravelKilometers[];
    workRecordCostTypes: WorkRecordCostType[];
    workRecordPeriods: WorkRecordPeriod[];
    workHours: CompanySettingsWorkHours[];
    applicationPackets: ApplicationPacket[];
    synchronizations: Synchronization[];
    expenseBearers: ExpenseBearer[];
    supportTickets: SupportTicket[];
    users: ApplicationUser[];
    companyEmailForwards: CompanyEmailForward[];
    datalabReferenceCompanies: DatalabReferenceCompany[];
    companyDatalabReferenceLinks: CompanyDatalabReferenceLink[];
    datalabReleaseLockdownRuns: DatalabReleaseLockdownRun[];
    wooCommerceKey: string;
    wooCommerceSecret: string;
    wooCommerceLocation: string;
    timeZone: string;
    culture: string;
    teamViewerScriptKey: string;
    teamViewerClientId: string;
    teamViewerClientSecret: string;
    pantheonAnDocKeyLenNumber: number;
    pantheonAnDocKeyLenDocType: number;
    pantheonCompanyName: string;
    pantheonAcCompanyPrtTextA: string;
    pantheonAcCompanyPrtTextB: string;
    pantheonCompanyImage: number[];
    pantheonCompanyOnixPhoneSmallImage?: number[];
    pantheonAnQtyInCodeLen: number;
    pantheonAnPrStNo: number;
    companyDocumentsEmail: string;
    pantheonCompanyAddress: string;
    teamViewerToken: string;
    teamViewerGroupId: string;
    meshCentralServerUrl?: string;
    meshCentralUsername?: string;
    meshCentralPassword?: string;
    datalabSyncEnabled: boolean;
    datalabUsername?: string;
    datalabPassword?: string;
    datalabBaseUrl?: string;
    datalabReferencePartnerQuery: string;
    bookStackUrl: string;
    additionalBottomTextOnPrint: string;
    fiscCertContent?: number[];
    fiscCertIssuer: string;
    fiscCertSerialNumber: string;
    fiscCertPassword: string;
    fiscCertPrivateKey?: number[];
    onixPhoneEInvoiceEnabled: boolean;
    eInvoiceIssuerVatRegistered?: boolean;
    workOrderItemsAdditionalReportData?: OnixPhoneAdditionalReportData;
    client?: ClientEnum;
    teamViewerRefreshToken: string;
    pantheonAcQtyInCodeCont: string;
    pantheonCompanyPIN: string;
    onixPhoneProxyDBCreated: boolean;
    companyStamp: number[];
    primaryCurrency: string;
    useSecondaryCurrency: boolean;
    companyOutboundEmail: string;
    companyOutboundEmailHost: string;
    companyOutboundEmailUser: string;
    companyOutboundEmailPassword: string;
    companyOutboundEmailPort: number;
    companyOutboundEmailUseSSL: boolean;
    companyOutboundEmailUseTLS: boolean;
    companyOutboundEmailDisplayName: string;
    companySQLConnectionString: string;
    pantheonAnGenerSubjNoLen?: number;
    pantheonAnGenerSubjNoFieldLen?: number;
    pantheonAlsoUseNDigitBarcodes?: number;
    testingFiscalisation?: boolean;
    companyGS1Prefix?: string;
    isMainAresDeploymentDatabase?: boolean;
    isMainAresTestingDatabase?: boolean;
    alternateMainServerPrefix?: string;
    workOrderWorkerPickerIncludesInactiveWorkers: boolean;
}

// ../../OnixWeb.Domain/Models/SupportTicketMessageTaskDto.cs
export interface SupportTicketMessageTaskDto {
    id: number;
    ticketId?: number;
    title: string;
    message: string;
    isDone: boolean;
    dueDate?: Date;
    modifiedOn?: Date;
    createdOn?: Date;
    project: string;
    company: string;
    projectId?: number;
    companyId?: number;
    responsibleAgent: string;
    responsibleAgentId: string;
    sentById: string;
}

// ../../OnixWeb.Domain/Models/ExternalIdentity.cs
export interface ExternalIdentity {
    id: number;
    provider: ExternalAuthProvider;
    providerSubject: string;
    providerTenantId?: string;
    verifiedEmail?: string;
    displayName?: string;
    createdAt: Date;
    lastUsedAt?: Date;
    applicationUsers: ApplicationUserExternalIdentity[];
    externalAuthTickets: ExternalAuthTicket[];
}

// ../../OnixWeb.Domain/Models/CompanySettingsWorkHours.cs
export interface CompanySettingsWorkHours extends ATenantOwned {
    id: number;
    day: DayOfWeek;
    startTime: number;
    endTime: number;
}

// ../../OnixWeb.Domain/Models/Contact.cs
export interface Contact extends ATenantOwned {
    id: number;
    fullName: string;
    note: string;
    deactivated: boolean;
    isMaintenance: boolean;
    isSpam: boolean;
    isIBackup: boolean;
    isPromotionalEmailRecipient: boolean;
    phoneNumbers: ContactPhone[];
    emails: ContactEmail[];
    contactCompanies: ContactCompany[];
    tickets: SupportTicket[];
}

// ../../OnixWeb.Domain/Models/LabelDefinitionLocation.cs
export interface LabelDefinitionLocation extends ATenantOwned {
    id: number;
    labelDefinitionId: number;
    labelDefinition: LabelDefinition;
    documentTypeId: number;
    documentType: DocumentType;
    location: LabelDefinitionLocationEnum;
    labelComposition: LabelComposition;
    labelCompositionId?: number;
}

// ../../OnixWeb.Domain/Models/HitnoAlertItemModel.cs
export interface HitnoAlertItemModel {
    key: string;
    ticketId: number;
    title: string;
    contact: string;
    agent: string;
    user: string;
    reason: string;
    preview: string;
    createdOn?: Date;
    link: string;
    isNew: boolean;
}

// ../../OnixWeb.Domain/Models/AresDeploymentInstallationStepPoint.cs
export interface AresDeploymentInstallationStepPoint extends ATenantOwned {
    id: number;
    aresDeploymentGroupCompanyMappingId?: number;
    aresDeploymentGroupCompanyMapping?: AresDeploymentGroupCompanyMapping;
    aresDeploymentGroupInstallationStepId?: number;
    aresDeploymentGroupInstallationStep?: AresDeploymentGroupInstallationStep;
    variableValue: string;
    supportTicketTimeLogId?: number;
    supportTicketTimeLog?: SupportTicketTimeLog;
}

// ../../OnixWeb.Domain/Models/OXSearchContractPrice.cs
export interface OXSearchContractPrice {
    cRetResult: string;
    cRetSubjekt: string;
    cRetIdent: string;
    cRetTip: string;
    cRetValuta: string;
    nRetCena: number;
    nRetRabat: number;
    cRetFormula: string;
    cRetDobavniRok: number;
    cRetRokPlacila: number;
    dRetDatumOD: Date;
    dRetDatumDO: Date;
    nRetRabat2: number;
    nRetRabat3: number;
    nRetCenaMP: number;
    pNRetDeliveryDeadline: number;
}

// ../../OnixWeb.Domain/Models/OpenAISessionMessage.cs
export interface OpenAISessionMessage extends ATenantOwned {
    id: number;
    message: string;
    sessionId: number;
    session: OpenAISession;
    type: OpenAIMessageType;
}

// ../../OnixWeb.Domain/Models/UserArbitrarySetting.cs
export interface UserArbitrarySetting extends ATenantOwned {
    id: number;
    userId: string;
    user: ApplicationUser;
    alsoIncludeThisPantheonUserOfflineCodebooks?: number;
}

// ../../OnixWeb.Domain/Models/Project.cs
export interface Project extends ATenantOwnedPantheonResource {
    id: number;
    name: string;
    subject: Subject;
    subjectId?: number;
    description: string;
    dueDate: Date;
    tickets: SupportTicket[];
    finished: boolean;
    billable: boolean;
    invoice: boolean;
    model: string;
    HINNumber: string;
    engineModel: string;
    engineSerialNumber: string;
    transmissionModel: string;
    transmissionSerialNumber: string;
}

// ../../OnixWeb.Domain/Models/SingleString.cs
export interface SingleString {
    value: string;
}

// ../../OnixWeb.Domain/Models/Item.cs
export interface Item extends ATenantOwnedPantheonResource {
    id: number;
    code: string;
    name: string;
    department: Department;
    departmentId?: number;
    itemGroupItems: ItemGroupItem[];
}

// ../../OnixWeb.Domain/Models/TicketTaskAssignedModel.cs
export interface TicketTaskAssignedModel {
    id: number;
    ticketId?: number;
    title: string;
    message: string;
    responsibleAgent: ApplicationUser;
    link: string;
    remoteContentSavedFileId?: number;
    desktopLink: string;
}

// ../../OnixWeb.Domain/Models/SubjectReturnDto.cs
export interface SubjectReturnDto {
    id: number;
    address: string;
    country: SubjectReturnDtoCountry;
    countryId?: number;
    mail: string;
    phone: string;
    contactName: string;
    longName: string;
    shortName: string;
    VATID: string;
    VATIDPrefix: string;
}

// ../../OnixWeb.Domain/Models/RatesAPIV2Response.cs
export interface RatesAPIV2Response {
    brojTecajnice: string;
    datumPrimjene: string;
    drzava: string;
    drzavaIso: string;
    sifraValute: string;
    valuta: string;
    jedinica: number;
    kupovniTecaj: string;
    srednjiTecaj: string;
    prodajniTecaj: string;
}

// ../../OnixWeb.Domain/Models/SupportTicketChange.cs
export interface SupportTicketChange extends ATenantOwned {
    id: number;
    supportTicketId: number;
    mergedIntoSupportTicketId?: number;
    hasBeenDeleted: boolean;
}

// ../../OnixWeb.Domain/Models/LabelComposition.cs
export interface LabelComposition extends ATenantOwned {
    id: number;
    name: string;
    SVGTemplate: string;
}

// ../../OnixWeb.Domain/Models/NotificationDeliveryReport.cs
export interface NotificationDeliveryReport extends ATenantOwned {
    id: string;
    notificationType: string;
    FCMTokenId: number;
    FCMToken: FCMToken;
    userId: string;
    user: ApplicationUser;
}

// ../../OnixWeb.Domain/Models/ClientServerWorkHours.cs
export interface ClientServerWorkHours extends ATenantOwned {
    id: number;
    day: DayOfWeek;
    startTime: number;
    endTime: number;
    clientServerServerName: string;
    clientServer: ClientServerStatus;
}

// ../../OnixWeb.Domain/Models/Account.cs
export interface Account extends ATenantOwned {
    id: number;
    code: string;
    name: string;
    userId: string;
    user: ApplicationUser;
    type: AccountType;
}

// ../../OnixWeb.Domain/Models/Department.cs
export interface Department extends ATenantOwned {
    id: number;
    name: string;
    items: Item[];
}

// ../../OnixWeb.Domain/Models/WorkRecordCostType.cs
export interface WorkRecordCostType extends ATenantOwned {
    id: number;
    costType: string;
    active: boolean;
    pantheonCostType: string;
    pantheonName: string;
    pantheonCostGroup: string;
    pantheonCostGroupName: string;
}

// ../../OnixWeb.Domain/Models/FCMToken.cs
export interface FCMToken extends ATenantOwned {
    id: number;
    token: string;
    userId: string;
    user: ApplicationUser;
    notificationDeliveryReport: NotificationDeliveryReport[];
}

// ../../OnixWeb.Domain/Models/THeSetFxRateQuery.cs
export interface THeSetFxRateQuery extends HasAdTimeInsAndAdTimeChgWithoutUser {
    acCurrency: string;
    adDate: Date;
    anFxRateBuy: number;
    anFxRateSale: number;
    anFxRate: number;
}

// ../../OnixWeb.Domain/Models/SupportTimeLogsSync.cs
export interface SupportTimeLogsSync {
    id: number;
    agent: string;
    rac: string;
    datum1: string;
    kupac: string;
    datum2: string;
    grupa: string;
    sati: string;
    opis: string;
    prioritet: string;
    status: string;
}

// ../../OnixWeb.Domain/Models/DocumentTypeLink.cs
export interface DocumentTypeLink extends DocumentTypeBase {
    functionality: DocumentPairFunctionalityEnum;
    applicationUser: ApplicationUser;
    applicationUserId: string;
    linkTo: DocumentType[];
    linkFrom: DocumentType[];
    useLinkSettings: boolean;
}

// ../../OnixWeb.Domain/Models/PortalSignInChallenge.cs
export interface PortalSignInChallenge {
    id: string;
    email: string;
    method: PortalVerificationMethod;
    externalIdentityId?: number;
    externalIdentity?: ExternalIdentity;
    displayName?: string;
    codeHash?: string;
    attempts: number;
    registrationTicketHash?: string;
    createdAt: Date;
    expiresAt: Date;
    verifiedAt?: Date;
    consumedAt?: Date;
    createdIp?: string;
}

// ../../OnixWeb.Domain/Models/RemoteConnection.cs
export interface RemoteConnection extends ATenantOwned {
    id: number;
    name: string;
    server: string;
    database: string;
    userId: string;
    password: string;
    failing: boolean;
    error: string;
    enabled: boolean;
    lastChecked?: Date;
    useTelnet: boolean;
}

// ../../OnixWeb.Domain/Models/PushedSettingsBlock.cs
export interface PushedSettingsBlock {
    appKey: string;
    appSecret: string;
    targetType: string;
}

// ../../OnixWeb.Domain/Models/SupportCannedResponse.cs
export interface SupportCannedResponse extends ATenantOwned {
    id: number;
    title: string;
    content: string;
}

// ../../OnixWeb.Domain/Models/SupportFilter.cs
export interface SupportFilter {
    id: number;
    user: ApplicationUser;
    userId: string;
    filter: string;
    name: string;
}

// ../../OnixWeb.Domain/Models/OnixPhoneKeyValueStorage.cs
export interface OnixPhoneKeyValueStorage {
    id: string;
    userId: string;
    key: string;
    context: string;
    userDocId?: number;
    version: string;
    value: number[];
    isDeletable?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    deletedAt?: Date;
}

// ../../OnixWeb.Domain/Models/DocumentTypeTemplate.cs
export interface DocumentTypeTemplate extends ATenantOwned {
    id: number;
    name: string;
    description?: string;
    isPartial: boolean;
    includedProperties?: string[];
    serializedDocumentType: string;
    type?: string;
    functionality?: DocumentFunctionalityEnum;
    sourceDocumentTypeId?: number;
    createdByUserId?: string;
    createdByUser?: ApplicationUser;
}

// ../../OnixWeb.Domain/Models/TicketTodoIsDueModel.cs
export interface TicketTodoIsDueModel {
    link: string;
    message: string;
    dateTime: Date;
    title: string;
    id: number;
    ticketId?: number;
    user: ApplicationUser;
    desktopLink: string;
}

// ../../OnixWeb.Domain/Models/SingleByteArray.cs
export interface SingleByteArray {
    value: number[];
}

// ../../OnixWeb.Domain/Models/SupportAiThread.cs
export interface SupportAiThread extends ATenantOwned {
    id: number;
    title?: string;
    prompt?: string;
    scopeType: SupportAiThreadScopeType;
    ticketId?: number;
    companyId?: number;
    startedByUserId: string;
    responseMode: SupportAiThreadResponseMode;
    status: SupportAiThreadStatus;
    lastActivityOn: Date;
    lastItemSequence: number;
}

// ../../OnixWeb.Domain/Models/ApplicationUserRole.cs
export interface ApplicationUserRole{
    user: ApplicationUser;
    role: ApplicationRole;
}

// ../../OnixWeb.Domain/Models/MarservisWorkOrder.cs
export interface MarservisWorkOrder extends ATenantOwned {
    id: string;
    documentNumber: number;
    date: Date;
    dateEnd: Date;
    project: Project;
    projectId: number;
    note: string;
    status: MarservisWorkOrderStatusEnum;
    location: string;
    files: SavedFile[];
    items: MarservisWorkOrderItem[];
}

// ../../OnixWeb.Domain/Models/SavedFileDto.cs
export interface SavedFileDto {
    data: number[];
    name: string;
    contentDisposition: string;
    contentType: string;
    maxDim: number;
    publicImage: boolean;
    nameOverride?: string;
    prependOriginalFileName?: boolean;
    keepOriginalExtension?: boolean;
    additionalDirectorySegments?: string;
    savedFileProperty?: string;
    savedFilePropertyValue?: string;
    uniqueClientId: string;
    description?: string;
    isProblemSubmission?: boolean;
    skipProblemSubmissionForwarding?: boolean;
}

// ../../OnixWeb.Domain/Models/ApplicationPacket.cs
export interface ApplicationPacket extends ATenantOwned {
    id: number;
    packet: ApplicationPacketEnum;
    from: Date;
    to: Date;
}

// ../../OnixWeb.Domain/Models/WorkRecordWorkHours.cs
export interface WorkRecordWorkHours extends ATenantOwned {
    id: number;
    day: number;
    workRecordId?: number;
    workHours: number;
    workMinutes: number;
    startTime?: number;
    workRecord: WorkRecord;
    note: string;
}

// ../../OnixWeb.Domain/Models/AresDeploymentAres.cs
export interface AresDeploymentAres extends ATenantOwned {
    id: number;
    aresDeploymentGroup: AresDeploymentGroup;
    aresDeploymentGroupId: number;
    aresDeploymentAresCompanyCurrentVersions: AresDeploymentAresCompanyCurrentVersion[];
    aresAcKey: string;
    aresAcName: string;
    aresVersion: number;
    executeSteps: boolean;
    executionPhase?: AresDeploymentExecutionPhase;
    executionPhaseOrder?: number;
    isSQLExecutionAres: boolean;
    isBoostrapExecutionAres: boolean;
    isTestSuiteAres: boolean;
}

// ../../OnixWeb.Domain/Models/WakaTimeWorklog.cs
export interface WakaTimeWorklog extends ATenantOwned {
    id: number;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    externalProjectName: string;
    internalProjectId?: number;
    internalProject?: Project;
    date: Date;
    duration: number;
    sourceType: WakaTimeWorklogSourceType;
    externalKey: string;
    dismissed: boolean;
    supportTicketId?: number;
    supportTicket?: SupportTicket;
    supportTicketTimeLogId?: number;
    supportTicketTimeLog?: SupportTicketTimeLog;
    summary?: string;
    technicalNote?: string;
    commitCount: number;
    commits: WakaTimeCommit[];
}

// ../../OnixWeb.Domain/Models/QueryResultWrapper.cs
export interface QueryResultWrapper<T> {
    value: T;
}

// ../../OnixWeb.Domain/Models/NewTicketCreatedModel.cs
export interface NewTicketCreatedModel {
    id: number;
    ticketId?: number;
    title: string;
    message: string;
    link: string;
    remoteContentSavedFileId?: number;
    desktopLink: string;
}

// ../../OnixWeb.Domain/Models/ApplicationUserWakaAuthor.cs
export interface ApplicationUserWakaAuthor extends ATenantOwned {
    id: number;
    applicationUserId: string;
    applicationUser: ApplicationUser;
    kind: WakaTimeAuthorKind;
    value: string;
}

// ../../OnixWeb.Domain/Models/Country.cs
export interface Country extends ATenantOwnedPantheonResource {
    id: number;
    name: string;
    currency: string;
    code: string;
}

// ../../OnixWeb.Domain/Models/MarservisWorkOrderItemItem.cs
export interface MarservisWorkOrderItemItem extends ATenantOwned {
    id: number;
    workOrderItemId: number;
    workOrderItem: MarservisWorkOrderItem;
    itemId: number;
    item: Item;
    finished: boolean;
    note: string;
}

// ../../OnixWeb.Domain/Models/CompanyTeamViewerDevice.cs
export interface CompanyTeamViewerDevice extends ATenantOwned {
    id: number;
    company: Company;
    companyId: number;
    remoteControlId: string;
    deviceId: string;
    alias: string;
    groupId: string;
    onlineState: string;
    assignedTo: boolean;
    teamviewerId: number;
}

// ../../OnixWeb.Domain/Models/QueryTableResult.cs
export interface QueryTableResult {
    query: string;
    results: QueryResultSet[];
}

// ../../OnixWeb.Domain/Models/QueryTableResult.cs
export interface QueryResultSet {
    columns: QueryResultColumn[];
    rows: QueryResultRow[];
}

// ../../OnixWeb.Domain/Models/QueryTableResult.cs
export interface QueryResultColumn {
    name: string;
    type: string;
}

// ../../OnixWeb.Domain/Models/QueryTableResult.cs
export interface QueryResultRow {
    values: string[];
}

// ../../OnixWeb.Domain/Models/QueryTableResult.cs
export interface SingleQueryResult {
    column: QueryResultColumn;
    value: string;
}

// ../../OnixWeb.Domain/Models/ApplicationUser.cs
export interface ApplicationUser{
    lastTokenRefresh: Date;
    lastLogin: Date;
    lastPlatform: string;
    lastVersion: string;
    isDeleted: boolean;
    firstName: string;
    id: string;
    userName: string;
    email: string;
    lastName: string;
    language: string;
    supportSignature: string;
    companySettingsId?: number;
    supportEmailAddress: string;
    supportEmailPassword: string;
    alternativeUserId?: string;
    supportNotifyOfNewMessages: boolean;
    timeZone: string;
    culture: string;
    settingsMigratedToMultiSettings: boolean;
    pushedAppKey: string;
    pushedAppSecret: string;
    pushedTargetType: string;
    teamViewerID: string;
    teamViewerSyncEnabled: boolean;
    teamViewerToken: string;
    wakaApiBaseUrl?: string;
    wakaApiKey?: string;
    wakaSyncEnabled: boolean;
    wakaLastSyncAt?: Date;
    wakaLastSyncError?: string;
    ciscoPhoneAdminPath: string;
    bookStackTokenId: string;
    bookStackTokenSecret: string;
    useNewDocumentFlow: boolean;
    responsibleUserId?: string;
    responsibleUser?: ApplicationUser;
    accountingUserId?: string;
    accountingUser?: ApplicationUser;
    alternativeUser: ApplicationUser;
    mobileSettings: MobileSettings;
    pantheonUser: PantheonUser;
    companySettings: CompanySettings;
    workRecordPeriods: WorkRecordPeriod[];
    userRoles: ApplicationUserRole[];
    alternativeUsers: ApplicationUser[];
    responsibleForUsers: ApplicationUser[];
    accountingForUsers: ApplicationUser[];
    userSupportTickets: SupportTicket[];
    temporaryOwnerSupportTickets: SupportTicket[];
    responsibleAgentTicketMessages: SupportTicketMessage[];
    documentTypes: DocumentType[];
    notifiedSupportTicketMessages: SupportTicketMessage[];
    sentSupportTicketMessages: SupportTicketMessage[];
    sentAsSupportTicketMessages: SupportTicketMessage[];
    wakaMachines: ApplicationUserWakaMachine[];
    wakaAuthors: ApplicationUserWakaAuthor[];
    wakaProjectMaps: ApplicationUserWakaProjectMap[];
    wakaTimeCommits: WakaTimeCommit[];
    wakaTimeWorklogs: WakaTimeWorklog[];
    assignedFiles: SavedFile[];
    documentTypePairs: DocumentTypePair[];
    documentTypeLinks: DocumentTypeLink[];
    unreadUserSupportTicketMessages: UnreadUserSupportTicketMessage[];
    supportGroupMembers: SupportGroupMember[];
    onixPhoneUserTasks: OnixPhoneUserTaskQueue[];
    userArbitrarySettings: UserArbitrarySetting[];
    externalIdentities: ApplicationUserExternalIdentity[];
    externalAuthRequestStates: ExternalAuthRequestState[];
    fullName: string;
    lastDevice?: string;
    lastLicenseTakeover: Date;
    licenseTakeoverCount: number;
    automaticLogout: number;
    visualAttributesOverview: string;
    lastRequestSource: string;
    onixDesktopPantheonExePath: string;
    onixDesktopPantheonIniPath: string;
    onixDesktopPantheonExePathMac: string;
    onixDesktopPantheonIniPathMac: string;
    supportOpenAIExecutions: SupportOpenAIExecution[];
    supportTimeLogsAlwaysNonBillable: boolean;
    supportTopBarCountersOpenTicketList?: boolean;
    supportTimeLogRoundingMinutes?: number;
    userAccessHash?: string;
    permanentLoginToken?: string;
    migratedToNewServer?: boolean;
    modifiedBy: string;
    createdBy: string;
    modifiedById: string;
    createdById: string;
    deletedBy: string;
    deletedById: string;
    restoredBy: string;
    restoredById: string;
    modifiedOn?: Date;
    createdOn?: Date;
    deletedOn?: Date;
    restoredOn?: Date;
    FCMTokens: FCMToken[];
    notificationDeliveryReport: NotificationDeliveryReport[];
    isDMSReferenceUser: boolean;
    excludeFromDmsBilling: boolean;
}

// ../../OnixWeb.Domain/Models/RatesAPIEUResponse.cs
export interface RatesAPIEUResponse {
    country: string;
    currency: string;
    ISOA3Code: string;
    ISOA2Code: string;
    value: number;
    comment: string;
}

// ../../OnixWeb.Domain/Models/PantheonConnectionStrings.cs
export interface PantheonConnectionStrings extends Map<string, string> {
}

// ../../OnixWeb.Domain/Models/ExternalAuthRequestState.cs
export interface ExternalAuthRequestState {
    id: number;
    stateHash: string;
    provider: ExternalAuthProvider;
    flowKind: ExternalAuthFlowKind;
    applicationUserId?: string;
    applicationUser?: ApplicationUser;
    appRedirectUri?: string;
    createdAt: Date;
    expiresAt: Date;
    consumedAt?: Date;
}

// ../../OnixWeb.Domain/Models/StockNameForUser.cs
export interface StockNameForUser {
    acSubject: string;
}

// ../../OnixWeb.Domain/Models/PortalServiceKey.cs
export interface PortalServiceKey {
    id: number;
    kind: PortalServiceKeyKind;
    name: string;
    keyHash: string;
    keyPrefix: string;
    companySettingsId?: number;
    createdByUserId?: string;
    createdAt: Date;
    expiresAt?: Date;
    lastUsedAt?: Date;
    revokedAt?: Date;
}

// ../../OnixWeb.Domain/Models/TwoStrings.cs
export interface TwoStrings {
    value1: string;
    value2: string;
}

// ../../OnixWeb.Domain/Models/DocumentTypeArbitraryField.cs
export interface DocumentTypeArbitraryField extends ATenantOwned {
    id: number;
    order: number;
    documentTypeId: number;
    documentType: DocumentType;
    name: string;
    value: string;
    JSValue: string;
    type: string;
    fieldType?: ArbitraryFieldEntryType;
    fieldReference: string;
    fieldRequired: boolean;
    fieldBaseValue: string;
    prefillFromField?: string;
    location: string;
    arbitraryFieldLocation?: ArbitraryFieldLocationEnum;
}

// ../../OnixWeb.Domain/Models/IBackupEventLogComputer.cs
export interface IBackupEventLogComputer extends ATenantOwned {
    id: number;
    name: string;
    companyId?: number;
    company: Company;
}

// ../../OnixWeb.Domain/Models/CompanyTeamViewerContact.cs
export interface CompanyTeamViewerContact extends ATenantOwned {
    id: number;
    company: Company;
    companyId: number;
    teamViewerContactID: string;
    teamViewerContactName: string;
    teamViewerContactDescription: string;
}

// ../../OnixWeb.Domain/Models/SupportTicketMessage.cs
export interface SupportTicketMessage extends ATenantOwned {
    id: number;
    private: boolean;
    attachments: SavedFile[];
    ticketId?: number;
    ticket?: SupportTicket;
    messageId: number;
    globalMessageId: string;
    globalMessageReplyId: string;
    inbound: boolean;
    sentBy: ApplicationUser;
    sentById: string;
    sentAs: ApplicationUser;
    sentAsId: string;
    htmlContent: string;
    textContent: string;
    notifyEmails: string[];
    CCEmails: string[];
    isTask: boolean;
    isTaskDone: boolean;
    isQueryExecution: boolean;
    supportAiThreadId?: number;
    supportAiRunId?: number;
    responsibleAgent: ApplicationUser;
    responsibleAgentId: string;
    taskStart?: Date;
    taskDue?: Date;
    notifyUsers: ApplicationUser[];
    helpLink: string;
    helpTitle: string;
    helpBookId?: number;
    helpId?: number;
    remoteContentSavedFileId?: number;
    internalCommunications: SupportTicketMessage[];
    internalCommunicationTo: SupportTicketMessage;
    internalCommunicationToId?: number;
    originalSender: string;
    originalSenderName: string;
    originalCCs: string;
    originalSubject: string;
    originalReceiver: string;
    originalReceiverName: string;
    collapsed: boolean;
    unreadUserSupportTicketMessage: UnreadUserSupportTicketMessage[];
    content: string;
    outbound: boolean;
    customerHasSeen?: boolean;
    customerHasSeenAt?: Date;
    scheduledSendOn?: Date;
    codexTaskId: string;
    codexTaskLastSeenOn?: Date;
    codexTaskWorkedOn?: Date;
    supportOpenAIExecutions: SupportOpenAIExecution[];
}

// ../../OnixWeb.Domain/Models/QueryStructure.cs
export interface QueryStructure {
    [key: string]: QueryCase;
}

// ../../OnixWeb.Domain/Models/UnreadClientData.cs
export interface UnreadClientData {
    emergencies: number;
    highPriority: number;
    oldTickets: number;
    unread: number;
    delegatedToMe: number;
    waitingFor: number;
    unfinished: number;
    userId: string;
    unassignedUnread: number;
    unfinishedTasks: number;
    companySettingsId?: number;
    unfinishedProjects: number;
    dailyNewTickets: number;
    dailyResolvedTickets: number;
    dailyUnresolvedTickets: number;
}

// ../../OnixWeb.Domain/Models/TimeLogTemplate.cs
export interface TimeLogTemplate extends ATenantOwned {
    id: number;
    templateName: string;
    time: number;
    note: string;
    technicalNote: string;
    type: string;
    userId?: string;
    user?: ApplicationUser;
}

// ../../OnixWeb.Domain/Models/UserDeviceChange.cs
export interface UserDeviceChange extends HasAuditFields {
    id: number;
    userName: string;
    userId: string;
    lastDevice: string;
    newDevice: string;
}

// ../../OnixWeb.Domain/Models/MaintenanceWindowNoticeRecipient.cs
export interface MaintenanceWindowNoticeRecipient {
    noticeId: number;
    notice: MaintenanceWindowNotice;
    userId: string;
    companySettingsId?: number;
    taskId?: number;
    submissionUncertain: boolean;
    submitted: boolean;
    lastAttemptAtUtc?: Date;
    lastError?: string;
}

// ../../OnixWeb.Domain/Models/CompanyMeshCentralDeviceRoute.cs
export interface CompanyMeshCentralDeviceRoute extends ATenantOwned {
    id: number;
    companyId: number;
    company: Company;
    companyMeshCentralGroupMappingId: number;
    companyMeshCentralGroupMapping: CompanyMeshCentralGroupMapping;
    meshCentralGroupId: string;
    meshCentralGroupName: string;
    meshCentralDeviceId: string;
    meshCentralDeviceName: string;
    name?: string;
    routeType: MeshCentralDeviceRouteTypeEnum;
    remotePort: number;
}

// ../../OnixWeb.Domain/Models/SavedFile.cs
export interface SavedFile extends ATenantOwned {
    id: number;
    path: string;
    local: boolean;
    name: string;
    contentType: string;
    contentDisposition: string;
    public: boolean;
    CID?: string;
    FTP: boolean;
    onixPantheonDMS: boolean;
    description: string;
    isProblemSubmission: boolean;
    supportTicketMessage: SupportTicketMessage;
    supportTicketMessageId?: number;
    supportTicketTimeLog: SupportTicketTimeLog;
    supportTicketTimeLogId?: number;
    supportAiThreadMessage: SupportAiThreadMessage;
    supportAiThreadMessageId?: number;
    supportAiThreadItem?: SupportAiThreadItem;
    supportAiThreadItemId?: number;
    travelWarrantItem: TravelWarrantItem;
    travelWarrantItemId?: number;
    workOrder: MarservisWorkOrder;
    workOrderId?: string;
    workOrderItemWork: MarservisWorkOrderItemWork;
    workOrderItemWorkId?: number;
    companyDocument: Company;
    companyDocumentId?: number;
    uniqueClientId: string;
    codeMagicArtifact: boolean;
    uploadedByUserId: string;
    wikiEntryId?: number;
    wikiEntry: WikiEntry;
    companyRunbookNoteId?: number;
    companyRunbookNote: CompanyRunbookNote;
    savedFileContentId?: string;
    savedFileContent?: SavedFileContent;
    users: ApplicationUser[];
    serverPath: string;
}

// ../../OnixWeb.Domain/Models/TravelWarrantPDFItem.cs
export interface TravelWarrantPDFItem {
    value: number;
    conversion: number;
    notForPayment: boolean;
    date: Date;
    note: string;
    currency: string;
}

// ../../OnixWeb.Domain/Models/WikiEntry.cs
export interface WikiEntry extends ATenantOwned {
    id: number;
    title: string;
    contentId: number;
    files: SavedFile[];
    tags: WikiEntryTag[];
    categoryId?: number;
    category?: WikiEntryCategory;
}

// ../../OnixWeb.Domain/Models/SupportMessageSignatureProfile.cs
export interface SupportMessageSignatureProfile extends ATenantOwned {
    id: number;
    normalizedSenderEmail: string;
    normalizedSenderDomain: string;
    signatureHash: string;
    boundaryKind: string;
    seenCount: number;
    trusted: boolean;
    firstMessageId?: number;
    lastMessageId?: number;
    firstSeenOn?: Date;
    lastSeenOn?: Date;
}

// ../../OnixWeb.Domain/Models/WikiEntryTag.cs
export interface WikiEntryTag extends ATenantOwned {
    id: number;
    name: string;
    description: string;
    wikiEntries: WikiEntry[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMove.cs
export interface THeMove extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    acNote: string;
    adDate?: Date;
    acDocType: string;
    anValue: number;
    anDiscount: number;
    acDoc2: string;
    anQid: number;
    acDoc1: string;
    acNote2: string;
    anVat: number;
    anForPay: number;
    acReceiver: string;
    acCurrency: string;
    acDelivery: string;
    anClerk?: number;
    acPayMethod: string;
    acPrsn3: string;
    anNoteClerk?: number;
    acCostDrvOut: string;
    acIssuer: string;
    acVerifyStatus: string;
    acFiscStatus: string;
    acVerifiedPrices: string;
    acContactPrsn: string;
    acContactPrsn3: string;
    acDept: string;
    acDeptOut: string;
    acFieldSA: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    acFieldSF: string;
    acFieldSg: string;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSJ: string;
    anFieldNA?: number;
    anFieldNB?: number;
    anFieldNc?: number;
    anFieldNd?: number;
    anFieldNe?: number;
    anFieldNf?: number;
    anFieldNg?: number;
    anFieldNh?: number;
    anFieldNi?: number;
    anFieldNj?: number;
    adFieldDA?: Date;
    adFieldDb?: Date;
    adFieldDc?: Date;
    adFieldDd?: Date;
    anSigner1?: number;
    anSigner2?: number;
    anSigner3?: number;
    anRebate: number;
    acParity: string;
    tHeMoveItem: THeMoveItem[];
    anClerkNavigation: THeSetSubjContact;
    acDeliveryNavigation: THeSetDelMet;
    acPayMethodNavigation: THeSetPayMet;
    acReceiverNavigation: THeSetSubj;
    acPrsn3Navigation: THeSetSubj;
    anNoteClerkNavigation: THeSetSubjContact;
    tHeLinkMoveMoveAcKeyNavigation: THeLinkMoveMove[];
    tHeLinkMoveMoveAcLnkKeyNavigation: THeLinkMoveMove[];
    tHeMoveItemExciseOuts: THeMoveItemExciseOut[];
    tHeMoveItemExcises: THeMoveItemExcise[];
    acCostDrvOutNavigation: THeCostDrv;
    adDateTimePrint?: Date;
    adDateDue?: Date;
    adDateDoc1?: Date;
    adDateDoc2?: Date;
    tHeMoveFiscalisation: THeMoveFiscalisation;
    acDeptNavigation: THeSetSubj;
    acDeptOutNavigation: THeSetSubj;
    acIssuerNavigation: THeSetSubj;
    acPosted: string;
    tHeMoveRmaworkSpecs: TrimTHeMoveRmaworkSpec[];
    tHeMovePaymentRecords: THeMovePaymentRecord[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemSnt.cs
export interface THeSetItemSnt {
    acColumn: string;
    acName: string;
    acType: string;
    adTimeChg?: Date;
    anUserChg?: number;
    adTimeIns?: Date;
    anUserIns?: number;
    anQid: number;
    tHeSetItemSntitems: THeSetItemSntitem[];
    tHeSetItemSntserialNos: THeSetItemSntserialNo[];
    tHeSetItems: THeSetItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSetDocType.cs
export interface TPaSetDocType extends HasAdTimeInsAndAdTimeChgWithUser {
    acDocType: string;
    acIssuer: string;
    acReceiver: string;
    acSetOf: string;
    acRmashowWorkSpec: string;
    acName: string;
    acWorkPlace: string;
    acFiscalDevice: string;
    acLinkDocName1: string;
    acLinkDocName2: string;
    acReceiverName: string;
    acIssuerName: string;
    acName3: string;
    acType: string;
    documentType: DocumentTypeEnum;
    tMnDocuments: TMnDocument[];
    tPaSetDocTypeStats: TPaSetDocTypeStat[];
    tHfWoexes: THfWoex[];
    tHfPlans: THfPlan[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaWorkflowDefinition.cs
export interface TPaWorkflowDefinition {
    anId: number;
    acWorkflow: string;
    acName: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acNote: string;
    acIdentify: string;
    acIcon: string;
    anCbid?: number;
    adUploadDate?: Date;
    tPaWorkflowIntegrates: TPaWorkflowIntegrate[];
}

// ../../OnixWeb.Domain/Models/Pantheon/VOpMoveBank.cs
export interface VOpMoveBank {
    ackey: string;
    total: number;
    payerNameAndSurname: string;
    payerAddress: string;
    payerPostNumAndPlace: string;
    receiverName: string;
    receiverAddress: string;
    receiverPostNumAndPlace: string;
    receiverBank: string;
    receiverCallOnNum: string;
    purposeText: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnFileLocal.cs
export interface TMnFileLocal {
    onixFileIdentifier: string;
    onixFileContent: number[];
    tMnFileId?: number;
    tMnFile: TMnFile;
    externalFileIdentifier: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetUm.cs
export interface THeSetUm {
    acUm: string;
    acName: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acInterUm: string;
    acFiscalCode: string;
    anMinValue?: number;
    anQid: number;
    acUmoriginal: string;
    acStdUm: string;
    anDecPlaces: number;
    acInterUm2: string;
    tHeSetItemAcUmNavigations: THeSetItem[];
    tHeSetItemAcUm2Navigations: THeSetItem[];
    tHfWoexes: THfWoex[];
    tHfWoexItemAcUmNavigations: THfWoexItem[];
    tHfWoexItemAcUm3Navigations: THfWoexItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THfPlan.cs
export interface THfPlan {
    acKey: string;
    acDocType: string;
    adDate?: Date;
    acName: string;
    acConsignee: string;
    acReceiver: string;
    acDept: string;
    acCostDrv: string;
    anClerk: number;
    adSchedStartTime?: Date;
    adSchedEndTime?: Date;
    acStatus: string;
    acPlannedBom: string;
    adPlannedBomtime?: Date;
    acScheduled: string;
    adScheduledTime?: Date;
    acPlannedCap: string;
    adPlannedCapTime?: Date;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    acDescr: string;
    anQid: number;
    acParentPlan: string;
    acKeyView: string;
    acConsigneeNavigation: THeSetSubj;
    acCostDrvNavigation: THeCostDrv;
    acDeptNavigation: THeSetSubj;
    acDocTypeNavigation: TPaSetDocType;
    acParentPlanNavigation: THfPlan;
    acReceiverNavigation: THeSetSubj;
    anClerkNavigation: THeSetSubjContact;
    inverseAcParentPlanNavigation: THfPlan[];
    tHfWoexes: THfWoex[];
}

// ../../OnixWeb.Domain/Models/Pantheon/VHeMoveFiscalisation.cs
export interface VHeMoveFiscalisation {
    acKey: string;
    acJir: string;
    adFiscalDate?: Date;
    acError: string;
    acHrfiskalNumber: string;
    acSifiskalNumber: string;
    acZik: string;
    acYearInv: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/OxMerdownloadReport.cs
export interface OxMerdownloadReport {
    imeFirme: string;
    oibfirme: string;
    tipDokumenta: string;
    dmsoznaka: string;
    greska: string;
    subjekt: string;
    brojDokumenta: string;
    vrijemeSlanja?: Date;
    acReportType: string;
    acReportStatus: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaUserGroup.cs
export interface TPaUserGroup {
    anUserGroup: number;
    acName: string;
    acNote: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acProfile: string;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaUser.cs
export interface TPaUser {
    anUserId: number;
    acUserId: string;
    acSubject: string;
    acTitle: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acAgencySignedBy: string;
    acDept: string;
    acCerTime: string;
    acCerPub: string;
    acLangId: string;
    acActive: string;
    acProfile: string;
    acWeb: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetSubjContactAddress.cs
export interface THeSetSubjContactAddress {
    acSubject: string;
    anNo: number;
    anSubNo: number;
    acType: string;
    acPhone: string;
    acNote: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    anQid: number;
    acSubjectAnNoNavigation: THeSetSubjContact;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeLinkMoveItemOrderItem.cs
export interface THeLinkMoveItemOrderItem extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acLnkKey: string;
    anLnkNo: number;
    acType: string;
    acTypeA: string;
    acTypeB: string;
    adDate?: Date;
    anQty: number;
    anMoveItemQid: number;
    anOrderItemQid: number;
    a: THeMoveItem;
    aNavigation: THeOrderItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnFile.cs
export interface TMnFile {
    anQid: number;
    anDocumentQid: number;
    anDocumentQ: TMnDocument;
    acFileGuid: string;
    acFileName: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anFileSize?: number;
    tMnFileLocal?: TMnFileLocal;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeCashReg.cs
export interface THeCashReg {
    acKey: string;
    acDocType: string;
    acType: string;
    adDate?: Date;
    acSubject: string;
    acDept: string;
    acPayMethod: string;
    anClerk?: number;
    anValue: number;
    anPaid: number;
    anRefund: number;
    acDoc1: string;
    adDateDoc1?: Date;
    acDoc2: string;
    adDateDoc2?: Date;
    acCurrency: string;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    acNote: string;
    acLocked: string;
    acStatus: string;
    anQid: number;
    anDocYear: number;
    anDocNo?: number;
    tHeCashRegItems: THeCashRegItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetSubj.cs
export interface THeSetSubj extends HasAdTimeInsAndAdTimeChgWithUser {
    anQid: number;
    acSubject: string;
    acName2: string;
    acAddress: string;
    acPost: string;
    acPin: string;
    acBuyer: string;
    acBuyerLimitCtrl: string;
    anLimit?: number;
    acPayer: string;
    acActive: string;
    anRebate: number;
    anClerk?: number;
    acCountry: string;
    acVatCodePrefix: string;
    acPhone: string;
    acWarehouse: string;
    acCode: string;
    acFieldSa: string;
    acFieldSf: string;
    acPriceRate: string;
    acDept: string;
    acSupplier: string;
    acSubjTypeBuyer: string;
    acCurrency: string;
    acWayOfSale: string;
    acDelivery?: string;
    acSubjTypeSupp: string;
    acFax?: string;
    acHttpPath?: string;
    anLatitude?: number;
    anLongitude?: number;
    acPayMethod: string;
    acSkis: string;
    anDaysForPayment: number;
    adFieldDa?: Date;
    adFieldDb?: Date;
    adFieldDc?: Date;
    adFieldDd?: Date;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    acFieldSg: string;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSj: string;
    anFieldNa: number;
    anFieldNb: number;
    anFieldNc: number;
    anFieldNd: number;
    anFieldNe: number;
    anFieldNf: number;
    anFieldNg: number;
    anFieldNh: number;
    anFieldNi: number;
    anFieldNj: number;
    acPayMethodNavigation: THeSetPayMet;
    tHeStockRes: THeStock[];
    tHeOrderAcConsigneeNavigation: THeOrder[];
    tHeOrderAcDeptNavigation: THeOrder[];
    tHeMoveAcDeptNavigation: THeMove[];
    tHeMoveAcDeptOutNavigations: THeMove[];
    tHeMoveAcIssuerNavigation: THeMove[];
    acPostNavigation: THeSetPostCode;
    tHeMoveAcReceiverNavigation: THeMove[];
    tHeMoveAcPrsn3Navigation: THeMove[];
    tHeCostDrvAcConsigneeNavigation: THeCostDrv[];
    tHeCostDrvAcDeptNavigation: THeCostDrv[];
    anClerkNavigation: THeSetSubjContact;
    tHeSetSubjContactAcSubjectNavigations: THeSetSubjContact[];
    tHeSetSubjPriceItem: THeSetSubjPriceItem[];
    tHeOrderAcReceiverNavigation: THeOrder[];
    acPayerNavigation: THeSetSubj;
    inverseAcPayerNavigation: THeSetSubj[];
    acSubjTypeBuyerNavigation: THeSetSubjType;
    tHeSetSubjPriceCategs: THeSetSubjPriceCateg[];
    tHfWoexAcConsigneeNavigations: THfWoex[];
    tHfWoexAcDeptNavigations: THfWoex[];
    tHfWoexAcReceiverNavigations: THfWoex[];
    tHfWoexItems: THfWoexItem[];
    tHfPlanAcConsigneeNavigations: THfPlan[];
    tHfPlanAcDeptNavigations: THfPlan[];
    tHfPlanAcReceiverNavigations: THfPlan[];
    tHrPrsnAcWorkerNavigation: THrPrsn;
    tHeSubjTypes: THeSubjType[];
}

// ../../OnixWeb.Domain/Models/Pantheon/VHeMoveOut.cs
export interface VHeMoveOut {
    acKey: string;
    acDocType: string;
    adDate?: Date;
    acReceiver: string;
    acIssuer: string;
    acReceiverStock: string;
    acIssuerStock: string;
    acPrsn3: string;
    acContactPrsn: string;
    acDoc1: string;
    adDateDoc1?: Date;
    acDoc2: string;
    adDateDoc2?: Date;
    acStatement: string;
    acWayOfSale: string;
    acPriceRate: string;
    acPayMethod: string;
    acDelivery: string;
    acForm: string;
    acInvoiceForm: string;
    adDateInv?: Date;
    anDaysForPayment: number;
    adDateDue?: Date;
    anValue: number;
    anVat: number;
    anDiscount: number;
    anForPay: number;
    acLimitDuty: string;
    anClerk?: number;
    acVerifiedPrices: string;
    acCurrency: string;
    anCurrValue: number;
    anFxrate: number;
    acCode1: string;
    acCode2: string;
    acCode3: string;
    acPayPurpose1: string;
    acPayPurpose2: string;
    acPayPurpose3: string;
    acRefNo1: string;
    acRefNo2: string;
    acDept: string;
    acContactPrsn3: string;
    anRebate: number;
    anTransport: number;
    anDuty: number;
    anDirectCost: number;
    anIncTax: number;
    acPosted: string;
    acTransPaperForm: string;
    anVatin: number;
    adDateVat?: Date;
    acParity: string;
    acParityPost: string;
    anVatbase: number;
    anBnkAcctNo: number;
    acCreatFromWo: string;
    adDateBeforeVat?: Date;
    acIsocountry: string;
    acTriangTrans: string;
    acAcctClaimLiab: string;
    acVatattType: string;
    adVatattDate?: Date;
    acCreatePayOrd: string;
    acDeptOut: string;
    acCostDrvOut: string;
    anNoteClerk?: number;
    acVerifyStatus: string;
    acNoteClerkName: string;
    acUserChgName: string;
    adDateDdvpay?: Date;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acNote: string;
    acContractNo: string;
    acIdbcstate: string;
    acRoundVatonDoc: string;
    anOurBankAcctNo?: number;
    anOurBankAcctNoFgn?: number;
    acKeyView: string;
    anCalcSum?: number;
    anCalcDiscPrc?: number;
    anRoundItem: number;
    anRoundValue: number;
    acRefNo3: string;
    acRefNo4: string;
    acPackNum: string;
    acInternalNote: string;
    acReceiverName2: string;
    acIssuerName2: string;
    acPrsn3Name2: string;
    anSigner1?: number;
    adSigned1?: Date;
    anSigner2?: number;
    adSigned2?: Date;
    anSigner3?: number;
    adSigned3?: Date;
    acFiskPrintNo: string;
    acFiskPrintNoS: string;
    acTransportCalcType: string;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    acFieldSf: string;
    acFieldSg: string;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSj: string;
    anFieldNa?: number;
    anFieldNb?: number;
    anFieldNc?: number;
    anFieldNd?: number;
    anFieldNe?: number;
    anFieldNf?: number;
    anFieldNg?: number;
    anFieldNh?: number;
    anFieldNi?: number;
    anFieldNj?: number;
    adFieldDa?: Date;
    adFieldDb?: Date;
    adFieldDc?: Date;
    adFieldDd?: Date;
    acProc: string;
    acParityType: string;
    acXmldocType: string;
    acNote2: string;
    acNote3: string;
    acZik: string;
    acJir: string;
    adTimeFiscal?: Date;
    acDocTypeStatusName: string;
    acStatus: string;
    anSeqWhNoIn?: number;
    anSeqWhNoOut?: number;
    anRoundItemFc: number;
    acDeliveryUnderArt163A: string;
    anRoundValueOc: number;
    anRoundPrice: number;
    acUjpdocId: string;
    adDateTimePrint?: Date;
    acFiscSalesBookDocNo: string;
    acFiscSalesBookSetNo: string;
    acFiscSalesBookSerNo: string;
    anState: number;
    acFiscalNumber: string;
    anPermissionSelect: boolean;
    anReverseChargeCoefficient?: number;
    acTransporter: string;
    acVehicleRegistrationNumber: string;
    acTrailerRegistrationNumber: string;
    acNaturalPersonR: string;
    acNaturalPerson3: string;
    acWayOfSaleR: string;
    acWayOfSale3: string;
    anQidGdprlogS0?: number;
    anQidGdprlogS1?: number;
    anQidGdprlogS2?: number;
    acNaturalPersonI: string;
    acLoyaltyCard: string;
    acFiscStatus: string;
    acRetailSale: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMoveItemSerialNo.cs
export interface THeMoveItemSerialNo extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acType: string;
    acSnwotype: string;
    acSerialNo: string;
    acIdent: string;
    acPackage: string;
    anQty: number;
    anUserChg?: number;
    anPackQty?: number;
    adDateDue: Date;
    anQid: number;
    anStockPrice?: number;
    a: THeMoveItem;
    acIdentNavigation: THeSetItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMoveFiscalisation.cs
export interface THeMoveFiscalisation {
    acKey: string;
    acWorkPlace: string;
    anFiscalDevice: number;
    anFiscalNumber: number;
    acZik: string;
    acJir: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anQid?: number;
    acDocType: string;
    acYearInv: string;
    acError: string;
    adFiscalDate?: Date;
    acFiscalDevice: string;
    acBarcode: string;
    anFiscVersion: number;
    anQidTemplate?: number;
    acCustomTemplate: string;
    acKeyNavigation: THeMove;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetPayMet.cs
export interface THeSetPayMet extends HasAdTimeInsAndAdTimeChgWithUser {
    anQid: number;
    acPayMethod: string;
    acName: string;
    acFiscalGroup: string;
    acIsPosTerminal: string;
    acPaymentType: string;
    tHeOrder: THeOrder[];
    tHeMove: THeMove[];
    tHeCashRegItems: THeCashRegItem[];
    tHeSetSubjAcPayMethodNavigations: THeSetSubj[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnDocument.cs
export interface TMnDocument {
    anQid: number;
    acKey: string;
    acDocType: string;
    adDate?: Date;
    adDateDue?: Date;
    acSubject: string;
    acNote: string;
    anClerk?: number;
    anClassifIcationQid: number;
    acStatus: string;
    anMailBoxQid?: number;
    acDeleted: string;
    acTitle: string;
    acGuid: string;
    anStorageQid: number;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anMailBoxQ: TMnMailbox;
    anStorageQ: TMnStorage;
    anClassifIcationQ: TMnSetClassification;
    tMnDocumentMetaData: TMnDocumentMetaDatum[];
    tMnLinkDocumentsWfs: TMnLinkDocumentsWf[];
    tMnFiles: TMnFile[];
    acDocTypeNavigation: TPaSetDocType;
    tMnDocumentChatLogs: TMnDocumentChatLog[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TOpFile.cs
export interface TOpFile {
    fileId: number;
    content: number[];
    rowGuid: string;
    acKey: string;
    fileCategory: string;
    fileName: string;
    note: string;
    anUserId?: number;
    tOpFileGroupId?: number;
    tOpFileGroup: TOpFileGroup;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemSntitem.cs
export interface THeSetItemSntitem {
    acColumn: string;
    acSerialNo: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anSeqNo?: number;
    anQid: number;
    acColumnNavigation: THeSetItemSnt;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaWorkflowTaskInstance.cs
export interface TPaWorkflowTaskInstance {
    anId: number;
    adCreatedOn?: Date;
    anUserId?: number;
    acComments: string;
    acName: string;
    acTitle: string;
    acDescription: string;
    anWorkflowInstanceKey?: number;
    anWorkflowDefinitionKey?: number;
    acCompleted: string;
    adModifiedOn?: Date;
    acModifiedUserId: string;
    anTaskVersion?: number;
    acTask: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    tMnDocumentMetaData: TMnDocumentMetaDatum[];
    tMnLinkDocumentsWfs: TMnLinkDocumentsWf[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemExtItemSubj.cs
export interface THeSetItemExtItemSubj extends HasAdTimeInsAndAdTimeChgWithUser {
    anQid: number;
    acIdent: string;
    acCode: string;
    acName: string;
    acType: string;
    acSubject: string;
    packageQuantity?: number;
    acIdentNavigation: THeSetItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeAcctTran.cs
export interface THeAcctTran {
    acKey: string;
    acDocType: string;
    adDate: Date;
    adDateOfEntry?: Date;
    anClerk?: number;
    anDebit: number;
    anCredit: number;
    acLocked: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acNote: string;
    anQid: number;
    acKeyView: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THrSetTrvlDum.cs
export interface THrSetTrvlDum {
    acDailyAllow: string;
    adDate: Date;
    anPriceTo?: number;
    anKm?: number;
    anPriceAbove?: number;
    acCurrency: string;
    adTimeChg?: Date;
    adTimeIns?: Date;
    anUserChg?: number;
    anUserIns?: number;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeCashRegItem.cs
export interface THeCashRegItem {
    acKey: string;
    anNo: number;
    acName: string;
    acPayMethod: string;
    anAmount: number;
    acLnkKey: string;
    acAcct: string;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    acCostDrv: string;
    acDept: string;
    anEventTypeId?: number;
    acLinkDoc: string;
    anQid: number;
    acTrvlType: string;
    acPayMethodNavigation: THeSetPayMet;
    acKeyNavigation: THeCashReg;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqlistepFile.cs
export interface TPaSqlistepFile {
    acKey: string;
    anNo: number;
    anSeqNo: number;
    acHfield: string;
    acHtype: string;
    anHlength: number;
    anHdec: number;
    acPfield: string;
    acPtype: string;
    anPlegth: number;
    anPdec: number;
    acPformat: string;
    acPseparator: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/VPnSaldo.cs
export interface VPnSaldo {
    acKey: string;
    opis: string;
    povezaniDokument: string;
    iznos?: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/THrPrsn.cs
export interface THrPrsn extends HasAdTimeInsAndAdTimeChgWithUser {
    acWorker: string;
    acActive: string;
    acName: string;
    acSurname: string;
    acRegNo: string;
    acWorkerNavigation: THeSetSubj;
    tHrPrsnStatuses: THrPrsnStatus[];
    tHrTrvls: THrTrvl[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSysMenu.cs
export interface TPaSysMenu {
    acMenuParent: string;
    anNo: number;
    acMenu: string;
    acDescr: string;
    acHint: string;
    anShortcut?: number;
    acAuthorisations: string;
    anVisible?: boolean;
    acType: string;
    acOperation: string;
    acUserMenu: string;
    acIconName: string;
    acLangId: string;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnLinkMnemoTrvl.cs
export interface TMnLinkMnemoTrvl {
    anQid: number;
    anTrvlQid: number;
    anDocumentQid: number;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSysParam.cs
export interface TPaSysParam extends HasAdTimeInsAndAdTimeChgWithUser {
    acCompanyImage: number[];
    acCustomLogoImage: number[];
    acCompanyPrtTextB: string;
    acCompanyPrtTextA: string;
    acVatcodeWithoutTaxInc: string;
    anDocKeyLenNumber?: number;
    anDocKeyLenDocType?: number;
    acOurCompany: string;
    anQtyInCodeLen: number;
    acQtyInCodeCont: string;
    acPrimCurrency: string;
    acFiscalServer: string;
    anGenerSubjNoLen: number;
    anGenerSubjNoFieldLen: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMoveItemExciseOut.cs
export interface THeMoveItemExciseOut {
    acKey: string;
    anNo: number;
    anNoCost: number;
    acType: string;
    acTransportCalcType: string;
    acInCalcRvc: string;
    acIncBase: string;
    anValue: number;
    anValuePercent: number;
    anPvvalue: number;
    anPvocvalue: number;
    anUserIns?: number;
    anUserChg?: number;
    adTimeIns?: Date;
    adTimeChg?: Date;
    acCurrency: string;
    acBaseType: string;
    acSetOfTax: string;
    anQty?: number;
    adDate?: Date;
    acUm: string;
    acIncStockValue: string;
    anQid: number;
    acKeyNavigation: THeMove;
    acSetOfTaxNavigation: THeSetDuty;
    tHeMoveItemNavigation: THeMoveItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemExcise.cs
export interface THeSetItemExcise {
    acIdent: string;
    anNo: number;
    anValue: number;
    anValuePercent: number;
    anUserIns?: number;
    anUserChg?: number;
    adTimeIns?: Date;
    adTimeChg?: Date;
    acSetOfTax: string;
    anQid: number;
    acIdentNavigation: THeSetItem;
    acSetOfTaxNavigation: THeSetDuty;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetDocText.cs
export interface THeSetDocText extends HasAdTimeInsAndAdTimeChgWithUser {
    acStatement: string;
    anUserChg?: number;
    acName: string;
    acDesc: string;
    anQid: number;
    acActive: string;
    acEdocument: string;
    tHeSetTaxes: THeSetTax[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnLinkDocumentsWf.cs
export interface TMnLinkDocumentsWf {
    anQid: number;
    anTaskInstId: number;
    anDocumentQid: number;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anWorkInstId?: number;
    anDocumentQ: TMnDocument;
    anTaskInst: TPaWorkflowTaskInstance;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMoveItem.cs
export interface THeMoveItem extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acIdent: string;
    anRebate: number;
    anRebate1: number;
    anRebate2: number;
    anRebate3: number;
    acNote: string;
    acName: string;
    anQty: number;
    anQid: number;
    anPrice: number;
    acUm: string;
    anVat: number;
    anPvvalue?: number;
    anPvvatbase?: number;
    acCostDrv: string;
    anPackQty: number;
    anPriceCurrency: number;
    acUM2: string;
    anPvforPay: number;
    anPvexcise: number;
    anPvdiscount: number;
    anPvocforPay: number;
    anPvocvat: number;
    anPvocvatbase: number;
    anPvocdiscount: number;
    anPvocvalue: number;
    anPvvat: number;
    anPvocexcise: number;
    anPvoctransport: number;
    anPvocduty: number;
    anPvocincVat: number;
    anPvocdirectCost: number;
    anPvocbeatShare: number;
    anPvocnonBeatShare: number;
    anPvocfixPriceDiff: number;
    anPvocstockValue: number;
    anPvocsuppExcise: number;
    anPvocsuppExciseIncSv: number;
    anPvocincVatwoExc: number;
    anPvocvatbaseWoExc: number;
    anPvocforPayWoExc: number;
    anPvocsuppExciseIncVb: number;
    anPvocsuppExciseNonIncVb: number;
    anPvocbeatShareWoExc: number;
    anPvocnonBeatShareWoExc: number;
    anRtprice: number;
    anExcise: number;
    anExciseP: number;
    anInRtprice: number;
    anRetailPrice: number;
    anExciseInc?: number;
    anExciseNotInc?: number;
    anExciseIncP?: number;
    anExciseNotIncP?: number;
    anPvocsuppExciseNonIncVbincSuppForPay?: number;
    anPvocsuppExciseIncVbincSuppForPay?: number;
    acKeyNavigation: THeMove;
    acIdentNavigation: THeSetItem;
    tHeLinkMoveItemOrderItem: THeLinkMoveItemOrderItem[];
    tHeLinkMoveItemMoveItemANavigations: THeLinkMoveItemMoveItem[];
    tHeLinkMoveItemMoveItemAs: THeLinkMoveItemMoveItem[];
    tHeMoveItemSerialNo: THeMoveItemSerialNo[];
    acVatcode: string;
    acVatcodeTr: string;
    acVatcodeNavigation: THeSetTax;
    acVatcodeTrNavigation: THeSetTax;
    anWarrenty: number;
    anDimWeight: number;
    tHeMoveItemExciseOut: THeMoveItemExciseOut;
}

// ../../OnixWeb.Domain/Models/Pantheon/VOpSetBoatName.cs
export interface VOpSetBoatName {
    acsubject: string;
    acBoatName: string;
    anLenght?: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetCurrency.cs
export interface THeSetCurrency extends HasAdTimeInsAndAdTimeChgWithUser {
    acCurrency: string;
    acName: string;
    anUnit: number;
    acCode: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemPriceForWrh.cs
export interface THeSetItemPriceForWrh extends HasAdTimeInsAndAdTimeChgWithUser {
    anQid: number;
    acIdent: string;
    acWarehouse: string;
    anRtprice: number;
    anSalePrice: number;
    anBuyPrice?: number;
    acIdentNavigation: THeSetItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/THrLinkTrvlTrvl.cs
export interface THrLinkTrvlTrvl {
    acKey: string;
    anNo: number;
    acLnkKey: string;
    anLnkNo: number;
    acType: string;
    acTypeA: string;
    acTypeB: string;
    anFieldNa: number;
    anFieldNb: number;
    anUserId?: number;
    adDate?: Date;
    acValue: string;
    anUserChg?: number;
    adTimeIns?: Date;
    adTimeChg?: Date;
    anUserIns?: number;
    anQid: number;
    acKeyNavigation: THrTrvl;
    acLnkKeyNavigation: THrTrvl;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnDocumentMetaDatum.cs
export interface TMnDocumentMetaDatum {
    anQid: number;
    anDocumentQid: number;
    anTaskInstId?: number;
    anClassificationMetaQid: number;
    acValue: string;
    anUserId: number;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acValue2: string;
    anClassificationMetaQ: TMnSetClassificationMetaDatum;
    anDocumentQ: TMnDocument;
    anTaskInst: TPaWorkflowTaskInstance;
}

// ../../OnixWeb.Domain/Models/Pantheon/THfWoexItem.cs
export interface THfWoexItem {
    acKey: string;
    anNo: number;
    anVariant: number;
    acUm: string;
    acIdent: string;
    acUm3: string;
    acUmtime: string;
    anPlanQty: number;
    anQty?: number;
    anQtySe?: number;
    anPrice?: number;
    anRebate?: number;
    anFieldNax?: number;
    anWasteQtySe?: number;
    anWasteQty?: number;
    anPlanWasteQty?: number;
    anVariantSubLvl?: number;
    anQty1?: number;
    anQty3?: number;
    anBatch?: number;
    anQtyBase3?: number;
    acQtyFormula: string;
    anQtyBase?: number;
    acDescr: string;
    acOperationType: string;
    acDelayType: string;
    anDelayQty?: number;
    acRuleId: string;
    adSchedStartTime?: Date;
    adSchedEndTime?: Date;
    acScrapIdent: string;
    anScrapPrc?: number;
    anPlanScrapQty?: number;
    anScrapQty?: number;
    anWastePrc?: number;
    acIssueFinished: string;
    acAutoPrepType: string;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    anFieldNa?: number;
    anFieldNb?: number;
    anFieldNc?: number;
    acNote: string;
    adTimeIns?: Date;
    adTimeChg?: Date;
    anUserChg?: number;
    anUserIns?: number;
    anActive?: number;
    acFieldSe: string;
    anPrcValue?: number;
    anQid: number;
    acIssuer: string;
    acGroupResursId: string;
    adEarliestStartTime?: Date;
    adLatestEndTime?: Date;
    acFixedResource: string;
    acFixedTime: string;
    acPhenologicalPhase: string;
    acAgriculturalReason: string;
    acTaskState: string;
    acOrigin: string;
    anQidFertType?: number;
    anFixedScrapQty: number;
    anFixedWasteQty: number;
    acKeyView: string;
    acIdentNavigation: THeSetItem;
    acIssuerNavigation: THeSetSubj;
    acKeyNavigation: THfWoex;
    acScrapIdentNavigation: THeSetItem;
    acUm3Navigation: THeSetUm;
    acUmNavigation: THeSetUm;
    tHfWoexItemSerialNos: THfWoexItemSerialNo[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetCustTariff.cs
export interface THeSetCustTariff {
    acCustTariff: string;
    acName: string;
    acSetOfTax: string;
    anRate: number;
    acAcctEdchaInvoInCr: string;
    acAcctEdchaInvoOutCr: string;
    anExcisePercent: number;
    anExciseValue: number;
    acPreloman: string;
    acUm: string;
    acAffilDept: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acDescr: string;
    acEeequipment: string;
    anQid: number;
    acDisabled: string;
    acSuperiorCustTariff: string;
    acSetOfTaxNavigation: THeSetDuty;
    tHeSetItems: THeSetItem[];
    tHeSetCustTariffSaleExes: THeSetCustTariffSaleEx[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMoveRmaworkSpec.cs
export interface THeMoveRmaworkSpec extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acWorker: string;
    adWorkStart?: Date;
    adWorkEnd?: Date;
    adTravelStart?: Date;
    adTravelEnd?: Date;
    anMileage?: number;
    anUserIns?: number;
    anUserChg?: number;
    acIdent: string;
    acNote: string;
    anQid: number;
    anWork?: number;
    acIdentNavigation: THeSetItem;
    acKeyNavigation: THeMove;
}

// ../../OnixWeb.Domain/Models/Pantheon/OnixInfoAdditionalTHeSetSubjData.cs
export interface OnixInfoAdditionalTHeSetSubjData {
    acSubject: string;
    subject: OnixInfoAdditionalTHeSetSubjDataSubj;
    data1: string;
    data2: string;
    data3: string;
    data4: string;
    data5: string;
    data6: string;
    data7: string;
    data8: string;
    data9: string;
    data10: string;
    data11: string;
    data12: string;
    data13: string;
    data14: string;
    data15: string;
    data16: string;
    data17: string;
    data18: string;
    data19: string;
    data20: string;
    data21: string;
    data22: string;
    data23: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaWorkflowIntegrate.cs
export interface TPaWorkflowIntegrate {
    anQid: number;
    anWorkflowId: number;
    acType: string;
    acName: string;
    acLink: string;
    acValue: string;
    acOperator: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anCbid?: number;
    anCbidWorkflow?: number;
    acWizardType: string;
    anWorkflow: TPaWorkflowDefinition;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetSubjPriceItem.cs
export interface THeSetSubjPriceItem extends HasAdTimeInsAndAdTimeChgWithUser {
    anQid: number;
    acSubject: string;
    acIdent: string;
    acInvoInOut: string;
    adDateStart: Date;
    adDateEnd?: Date;
    anRebate: number;
    anPrice: number;
    anSalePrice?: number;
    acIdentNavigation: THeSetItem;
    acSubjectNavigation: THeSetSubj;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnMailbox.cs
export interface TMnMailbox {
    anQid: number;
    acName: string;
    acSubject: string;
    acType: string;
    anDirection?: number;
    acGuid: string;
    acIcon: string;
    anClassificationQid?: number;
    anLoginsQid?: number;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acIdentify: string;
    anTransferId?: number;
    acDocTypeOrder: string;
    acDocTypeIssue: string;
    anClassificationQ: TMnSetClassification;
    tMnDocuments: TMnDocument[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeLinkMoveItemMoveItem.cs
export interface THeLinkMoveItemMoveItem extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acLnkKey: string;
    anLnkNo: number;
    acType: string;
    acTypeA: string;
    acTypeB: string;
    adDate?: Date;
    anQty: number;
    a: THeMoveItem;
    aNavigation: THeMoveItem;
    anMoveItemChildQid: number;
    anMoveItemParentQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMovePaymentRecord.cs
export interface THeMovePaymentRecord extends HasAuditFields {
    id: number;
    tHeMove: THeMove;
    tHeMoveAcKey: string;
    paymentResponse: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/OnixGS1AIs.cs
export interface OnixGS1AIs {
    AI: string;
    description: string;
    format: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqlipcu.cs
export interface TPaSqlipcu {
    acName: string;
    acDescription: string;
    acPcu: number[];
    acCompiled: string;
    anQid: number;
    acPas: number[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THrTrvlItemDailyAllow.cs
export interface THrTrvlItemDailyAllow {
    acKey: string;
    anNo: number;
    acDailyAllow: string;
    acCurrency: string;
    anFxrate?: number;
    anPriceFieldBonus?: number;
    anDayAllowNo?: number;
    anPriceDailyAllow?: number;
    acBreakfast: string;
    acLunch: string;
    acDinner: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anId: number;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnStorage.cs
export interface TMnStorage {
    anQid: number;
    acName: string;
    acUrl: string;
    acGuid: string;
    anLoginsQid?: number;
    acIdentify: string;
    acDescription: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    tMnDocuments: TMnDocument[];
    tMnSetClassifications: TMnSetClassification[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeOrderItem.cs
export interface THeOrderItem extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acIdent: string;
    anRebate: number;
    anRebate1: number;
    anRebate2: number;
    anRebate3: number;
    acNote: string;
    acName: string;
    anQty: number;
    anPrice: number;
    acUm: string;
    anVat: number;
    anPvvalue?: number;
    anPvvatbase?: number;
    anPackQty: number;
    acUM2: string;
    anQtyDispDoc: number;
    acVatcode: string;
    acLnkKey: string;
    anLnkNo: number;
    anExcise: number;
    anExciseP: number;
    anSalePrice: number;
    adDeliveryDeadline?: Date;
    adDeliveryDate?: Date;
    acDept: string;
    acCostDrv: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anVariant: number;
    anDimVolume: number;
    anDimWeight: number;
    anDimWeightBrutto: number;
    acOrigin: string;
    anRetailPrice: number;
    anPriceCurrency?: number;
    anPvdiscount?: number;
    anPvexcise?: number;
    anPvvat?: number;
    anPvforPay?: number;
    anPvocvalue?: number;
    anPvocdiscount?: number;
    anPvocexcise?: number;
    anPvocvatbase?: number;
    anPvocvat?: number;
    anPvocforPay?: number;
    anRtprice?: number;
    anReserved: number;
    anExciseInc?: number;
    anExciseNotInc?: number;
    anExciseIncP?: number;
    anExciseNotIncP?: number;
    anQid: number;
    anQtyConverted?: number;
    acUmconverted: string;
    anLastprice?: number;
    acPriority: string;
    anUmdecPlaces?: number;
    acKeyNavigation: THeOrder;
    acIdentNavigation: THeSetItem;
    tHeLinkMoveItemOrderItem: THeLinkMoveItemOrderItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetTax.cs
export interface THeSetTax {
    acVatcode: string;
    acVatnoCode: string;
    acName: string;
    anVat: number;
    acIsVatcalc: string;
    acVatnotAdmit: string;
    acIsVatcount: string;
    acAcctCr: string;
    acAcctInclVatdb: string;
    acAcctInclVatcr: string;
    acIsService: string;
    acRealEstate: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acFa: string;
    acLumpCompen: string;
    acBanato: string;
    acVateu: string;
    acDistSaleEu: string;
    acSerExpDisp: string;
    acPartialTax: string;
    acOtherServices: string;
    acStatement: string;
    acVatcalcReceiver: string;
    acIntlTrans: string;
    acPrintPosOnDocs: string;
    acFiscalCode: string;
    acVatpost: string;
    acInvestive: string;
    acPublicInterest: string;
    acExemptions: string;
    acFreed: string;
    acFaownUsage: string;
    acOtherPayFreed: string;
    anQid: number;
    acLicenses: string;
    acTypeOfVatRate: string;
    acNewTransportMeans: string;
    acTourismAgency: string;
    acUsedMotorVehicle: string;
    acUsedGoods: string;
    anVatpdv?: number;
    acScrap: string;
    acNonChargable: string;
    acSpecSchema: string;
    acIpafond: string;
    acShipping: string;
    acOverallAssets: string;
    acOtherPreliminary: string;
    acDeductibility: string;
    acHideRecapitulation: string;
    acElectronicServ: string;
    acSyntheticsGoods: string;
    acInternationalShipping: string;
    acLegalTransactions: string;
    acTaxDebt: string;
    acFoodDonation: string;
    acUnauthVat: string;
    acDistingVat: string;
    acField37: string;
    acAnnulment: string;
    acBefReg: string;
    acVatafterDeduction: string;
    acInitialStock: string;
    acVatrefund: string;
    acActive: string;
    acVatadjustments: string;
    acBadDebt: string;
    acDebitCreditNote: string;
    acShowVatdeducInreceive: string;
    acAsls: string;
    acStatementNavigation?: THeSetDocText;
    tHeMoveItemAcVatcodeNavigations: THeMoveItem[];
    tHeMoveItemAcVatcodeTrNavigations: THeMoveItem[];
    tHeSetItemAcVatcodeNavigations: THeSetItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqliformName.cs
export interface TPaSqliformName {
    acFormName: string;
    acName: string;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TDeSetAccount.cs
export interface TDeSetAccount extends HasAdTimeInsAndAdTimeChgWithUser {
    acAcct: string;
    acName: string;
    anPlanId: number;
    acPermitPost: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THrPrsnStatus.cs
export interface THrPrsnStatus {
    acWorker: string;
    acStatus: string;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    anQid: number;
    acWorkerNavigation: THrPrsn;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeAcctTransItem.cs
export interface THeAcctTransItem extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acAcct: string;
    anDebit: number;
    anCredit: number;
    anValDebit: number;
    anValCredit: number;
    acSubject: string;
    acLinkDoc: string;
    adDateDoc: Date;
    acCurrency: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSubjType.cs
export interface THeSubjType {
    acSubject: string;
    acSubjType: string;
    acType: string;
    anSortNo?: number;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anQId: number;
    subject: THeSetSubj;
    subjTypeNavigation: THeSetSubjType;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeCostDrv.cs
export interface THeCostDrv extends HasAdTimeInsAndAdTimeChgWithUser {
    acCostDrv: string;
    acName: string;
    acStatus: string;
    acConsignee: string;
    acDept: string;
    acFieldSa: string;
    anFieldNa?: number;
    acClassif: string;
    acConsigneeNavigation: THeSetSubj;
    acDeptNavigation: THeSetSubj;
    tHeMove: THeMove[];
    tHfWoexes: THfWoex[];
    tHfPlans: THfPlan[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetDelMet.cs
export interface THeSetDelMet extends HasAdTimeInsAndAdTimeChgWithUser {
    acDelivery: string;
    acName: string;
    acAtactive: string;
    anUserIns?: number;
    anUserChg?: number;
    acTransport: string;
    acActive: string;
    anQid: number;
    tHeOrder: THeOrder[];
    tHeMove: THeMove[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeStockSerialNo.cs
export interface THeStockSerialNo extends HasAdTimeInsAndAdTimeChgWithUser {
    anQid: number;
    acWarehouse: string;
    acIdent: string;
    acSerialNo: string;
    adDateDue: Date;
    anStock: number;
    acFree: string;
    anReserved: number;
    acIdentNavigation: THeSetItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnDocumentChatLog.cs
export interface TMnDocumentChatLog {
    anQid: number;
    anDocumentQid: number;
    anUserId: number;
    adDateCreated: Date;
    acMessage: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anDocumentQ: TMnDocument;
    anUser: THeSetSubjContact;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItem.cs
export interface THeSetItem extends HasAdTimeInsAndAdTimeChgWithUser {
    acIdent: string;
    acName: string;
    acNote: string;
    anWsprice: number;
    acUm: string;
    anRebate: number;
    anRtPrice: number;
    anDimHeight: number;
    acCode: string;
    acSetOfItem: string;
    acClassif: string;
    acClassif2: string;
    acCurrency: string;
    acFieldSj: string;
    acFieldSi: string;
    acFieldsA: string;
    anFieldNj: number;
    anUmtoUm2: number;
    acUm2: string;
    acActive: string;
    anSubClassif: number;
    acSupplier: string;
    acFormula: string;
    anVat: number;
    anSalePrice: number;
    anRtprice: number;
    anWsprice2: number;
    anPrStPrice: number;
    anProdPrice?: number;
    anBuyPrice: number;
    acVatcode: string;
    acVatcodeLow: string;
    anDiscount: number;
    anWarrenty: number;
    acSerialNo: string;
    acHttppath: string;
    acMakeCalc: string;
    anPrice: number;
    anTransport: number;
    anDuty: number;
    anDirectCost: number;
    anIncTax: number;
    anWsprice2P: number;
    anWspriceP: number;
    anRtpriceP: number;
    anMinStock: number;
    acStandardize: string;
    acDocTypeOrdSupp: string;
    acDocTypeProd: string;
    anDimWidth: number;
    anDimDepth: number;
    anDimWeight: number;
    anDimWeightBrutto: number;
    acCustTariff: string;
    anPriceSupp: number;
    anPrStPriceP: number;
    acPurchCurr: string;
    acOrderTransInMf: string;
    acOrigin: string;
    acDeclarForOriginType: string;
    acAcct: string;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    anFieldNa: number;
    anFieldNb: number;
    acEvidence: string;
    anExcise: number;
    anExciseP: number;
    anMaxStock: number;
    anOptStock: number;
    acDeclarForOrigin: string;
    acDept: string;
    acQtyInCode: string;
    acUmdim1: string;
    acUmdim2: string;
    anWasteQty: number;
    acUmseries: string;
    anQtySeries: number;
    acColumn: string;
    anUmtoUm3: number;
    acUm3: string;
    anUmtoDeclarReport: number;
    acReportDeclar: string;
    anFieldNc: number;
    anFieldNd: number;
    anFieldNe: number;
    acFieldSd: string;
    acFieldSe: string;
    acPrstUmtime: string;
    anPrstTime?: number;
    anPrStInsertUserId?: number;
    adPrStInsertTime?: Date;
    anPrStUpdateUserId?: number;
    adPrStUpdateTime?: Date;
    anPrStCheckUserId?: number;
    adPrStCheckTime?: Date;
    anPrStVariantValid: number;
    anPrStOptimalQty: number;
    anPrStDailyQty: number;
    anUnionDeadline: number;
    anDeliveryDeadline: number;
    anPosqty: number;
    acShowAtena: string;
    acAcctIncome: string;
    acInFlowOutFlow: string;
    anFieldNf: number;
    anFieldNg: number;
    acFieldSf: string;
    acFieldSg: string;
    acFieldSh: string;
    anFieldNh: number;
    anFieldNi: number;
    anFixPriceDiff: number;
    anQtyInCodeDecPlace: number;
    anOrderMinQty: number;
    anOrderOptQty: number;
    acCostDrv: string;
    acPacking: string;
    anPurExciseE: number;
    anPurExciseA: number;
    anPurExciseT: number;
    anBeatShare: number;
    adTimeIns?: Date;
    anUserIns?: number;
    anUserChg?: number;
    acIsReturnPack: string;
    acEnvrmntCost: string;
    acWastePack: string;
    acWstEeequip: string;
    acUsedTyre: string;
    acVehiclePart: string;
    acPackSlopak: string;
    acPackSlopaktype: string;
    acUmmarkLabel: string;
    anQtyMarkLabel?: number;
    acPrstPrice: string;
    anPlucode?: number;
    acTechProcedure: string;
    acDescr: string;
    anMaxRebate: number;
    acDateDue: string;
    anMonthDue?: number;
    acDroe: string;
    acDroesubject: string;
    adFieldDa?: Date;
    adFieldDb?: Date;
    adFieldDc?: Date;
    adFieldDd?: Date;
    anMinMargin: number;
    anPosQtyStep?: number;
    adDiscountBegin?: Date;
    adDiscountEnd?: Date;
    acDocTypeIssue: string;
    acEnableChgPrSt: string;
    anPlucode2?: number;
    anBuyRebate2?: number;
    anBuyRebate3?: number;
    anSaleRebate2?: number;
    anSaleRebate3?: number;
    acQtyNotToKol: string;
    anQid: number;
    acBackPacking: string;
    acFormulaRt: string;
    acAcctNotTaxDeduct: string;
    acClassProdByAct: string;
    acBullId: string;
    acPosprinterId: string;
    acBst: string;
    acVatcodeReceive: string;
    anVatreceive: number;
    acWeighableItem: string;
    anAllowedWastage?: number;
    acSerialnoDueType: string;
    acPackagingType: string;
    acTransferredWs: string;
    anColorCode?: number;
    abIcon: number[];
    anAllowedInvShort: number;
    acAcctBuyVasale: string;
    anPackWeight?: number;
    anPackWasteWeight?: number;
    anDiscountPrice: number;
    anDiscountPriceRt: number;
    acPicture?: number[];
    acClassifNavigation: THeSetItemCateg;
    tHeStock: THeStock[];
    tHeStockSerialNos: THeStockSerialNo[];
    tHeSetItemExtItemSubj: THeSetItemExtItemSubj[];
    tHeOrderItem: THeOrderItem[];
    tHeMoveItem: THeMoveItem[];
    tHeMoveItemSerialNo: THeMoveItemSerialNo[];
    tHeSetItemPriceForWrh: THeSetItemPriceForWrh[];
    tHeSetSubjPriceItem: THeSetSubjPriceItem[];
    tHeSetItemExcises: THeSetItemExcise[];
    acVatCodeNavigation: THeSetTax;
    acCustTariffNavigation: THeSetCustTariff;
    acColumnNavigation: THeSetItemSnt;
    acSetOfItemNavigation: THeSetItemType;
    acUmNavigation: THeSetUm;
    acUm2Navigation: THeSetUm;
    tHfWoexAcIdentNavigations: THfWoex[];
    tHfWoexAcLnkPrStIdentParentNavigations: THfWoex[];
    tHfWoexAcScrapIdentNavigations: THfWoex[];
    tHfWoexItemAcIdentNavigations: THfWoexItem[];
    tHfWoexItemAcScrapIdentNavigations: THfWoexItem[];
    tHfWoexItemSerialNos: THfWoexItemSerialNo[];
}

// ../../OnixWeb.Domain/Models/Pantheon/FISBarcodeScanning.cs
export interface FISBarcodeScanning {
    id: number;
    anUserId: number;
    barcode: string;
    scannedAt: Date;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetCustTariffSaleEx.cs
export interface THeSetCustTariffSaleEx {
    acCustTariff: string;
    acSetOfTax: string;
    anExcisePercent: number;
    anExciseValue: number;
    adDate: Date;
    anQty: number;
    acUm: string;
    acBaseType: string;
    acCurrency: string;
    acAcctEdchaInvoInCr: string;
    acAcctEdchaInvoOutCr: string;
    anUserIns?: number;
    anUserChg?: number;
    adTimeIns?: Date;
    adTimeChg?: Date;
    anQid: number;
    adDateTo?: Date;
    anRate?: number;
    acCustTariffNavigation: THeSetCustTariff;
}

// ../../OnixWeb.Domain/Models/Pantheon/THrTrvl.cs
export interface THrTrvl extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    acDocType: string;
    adDate?: Date;
    acWorker: string;
    acCarRegNo: string;
    acCompanyCar: string;
    acPayer: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acDept: string;
    acViacle: string;
    acConfrm: string;
    adDateCalc?: Date;
    anBnkAcctNo?: number;
    acCode1: string;
    acCode2: string;
    acCode3: string;
    acRefNo1: string;
    acRefNo2: string;
    acApproved: string;
    anApprovedBy: number;
    acStatus: string;
    anBnkAcctNoComp?: number;
    acPlaceStart: string;
    acPlaceFinish: string;
    acUpnRfcode: string;
    acVersion: string;
    acUpnRfcodeA: string;
    acSumHours: string;
    acPrivatCar: string;
    anjobId?: number;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    acFieldSf: string;
    acFieldSg: string;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSj: string;
    anTrvl01?: number;
    anTrvl02?: number;
    anTrvl03?: number;
    anTrvl04?: number;
    anTrvl05?: number;
    anTrvl06?: number;
    anTrvl07?: number;
    anTrvl08?: number;
    anTrvl09?: number;
    anTrvl10?: number;
    acViacleType: string;
    acPosted: string;
    acLinkDoc: string;
    acForeignDoc: string;
    anIrisShow?: number;
    acBnkAcctType: string;
    acVerifyStatus: string;
    acInsertedFrom: string;
    acKeyView: string;
    anQid: number;
    tHrTrvlItems: THrTrvlItem[];
    tHrLinkTrvlTrvlAcKeyNavigations: THrLinkTrvlTrvl[];
    tHrLinkTrvlTrvlAcLnkKeyNavigations: THrLinkTrvlTrvl[];
    acWorkerNavigation: THrPrsn;
}

// ../../OnixWeb.Domain/Models/Pantheon/VPnCard.cs
export interface VPnCard {
    acKey: string;
    datum: Date;
    opis: string;
    povezaniDokument: string;
    uplataAkontacija: number;
    obračun?: number;
    obračunAkontacija?: number;
    razlika?: number;
    uplata: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TOpFileGroup.cs
export interface TOpFileGroup {
    id: number;
    note: string;
    anUserId?: number;
    tmndocumentAnQid?: number;
    files: TOpFile[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THrTrvlUndo.cs
export interface THrTrvlUndo {
    dlLastCh: Date;
    dlTypeCh: string;
    dlUserCh: number;
    acKey: string;
    acDocType: string;
    adDate?: Date;
    acWorker: string;
    adDateCalc?: Date;
    anjobId?: number;
    acCarRegNo: string;
    acCompanyCar: string;
    acPayer: string;
    acVerifyStatus: string;
    acDept: string;
    acViacle: string;
    acConfrm: string;
    acApproved: string;
    anApprovedBy: number;
    anBnkAcctNo?: number;
    acCode1: string;
    acCode2: string;
    acCode3: string;
    acRefNo1: string;
    acRefNo2: string;
    acBnkAcctType: string;
    acStatus: string;
    acPlaceStart: string;
    acPlaceFinish: string;
    anBnkAcctNoComp?: number;
    acUpnRfcode: string;
    acVersion: string;
    acUpnRfcodeA: string;
    acSumHours: string;
    acPrivatCar: string;
    acKeyView: string;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    acFieldSf: string;
    acFieldSg: string;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSj: string;
    anTrvl01?: number;
    anTrvl02?: number;
    anTrvl03?: number;
    anTrvl04?: number;
    anTrvl05?: number;
    anTrvl06?: number;
    anTrvl07?: number;
    anTrvl08?: number;
    anTrvl09?: number;
    anTrvl10?: number;
    acViacleType: string;
    acPosted: string;
    acLinkDoc: string;
    acForeignDoc: string;
    anIrisShow?: number;
    acInsertedFrom: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnSetClassificationMetaDatum.cs
export interface TMnSetClassificationMetaDatum {
    anQid: number;
    anClassificationQid: number;
    anSequence?: number;
    acVarName: string;
    acDisplayName: string;
    acHint: string;
    acSetter: string;
    acMandatory: string;
    acDefaultValue: string;
    acSetterDataType: string;
    acVisible: string;
    acDocumentFieldSync: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anClassificationQ: TMnSetClassification;
    tMnDocumentMetaData: TMnDocumentMetaDatum[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THfSetParam2.cs
export interface THfSetParam2 {
    anQid: number;
    abUseStockPrice?: boolean;
    abEvaluateScrap?: boolean;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anPrStNo?: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/pHE_SearchContrctPriceDto.cs
export interface pHE_SearchContrctPriceDto {
    cTipCenik: string;
    cSubjekt: string;
    cIdent: string;
    cKlasif: string;
    cTipPartnerja: string;
    dDatum: Date;
    classif2: boolean;
    acClassif2: string;
    acClassif: string;
    cRetResult: string;
    cRetSubjekt: string;
    cRetTip: string;
    cRetValuta: string;
    nRetCena?: number;
    nRetRabat?: number;
    cRetFormula: string;
    cRetDobavniRok?: number;
    cRetRokPlacila?: number;
    dRetDatumOD?: Date;
    dRetDatumDO?: Date;
    nRetRabat2?: number;
    nRetRabat3?: number;
    nRetCenaMP?: number;
    pNRetDeliveryDeadline?: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/DbFile.cs
export interface DbFile {
    fileId: number;
    fileName: string;
    content: number[];
    acKey: string;
    fileCategory: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetDuty.cs
export interface THeSetDuty {
    acSetOfTax: string;
    acName: string;
    acDutyType: string;
    acIncBase: string;
    adTimeChg?: Date;
    adTimeIns?: Date;
    anUserChg?: number;
    anUserIns?: number;
    acIncStockValue: string;
    acInCalcRvc: string;
    acHrspendTax: string;
    acHrdeposit: string;
    acHrsubType: string;
    anQid: number;
    acIncSuppForPay: string;
    tHeMoveItemExciseOuts: THeMoveItemExciseOut[];
    tHeSetItemExcise: THeSetItemExcise[];
    tHeSetCustTariffs: THeSetCustTariff[];
}

// ../../OnixWeb.Domain/Models/Pantheon/OxScans.cs
export interface OxScan {
    id: number;
    scanContent: string;
    scanDate: Date;
    acKey: string;
    anNo: number;
    anUserId: number;
    fullScanContent?: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THfWoexItemSerialNo.cs
export interface THfWoexItemSerialNo {
    acKey: string;
    anNo: number;
    acType: string;
    acSnwotype: string;
    acSerialNo: string;
    acIdent: string;
    acPackage: string;
    anQty: number;
    adTimeIns?: Date;
    anUserIns?: number;
    anUserChg?: number;
    adTimeChg?: Date;
    anPackQty?: number;
    adDateDue: Date;
    anQid: number;
    anMultiIssueId: number;
    a: THfWoexItem;
    acIdentNavigation: THeSetItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetCountry.cs
export interface THeSetCountry extends HasAdTimeInsAndAdTimeChgWithUser {
    acCountry: string;
    acCurrency: string;
    acIsocitizenship: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/VHeMove.cs
export interface VHeMove {
    acKey: string;
    acDocType: string;
    adDate?: Date;
    acReceiver: string;
    acIssuer: string;
    acReceiverStock: string;
    acIssuerStock: string;
    acPrsn3: string;
    acContactPrsn: string;
    acDoc1: string;
    adDateDoc1?: Date;
    acDoc2: string;
    adDateDoc2?: Date;
    acStatement: string;
    acWayOfSale: string;
    acPriceRate: string;
    acPayMethod: string;
    acDelivery: string;
    acForm: string;
    acInvoiceForm: string;
    adDateInv?: Date;
    anDaysForPayment: number;
    adDateDue?: Date;
    anValue: number;
    anVat: number;
    anDiscount: number;
    anForPay: number;
    acLimitDuty: string;
    anClerk?: number;
    acVerifiedPrices: string;
    acCurrency: string;
    anCurrValue: number;
    anFxrate: number;
    acCode1: string;
    acCode2: string;
    acCode3: string;
    acPayPurpose1: string;
    acPayPurpose2: string;
    acPayPurpose3: string;
    acRefNo1: string;
    acRefNo2: string;
    acDept: string;
    acContactPrsn3: string;
    anRebate: number;
    anTransport: number;
    anDuty: number;
    anDirectCost: number;
    anIncTax: number;
    acPosted: string;
    acTransPaperForm: string;
    anVatin: number;
    adDateVat?: Date;
    acParity: string;
    acParityPost: string;
    anVatbase: number;
    anBnkAcctNo: number;
    acCreatFromWo: string;
    adDateBeforeVat?: Date;
    acIsocountry: string;
    acTriangTrans: string;
    acAcctClaimLiab: string;
    acVatattType: string;
    adVatattDate?: Date;
    acCreatePayOrd: string;
    acDeptOut: string;
    acCostDrvOut: string;
    anNoteClerk?: number;
    acVerifyStatus: string;
    acNoteClerkName: string;
    acUserChgName: string;
    adDateDdvpay?: Date;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acDutyTran: string;
    acNote: string;
    acContractNo: string;
    acRoundVatonDoc: string;
    acKeyView: string;
    anRoundItem: number;
    anRoundValue: number;
    acRefNo3: string;
    acRefNo4: string;
    acPackNum: string;
    acDocTypePayOrd: string;
    acDocTypePayOrdFgn: string;
    anOurBankAcctNo?: number;
    anOurBankAcctNoFgn?: number;
    acInternalNote: string;
    acReceiverName2: string;
    acIssuerName2: string;
    acPrsn3Name2: string;
    anFgnBankNo?: number;
    anSigner1?: number;
    adSigned1?: Date;
    anSigner2?: number;
    adSigned2?: Date;
    anSigner3?: number;
    adSigned3?: Date;
    acFiskPrintNo: string;
    acFiskPrintNoS: string;
    acTransportCalcType: string;
    acUpnreference: string;
    acUpncode: string;
    acUpncontrolNum: string;
    acProc: string;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    acFieldSf: string;
    acFieldSg: string;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSj: string;
    anFieldNa?: number;
    anFieldNb?: number;
    anFieldNc?: number;
    anFieldNd?: number;
    anFieldNe?: number;
    anFieldNf?: number;
    anFieldNg?: number;
    anFieldNh?: number;
    anFieldNi?: number;
    anFieldNj?: number;
    adFieldDa?: Date;
    adFieldDb?: Date;
    adFieldDc?: Date;
    adFieldDd?: Date;
    acParityType: string;
    acXmldocType: string;
    acNote2: string;
    acNote3: string;
    anLicensesBase?: number;
    anLicensesVat?: number;
    acDocTypeStatusName: string;
    acStatus: string;
    anSeqWhNoIn?: number;
    anSeqWhNoOut?: number;
    anRoundItemFc: number;
    acDeliveryUnderArt163A: string;
    anRoundValueOc: number;
    anRoundPrice: number;
    acUjpdocId: string;
    acFiscSalesBookSetNo: string;
    acFiscSalesBookSerNo: string;
    acFiscSalesBookDocNo: string;
    anState: number;
    anPermissionSelect: boolean;
    anReverseChargeCoefficient?: number;
    acNaturalPersonI: string;
    acNaturalPerson3: string;
    acNaturalPersonR: string;
    acWayOfSaleI: string;
    acWayOfSale3: string;
    acWayOfSaleR: string;
    anQidGdprlogS0?: number;
    anQidGdprlogS1?: number;
    anQidGdprlogS2?: number;
    acLoyaltyCard: string;
    acFiscStatus: string;
    acRetailSale: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetSubjContact.cs
export interface THeSetSubjContact extends HasAdTimeInsAndAdTimeChgWithUser {
    acSubject: string;
    anNo: number;
    acActive: string;
    acName: string;
    acSurname: string;
    acMiddle: string;
    acPrefix: string;
    acUserId: string;
    acPassword: string;
    acDefLang: string;
    acAtorder: string;
    acAtstock: string;
    acAtcash: string;
    acAtinvoice: string;
    acAtcalendar: string;
    acPersonal: string;
    acAppl: string;
    adBday?: Date;
    acFunction: string;
    acBankBranch: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acWorkerContact: string;
    anUserId: number;
    acDept: string;
    acAgencySignedBy: string;
    anUserGroup?: number;
    acLangId: string;
    acCerTime: string;
    acCerPub: string;
    acRegNo: string;
    anMaxRebate?: number;
    acWebUserId: string;
    acPhoto: number[];
    acLicDataBase: string;
    acProfile: string;
    acPost: string;
    anQid: number;
    acPin: string;
    acSignature: number[];
    acCode: string;
    acAdditPersonMark: string;
    adGdprconfirm?: Date;
    acForeigner: string;
    acSubjectNavigation: THeSetSubj;
    tHeOrderAnClerkNavigation: THeOrder[];
    tHeOrderAnNoteClerkNavigation: THeOrder[];
    tHeMoveAnClerkNavigation: THeMove[];
    tHeMoveAnNoteClerkNavigation: THeMove[];
    tHeSetSubjAnClerkNavigation: THeSetSubj[];
    tHeSetSubjContactAddresses: THeSetSubjContactAddress[];
    tHfPlans: THfPlan[];
    tMnDocumentChatLogs: TMnDocumentChatLog[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMoveCash.cs
export interface THeMoveCash {
    acKey: string;
    anNo: number;
    acPayMethod: string;
    anAmount?: number;
    acCurrency: string;
    anAmountCurr?: number;
    acName: string;
    adTimeChg?: Date;
    adTimeIns?: Date;
    anUserChg?: number;
    anUserIns?: number;
    anQid: number;
    anDiscount: number;
    anRebate: number;
    anRebateMove: number;
    anForPayBase: number;
    anDiscountCompensation: number;
    acIsRefund: string;
    anRebateMoveError: number;
    anPosterminalTransType: number;
    acPosterminalTransStatus: string;
    anTerminalId?: number;
    acOrderKey: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/TMnSetClassification.cs
export interface TMnSetClassification {
    anQid: number;
    anTopId?: number;
    acType: string;
    acTypeDesc: string;
    anValidValue?: number;
    acValidType: string;
    anClerk?: number;
    acNote: string;
    acDocKind: string;
    anCbid?: number;
    anCbtopId?: number;
    anWorkflowId?: number;
    anStorageQid: number;
    anWorkflowElapsedId?: number;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anEscalation: number;
    anStorageQ: TMnStorage;
    tMnMailboxes: TMnMailbox[];
    anTop: TMnSetClassification;
    inverseAnTop: TMnSetClassification[];
    tMnDocuments: TMnDocument[];
    tMnSetClassificationMetaData: TMnSetClassificationMetaDatum[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemSntserialNo.cs
export interface THeSetItemSntserialNo {
    acColumn: string;
    anNo: number;
    anLen: number;
    acName: string;
    anNameLength: number;
    acSignForEmpty: string;
    acHandling: string;
    acRequireEnter: string;
    acSqlselect: string;
    acSqlcontrol: string;
    acInternal: string;
    acMessage: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    acSqlselectDefault: string;
    anQid: number;
    GS1Mapping: string;
    GS1FieldFormat: string;
    GS1FieldType: string;
    GS1FieldMask: string;
    acColumnNavigation: THeSetItemSnt;
}

// ../../OnixWeb.Domain/Models/Pantheon/OnixInfoAdditionalTHeSetSubjDataSubj.cs
export interface OnixInfoAdditionalTHeSetSubjDataSubj {
    acSubject: string;
    acName2: string;
    acFieldSf: string;
    acActive: string;
    acSubjTypeBuyer: string;
    acSubjTypeBuyerNavigation: THeSetSubjType;
    subjData: OnixInfoAdditionalTHeSetSubjData;
    subjNavigation: THeSetSubj;
    tHeSetSubjPriceItem: THeSetSubjPriceItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THeMoveItemExcise.cs
export interface THeMoveItemExcise {
    acKey: string;
    anNo: number;
    anNoCost: number;
    acType: string;
    acTransportCalcType: string;
    acInCalcRvc: string;
    acIncBase: string;
    anValue: number;
    anValuePercent: number;
    anPvvalue: number;
    anPvocvalue: number;
    anUserIns?: number;
    anUserChg?: number;
    adTimeIns?: Date;
    adTimeChg?: Date;
    acCurrency: string;
    acBaseType: string;
    acSetOfTax: string;
    anQty?: number;
    adDate?: Date;
    acUm: string;
    acIncStockValue: string;
    anQid: number;
    acIncSuppForPay: string;
    acKeyNavigation: THeMove;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeFa.cs
export interface THeFa extends HasAdTimeInsAndAdTimeChgWithUser {
    acType: string;
    acInventNum: string;
    acName: string;
    acCompanyCar: string;
    acIsRented: string;
    acCarRegNo: string;
    acVtsid: string;
    acNote: string;
    acSuppCarRegNo: string;
    acActive: string;
    anQty: number;
    adDateOfAcq?: Date;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemType.cs
export interface THeSetItemType {
    acSetOfItem: string;
    acType: string;
    acName: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anQid: number;
    anFarmType?: number;
    acGoodsAsService: string;
    acServiceAsGoods: string;
    tHeSetItems: THeSetItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THrSetDocTypeTrvlExp.cs
export interface THrSetDocTypeTrvlExp extends HasAdTimeInsAndAdTimeChgWithUser {
    acDocType: string;
    anType: number;
    acName: string;
    acAcctDb: string;
    anUserChg?: number;
    anUserIns?: number;
    anQid: number;
    acTrvlEt: string;
    acTrvlNotForPay: string;
    anTrvlType?: number;
    acIrek: string;
    acActive: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/Subjektski.cs
export interface Subjektski {
    skis: string;
    naziv: string;
    naziv2: string;
    userspre?: number;
    userzap?: number;
    datumspre?: Date;
    datumzap?: Date;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSysParamSys.cs
export interface TPaSysParamSys {
    acRegUser: string;
    anBuildNo: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeStock.cs
export interface THeStock extends HasAdTimeInsAndAdTimeChgWithUser {
    acWarehouse: string;
    acIdent: string;
    anStock: number;
    anValue: number;
    anLastPrice: number;
    adTimeChg?: Date;
    anReserved: number;
    adTimeIns?: Date;
    anUserIns?: number;
    anUserChg?: number;
    anMinStock: number;
    anOptStock: number;
    anMaxStock: number;
    anQid: number;
    acIdentNavigation: THeSetItem;
    acWarehouseNavigation: THeSetSubj;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetSubjPriceCateg.cs
export interface THeSetSubjPriceCateg {
    acSubject: string;
    acClassif: string;
    acInvoInOut: string;
    adDateStart: Date;
    adDateEnd?: Date;
    acType: string;
    anPrice: number;
    anRebate: number;
    acSetOf: string;
    acCurrency: string;
    acFormula: string;
    anDeliveryDeadline: number;
    anPaymentDeadline: number;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    anRebate2: number;
    anRebate3: number;
    anQid: number;
    acNote: string;
    anSalePrice?: number;
    acSubjectNavigation: THeSetSubj;
    acClassifNavigation: THeSetItemCateg;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqli.cs
export interface TPaSqli {
    acKey: string;
    acName: string;
    acIsDebug: string;
    acType: string;
    acVarInIni: string;
    acAutoStart: string;
    acAutoClose: string;
    acEndMessage: string;
    acLocalization: string;
    acFormNameAuthor: string;
    acActive: string;
    anVersion?: number;
    acLogType: string;
    acInstCode: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    acIsLocalized: string;
    acRunOnInstall: string;
    acRunOnUpdate: string;
    acRunOnDelete: string;
    anOldVersion?: number;
    acCryptPass: string;
    acCompiledScript: number[];
    acNote: string;
    acAresLite: string;
    acUseCompiled: string;
    acAutoCompile: string;
    abIsRLSBackwardCompatible: boolean;
    tPaSqliforms: TPaSqliform[];
    tPaSqlistepFiles: TPaSqlistepFile[];
    tPaSqlistepStrEvents: TPaSqlistepStrEvent[];
    tPaSqlistepStrs: TPaSqlistepStr[];
    tPaSqlisteps: TPaSqlistep[];
    tPaSqlitranslations: TPaSqlitranslation[];
    tPaSqlivars: TPaSqlivar[];
    tPaSqlivers: TPaSqliver[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THrSetTrvlKm.cs
export interface THrSetTrvlKm extends HasAdTimeInsAndAdTimeChgWithUser {
    acDailyAllow: string;
    adDate: Date;
    anPriceTo?: number;
    anKm?: number;
    anPriceAbove?: number;
    anUserChg?: number;
    anUserIns?: number;
    acCurrency: string;
    anQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqlivar.cs
export interface TPaSqlivar {
    acKey: string;
    acWhereKey: string;
    anNo: number;
    acFieldName: string;
    acParamVar: string;
    acFieldType: string;
    acFieldReq: string;
    acFieldCaption: string;
    acDefaultExp: string;
    acDefaultValue: string;
    acLookUpSql: string;
    acOperator: string;
    acVarHint: string;
    acAddApostrof: string;
    acPrtCrit: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    anSystem: boolean;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeDocs.cs
export interface THeDocs {
    acAppl: string;
    anKey: number;
    acLnkKey: string;
    acName: string;
    acUrl: string;
    acTypeDocu: string;
    adDateValid?: Date;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    acForeignIdentifier: string;
    acLnkKeyOrd: string;
    anQid: number;
    acPerKey: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSetDocTypeStat.cs
export interface TPaSetDocTypeStat {
    acDocType: string;
    acStatus: string;
    acName: string;
    acFreeStock: string;
    acLimitControl: string;
    acIsIssueAllowdOpenBills: string;
    acFinished: string;
    adTimeIns?: Date;
    adTimeChg?: Date;
    anUserChg?: number;
    anUserIns?: number;
    anQid: number;
    tHeOrders: THeOrder[];
    acDocTypeNavigation: TPaSetDocType;
}

// ../../OnixWeb.Domain/Models/Pantheon/THrTrvlItemExpWithAttachment.cs
export interface THrTrvlItemExpWithAttachment {
    acKey: string;
    anNo: number;
    anCostNo: number;
    anType?: number;
    acNote: string;
    anPriceCurrency?: number;
    acCurrency: string;
    anFxrate?: number;
    acNotInCurrency: string;
    acAcctDb: string;
    adDateCost?: Date;
    acNotForPayment: string;
    anQid: number;
    acDoc1: string;
    acIrek: string;
    acLinkDoc: string;
    a: THrTrvlItem;
}

// ../../OnixWeb.Domain/Models/Pantheon/OxDmsxmlitem.cs
export interface OxDmsxmlitem {
    anDocumentQid: number;
    acJoinReason: string;
    anId?: number;
    acIdent: string;
    acCode: string;
    acName: string;
    acDescription: string;
    acUm: string;
    anQty?: number;
    anForPay?: number;
    anPrice?: number;
    anRebate?: number;
    anRebate1?: number;
    anVat?: number;
    anVatamount?: number;
    anVatbase?: number;
    acDept: string;
    acCostBearer: string;
    acIdentName: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaReport.cs
export interface TPaReport {
    acReport: string;
    acLangId: string;
    acLocalization: string;
    acFormName: string;
    acName: string;
    acDefaultPrinter: string;
    acPreview: string;
    anMaxPrStLevel: number;
    acSubstituteSign: string;
    acPrintIfEmpty: string;
    acPrintToText: string;
    anNoOfCopy: number;
    acOrderBy: string;
    acRegUserCode: string;
    acActive: string;
    acKeyShortCut: string;
    anUserIns?: number;
    adTimeIns?: Date;
    anUserChg?: number;
    adTimeChg?: Date;
    acText1: string;
    acText2: string;
    acText3: string;
    acNote: string;
    acReportData: number[];
    acPdfprintoptimized: string;
    anQid: number;
    acPaperType: string;
    anCanDesign: boolean;
    anCanEdit: boolean;
    anCanDelete: boolean;
    anCanCopy: boolean;
    acStoredProcedure: string;
    anGfx: boolean;
    anTxt: boolean;
    acDocTypes: string;
    adDateFrom?: Date;
    adDateTo?: Date;
    adTimeFrom?: Date;
    adTimeTo?: Date;
    anDefault: boolean;
    anNo: number;
    acGdprlog: string;
    acExportFileName: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetPostCode.cs
export interface THeSetPostCode extends HasAdTimeInsAndAdTimeChgWithUser {
    anQid: number;
    acPost: string;
    acName: string;
    anLatitude?: number;
    anLongitude?: number;
    tHeSetSubjAcPostNavigation: THeSetSubj[];
    acRegion: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeSetItemCateg.cs
export interface THeSetItemCateg {
    acClassif: string;
    acName: string;
    acVatcode: string;
    acVatcodeLow: string;
    acSerialNo: string;
    anWarrenty: number;
    acWayBillDescr: string;
    acSetOfItem: string;
    acCurrency: string;
    acUm: string;
    anUmtoUm2?: number;
    acUm2: string;
    anMinstock: number;
    anDiscount: number;
    acFormula: string;
    acCustTariff: string;
    anPosqty: number;
    anRebate: number;
    anTransport: number;
    anDuty: number;
    anDirectCost: number;
    anIncTax: number;
    anRtpriceP: number;
    anWspriceP: number;
    anWsprice2P: number;
    anPrStPriceP: number;
    acMakeCalc: string;
    acPriceCalcMethod: string;
    acRrebate: string;
    acRtransport: string;
    acRnepstr: string;
    acRduty: string;
    acRvrdavek: string;
    acRrtpriceP: string;
    acRwspriceP: string;
    acRwsprice2P: string;
    acRprStPriceP: string;
    acClassFillMethod: string;
    acPurchCurr: string;
    acAcct: string;
    anMaxstock: number;
    anOptStock: number;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    anFieldNa: number;
    anFieldNb: number;
    anFieldNc: number;
    anFieldNd: number;
    anFieldNe: number;
    acShowAtena: string;
    acShowAtenaDesc: string;
    acAtdescPos: string;
    acAtorder: string;
    acAcctIncome: string;
    acFieldSf: string;
    acFieldSg: string;
    anFieldNf: number;
    anFieldNg: number;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSj: string;
    anFieldNh: number;
    anFieldNi: number;
    anFieldNj: number;
    anDeliveryDeadline: number;
    acColumn: string;
    adTimeIns?: Date;
    adTimeChg?: Date;
    anUserIns?: number;
    anUserChg?: number;
    acType: string;
    anPrStMatVariantSubLvl?: number;
    anPrStMatQty1?: number;
    anPrStMatBatch?: number;
    anPrStMatQtyBase?: number;
    acPrStMatQtyFormula: string;
    acPrStMatUm: string;
    acPrStMatScrapIdent: string;
    anPrStMatScrapQty?: number;
    anPrStMatScrapPrc?: number;
    anPrStMatWasteQty?: number;
    anPrStMatWastePrc?: number;
    anPrStOprQty1?: number;
    anPrStOprQty2?: number;
    anPrStOprBatch?: number;
    anPrStOprQtyBase?: number;
    acPrStOprQtyFormula: string;
    acPrStOprUm: string;
    acPrStOprUmtime: string;
    anPrStOprQty3?: number;
    anPrStOprQtyBase3?: number;
    acPrStOprUm3: string;
    acPrStOprResursId: string;
    acPrStOprRuleId: string;
    acPrStOprIncomeGrp: string;
    acPrStOprEtadditive: string;
    anPrStOprNoOfWrk?: number;
    acPrStOprOperationType: string;
    acPrStOprDelayType: string;
    anPrStOprOptimalQty?: number;
    acPrStC1: string;
    acPrStC2: string;
    acPrStC3: string;
    acPrStC4: string;
    anPrStC5?: number;
    anPrStC6?: number;
    anPrStC7?: number;
    acPrStC8: string;
    acPicture: number[];
    acDescr: string;
    anBeatShare: number;
    anPurExciseE: number;
    anPurExciseA: number;
    anPurExciseT: number;
    anMaxRebate: number;
    anMinMargin: number;
    adDiscountBegin?: Date;
    adDiscountEnd?: Date;
    anBuyRebate2?: number;
    anBuyRebate3?: number;
    anSaleRebate2?: number;
    anSaleRebate3?: number;
    acRbuyRebate2: string;
    acRbuyRebate3: string;
    acRsaleRebate2: string;
    acRsaleRebate3: string;
    anRtprice: number;
    anWsprice: number;
    anWsprice2: number;
    anPrStPrice: number;
    acRrtprice: string;
    acRwsprice: string;
    acRwsprice2: string;
    acRprStPrice: string;
    anQid: number;
    anDimHeight: number;
    anDimWidth: number;
    anDimDepth: number;
    anDimWeight: number;
    anDimWeightBrutto: number;
    acUmdim1: string;
    acUmdim2: string;
    acUmmarkLabel: string;
    anQtyMarkLabel?: number;
    acQtyNotToKol: string;
    anSequence: number;
    anMaxRebatePos: number;
    acPosprinterId: string;
    anColorCode?: number;
    abIcon: number[];
    acSuprClassif: string;
    anAllowedInvShort: number;
    acActive: string;
    anMinMarginCateg: number;
    acPacking: string;
    acEnvrmntCost: string;
    acDroe: string;
    acDroesubject: string;
    acPackSlopak: string;
    acPackSlopaktype: string;
    tHeSetItemAcClassifNavigations: THeSetItem[];
    tHeSetSubjPriceCategs: THeSetSubjPriceCateg[];
}

// ../../OnixWeb.Domain/Models/Pantheon/THrTrvlItem.cs
export interface THrTrvlItem {
    acKey: string;
    anNo: number;
    acSubject: string;
    acPost: string;
    acCity: string;
    acCountry: string;
    adDateHourFrom?: Date;
    adDateHourTo?: Date;
    anKmcounterBefore?: number;
    anKmcounterAfter?: number;
    acDailyAllow: string;
    anPriceDailyAllow?: number;
    acCurrency: string;
    anFxrate?: number;
    anPriceFieldBonus?: number;
    anDayAllowNo?: number;
    anKm?: number;
    anPriceKm?: number;
    anLimitPriceKm?: number;
    anPrice500Km?: number;
    acNotInCurrency: string;
    acCostDrv: string;
    acOrder: string;
    acRetNote: string;
    acViacle: string;
    acCarRegNo: string;
    acSuppCarRegNo: string;
    acSuppViacle: string;
    acBreakfast: string;
    acLunch: string;
    acDinner: string;
    acGeoJson: string;
    acCurrencyKm: string;
    anFxrateKm?: number;
    acNotInCurrencyKm: string;
    anQid?: number;
    acDept: string;
    acLocoDriving: string;
    acKeyNavigation: THrTrvl;
    tHrTrvlItemExps: THrTrvlItemExpWithAttachment[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqliver.cs
export interface TPaSqliver {
    acKey: string;
    anVersion: number;
    anNo: number;
    acSqlexp: string;
    acNote: string;
    adTimeChg?: Date;
    anUserChg?: number;
    adTimeIns?: Date;
    anUserIns?: number;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeOrder.cs
export interface THeOrder extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    acNote: string;
    anDaysForValid: number;
    adDate?: Date;
    acDocType: string;
    anValue: number;
    anDiscount: number;
    acDoc2: string;
    anVat: number;
    anForPay: number;
    acWarehouse: string;
    acConsignee: string;
    acReceiver: string;
    acStatus: string;
    acCurrency: string;
    acDelivery?: string;
    adDateValid?: Date;
    adDeliveryDeadline?: Date;
    anClerk?: number;
    anNoteClerk?: number;
    acPayMethod: string;
    acDept: string;
    acWayOfSale: string;
    anDaysForPayment: number;
    anRoundItem: number;
    acPriceRate: string;
    acDoc1: string;
    adDateDoc1?: Date;
    adDateDoc2?: Date;
    acContactPrsn: string;
    acContactPrsn3: string;
    anDeliveryDays: number;
    adDeliveryDate?: Date;
    acParity: string;
    tHeOrderItem: THeOrderItem[];
    acConsigneeNavigation: THeSetSubj;
    anClerkNavigation: THeSetSubjContact;
    anNoteClerkNavigation: THeSetSubjContact;
    acDeliveryNavigation: THeSetDelMet;
    acPayMethodNavigation: THeSetPayMet;
    acReceiverNavigation: THeSetSubj;
    acStatusNavigation: TPaSetDocTypeStat;
    acDeptNavigation: THeSetSubj;
    acFieldSa: string;
    acFieldSb: string;
    acFieldSc: string;
    acFieldSd: string;
    acFieldSe: string;
    acFieldSf: string;
    acFieldSg: string;
    acFieldSh: string;
    acFieldSi: string;
    acFieldSj: string;
    anFieldNa?: number;
    anFieldNb?: number;
    anFieldNc?: number;
    anFieldNd?: number;
    anFieldNe?: number;
    anFieldNf?: number;
    anFieldNg?: number;
    anFieldNh?: number;
    anFieldNi?: number;
    anFieldNj?: number;
    adFieldDa?: Date;
    adFieldDb?: Date;
    adFieldDc?: Date;
    adFieldDd?: Date;
}

// ../../OnixWeb.Domain/Models/Pantheon/THfWoex.cs
export interface THfWoex {
    acKey: string;
    anNo?: number;
    acDocType: string;
    adDate?: Date;
    acConsignee: string;
    acIdent: string;
    acUm: string;
    anPlanQty?: number;
    anProducedQty?: number;
    adSchedEndTime?: Date;
    acStatus: string;
    acLnkKey: string;
    anLnkNo?: number;
    adLnkDate?: Date;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    acReceiver: string;
    acDept: string;
    anQtySeries?: number;
    anPlanWasteQty?: number;
    anWasteQty?: number;
    anFieldNa?: number;
    adSchedStartTime?: Date;
    acReversal: string;
    acStatusMf: string;
    acParentWo: string;
    anParentWoqty?: number;
    anPlanScrapQty?: number;
    anScrapQty?: number;
    acScrapIdent: string;
    acBuyOrdId: string;
    adWofinishDate?: Date;
    acReceiveFinished: string;
    acPlanId: string;
    acName: string;
    acCostDrv: string;
    acCreateFrom: string;
    anSntransfer?: number;
    anWorkTime?: number;
    anThroTime?: number;
    anLnkPrStNo?: number;
    acLnkPrStIdentParent: string;
    anLnkPrStSubNo?: number;
    anLnkPrStNoParent?: number;
    acNote: string;
    anQid: number;
    anQidCa?: number;
    acCropType: string;
    anRepairQty?: number;
    acProdVariant: string;
    anPriority: number;
    acKeyView: string;
    acConsigneeNavigation: THeSetSubj;
    acCostDrvNavigation: THeCostDrv;
    acDeptNavigation: THeSetSubj;
    acDocTypeNavigation: TPaSetDocType;
    acIdentNavigation: THeSetItem;
    acLnkPrStIdentParentNavigation: THeSetItem;
    acPlan: THfPlan;
    acReceiverNavigation: THeSetSubj;
    acScrapIdentNavigation: THeSetItem;
    acUmNavigation: THeSetUm;
    tHfWoexItems: THfWoexItem[];
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaCertificate.cs
export interface TPaCertificate {
    anQid: number;
    acLabel: string;
    acCertificate: number[];
    acNote: string;
    adDateValidTo: Date;
    acSerialNumber: string;
    acInfo?: string;
    anGroup?: number;
    acIssuerName: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anGroupSub?: number;
    acState: string;
    anUserId?: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqlistep.cs
export interface TPaSqlistep {
    acKey: string;
    anNo: number;
    acView: string;
    acSetOf: string;
    acDescr: string;
    acReport: string;
    acFileCreateTable: string;
    anFileDelimiter: number;
    acFileName: string;
    acFileTableName: string;
    acFileDest: string;
    acFileType: string;
    acFileTypeXml: string;
    acShowIfEmpty: string;
    acTitleButtons: string;
    anTitleLines: number;
    anBeginFromRecord: number;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    acCharSet: string;
    acStyleSheet: string;
    acUnitName: string;
    acNewThread: string;
    acNote: string;
    acPcu: string;
    acCompiled: string;
    acSqlexp: string;
    acSqlexport2: string;
    acPas: string;
    acDfm: string;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/OxPalletsView.cs
export interface OxPalletsView {
    anQid: number;
    acCode: string;
    acSscc: string;
    adDate: Date;
    anUserId: number;
    adDateOnly?: Date;
    acSsccNormalized: string;
    acKey: string;
    acKeyView: string;
    acReceiver: string;
    acReceiverName: string;
    acPrsn3: string;
    acPrsn3Name: string;
    acUserName: string;
    acReceiverRegion: string;
    acPrsn3Region: string;
}

// ../../OnixWeb.Domain/Models/Pantheon/VPnObracuni.cs
export interface VPnObracuni {
    acKey: string;
    acLnkKey: string;
    acKeyView: string;
    documentQid: number;
    tmnFileQid: number;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqlitranslation.cs
export interface TPaSqlitranslation {
    acKey: string;
    acUnitName: string;
    acObjectName: string;
    acTranslation: string;
    acLocalisation: string;
    anQid: number;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqliform.cs
export interface TPaSqliform {
    acKey: string;
    acFormName: string;
    acDocType: string;
    acObjectName: string;
    acType: string;
    acKeyShortCut: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    acTabSheetName: string;
    acFormType: string;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqlistepStrEvent.cs
export interface TPaSqlistepStrEvent {
    acKey: string;
    anNo: number;
    acDataEvent: string;
    acDataReturnValue: string;
    acKeyAndNo: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/TPaSqlistepStr.cs
export interface TPaSqlistepStr {
    acKey: string;
    anNo: number;
    anSeqNo: number;
    acFieldName: string;
    anFieldSize: number;
    acFieldTitle: string;
    acFieldReadOnly: string;
    acEditType: string;
    acFieldConst: string;
    acFieldFormat: string;
    acFieldDefault: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeIns?: Date;
    adTimeChg?: Date;
    acLookupSql: string;
    acKeyNavigation: TPaSqli;
}

// ../../OnixWeb.Domain/Models/Pantheon/THeLinkMoveMove.cs
export interface THeLinkMoveMove extends HasAdTimeInsAndAdTimeChgWithUser {
    acKey: string;
    anNo: number;
    acLnkKey: string;
    anLnkNo: number;
    acType: string;
    acTypeA: string;
    acTypeB: string;
    anFieldNa: number;
    anFieldNb: number;
    anUserId?: number;
    adDate?: Date;
    acValue: string;
    anUserChg?: number;
    anUserIns?: number;
    anQid: number;
    acKeyNavigation: THeMove;
    acLnkKeyNavigation: THeMove;
}

// ../../OnixWeb.Domain/Models/Pantheon/THrSetSlryEt.cs
export interface THrSetSlryEt {
    acEt: string;
    acName: string;
    acFieldSa: string;
}

// ../../OnixWeb.Domain/Dtos/UpdateTOpFileGroupDto.cs
export interface UpdateTOpFileGroupDto {
    note: string;
    tmndocumentAnQid?: number;
}

// ../../OnixWeb.Domain/Dtos/TravelWarrantItemReturnDto.cs
export interface TravelWarrantItemReturnDto {
    id: number;
    travelWarrantId: string;
    date: Date;
    costType: TravelWarrantCostType;
    costTypeId?: number;
    note: string;
    value: number;
    currency: Currency;
    currencyId: number;
    conversion: number;
    hasBackingInvoice: boolean;
    notForPayment: boolean;
    hasFiles: boolean;
    forPeriod?: Date;
}

// ../../OnixWeb.Domain/Dtos/AccountingCompanyDB.cs
export interface AccountingCompanyDB {
    DBName: string;
    companyName: string;
    create: boolean;
}

// ../../OnixWeb.Domain/Dtos/ChatGPTMessageDto.cs
export interface ChatGPTMessageDto {
    sessionId?: number;
    message: string;
}

// ../../OnixWeb.Domain/Dtos/UserWorkOrderItemDto.cs
export interface MarservisUserWorkOrderItemDto {
    id: number;
    workOrderId: string;
    user: MarservisWorkOrderItemReturnDtoUserDto;
    userId: string;
    deadlineDate?: Date;
    note: string;
    itemId?: number;
    item?: MarservisWorkOrderItemReturnDtoItemDto;
    status: MarservisWorkOrderItemStatusEnum;
    projectId?: number;
    subjectId?: number;
    project: MarservisWorkOrderItemReturnDtoProjectDto;
    subject: MarservisWorkOrderItemReturnDtoSubjectDto;
    workOrderStatus?: MarservisWorkOrderStatusEnum;
    workOrderLocation: string;
    workOrderDateEnd?: Date;
    hasFiles: boolean;
    itemGroupId?: number;
    itemGroup: any;
}

// ../../OnixWeb.Domain/Dtos/CultureDto.cs
export interface CultureDto {
    name: string;
    nativeName: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerOAuth2TokenRefreshDtoToken.cs
export interface TeamViewerOAuth2TokenDtoToken {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
}

// ../../OnixWeb.Domain/Dtos/ContactDto.cs
export interface ContactDto {
    id?: number;
    fullName: string;
    note: string;
    deactivated: boolean;
    isMaintenance: boolean;
    isSpam: boolean;
    isIBackup: boolean;
    isPromotionalEmailRecipient: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketLatestMessageDtoUserDto.cs
export interface SupportTicketLatestMessageDtoUserDto {
    firstName: string;
}

// ../../OnixWeb.Domain/Dtos/UpdateSupportAiKnowledgeEntryDto.cs
export interface UpdateSupportAiKnowledgeEntryDto {
    title?: string;
    content?: string;
    tags?: string;
    triggerTerms?: string;
    active?: boolean;
    reviewStatus?: SupportAiKnowledgeReviewStatus;
    scopeType?: SupportAiKnowledgeScopeType;
    companyId?: number;
}

// ../../OnixWeb.Domain/Dtos/WakaTimeAvailableMachineDto.cs
export interface WakaTimeAvailableMachineDto {
    id: string;
    displayName?: string;
    hostName?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiInvestigationTransportDto.cs
export interface SupportAiInvestigationTransportDto {
    transportType?: SupportAiInvestigationTransportTypeEnum;
    blockedReason?: string;
    meshCentralMappingId?: number;
    meshCentralGroupId?: string;
    meshCentralGroupName?: string;
    meshCentralServerDeviceId?: string;
    meshCentralServerDeviceName?: string;
    meshCentralSqlPort?: number;
    meshCentralSqlPortDefaulted: boolean;
}

// ../../OnixWeb.Domain/Dtos/CreateGenericDocumentDto.cs
export interface CreateGenericDocumentDto {
    note?: string;
    pantheonReceiverAcSubject?: string;
    pantheonPayerAcSubject?: string;
    documentType: number;
    documentPair?: number;
    pantheonAcDelivery?: string;
    pantheonAcPayMethod?: string;
    contact?: string;
    contactEmail?: string;
    deliveryDeadlineDays?: number;
    printTime?: Date;
    items?: CreateGenericDocumentItemDto[];
    pantheonAcWarehouse?: string;
    pantheonReceivingAcWarehouse?: string;
    originalDocumentNumber?: string;
    originalDocumentDate?: Date;
    originalDocument2Number?: string;
    originalDocument2Date?: Date;
    documentDate?: Date;
    adDate?: Date;
    adDateDue?: Date;
    signature?: number[];
    ZKI?: string;
    UID?: string;
    fiscalInternalNumber?: string;
    fiscalYear?: number;
    fiscalSequenceNumber?: number;
    fiscalBaseAmount?: number;
    fiscalTotal?: number;
    additionalFields?: string;
    additionalEntryFields?: string;
    paymentProviderResponse?: string;
    originApplicationUserId?: string;
    originCompanySettingsId?: number;
    eInvoiceContractVersion?: number;
    expectedEInvoiceRoute?: EInvoiceRoute;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCodexActivityDto.cs
export interface SupportMcpCodexActivityStates {
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCodexActivityDto.cs
export interface SupportMcpAgentTaskIds {
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCodexActivityDto.cs
export interface SupportMcpCodexActivityRequest {
    codexTaskId: string;
    activity: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCodexActivityDto.cs
export interface SupportMcpCodexActivityResponse {
    messageId: number;
    codexTaskId: string;
    state: string;
    lastSeenOn: Date;
    workedOn?: Date;
    created: boolean;
}

// ../../OnixWeb.Domain/Dtos/GetWorkOrderResourcesDto.cs
export interface GetWorkOrderResources {
    acKey: string;
    cachingKeys: CachingKeysEnum[];
}

// ../../OnixWeb.Domain/Dtos/NewUserPasswordDto.cs
export interface NewUserPasswordDto {
    userId: string;
    password: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentPackageDto.cs
export interface AresDeploymentPackageDto {
    groupId: number;
    groupName: string;
    isPublic: boolean;
    deploymentEnvironment: AresDeploymentEnvironment;
    snapshotId?: number;
    snapshotVersionNo?: number;
    aresKeys: string[];
    areses: AresDefinitionExportDto[];
    workflowDefinitions: WorkflowDefinitionExportDto[];
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentPackageDto.cs
export interface AresDefinitionExportDto {
    acKey: string;
    acName: string;
    version?: number;
    isSqlExecutionAres: boolean;
    isBootstrapExecutionAres: boolean;
    payload: TPaSqliExportDto;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentPackageDto.cs
export interface TPaSqliExportDto {
    ares: Record<string, any>;
    sqliforms: Record<string, any>[];
    sqlistepFiles: Record<string, any>[];
    sqlistepStrEvents: Record<string, any>[];
    sqlistepStrs: Record<string, any>[];
    sqlisteps: Record<string, any>[];
    sqlitranslations: Record<string, any>[];
    sqlivars: Record<string, any>[];
    sqlivers: Record<string, any>[];
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentPackageDto.cs
export interface WorkflowDefinitionExportDto {
    definition: Record<string, any>;
    integrates: Record<string, any>[];
}

// ../../OnixWeb.Domain/Dtos/CreateBobAiThreadDto.cs
export interface CreateBobAiThreadDto {
    prompt: string;
    responseMode?: SupportAiThreadResponseMode;
}

// ../../OnixWeb.Domain/Dtos/FreshdeskContactImport.cs
export interface FreshdeskContactImport {
    fullName: string;
    title: string;
    email: string;
    workPhone: string;
    mobilePhone: string;
    twitter: string;
    company: string;
    canSeeAllTicketsFromThisCompany: string;
    address: string;
    timeZone: string;
    language: string;
    tags: string;
    uniqueExternalId: string;
    about: string;
    twitterVerifiedProfile: string;
    twitterFollowerCount: string;
}

// ../../OnixWeb.Domain/Dtos/AddTHeSetSubjContactDto.cs
export interface AddTHeSetSubjContactDto {
    acSubject: string;
    acActive: string;
    acName: string;
    acSurname: string;
    acFunction: string;
}

// ../../OnixWeb.Domain/Dtos/AddTMnFileDto.cs
export interface AddTMnFileDto {
    tMnDocumentId: number;
    fileName: string;
    fileSize?: number;
    fileContent: number[];
}

// ../../OnixWeb.Domain/Dtos/SupportAiDatabaseOptionsDto.cs
export interface SupportAiDatabaseOptionsDto {
    target?: SupportAiRunTargetDto;
    suggestedDatabaseNames: string[];
    canUseManualDatabaseName: boolean;
    databaseDiscoveryMessage?: string;
    investigationTransport?: SupportAiInvestigationTransportDto;
    error?: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebServer.cs
export interface IISWebServerRoot {
    name: string;
    id: string;
    physicalPath: string;
    key: string;
    status: string;
    serverAutoStart: string;
    enabledProtocols: string;
    limits: IISWebServerLimits;
    bindings: IISWebServerBinding[];
    applicationPool: IISWebServerApplicationPool;
}

// ../../OnixWeb.Domain/Dtos/IISWebServer.cs
export interface IISWebServerLimits {
    connectionTimeout: string;
    maxBandwidth: string;
    maxConnections: string;
    maxUrlSegments: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebServer.cs
export interface IISWebServerBinding {
    protocol: string;
    bindingInformation: string;
    ipAddress: string;
    port: string;
    hostname: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebServer.cs
export interface IISWebServerApplicationPool {
    name: string;
    id: string;
    status: string;
}

// ../../OnixWeb.Domain/Dtos/TPaSqliReturnDto.cs
export interface TPaSqliReturnDto {
    acKey: string;
    acName: string;
    acIsDebug: string;
    acType: string;
    acVarInIni: string;
    acAutoStart: string;
    acAutoClose: string;
    acEndMessage: string;
    acLocalization: string;
    acFormNameAuthor: string;
    acActive: string;
    anVersion?: number;
    acLogType: string;
    acInstCode: string;
    anUserChg?: number;
    anUserIns?: number;
    adTimeChg?: Date;
    adTimeIns?: Date;
    acIsLocalized: string;
    acRunOnInstall: string;
    acRunOnUpdate: string;
    acRunOnDelete: string;
    anOldVersion?: number;
    acCryptPass: string;
    acCompiledScript: number[];
    acNote: string;
    acAresLite: string;
    acUseCompiled: string;
    acAutoCompile: string;
    abIsRLSBackwardCompatible: boolean;
}

// ../../OnixWeb.Domain/Dtos/UpdateMaterialNoteDto.cs
export interface UpdateMaterialNoteDto {
    acKey: string;
    anNo: number;
    note: string;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketDto.cs
export interface SupportTicketDto {
    id: number;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    status: SupportStatusEnum;
    title: string;
    user: string;
    company: string;
    email: string;
    dateDue?: Date;
    userId: string;
    emailId?: number;
    companyId?: number;
    contactId?: number;
    createdOn?: Date;
    modifiedOn?: Date;
    contact: string;
    reportedByApplicationUserDatabase: string;
    companySettingsId?: number;
    unread: number;
    iHaveUnfinishedTasks: boolean;
    hasTasks: boolean;
    temporaryOwner: string;
    temporaryOwnerId?: string;
    supportGroupId?: number;
    supportGroup: string;
    contactEmailId?: number;
    project: string;
    projectId?: number;
    someoneElseHasUnfinishedTasks: boolean;
    iHaveTasks: boolean;
    someoneElseHasTasks: boolean;
    companyPantheonStatus: string;
    companyPantheonBuyerType: string;
    companyPantheonBuyerTypeName: string;
    pantheonVersion: string;
    pantheonVersionFormatted: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisItemGroupMaterialReturnDto.cs
export interface MarservisItemGroupMaterialReturnDto extends MarservisItemGroupMaterialDto {
    id: number;
    materialName: string;
    unitOfMeasure: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerReportsConnectionsDto.cs
export interface TeamViewerReportsConnectionsDtoRecord {
    id: string;
    userid: string;
    username: string;
    deviceid: string;
    devicename: string;
    groupid: string;
    groupname: string;
    supportSessionType: number;
    startDate: Date;
    endDate: Date;
    currency: string;
    billingState: string;
    contactId: string;
    notes: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerReportsConnectionsDto.cs
export interface TeamViewerReportsConnectionsDto {
    records: TeamViewerReportsConnectionsDtoRecord[];
}

// ../../OnixWeb.Domain/Dtos/PartialFinishDeliveryNotesItemDto.cs
export interface PartialFinishDeliveryNotesItemDto {
    acIdent: string;
    anQty: number;
}

// ../../OnixWeb.Domain/Dtos/ContactCompanyDto.cs
export interface ContactCompanyDto {
    id?: number;
    companyId?: number;
    contactId?: number;
    isPrimary: boolean;
}

// ../../OnixWeb.Domain/Dtos/UpdateSubjectDto.cs
export interface UpdateSubjectDto extends AddSubjectDto {
    acPhone?: string;
    acFax?: string;
    acHttpPath?: string;
    acPayer?: string;
    acPayMethod?: string;
    anDaysForPayment?: number;
    acEmail?: string;
}

// ../../OnixWeb.Domain/Dtos/DatalabReferenceCompanySearchResultDto.cs
export interface DatalabReferenceCompanySearchResultDto {
    id: number;
    displayName: string;
    normalizedName: string;
    detailUrl: string;
    remoteKey: string;
    lastSyncedAt: Date;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemDto.cs
export interface MarservisWorkOrderItemDto {
    id: number;
    workOrderId?: string;
    userId: string;
    billableTime: number;
    itemGroupId?: number;
    deadlineDate?: Date;
    note: string;
    status: MarservisWorkOrderItemStatusEnum;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketTodoReturnDto.cs
export interface SupportTicketTodoReturnDto {
    id?: number;
    ticketId?: number;
    dateTime: Date;
    note: string;
    userId: string;
    ticketTitle: string;
    notified: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportAiVisibleMessageDto.cs
export interface SupportAiVisibleMessageDto {
    id: number;
    threadId: number;
    runId?: number;
    questionId?: number;
    authorKind: SupportAiVisibleMessageAuthorKind;
    kind: SupportAiVisibleMessageKind;
    body: string;
    secondaryBody?: string;
    payloadJson?: string;
    createdOn?: Date;
    attachments: SupportAiMessageAttachmentDto[];
}

// ../../OnixWeb.Domain/Dtos/AddArticlesFromGroupDto.cs
export interface AddArticlesFromGroupDto {
    articleIds: number[];
}

// ../../OnixWeb.Domain/Dtos/TeamViewerDevicesDto.cs
export interface TeamViewerDevicesDtoDevice {
    remotecontrolId: string;
    deviceId: string;
    alias: string;
    groupid: string;
    onlineState: string;
    assignedTo: boolean;
    teamviewerId: number;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerDevicesDto.cs
export interface TeamViewerDevicesDto {
    devices: TeamViewerDevicesDtoDevice[];
}

// ../../OnixWeb.Domain/Dtos/AddTOpFileGroupDto.cs
export interface AddTOpFileGroupDto {
    note: string;
    tmndocumentAnQid?: number;
}

// ../../OnixWeb.Domain/Dtos/AllActiveAccountsDto.cs
export interface AllActiveAccountsDto {
    customer: AllActiveAccountsDtoAccountDto[];
    supplier: AllActiveAccountsDtoAccountDto[];
    money: AllActiveAccountsDtoAccountDto[];
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadSummaryDto.cs
export interface SupportAiThreadSummaryDto {
    id: number;
    title?: string;
    scopeType: SupportAiThreadScopeType;
    status: SupportAiThreadStatus;
    ticketId?: number;
    companyId?: number;
    createdOn?: Date;
    lastActivityOn: Date;
    latestRun?: SupportAiRunSummaryDto;
}

// ../../OnixWeb.Domain/Dtos/SupportAiKnowledgeEntryDto.cs
export interface SupportAiKnowledgeEntryDto {
    id: number;
    scopeType: SupportAiKnowledgeScopeType;
    companyId?: number;
    companyName?: string;
    sourceType: SupportAiKnowledgeSourceType;
    reviewStatus: SupportAiKnowledgeReviewStatus;
    title: string;
    content: string;
    tags?: string;
    triggerTerms?: string;
    sourceRunId?: number;
    active: boolean;
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/CreateSupportAiRunDto.cs
export interface CreateSupportAiRunDto {
    ticketId: number;
    investigationCompanyId?: number;
    investigationDatabaseName?: string;
    initialMessage?: string;
    uniqueClientId?: string;
}

// ../../OnixWeb.Domain/Dtos/ExternalProviderIdentityDto.cs
export interface ExternalProviderIdentityDto {
    provider: ExternalAuthProvider;
    providerSubject: string;
    providerTenantId?: string;
    verifiedEmail?: string;
    displayName?: string;
}

// ../../OnixWeb.Domain/Dtos/ToggleSqlTaskDto.cs
export interface ToggleSqlTaskDto {
    enabled: boolean;
}

// ../../OnixWeb.Domain/Dtos/BookStackBook.cs
export interface BookStackBook {
    id: number;
    name: string;
    slug: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    createdBy: number;
    updatedBy: number;
    ownedBy: number;
    imageId: number;
}

// ../../OnixWeb.Domain/Dtos/CostBearerWorkHourEntryDto.cs
export interface CostBearerWorkHourEntryDto {
    workRecordId: number;
    workRecordCostTypeId?: number;
    workRecordCostType?: string;
    date: Date;
    hours: number;
    minutes: number;
    startTime?: number;
    note?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiRunCheckpointDto.cs
export interface SupportAiRunCheckpointDto {
    id: number;
    threadId: number;
    runId: number;
    sequence: number;
    reason: SupportAiCheckpointReason;
    summary: string;
    sourceEventSequence?: number;
    createdOn?: Date;
    openHypotheses: string[];
    pendingQuestions: string[];
    suggestedNextSteps: string[];
}

// ../../OnixWeb.Domain/Dtos/UserInfoViewModelV4Dto.cs
export interface UserInfoViewModelV4Dto {
    userName: string;
    userRoles: string[];
    applicationPackets: ApplicationPacketEnum[];
    deleted: boolean;
    language: string;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    alternativeUsers: UserInfoViewModelV3AlternativeUserDto[];
    alternativeUserId?: string;
    alternativeUserCompanyName: string;
    userInfo: UserInfoViewModelV4UserInfoDto;
    automaticLogout: number;
    bookStacksUrl: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface EInvoicePreflightInput {
    documentTypeId: number;
    pairId?: number;
    sourceAcKey?: string;
    buyerCode: string;
    paymentMethodCode: string;
    updateExisting: boolean;
    documentUid: string;
    originApplicationUserId: string;
    originCompanySettingsId: number;
    eInvoiceContractVersion?: number;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface EInvoicePreflightDto {
    route: EInvoiceRoute;
    requiresF1Signing: boolean;
    reasonCode?: string;
    errors: string[];
    contractVersion: number;
    maxPdfBytes: number;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface UraEInvoiceReadiness {
    ready: boolean;
    integrationType?: string;
    reasonCode?: string;
    errors: UraEInvoiceReadinessError[];
    maxPdfBytes: number;
    maxRequestBytes?: number;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface UraEInvoiceReadinessError {
    reasonCode: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface UraDmsDocument {
    documentQId: number;
    sent: boolean;
    externalId?: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface UraEInvoiceOutcome {
    dispatchId: string;
    documentQId?: number;
    sourceFileQId?: number;
    xmlSha256?: string;
    pdfArtifactId?: string;
    pdfSha256?: string;
    pdfByteLength?: number;
    exchange: EInvoiceExchangeOutcome;
    externalId?: string;
    fiscalization: EInvoiceFiscalizationOutcome;
    fiscalizedAt?: string;
    fiscalizationEvidence?: string;
    fiscalizationStatusUnavailable: boolean;
    safeToRetry: boolean;
    reasonCode?: string;
    rawStatus?: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface EInvoiceTransition {
    state: EInvoiceQueueState;
    stage: EInvoiceStage;
    isSafeRetry: boolean;
    nextAttemptAt?: string;
    reasonCode?: string;
    leaseOwner?: string;
    auditActorUserId?: string;
    outcome?: UraEInvoiceOutcome;
    isTechnicalInterruption: boolean;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface EInvoiceDispatchDto {
    dispatchId: string;
    documentUid: string;
    acKey?: string;
    state: EInvoiceQueueState;
    stage: EInvoiceStage;
    artifactId?: string;
    pdfSha256?: string;
    pdfByteLength?: number;
    exchange: EInvoiceExchangeOutcome;
    fiscalization: EInvoiceFiscalizationOutcome;
    reasonCode?: string;
    createdAt: string;
    updatedAt: string;
    issuedAt?: string;
    firstFailureAt?: string;
    nextAttemptAt?: string;
    fiscalizedAt?: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface SaveEInvoicePdfArtifactInput {
    dispatchId: string;
    documentUid: string;
    originApplicationUserId: string;
    originCompanySettingsId: number;
    filename: string;
    byteLength: number;
    sha256: string;
    contentBase64: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export interface EInvoicePdfArtifactAck {
    artifactId: string;
    sha256: string;
    byteLength: number;
    dispatch: EInvoiceDispatchDto;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export enum EInvoiceRoute {
    F1 = 0,
    F2 = 1,
    LegacyManual = 2,
    NotApplicable = 3,
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export enum EInvoiceQueueState {
    AwaitingCommit = 0,
    AwaitingPdf = 1,
    Ready = 2,
    Processing = 3,
    AwaitingFiscalization = 4,
    RetryPending = 5,
    Completed = 6,
    NeedsAttention = 7,
    ReconcileRequired = 8,
    NotIssued = 9,
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export enum EInvoiceStage {
    Commit = 0,
    PDF = 1,
    XML = 2,
    ProviderExchange = 3,
    Fiscalization = 4,
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export enum EInvoiceExchangeOutcome {
    NotAttempted = 0,
    DefinitivelyNotAccepted = 1,
    Accepted = 2,
    Uncertain = 3,
}

// ../../OnixWeb.Domain/Dtos/EInvoiceContracts.cs
export enum EInvoiceFiscalizationOutcome {
    Unknown = 0,
    Pending = 1,
    Confirmed = 2,
    Failed = 3,
}

// ../../OnixWeb.Domain/Dtos/SupportDashboardTimeLogDto.cs
export interface SupportDashboardTimeLogDto {
    ticketId?: number;
    timeLogId: number;
    companyId?: number;
    company: string;
    contactId?: number;
    emailId?: number;
    email: string;
    contact: string;
    agent: string;
    agentId: string;
    time: number;
    billableTime: number;
    createdOn?: Date;
    billable: boolean;
    exportedOn?: Date;
    workOutsideWorkingHours: boolean;
    note: string;
    technicalNote: string;
    date: Date;
    status?: SupportStatusEnum;
    priority?: SupportPriorityEnum;
    title: string;
    ownerId?: string;
    owner: string;
    type: string;
    project: string;
    projectId?: number;
    projectSubjectShortName?: string;
    invoice: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportGroupMemberDto.cs
export interface SupportGroupMemberDto {
    userId: string;
    userName: string;
    fullName: string;
    email: string;
}

// ../../OnixWeb.Domain/Dtos/TokenDto.cs
export interface TokenDto {
    token: string;
}

// ../../OnixWeb.Domain/Dtos/SqlMetadataDto.cs
export interface SqlTableMetadataDto {
    schemaName: string;
    tableName: string;
    rowCount?: number;
    createDate?: Date;
    modifyDate?: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlMetadataDto.cs
export interface SqlRoutineMetadataDto {
    schemaName: string;
    routineName: string;
    routineType: string;
    createDate?: Date;
    modifyDate?: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlMetadataDto.cs
export interface SqlObjectDefinitionRequestDto {
    objectType: string;
    schemaName?: string;
    objectName: string;
    parentSchemaName?: string;
    parentObjectName?: string;
    sessionId?: number;
}

// ../../OnixWeb.Domain/Dtos/SqlMetadataDto.cs
export interface SqlObjectDefinitionDto {
    definition: string;
}

// ../../OnixWeb.Domain/Dtos/SqlMetadataDto.cs
export interface SqlObjectMetadataDto {
    objectType: string;
    schemaName?: string;
    objectName: string;
    parentSchemaName?: string;
    parentObjectName?: string;
    objectKind: string;
    details?: string;
    isDisabled?: boolean;
    ordinal?: number;
    createDate?: Date;
    modifyDate?: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlMetadataDto.cs
export interface SqlObjectDetailsRequestDto {
    objectType: string;
    schemaName?: string;
    objectName: string;
}

// ../../OnixWeb.Domain/Dtos/SqlMetadataDto.cs
export interface SqlObjectDetailsDto {
    columns: SqlObjectMetadataDto[];
    constraints: SqlObjectMetadataDto[];
    indexes: SqlObjectMetadataDto[];
    triggers: SqlObjectMetadataDto[];
    parameters: SqlObjectMetadataDto[];
    dependencies: SqlObjectMetadataDto[];
    memberships: SqlObjectMetadataDto[];
    permissions: SqlObjectMetadataDto[];
}

// ../../OnixWeb.Domain/Dtos/CompanyMeshCentralGroupMappingUpsertDto.cs
export interface CompanyMeshCentralGroupMappingUpsertDto {
    companyId: number;
    meshCentralGroupId: string;
    meshCentralServerDeviceId?: string;
    mssqlPort?: number;
}

// ../../OnixWeb.Domain/Dtos/LURInvoiceListItemDto.cs
export interface LURInvoiceListItemDto {
    acKey: string;
    acNote: string;
    adDate?: Date;
    adTimeIns?: Date;
    acDocType: string;
    acDoc2: string;
    acDoc1: string;
    anForPay: number;
    acReceiver: string;
    acCurrency: string;
    acPayMethod: string;
    acPrsn3: string;
    acVerifiedPrices: string;
    acDept: string;
    acHrFiskalNumber: string;
    anClerk: number;
}

// ../../OnixWeb.Domain/Dtos/AccountDto.cs
export interface AccountDto {
    code: string;
    name: string;
    id?: number;
    type: AccountType;
    userId: string;
}

// ../../OnixWeb.Domain/Dtos/TransferSettingsResultDto.cs
export interface TransferSettingsResultDto {
    sourceWarehouse?: string;
    targetWarehouse?: string;
    warehouseRemaps: TransferSettingsWarehouseRemapDto[];
    warnings: string[];
}

// ../../OnixWeb.Domain/Dtos/TransferSettingsResultDto.cs
export interface TransferSettingsWarehouseRemapDto {
    documentTypeId: number;
    type?: string;
    acName?: string;
    entity: string;
    entityId: number;
    field: string;
    previousValue?: string;
    value?: string;
}

// ../../OnixWeb.Domain/Dtos/TravelWarrantReturnDto.cs
export interface TravelWarrantReturnDto extends ATenantOwnedPantheonResource {
    id: string;
    documentNumber: number;
    date: Date;
    note: string;
    returnNote: string;
    status: TravelWarrantStatus;
    place: string;
    driver: string;
    coDrivers: string;
    vehicle: string;
    travelStartDateTime?: Date;
    travelEndDateTime?: Date;
    travelStartMeter?: number;
    travelEndMeter?: number;
    downPayment?: number;
    downPaymentCurrency: CurrencyDto;
    downPaymentCurrencyId?: number;
    downPaymentConversion?: number;
    placeOfDeparture: string;
    expenseBearer: ExpenseBearerDto;
    expenseBearerId?: number;
    expenseBearerAllowanceConversion: number;
    country: Country;
    countryId?: number;
    countryAllowance: number;
    countryAllowanceCurrency: string;
    countryAllowanceConversion: number;
    officialVehicle: OfficialVehicleDto;
    officialVehicleId?: number;
    personalVehicle: PersonalVehicleDto;
    personalVehicleId?: number;
    applicationUser: ApplicationUserDto;
    applicationUserId: string;
    travelKilometersConversion: number;
    travelKilometers: TravelKilometersDto;
    expenseBearerAllowance: number;
    expenseBearerCurrency: string;
    pantheonStatus?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiFollowUpQuestionDto.cs
export interface SupportAiFollowUpQuestionDto {
    question: string;
    whyNeeded: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadDetailDto.cs
export interface SupportAiThreadDetailDto {
    id: number;
    title?: string;
    prompt?: string;
    scopeType: SupportAiThreadScopeType;
    responseMode: SupportAiThreadResponseMode;
    status: SupportAiThreadStatus;
    ticketId?: number;
    companyId?: number;
    createdOn?: Date;
    lastActivityOn: Date;
    activeDatabaseGrant?: SupportAiDatabaseGrantDto;
    activeDatabaseTransport?: SupportAiInvestigationTransportDto;
    runs: SupportAiRunSummaryDto[];
}

// ../../OnixWeb.Domain/Dtos/SupportTicketTimeLogDto.cs
export interface SupportTicketTimeLogDto{
    id: number;
    agentId: string;
    date: Date;
    time: number;
    billableTime: number;
    billable: boolean;
    invoice: boolean;
    workOutsideWorkingHours: boolean;
    note: string;
    technicalNote: string;
    ticketId?: number;
    type?: string;
    teamViewerSessionId?: string;
    teamViewerSessionIds?: string[];
    wakaTimeWorklogId?: number;
    wakaTimeWorklogIds?: number[];
    pantheonSessionId?: number;
    pantheonSessionIds?: number[];
    ciscoPhoneSessionId?: string;
    projectPhase?: string;
    uniqueClientId?: string;
}

// ../../OnixWeb.Domain/Dtos/UserInfoViewModelV3AlternativeUserDto.cs
export interface UserInfoViewModelV3AlternativeUserDto {
    companyName: string;
    id?: string;
}

// ../../OnixWeb.Domain/Dtos/MobileSettingsUpdateDto.cs
export interface MobileSettingsUpdateDto {
    bluetoothPrinterAddress: string;
    bluetoothPrinterName: string;
    bluetoothPrinterType: string;
    bluetoothPrinterPaperWidth?: number;
    useDarkTheme: boolean;
    useListViewOnPickers: boolean;
    useTabletMode?: boolean;
    useOnlyShortcuts: boolean;
    useDocumentTypeCodesInTitles?: boolean;
    bluetoothPrinterBoldMode?: boolean;
    bluetoothPrinterPrintSpeed?: number;
    bluetoothPrinterArbitrarySettings?: Record<string, string>;
    useWiderColumns?: boolean;
    a4PrinterURL?: string;
    language?: string;
    thermalPrinterPrintVerticalPDF417?: boolean;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderMaterialDto.cs
export interface TrimWorkOrderMaterialQuery {
    acKey: string;
    acName: string;
    acIdent: string;
    anQty: number;
    acNote: string;
    acUm: string;
    anNo: number;
    acSerialNo: string;
}

// ../../OnixWeb.Domain/Dtos/FreshdeskCompanyImport.cs
export interface FreshdeskCompanyImport {
    companyName: string;
    description: string;
    notes: string;
    domainsForThisCompany: string;
    healthScore: string;
    accountTier: string;
    renewalDate: string;
    industry: string;
}

// ../../OnixWeb.Domain/Dtos/ClientServerHostAssignmentDto.cs
export interface ClientServerHostAssignmentDto {
    serverName: string;
    companyId?: number;
    companyName?: string;
    companyTeamViewerDeviceId?: number;
    teamViewerDeviceName?: string;
    companyMeshCentralGroupMappingId?: number;
    meshCentralGroupName?: string;
    meshCentralDeviceId?: string;
    meshCentralDeviceName?: string;
    teamViewerOnline?: boolean;
    meshCentralOnline?: boolean;
    hostOnline?: boolean;
    hostCheckedOn?: Date;
    hostCheckError?: string;
}

// ../../OnixWeb.Domain/Dtos/ClientServerHostAssignmentDto.cs
export interface ClientServerHostAssignmentUpsertDto {
    companyId?: number;
    companyTeamViewerDeviceId?: number;
    companyMeshCentralGroupMappingId?: number;
    meshCentralDeviceId?: string;
}

// ../../OnixWeb.Domain/Dtos/ClientServerHostAssignmentDto.cs
export interface ClientServerHostOptionsDto {
    teamViewerDevices: ClientServerTeamViewerDeviceOptionDto[];
}

// ../../OnixWeb.Domain/Dtos/ClientServerHostAssignmentDto.cs
export interface ClientServerTeamViewerDeviceOptionDto {
    id: number;
    alias: string;
    deviceId: string;
    remoteControlId: string;
}

// ../../OnixWeb.Domain/Dtos/OriginPantheonItemDetails.cs
export interface OriginPantheonItemDetails {
    acKey: string;
    anNo: number;
}

// ../../OnixWeb.Domain/Dtos/AdminUsersGroupsAndItemsDto.cs
export interface AdminUsersGroupsAndItemsDto {
    items: ApplicationUser[];
    groups: AdminUsersGroupsDto[];
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeUpdateDtoV2.cs
export interface DocumentTypeUpdateDtoV2 {
    sendB2BAsEInvoice?: boolean;
    warehouseOverviewShowOnlyInStock: boolean;
    articleSearchShowOnlyInStock: boolean;
    articleSearchAllowSearchingByClassification: boolean;
    itemListShowDetailed: boolean;
    documentOnCreateMakePDF: boolean;
    documentOnCreateMakeBluetoothPrint: boolean;
    stockViewShowOnlyInStock: boolean;
    addingItemWarnIfQuantityMoreThanAvailable: boolean;
    bluetoothPrintCopiesNumber: number;
    workOrderPrintSpecificationDuration: boolean;
    quantityDecimalPlaces: number;
    skipConfirmationOnShortcuts: boolean;
}

// ../../OnixWeb.Domain/Dtos/WooCommerceSettingsDto.cs
export interface WooCommerceSettingsDto {
    key: string;
    secret: string;
    location: string;
}

// ../../OnixWeb.Domain/Dtos/ItemGroupItemItemDto.cs
export interface ItemGroupItemItemDto {
}

// ../../OnixWeb.Domain/Dtos/TeamViewerDevicesDtoDeviceReturn.cs
export interface TeamViewerDevicesDtoDeviceReturn {
    deviceId: string;
    groupId: string;
    remoteControlId: string;
    alias: string;
    teamViewerId: number;
    connectedCompanyId?: number;
    connectedCompanyName: string;
    suggestedCompanyId?: number;
    suggestedCompanyName: string;
    suggestionScore?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiStartOptionsDto.cs
export interface SupportAiStartOptionsDto {
    target?: SupportAiRunTargetDto;
    suggestedDatabaseNames: string[];
    canUseManualDatabaseName: boolean;
    databaseDiscoveryMessage?: string;
    investigationTransport?: SupportAiInvestigationTransportDto;
    error?: string;
}

// ../../OnixWeb.Domain/Dtos/AiSupportModelsRequestDto.cs
export interface AiSupportModelsRequestDto {
    apiKey?: string;
}

// ../../OnixWeb.Domain/Dtos/OtherSettingsDto.cs
export interface OtherSettingsDto {
    language: string;
    culture: string;
    timeZone: string;
    automaticLogout: number;
}

// ../../OnixWeb.Domain/Dtos/CompanyDto.cs
export interface CompanyDto {
    id?: number;
    name: string;
    description: string;
    notes: string;
    connectionSettings: string;
    myEInvoiceSettings: string;
    pantheonAcSubject: string;
    shouldHaveIBackup: boolean;
    pantheonId: string;
    notOurCustomer: boolean;
    pantheonConnectionString: string;
    accountingCompanyId?: number;
    linkedCompanySettingsId?: number;
    alternateMainServerPrefix?: string;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeUpdateDto.cs
export interface DocumentTypeUpdateDto {
    sendB2BAsEInvoice?: boolean;
    warehouseOverviewShowOnlyInStock: boolean;
    articleSearchShowOnlyInStock: boolean;
    articleSearchInitiallyLoadAll: boolean;
    articleSearchRepeatLastSearch: boolean;
    articleSearchShowOnlyWhereAcFieldsAIs: string;
    articleSearchAllowSearchingByClassification: boolean;
    itemListShowDetailed: boolean;
    documentOnCreateMakePDF: boolean;
    documentOnCreateMakeBluetoothPrint: boolean;
    stockViewLoadAllOnOpen: boolean;
    stockViewShowOnlyInStock: boolean;
    addingItemWarnIfQuantityMoreThanAvailable: boolean;
    bluetoothPrintCopiesNumber: number;
    cacheDuration: number;
    cacheUseCacheForAnyResource: boolean;
    cacheUseForArticleSearch: boolean;
    cacheUseForCustomerSearch: boolean;
    cacheUseForWarehouseSearch: boolean;
    workOrderPrintSpecificationDuration: boolean;
    quantityDecimalPlaces: number;
    skipConfirmationOnShortcuts: boolean;
    pickingShowConfirmationOnPick: boolean;
}

// ../../OnixWeb.Domain/Dtos/ArticleDto.cs
export interface ArticleDto {
    identCode: string;
    identName: string;
    UM: string;
    vatCode: string;
    vat: number;
    classif: string;
    custTariff: string;
    custTariffRate: number;
    active: boolean;
}

// ../../OnixWeb.Domain/Dtos/CompanySettingsReturnDto.cs
export interface CompanySettingsReturnDto {
    id: number;
    onixPhoneEInvoiceEnabled?: boolean;
    eInvoiceIssuerVatRegistered?: boolean;
    connectionName: string;
    tenant?: OnixTenant;
    supportEmailAddress: string;
    supportEmailPassword: string;
    supportRedirectAllToSender: boolean;
    supportAutoReplyOnNewTicket: boolean;
    supportAutoReplyOnNewTicketSubject?: string;
    supportAutoReplyOnNewTicketBody?: string;
    wooCommerceKey: string;
    wooCommerceSecret: string;
    wooCommerceLocation: string;
    timeZone: string;
    culture: string;
    pantheonAnDocKeyLenNumber: number;
    pantheonCompanyName: string;
    pantheonAcCompanyPrtTextA: string;
    pantheonAcCompanyPrtTextB: string;
    companyDocumentsEmail: string;
    bookStackUrl: string;
    companySQLConnectionStringExists: boolean;
    applicationPackets: ApplicationPacketEnum[];
    pantheonAlsoUseNDigitBarcodes?: number;
    pantheonCompanyImage: number[];
    pantheonCompanyOnixPhoneSmallImage?: number[];
    isMainAresDeploymentDatabase?: boolean;
    isMainAresTestingDatabase?: boolean;
    alternateMainServerPrefix?: string;
    workOrderWorkerPickerIncludesInactiveWorkers: boolean;
    aiSupportTriageModel?: string;
    aiSupportInvestigationModel?: string;
    aiSupportReasoningEffort?: string;
    aiSupportVerbosity?: string;
    aiSupportRunBudgetMode: AiSupportRunBudgetMode;
    aiSupportMaxToolRounds?: number;
    aiSupportMaxInputTokensPerTurn?: number;
    aiSupportMaxOutputTokensPerTurn?: number;
    aiSupportDefaultTimeoutMinutes?: number;
}

// ../../OnixWeb.Domain/Dtos/ForwardEmailStructure.cs
export interface ForwardEmailStructure {
    title: string;
    body: string;
    fileName: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadItemDto.cs
export interface SupportAiThreadItemDto {
    id: number;
    threadId: number;
    runId?: number;
    sequence: number;
    revision: number;
    parentItemId?: number;
    kind: SupportAiThreadItemKind;
    status: SupportAiThreadItemStatus;
    role?: SupportAiThreadItemRole;
    phase?: SupportAiThreadItemPhase;
    toolCallId?: number;
    questionId?: number;
    title?: string;
    body?: string;
    summary?: string;
    payloadJson?: string;
    errorCode?: string;
    startedOn?: Date;
    completedOn?: Date;
    createdOn?: Date;
    attachments: SupportAiMessageAttachmentDto[];
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAddInternalAiNoteDto.cs
export interface SupportMcpAddInternalAiNoteDto {
    content: string;
    notifyUserIds?: string[];
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAddInternalAiNoteDto.cs
export interface SupportMcpAddInternalAiNoteResponseDto {
    ticketId: number;
    messageId: number;
    createdOn?: Date;
    sentByUserId: string;
    notifyUserIds: string[];
    notifiedUsersCount: number;
    type: string;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeDto.cs
export interface DocumentTypeDto {
    functionality: DocumentFunctionalityEnum;
    cacheDuration: number;
    warehouseName: string;
    bluetoothPrintCopiesNumber: number;
    itemListShowDetailed: boolean;
    articleSearchInitiallyLoadAll: boolean;
    articleSearchRepeatLastSearch: boolean;
    cacheUseForArticleSearch: boolean;
    cacheUseForCustomerSearch: boolean;
    cacheUseForWarehouseSearch: boolean;
    articleSearchShowOnlyInStock: boolean;
    articleSearchAllowSearchingByClassification: boolean;
    cacheUseCacheForAnyResource: boolean;
    documentOnCreateMakeBluetoothPrint: boolean;
    stockViewLoadAllOnOpen: boolean;
    stockViewShowOnlyInStock: boolean;
    warehouseOverviewShowOnlyInStock: boolean;
    documentOnCreateMakePDF: boolean;
    addingItemWarnIfQuantityMoreThanAvailable: boolean;
    workOrderPrintSpecificationDuration: boolean;
    adminSendDocumentToCompanyDocumentEmail: boolean;
    quantityDecimalPlaces: number;
    create: boolean;
    update: boolean;
    delete: boolean;
    view: boolean;
}

// ../../OnixWeb.Domain/Dtos/DocumentItemDto.cs
export interface DocumentItemDto {
    identCode: string;
    UM: string;
    VATCode: string;
    VAT: number;
    qty: number;
    rebate: number;
    PN: number;
    excise: number;
    totalCurr: number;
    totalHRK: number;
    dept: string;
    costDrv: string;
    serialNo: string;
    dateExp: Date;
    note: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCreateCompanyAiKnowledgeEntryDto.cs
export interface SupportMcpCreateCompanyAiKnowledgeEntryDto {
    title?: string;
    content?: string;
    tags?: string;
    triggerTerms?: string;
}

// ../../OnixWeb.Domain/Dtos/CompanySqlTaskReturnDto.cs
export interface CompanySqlTaskReturnDto {
    id: number;
    name: string;
    sqlText: string;
    connectionString: string;
    companyId: number;
    companyName: string;
    enabled: boolean;
    isRecurring: boolean;
    cronExpression: string;
    scheduledFor?: Date;
    nextRunAt?: Date;
    lastRunAt?: Date;
    lastRunSucceeded?: boolean;
    lastRunError: string;
    runsExecuted: number;
    maxRuns?: number;
    scheduleDescription: string;
    timeZoneId: string;
    schedule: CompanySqlTaskScheduleDto;
    isConsumed: boolean;
}

// ../../OnixWeb.Domain/Dtos/BookStackAddPageDto.cs
export interface BookStackAddPageDto {
    messageId: number;
    bookId: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/AdminUsersTenantCompanyReturnDto.cs
export interface AdminUsersTenantCompanyReturnDto {
    id: number;
    connectionName: string;
    pantheonCompanyName: string;
}

// ../../OnixWeb.Domain/Dtos/PantheonUserDto.cs
export interface PantheonUserDto {
    pantheonAcWorker?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadBudgetStateDto.cs
export interface SupportAiThreadBudgetStateDto {
    maxAutoContinuationRunsPerThread: number;
    autoContinuationRunsUsed: number;
    maxTotalToolRoundsPerThread: number;
    totalToolRoundsUsed: number;
    maxThreadWallClockMinutes: number;
    threadWallClockMinutesUsed: number;
}

// ../../OnixWeb.Domain/Dtos/THeMoveItemDto.cs
export interface THeMoveItemDto extends THeMoveItem {
    acIdent: string;
    anQty: number;
}

// ../../OnixWeb.Domain/Dtos/DocumentFlowSelectionDuplicateDto.cs
export interface DocumentFlowSelectionDuplicateDto {
    userId: string;
    documentTypeIds: number[];
    documentPairIds: number[];
    offsetX: number;
    offsetY: number;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketSingleDtoMessageDtoNotifyUserDto.cs
export interface SupportTicketSingleDtoMessageDtoNotifyUserDto {
    id: string;
    name: string;
    email?: string;
}

// ../../OnixWeb.Domain/Dtos/DeclarationDto.cs
export interface DeclarationDto {
    subjectCode: string;
    docNr: string;
    docDate: Date;
    identCode: string;
    NCTS: string;
    MRN: string;
    customsOffice: string;
    receiver: string;
    transporter: string;
    driver: string;
    regNo: string;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneDocumentTypeActivitySnapshot {
    id: number;
    code?: string;
    name?: string;
    functionality: DocumentFunctionalityEnum;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneFunctionalityActivityTrackRequest {
    occurredOnUtc?: Date;
    companySettingsId?: number;
    documentTypeId?: number;
    documentTypeCode: string;
    documentTypeName: string;
    functionality?: DocumentFunctionalityEnum;
    prevalidatedDocumentType?: OnixPhoneDocumentTypeActivitySnapshot;
    sourceTable: string;
    counterKey: string;
    action: OnixPhoneFunctionalityActivityActionEnum;
    quantity: number;
    relatedAcKey: string;
    relatedAnNo?: number;
    relatedAnQid?: number;
    relatedDocumentPrimaryKey: string;
    relatedRecordPrimaryKey: string;
    relatedDocumentTypeCode: string;
    sourceAcKey: string;
    sourceAnNo?: number;
    sourceDocumentPrimaryKey: string;
    documentPairId?: number;
    batchId?: string;
    clientSource: string;
    metadataJson: string;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneFunctionalityActivityReportFilterDto {
    year: number;
    month: number;
    companySettingsId?: number;
    userId: string;
    documentTypeId?: number;
    documentTypeCode: string;
    functionality?: DocumentFunctionalityEnum;
    sourceTable: string;
    counterKey: string;
    action?: OnixPhoneFunctionalityActivityActionEnum;
    excludeDmsBillingExcludedUsers: boolean;
    page: number;
    count: number;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneFunctionalityActivitySummaryDto {
    companySettingsId?: number;
    companySettingsName: string;
    companySettingsConnectionName: string;
    grunfCompanyId?: number;
    grunfCompanyName: string;
    grunfAccountingCompanyId?: number;
    grunfAccountingCompanyName: string;
    userId: string;
    userName: string;
    userDisplayName: string;
    pantheonAnUserId?: number;
    pantheonAcUserId: string;
    documentTypeId?: number;
    documentTypeCode: string;
    documentTypeName: string;
    functionality?: DocumentFunctionalityEnum;
    functionalityText: string;
    sourceTable: string;
    counterKey: string;
    action: OnixPhoneFunctionalityActivityActionEnum;
    actionText: string;
    count: number;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneFunctionalityActivityDetailDto {
    id: number;
    occurredOnUtc: Date;
    occurredOnLocal: Date;
    periodYear: number;
    periodMonth: number;
    companySettingsId?: number;
    companySettingsName: string;
    companySettingsConnectionName: string;
    grunfCompanyId?: number;
    grunfCompanyName: string;
    grunfAccountingCompanyId?: number;
    grunfAccountingCompanyName: string;
    userId: string;
    userName: string;
    userDisplayName: string;
    userEmail: string;
    pantheonAnUserId?: number;
    pantheonAcUserId: string;
    documentTypeId?: number;
    documentTypeCode: string;
    documentTypeName: string;
    functionality?: DocumentFunctionalityEnum;
    functionalityText: string;
    sourceTable: string;
    counterKey: string;
    action: OnixPhoneFunctionalityActivityActionEnum;
    actionText: string;
    quantity: number;
    relatedAcKey: string;
    relatedAnNo?: number;
    relatedAnQid?: number;
    relatedDocumentPrimaryKey: string;
    relatedRecordPrimaryKey: string;
    sourceAcKey: string;
    sourceAnNo?: number;
    sourceDocumentPrimaryKey: string;
    documentPairId?: number;
    batchId?: string;
    clientSource: string;
    metadataJson: string;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneFunctionalityActivityReportOptionsDto {
    companies: OnixPhoneFunctionalityActivityOptionDto[];
    users: OnixPhoneFunctionalityActivityOptionDto[];
    documentTypes: OnixPhoneFunctionalityActivityOptionDto[];
    functionalities: OnixPhoneFunctionalityActivityOptionDto[];
    sourceTables: OnixPhoneFunctionalityActivityOptionDto[];
    counterKeys: OnixPhoneFunctionalityActivityOptionDto[];
    actions: OnixPhoneFunctionalityActivityOptionDto[];
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneFunctionalityActivityOptionDto {
    key: string;
    text: string;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface GrunfCompanyAccountingSnapshotDto {
    grunfCompanyId: number;
    grunfCompanyName: string;
    grunfAccountingCompanyId?: number;
    grunfAccountingCompanyName: string;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneFunctionalityActivityDtos.cs
export interface OnixPhoneFunctionalityActivityGrunfAccountingBackfillResultDto {
    companiesChecked: number;
    companiesResolved: number;
    companiesMissingAccountingSnapshot: number;
    rowsScanned: number;
    rowsUpdated: number;
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationCheckDto.cs
export interface OnixClrInstallationCheckDto {
    server: string;
    database: string;
    instance: string;
    edition: string;
    version: string;
    machineUID: string;
    operation: string;
    method: string;
    host: string;
    path: string;
    aresDeploymentGroupId: string;
    userId: string;
    onixHeaders: Record<string, string>;
    usageCounters: OnixClrUsageCounterUploadDto[];
    pantheonBuildNo?: number;
    deploymentEnvironment: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupAccessDto.cs
export interface AresDeploymentGroupAccessDto {
    id: number;
    name: string;
    description: string;
    isPublic: boolean;
    isMappedToCompany: boolean;
    isBackgroundInstallable: boolean;
    minPantheonBuildNo?: number;
    maxPantheonBuildNo?: number;
    aresCount: number;
    workflowDefinitionCount: number;
    installationStepCount: number;
    deploymentEnvironment: AresDeploymentEnvironment;
}

// ../../OnixWeb.Domain/Dtos/PantheonMeshCentralRelayTargetDto.cs
export interface PantheonMeshCentralRelayTargetDto {
    pantheonIniId: number;
    companyId?: number;
    isEnabled: boolean;
    isAvailable: boolean;
    blockedReason?: string;
    meshCentralMappingId?: number;
    meshCentralGroupId?: string;
    meshCentralGroupName?: string;
    meshCentralServerDeviceId?: string;
    meshCentralServerDeviceName?: string;
    meshCentralSqlPort?: number;
    meshCentralSqlPortDefaulted: boolean;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderSpecDto.cs
export interface TrimWorkOrderSpecQuery {
    acKey: string;
    acName: string;
    anNo: number;
    acWorker: string;
    anMileage?: number;
    acIdent: string;
    anWork?: number;
    acNote2: string;
    adWorkStart?: Date;
    adWorkEnd?: Date;
}

// ../../OnixWeb.Domain/Dtos/AdminUsersTenantUserReturnDto.cs
export interface AdminUsersTenantUserReturnDto {
    id: string;
    userName: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelf.cs
export interface BookStackShelf {
    id: number;
    name: string;
    slug: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    createdBy: number;
    updatedBy: number;
    ownedBy: number;
    imageId: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpTicketMessagesResponseDto.cs
export interface SupportMcpTicketMessagesResponseDto {
    page: number;
    pageSize: number;
    totalCount: number;
    messages: SupportTicketSingleDtoMessageDto[];
}

// ../../OnixWeb.Domain/Dtos/THeOrderTotalsDto.cs
export interface THeOrderTotalsDto {
    acKey: string;
    anValue: number;
    anDiscount: number;
    valueWithDiscount: number;
    anVat: number;
    anForPay: number;
}

// ../../OnixWeb.Domain/Dtos/CreateBobAiMessageDto.cs
export interface CreateBobAiMessageDto {
    text: string;
    uniqueClientId?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiConclusionDto.cs
export interface SupportAiConclusionDto {
    status: string;
    summary: string;
    rootCauseHypotheses: SupportAiRootCauseHypothesisDto[];
    evidence: string[];
    recommendedNextActions: string[];
    needsHumanApproval: boolean;
    confidence?: number;
}

// ../../OnixWeb.Domain/Dtos/OfficialVehicleDto.cs
export interface OfficialVehicleDto {
    id: number;
    makeAndModel: string;
    pantheonId: string;
    registration: string;
}

// ../../OnixWeb.Domain/Dtos/WorkRecordPeriodOverviewWorkRecordWorkHours.cs
export interface WorkRecordPeriodOverviewWorkRecordWorkHours {
    costBearer: string;
    costBearerName: string;
    day: number;
    workHours: number;
    workMinutes: number;
    date: Date;
    note: string;
    subject: string;
    workRecordCostType: string;
    workRecordCostTypeId?: number;
    applicationUser: string;
    finalized: boolean;
    periodId?: number;
    month: number;
    year: number;
    workRecordPantheonCostType: string;
    workRecordPantheonCostGroup: string;
    workRecordPantheonCostGroupName: string;
    applicationUserId: string;
    lastName: string;
    companySettingsId?: number;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeReturnDto.cs
export interface DocumentTypeReturnDto {
    functionality: DocumentFunctionalityEnum;
    cacheDuration: number;
    warehouseName: string;
    bluetoothPrintCopiesNumber: number;
    itemListShowDetailed: boolean;
    articleSearchInitiallyLoadAll: boolean;
    articleSearchRepeatLastSearch: boolean;
    cacheUseForArticleSearch: boolean;
    cacheUseForCustomerSearch: boolean;
    cacheUseForWarehouseSearch: boolean;
    articleSearchShowOnlyInStock: boolean;
    articleSearchShowOnlyWhereAcFieldsAIs: string;
    articleSearchAllowSearchingByClassification: boolean;
    cacheUseCacheForAnyResource: boolean;
    documentOnCreateMakeBluetoothPrint: boolean;
    stockViewLoadAllOnOpen: boolean;
    stockViewShowOnlyInStock: boolean;
    warehouseOverviewShowOnlyInStock: boolean;
    documentOnCreateMakePDF: boolean;
    addingItemWarnIfQuantityMoreThanAvailable: boolean;
    adminCanEditDocumentAfterSaving: boolean;
    adminUseSerialNumberForItems: boolean;
    adminDocumentOnCreateMakeWarehouseReservation: boolean;
    adminItemQuantityMustBeInStock: boolean;
    adminAllowChangingItemPrice: boolean;
    workOrderPrintSpecificationDuration: boolean;
    adminSendDocumentToCompanyDocumentEmail: boolean;
    quantityDecimalPlaces: number;
    appendToItemIfExists?: boolean;
    showAcDoc1?: boolean;
    showAdDateDoc1?: boolean;
    showAcDoc2?: boolean;
    showAdDateDoc2?: boolean;
    ifCopyingFromOrderUpdateLeftOverQuantity?: boolean;
    hideClerkFieldOnPrint?: boolean;
    clerkFieldOnPrint?: string;
    hideAcceptedByFieldOnPrint?: boolean;
    acceptedByFieldOnPrint?: string;
    create: boolean;
    update: boolean;
    delete: boolean;
    read: boolean;
    acType: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderOverviewDto.cs
export interface MarservisWorkOrderOverviewDto {
    workOrderId: string;
    workOrderDate?: Date;
    documentNumber: number;
    subjectName: string;
    projectName: string;
    workDate?: Date;
    workerFirstName: string;
    workerLastName: string;
    time?: number;
    billableTime?: number;
    worker: string;
    itemGroupName: string;
    itemName: string;
    companySettingsId?: number;
    subjectId?: number;
    projectId?: number;
    itemGroupId?: number;
}

// ../../OnixWeb.Domain/Dtos/MarservisLocalWorkOrderReturnDto.cs
export interface MarservisLocalWorkOrderReturnDto {
    id: string;
    documentNumber: number;
    date: Date;
    projectId: number;
    project: MarservisLocalWorkOrderReturnProjectDto;
    note: string;
    subjectId?: number;
    subject: MarservisLocalWorkOrderReturnSubjectDto;
    status: MarservisWorkOrderStatusEnum;
    location: string;
    dateEnd: Date;
    hasFiles: boolean;
    hasMaterials: boolean;
    hasUserFiles: boolean;
    hasUserNotes: boolean;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface AresDeploymentGroupSnapshotPayloadDto {
    groupId: number;
    groupName: string;
    groupDescription: string;
    isPublic: boolean;
    isBackgroundInstallable: boolean;
    aresDefinitions: AresDeploymentGroupSnapshotAresDto[];
    installationSteps: AresDeploymentGroupSnapshotInstallationStepDto[];
    workflowDefinitions: AresDeploymentGroupSnapshotWorkflowDefinitionDto[];
    aresPayloads: TPaSqli[];
    workflowPayloads: TPaWorkflowDefinition[];
    reportPayloads: TPaReport[];
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface AresDeploymentGroupSnapshotAresDto {
    aresDeploymentAresId: number;
    aresAcKey: string;
    aresAcName: string;
    aresVersion?: number;
    executeSteps: boolean;
    executionPhase?: AresDeploymentExecutionPhase;
    executionPhaseOrder?: number;
    isSQLExecutionAres: boolean;
    isBoostrapExecutionAres: boolean;
    isTestSuiteAres: boolean;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface AresDeploymentGroupSnapshotInstallationStepDto {
    id: number;
    aresDeploymentGroupId: number;
    order?: number;
    variableName: string;
    variableType: string;
    resetsOnInvoicing: boolean;
    duration?: number;
    sumType: string;
    description: string;
    triggerType: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface AresDeploymentGroupSnapshotWorkflowDefinitionDto {
    id: number;
    aresDeploymentGroupId: number;
    acIdentify: string;
    acName: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface AresDeploymentGroupSnapshotSummaryDto {
    id: number;
    aresDeploymentGroupId: number;
    versionNo: number;
    name: string;
    notes: string;
    sourceHash: string;
    snapshotTakenAt: Date;
    isTesting: boolean;
    isStaging: boolean;
    isProduction: boolean;
    pullCount: number;
    lastPulledAt?: Date;
    installCount: number;
    lastInstalledAt?: Date;
    createdOn?: Date;
    createdBy: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface CreateAresDeploymentGroupSnapshotRequestDto {
    name: string;
    notes: string;
    markTesting: boolean;
    markStaging: boolean;
    markProduction: boolean;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface UpdateAresDeploymentGroupSnapshotRequestDto {
    name: string;
    notes: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface PrepareAresDeploymentGroupSnapshotsBatchRequestDto {
    groupIds: number[];
    name: string;
    notes: string;
    targetEnvironment: AresDeploymentEnvironment;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface PrepareAresDeploymentGroupSnapshotsBatchResponseDto {
    requestedGroupCount: number;
    testRunCount: number;
    items: PrepareAresDeploymentGroupSnapshotBatchItemDto[];
    hasErrors: boolean;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupSnapshotDto.cs
export interface PrepareAresDeploymentGroupSnapshotBatchItemDto {
    groupId: number;
    groupName: string;
    status: string;
    message: string;
    sourceHash: string;
    reusableTestSourceHash: string;
    testRepresentativeGroupId?: number;
    testReused: boolean;
    snapshot: AresDeploymentGroupSnapshotSummaryDto;
}

// ../../OnixWeb.Domain/Dtos/AresActivityReportDto.cs
export interface AresActivityReportDto {
    groups: AresActivityReportGroupDto[];
    rows: AresActivityReportRowDto[];
}

// ../../OnixWeb.Domain/Dtos/AresActivityReportDto.cs
export interface AresActivityReportGroupDto {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/AresActivityReportDto.cs
export interface AresActivityReportRowDto {
    companyId: number;
    companyName: string;
    accountingCompanyName: string;
    statuses: AresActivityReportStatusDto[];
}

// ../../OnixWeb.Domain/Dtos/AresActivityReportDto.cs
export interface AresActivityReportStatusDto {
    groupId: number;
    groupName: string;
    isActive?: boolean;
    lastCheckedAt?: Date;
    result: string;
    activeCount: number;
    totalCount: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiRunDetailDto.cs
export interface SupportAiRunDetailDto {
    id: number;
    ticketId?: number;
    threadId?: number;
    continuedFromRunId?: number;
    status: SupportAiRunStatusEnum;
    pauseReason?: SupportAiRunPauseReason;
    currentPhase: SupportAiRunPhaseEnum;
    lastEventSequence: number;
    createdOn?: Date;
    startedOn?: Date;
    completedOn?: Date;
    cancelRequestedOn?: Date;
    conclusionSummary?: string;
    lastError?: string;
    canContinue: boolean;
    triage?: SupportAiTriageDto;
    configuration?: SupportAiRunConfigurationDto;
    target?: SupportAiRunTargetDto;
    investigationTransport?: SupportAiInvestigationTransportDto;
    toolCalls: SupportAiToolCallDto[];
    conclusion?: SupportAiConclusionDto;
    reply?: SupportAiReplyDto;
}

// ../../OnixWeb.Domain/Dtos/SupportDailyMetricDayDto.cs
export interface SupportDailyMetricDayDto {
    day: Date;
    newTickets: number;
    resolvedTickets: number;
    resolvedTicketsExact: boolean;
    unresolvedTodayTickets: number;
    difference: number;
}

// ../../OnixWeb.Domain/Dtos/UserOnixDesktopSettingsDto.cs
export interface UserOnixDesktopSettingsDto {
    id: string;
    onixDesktopPantheonExePath: string;
    onixDesktopPantheonIniPath: string;
    onixDesktopPantheonExePathMac: string;
    onixDesktopPantheonIniPathMac: string;
    supportTimeLogRoundingMinutes?: number;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelfDetails.cs
export interface BookStackShelfDetailsCreatedBy {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelfDetails.cs
export interface BookStackShelfDetailsUpdatedBy {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelfDetails.cs
export interface BookStackShelfDetailsOwnedBy {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelfDetails.cs
export interface BookStackShelfDetailsTag {
    id: number;
    name: string;
    value: string;
    order: number;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelfDetails.cs
export interface BookStackShelfDetailsCover {
    id: number;
    name: string;
    url: string;
    createdAt: string;
    updatedAt: string;
    createdBy: number;
    updatedBy: number;
    path: string;
    type: string;
    uploadedTo: number;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelfDetails.cs
export interface BookStackShelfDetailsBook {
    id: number;
    name: string;
    slug: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackShelfDetails.cs
export interface BookStackShelfDetails {
    id: number;
    name: string;
    slug: string;
    description: string;
    createdBy: BookStackShelfDetailsCreatedBy;
    updatedBy: BookStackShelfDetailsUpdatedBy;
    ownedBy: BookStackShelfDetailsOwnedBy;
    createdAt: string;
    updatedAt: string;
    tags: BookStackShelfDetailsTag[];
    cover: BookStackShelfDetailsCover;
    books: BookStackShelfDetailsBook[];
}

// ../../OnixWeb.Domain/Dtos/TravelWarrantDto.cs
export interface TravelWarrantDto{
    id: string;
    note: string;
    place: string;
    driver: string;
    coDrivers: string;
    vehicle: string;
    travelStartDateTime?: Date;
    travelEndDateTime?: Date;
    travelStartMeter?: number;
    travelEndMeter?: number;
    expenseBearerId?: number;
    countryId?: number;
    officialVehicleId?: number;
    personalVehicleId?: number;
    applicationUserId: string;
    downPayment?: number;
    downPaymentCurrencyId?: number;
    downPaymentConversion?: number;
    placeOfDeparture: string;
    date?: Date;
    countryAllowance: number;
    countryAllowanceCurrency: string;
    expenseBearerAllowance: number;
    expenseBearerCurrency: string;
    expenseBearerAllowanceConversion: number;
    countryAllowanceConversion: number;
    travelKilometersConversion: number;
    travelKilometers: TravelKilometers;
    recalculateDownPaymentConversion: boolean;
    country?: Country;
    returnNote?: string;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeLinkDto.cs
export interface DocumentTypeLinkDto extends DocumentTypeLink {
    fromDocId?: number;
    toDocId?: number;
    fromLinkId?: number;
    toLinkId?: number;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderReclamationQuery.cs
export interface TrimWorkOrderReclamationQuery {
    acKey: string;
    acName: string;
    acIdent: string;
    oxInventoryNumber: string;
    anQty: number;
    acNote: string;
    acUm: string;
    anNo: number;
}

// ../../OnixWeb.Domain/Dtos/CreateGenericDocumentItemDtoSerialDto.cs
export interface CreateGenericDocumentItemDtoSerialDto {
    serialNumber: string;
    quantity: number;
    type?: string;
    dateDue: Date;
    relatedSSCC?: string;
    pallet?: CreateGenericDocumentItemDtoSerialDtoPalletDto;
}

// ../../OnixWeb.Domain/Dtos/PersonalVehicleDto.cs
export interface PersonalVehicleDto {
    id: number;
    makeAndModel: string;
    registration: string;
}

// ../../OnixWeb.Domain/Dtos/PantheonSessionUpsertDto.cs
export interface PantheonSessionUpsertDto {
    clientSessionId: string;
    pantheonIniId?: number;
    pantheonCompanyName: string;
    status: string;
    startedAt: Date;
    endedAt: Date;
    duration: number;
    note: string;
    supportTicketId?: number;
}

// ../../OnixWeb.Domain/Dtos/BookStackChapter.cs
export interface BookStackChapter {
    id: number;
    name: string;
    slug: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    createdBy: number;
    updatedBy: number;
    ownedBy: number;
    imageId: number;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderReceptionDto.cs
export interface TrimWorkOrderReceptionQuery {
    acKey: string;
    acName: string;
    acIdent: string;
    oxInventoryNumber: string;
    anQty: number;
    acNote: string;
    acUm: string;
    anNo?: number;
    acSerialNo: string;
    acSetOfItem: string;
    acDescr: string;
}

// ../../OnixWeb.Domain/Dtos/CreateGenericDocumentFromAnotherItemDto.cs
export interface CreateGenericDocumentFromAnotherItemDto {
    originPantheonAnNo: number;
    originPantheonDetails?: OriginPantheonItemDetails[];
}

// ../../OnixWeb.Domain/Dtos/EInvoiceOperatorDto.cs
export interface EInvoiceOperatorActionDto {
    reason: string;
    crossCompany: boolean;
    paused: boolean;
    documentKey?: string;
    externalId?: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceOperatorDto.cs
export interface EInvoiceOperatorDetailDto {
    dispatchId: string;
    companySettingsId: number;
    documentUid: string;
    acKey?: string;
    acDocType?: string;
    documentTypeId: number;
    actorUserId: string;
    configurationOwnerUserId: string;
    state: EInvoiceQueueState;
    stage: EInvoiceStage;
    createdAt: string;
    issuedAt?: string;
    firstFailureAt?: string;
    nextAttemptAt?: string;
    fiscalizedAt?: string;
    pdfArtifactId?: string;
    pdfFileQId?: number;
    pdfSha256?: string;
    pdfByteLength?: number;
    documentQId?: number;
    sourceFileQId?: number;
    xmlSha256?: string;
    businessSha256?: string;
    externalId?: string;
    exchange: EInvoiceExchangeOutcome;
    fiscalization: EInvoiceFiscalizationOutcome;
    reasonCode?: string;
    externalSendPaused: boolean;
    canRetrySafeStage: boolean;
    canRecoverPdf: boolean;
    canReconcile: boolean;
    audit: EInvoiceOperatorAuditDto[];
}

// ../../OnixWeb.Domain/Dtos/EInvoiceOperatorDto.cs
export interface EInvoiceOperatorAuditDto {
    createdAt: string;
    actorUserId?: string;
    fromState: EInvoiceQueueState;
    toState: EInvoiceQueueState;
    stage: EInvoiceStage;
    reasonCode?: string;
    operatorReason?: string;
    operatorDocumentKey?: string;
    operatorExternalId?: string;
}

// ../../OnixWeb.Domain/Dtos/UpdateSupportAiThreadResponseModeDto.cs
export interface UpdateSupportAiThreadResponseModeDto {
    responseMode: SupportAiThreadResponseMode;
}

// ../../OnixWeb.Domain/Dtos/MobileSettingsReturnDto.cs
export interface MobileSettingsReturnDto extends HasCreatedOnAndModifiedOn {
    userId: string;
    user: ApplicationUser;
    bluetoothPrinterName: string;
    bluetoothPrinterType: string;
    bluetoothPrinterAddress: string;
    bluetoothPrinterPaperWidth?: number;
    useDarkTheme: boolean;
    useListViewOnPickers: boolean;
    useTabletMode?: boolean;
    useWiderColumns?: boolean;
}

// ../../OnixWeb.Domain/Dtos/CreateGenericDocumentItemDtoSerialDtoPalletDto.cs
export interface CreateGenericDocumentItemDtoSerialDtoPalletDto {
    shortCode: string;
    SSCCCode?: string;
    createdAt: Date;
    userId?: number;
    acRegion?: string;
    acSubject?: string;
}

// ../../OnixWeb.Domain/Dtos/UpdateTHeSetSubjContactAddressDto.cs
export interface UpdateTHeSetSubjContactAddressDto {
    acType: string;
    acPhone: string;
    acNote: string;
}

// ../../OnixWeb.Domain/Dtos/UpdateTHeSetSubjContactDto.cs
export interface UpdateTHeSetSubjContactDto {
    acSubject: string;
    acActive: string;
    acName: string;
    acSurname: string;
    acFunction: string;
}

// ../../OnixWeb.Domain/Dtos/DocumentDto.cs
export interface DocumentDto {
    docNr: string;
    docType: string;
    dateDoc: Date;
    dateDue: Date;
    subjectCode: string;
    currency: string;
    rxRate: number;
    valueCurr: number;
    valueHRK: number;
    VATHRK: number;
    totalHRK: number;
    dept: string;
    linkDocNr: string;
    linkDocType: string;
    linkDateDoc: Date;
    note: string;
    items: DocumentItemDto[];
}

// ../../OnixWeb.Domain/Dtos/CreateGenericDocumentItemDtoScanDto.cs
export interface CreateGenericDocumentItemDtoScanDto {
    scanContent: string;
    scanDate: Date;
    fullScanContent?: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingWorkOrderWorkSpecDto.cs
export interface SubmittingWorkOrderWorkSpecViewModel {
    from: Date;
    to: Date;
    ident: string;
    note: string;
    kilometers: number;
    acKey: string;
    worker: string;
    location: LocationStructure;
    anNo?: number;
}

// ../../OnixWeb.Domain/Dtos/MaterialDto.cs
export interface TrimMaterial {
    acWarehouse: string;
    acName: string;
    acIdent: string;
    anStockMinusAnReservedSum?: number;
    acUm: string;
    acSetOfItem: string;
    serialNumbers: THeStockSerialNo[];
}

// ../../OnixWeb.Domain/Dtos/THeMoveTotalsDto.cs
export interface THeMoveTotalsDto {
    acKey: string;
    anValue: number;
    anDiscount: number;
    valueWithDiscount: number;
    anVat: number;
    anForPay: number;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketSearchDto.cs
export interface SupportTicketSearchDto {
    id: number;
    title: string;
}

// ../../OnixWeb.Domain/Dtos/MeshCentralGroupDto.cs
export interface MeshCentralGroupDto {
    id: string;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/DocumentFlowSelectionDuplicateResultDto.cs
export interface DocumentFlowSelectionDuplicateResultDto {
    documentIdMap: Record<number, number>;
    pairIdMap: Record<number, number>;
}

// ../../OnixWeb.Domain/Dtos/OnixClrUsageReportDtos.cs
export interface OnixClrUsageCounterUploadDto {
    periodYear: number;
    periodMonth: number;
    aresDeploymentGroupId: string;
    action: string;
    count: number;
    firstSeenUtc?: Date;
    lastSeenUtc?: Date;
}

// ../../OnixWeb.Domain/Dtos/OnixClrUsageReportDtos.cs
export interface OnixClrUsageReportFilterDto {
    year: number;
    month: number;
    companyId?: number;
    database: string;
    aresDeploymentGroupId: string;
    action: string;
}

// ../../OnixWeb.Domain/Dtos/OnixClrUsageReportDtos.cs
export interface OnixClrUsageReportSummaryDto {
    onixClrInstallationId: number;
    machineUID: string;
    server: string;
    database: string;
    companyId?: number;
    companyName: string;
    periodYear: number;
    periodMonth: number;
    aresDeploymentGroupId: string;
    aresDeploymentGroupName: string;
    action: string;
    count: number;
    firstSeenUtc: Date;
    lastSeenUtc: Date;
}

// ../../OnixWeb.Domain/Dtos/OnixClrUsageReportDtos.cs
export interface OnixClrUsageReportOptionsDto {
    companies: OnixPhoneFunctionalityActivityOptionDto[];
    databases: OnixPhoneFunctionalityActivityOptionDto[];
    aresDeploymentGroups: OnixPhoneFunctionalityActivityOptionDto[];
    actions: OnixPhoneFunctionalityActivityOptionDto[];
}

// ../../OnixWeb.Domain/Dtos/UpdateWorkSpecDto.cs
export interface UpdateWorkSpecDto {
    acKey: string;
    anNo: number;
    note: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemWorkReturnDto.cs
export interface MarservisWorkOrderItemWorkReturnDto extends MarservisWorkOrderItemWorkWithoutFilesReturnDto {
    hasFiles: boolean;
}

// ../../OnixWeb.Domain/Dtos/KanbanDataDtoItem.cs
export interface KanbanDataDtoItem {
    status: SupportStatusEnum;
    userId: string;
    userFirstName: string;
    agentId: string;
    agentFirstName: string;
    id: number;
    title: string;
}

// ../../OnixWeb.Domain/Dtos/TMnFileResponseDto.cs
export interface TMnFileResponseDto {
    acFileName: string;
    onixFileContent: number[];
    anQid: number;
}

// ../../OnixWeb.Domain/Dtos/TMnImageResponseDto.cs
export interface TMnImageResponseDto {
    acFileName: string;
    onixFileContent: number[];
    anQid: number;
}

// ../../OnixWeb.Domain/Dtos/MarservisMaterialDto.cs
export interface MarservisMaterialDto {
    name: string;
    unitOfMeasure: string;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneAdditionalReportData.cs
export interface OnixPhoneAdditionalReportData {
    reportTitle: string;
    jsonSchema: string;
    UISchema: string;
    reportUserSignatureText: string;
    reportUserSignsTheDocument: boolean;
    reportBccAddress: string;
    reportAddCompanySignature: boolean;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderServiceDto.cs
export interface TrimWorkOrderServiceQuery {
    acKey: string;
    acName: string;
    acIdent: string;
    anQty: number;
    acNote: string;
    acUm: string;
    anNo: number;
}

// ../../OnixWeb.Domain/Dtos/SubmittingWorkOrderDto.cs
export interface LocationStructure {
    longitude: number;
    latitude: number;
}

// ../../OnixWeb.Domain/Dtos/SubmittingWorkOrderDto.cs
export interface SubmittingWorkOrderViewModel {
    costBearer: SubmittingWorkOrderTHeCostDrv;
    buyer: SubmittingWorkOrderTHeSetSubj;
    otherAcWorkers?: string[];
    buyerPayer?: string;
    note: string;
    location: LocationStructure;
    documentType: string;
    endingMileage: number;
    startingMileage: number;
    zeroAcKey: string;
    signatory: string;
    contact: string;
    acDoc1: string;
    acDoc2: string;
    acDoc1Date?: Date;
    acDoc2Date?: Date;
    UID?: string;
    acFieldSF?: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingWorkOrderDto.cs
export interface SubmittingWorkOrderTHeCostDrv {
    acCostDrv: string;
    acName: string;
    acStatus: string;
    acConsignee: string;
    acDept: string;
    acFieldSa: string;
    anFieldNa?: number;
    acClassif: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingWorkOrderDto.cs
export interface SubmittingWorkOrderTHeSetSubj {
    acSubject: string;
    acName2: string;
    acAddress: string;
    acPost: string;
    acPin: string;
    acBuyer: string;
    acPayer: string;
    acActive: string;
    anRebate: number;
    anClerk?: number;
    acCountry: string;
    acVatCodePrefix: string;
    acPhone: string;
    acWarehouse: string;
}

// ../../OnixWeb.Domain/Dtos/AnalysisDocumentPerCustomerDto.cs
export interface AnalysisDocumentPerCustomerDto {
    document: string;
    value: number;
    date: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlTemplateDto.cs
export interface SqlTemplateDto {
    id: number;
    name: string;
    category: string;
    description: string;
    sqlText: string;
    isPinned: boolean;
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/NewAdminUserDto.cs
export interface NewAdminUserViewModel {
    username: string;
    email: string;
    password: string;
}

// ../../OnixWeb.Domain/Dtos/CreateTicketAndTimeLogDto.cs
export interface CreateTicketAndTimeLogDto {
    ticket: FastSupportTicketDto;
    timeLog: SupportTicketTimeLogDto;
}

// ../../OnixWeb.Domain/Dtos/WakaTimeAttachWorklogDto.cs
export interface WakaTimeAttachWorklogDto {
    ticketId: number;
}

// ../../OnixWeb.Domain/Dtos/UploadWorkRecordsDto.cs
export interface UploadWorkRecordsDto {
    year: number;
    month: number;
    users: string[];
}

// ../../OnixWeb.Domain/Dtos/FastSupportTicketDto.cs
export interface FastSupportTicketDto {
    title: string;
    companyId?: number;
    contactId?: number;
    contactEmailId?: number;
    status: SupportStatusEnum;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    projectId?: number;
    supportGroupId?: number;
}

// ../../OnixWeb.Domain/Dtos/DailyRecapDto.cs
export interface DailyRecapDto {
    fromDoc: string;
    toDoc: string;
    fromDate?: Date;
    toDate?: Date;
    items: DailyRecapDtoItemDto[];
    acKeys: string[];
}

// ../../OnixWeb.Domain/Dtos/DailyRecapDto.cs
export interface DailyRecapDtoItemDto {
    paymentType: string;
    paid: number;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerAuthorizedDto.cs
export interface TeamViewerAuthorizedDto {
    accessToken: string;
    refreshToken: string;
    tokenType: string;
    expiresIn: number;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeCreateOptionsDto.cs
export interface DocumentTypeCreateOptionsDto {
    optionsScope: DocumentTypeSyncOptionsScopeEnum;
    selectedOptions: string[];
    usersScope: DocumentTypeSyncUsersScopeEnum;
    selectedUsers: string[];
}

// ../../OnixWeb.Domain/Dtos/THeOrderPagedParametrizedDto.cs
export interface THeOrderPagedParametrizedDto {
    acDelivery?: string;
    acDept?: string;
    acStatus?: string;
    from?: Date;
    to?: Date;
    useDeliveryDeadline?: boolean;
    acStatusNotIn?: string[];
    acStatusIn?: string[];
    fromAcKey?: string;
    toAcKey?: string;
    anClerk?: number;
    acConsignee?: string;
    acReceiver?: string;
    sortField?: THeOrderPagedSortField;
    sortDescending?: boolean;
    showOnlyDocumentsWhereAnClerkIs?: number;
    showOnlyDocumentsWhereAnNoteClerkIs?: number;
    showAnClerkAndAnNoteClerkIsOROperation?: boolean;
    filterOrdersByThisAcWarehouse?: string;
    scannedModifierChar?: string;
}

// ../../OnixWeb.Domain/Dtos/UpdatingWorkRecordDto.cs
export interface UpdatingWorkRecordDto {
    id: number;
    costBearer: string;
    workRecordCostTypeId: number;
    description: string;
}

// ../../OnixWeb.Domain/Dtos/SupportDailyMetricTicketDto.cs
export interface SupportDailyMetricTicketDto {
    id: number;
    title: string;
    status: SupportStatusEnum;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    company?: string;
    contact?: string;
    user?: string;
    temporaryOwner?: string;
    modifiedBy?: string;
    modifiedById?: string;
    resolvedBy?: string;
    resolvedById?: string;
    resolvedOn?: Date;
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlEditorInsightsDto.cs
export interface SqlEditorInsightsDto {
    users: SqlUserInfoDto[];
    sessions: SqlSessionInfoDto[];
    usersError: string;
    sessionsError: string;
}

// ../../OnixWeb.Domain/Dtos/SqlEditorInsightsDto.cs
export interface SqlUserInfoDto {
    userName: string;
    type: string;
    authenticationType: string;
    defaultSchema: string;
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlEditorInsightsDto.cs
export interface SqlSessionInfoDto {
    sessionId?: number;
    loginName: string;
    hostName: string;
    programName: string;
    status: string;
    loginTime?: Date;
    command: string;
    cpuTimeMs?: number;
    totalElapsedTimeMs?: number;
    blockingSessionId?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbExecDebugRequestDto {
    companyId: number;
    procedureName: string;
    parameters?: SupportMcpCompanyDbDebugParameterDto[];
    sessionContext?: Record<string, string>;
    anUserId?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbScriptDebugRequestDto {
    companyId: number;
    sql: string;
    sessionContext?: Record<string, string>;
    anUserId?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbRuntimeLogsRequestDto {
    companyId: number;
    limit?: number;
    contains?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbCreatePantheonUserRequestDto {
    companyId: number;
    databaseName?: string;
    acUserId: string;
    subject: string;
    firstName?: string;
    lastName?: string;
    pin?: string;
    langId?: string;
    active?: string;
    profile?: string;
    additPersonMark?: string;
    code?: string;
    foreigner: boolean;
    requireActiveSubject?: boolean;
    sessionContext?: Record<string, string>;
    anUserId?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbDebugParameterDto {
    name: string;
    value?: any;
    direction?: string;
    dbType?: string;
    size?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbExecDebugResponseDto {
    companyId: number;
    procedureName: string;
    databaseName?: string;
    success: boolean;
    rolledBack: boolean;
    durationMs: number;
    returnValue?: any;
    outputParameters: Record<string, any>;
    resultSets: Record<string, any>[][];
    error?: SupportMcpSqlExecutionErrorDto;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbScriptDebugResponseDto {
    companyId: number;
    databaseName?: string;
    success: boolean;
    rolledBack: boolean;
    durationMs: number;
    resultSets: Record<string, any>[][];
    error?: SupportMcpSqlExecutionErrorDto;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbRuntimeLogsResponseDto {
    companyId: number;
    databaseName?: string;
    limit: number;
    selectedSourceTable?: string;
    candidateTables: string[];
    items: Record<string, any>[];
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpCompanyDbCreatePantheonUserResponseDto {
    companyId: number;
    databaseName?: string;
    acUserId: string;
    subject: string;
    success: boolean;
    created: boolean;
    existingBefore: boolean;
    durationMs: number;
    anUserId?: number;
    acName?: string;
    acSurname?: string;
    acPin?: string;
    subjectActive?: boolean;
    subjectIsWorker?: boolean;
    subjectIsWarehouse?: boolean;
    resultSets: Record<string, any>[][];
    error?: SupportMcpSqlExecutionErrorDto;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyDbDebugDtos.cs
export interface SupportMcpSqlExecutionErrorDto {
    number?: number;
    lineNumber?: number;
    state?: number;
    class?: number;
    procedure?: string;
    message: string;
}

// ../../OnixWeb.Domain/Dtos/AnalysisTotalsDto.cs
export interface AnalysisTotalsDto {
    money: AnalysisCurrencyTotal[];
    customer: AnalysisCurrencyTotal[];
    supplier: AnalysisCurrencyTotal[];
}

// ../../OnixWeb.Domain/Dtos/ReactFlowElement.cs
export interface Data {
    dataData: any;
    type: number;
    color: string;
    label: string;
    id: string;
}

// ../../OnixWeb.Domain/Dtos/ReactFlowElement.cs
export interface Position {
    x: number;
    y: number;
}

// ../../OnixWeb.Domain/Dtos/ReactFlowElement.cs
export interface Style {
    background: string;
}

// ../../OnixWeb.Domain/Dtos/ReactFlowElement.cs
export interface ReactFlowElement {
    data: Data;
    id: string;
    position: Position;
    style: Style;
    sourcePosition: string;
    targetPosition: string;
    className: string;
    source: string;
    sourceHandle: any;
    target: string;
    targetHandle: any;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketBranchParentDto.cs
export interface SupportTicketBranchParentDto {
    id: number;
    sourceMessageId: number;
    sourceMessageCreatedOn?: Date;
    sourceTicketId: number;
    sourceTicketTitle: string;
    sourceTicketStatus: SupportStatusEnum;
    sourceTicketPriority: SupportPriorityEnum;
    sourceTicketSource: SupportSourceEnum;
    sourceTicketContact: string;
    sourceTicketCompany: string;
    linkedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/CreateGenericDocumentItemDto.cs
export interface CreateGenericDocumentItemDto {
    quantity: number;
    rebate1: number;
    rebate2: number;
    rebate3: number;
    pantheonAcIdent: string;
    note: string;
    price: number;
    packQuantity: number;
    serialNumber: string;
    serialNumbers: CreateGenericDocumentItemDtoSerialDto[];
    scans?: CreateGenericDocumentItemDtoScanDto[];
}

// ../../OnixWeb.Domain/Dtos/SetExternalIdDto.cs
export interface SetExternalIdDto {
    companySettingsId: number;
    externalId: string;
}

// ../../OnixWeb.Domain/Dtos/CompanySqlTaskScheduleDto.cs
export interface CompanySqlTaskScheduleDto {
    mode: SqlTaskScheduleMode;
    onceAt?: Date;
    everyNMinutes?: number;
    everyNHours?: number;
    dailyAt: string;
    daysOfWeek: DayOfWeek[];
    dayOfMonth?: number;
    customCron: string;
    timeZoneId: string;
    description: string;
    startDate?: Date;
    endDate?: Date;
}

// ../../OnixWeb.Domain/Dtos/MarservisUserMobileWorkOrderItemDto.cs
export interface MarservisUserMobileWorkOrderItemDto {
    id: number;
    note: string;
    deadlineDate?: Date;
    workOrderId: string;
    itemId?: number;
    itemName: string;
    itemCode: string;
    status: MarservisWorkOrderItemStatusEnum;
    projectId?: number;
    subjectId?: number;
    workOrderStatus?: MarservisWorkOrderStatusEnum;
    workOrderLocation: string;
    workOrderDateEnd?: Date;
    projectName: string;
    projectDueDate: any;
    subjectShortName: string;
    subjectLongName: string;
    userId: string;
    itemGroupId?: number;
    itemGroupName: string;
    unfinishedItems?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketSingleDtoMessageDto.cs
export interface SupportTicketSingleDtoMessageDto {
    id: number;
    content: string;
    createdOn?: Date;
    modifiedOn?: Date;
    inbound: boolean;
    CCEmails: string[];
    notifyUsers: SupportTicketSingleDtoMessageDtoNotifyUserDto[];
    private: boolean;
    sentBy: string;
    sentById: string;
    sentAs: string;
    sentAsId: string;
    isTask: boolean;
    isTaskDone: boolean;
    responsibleAgent: string;
    responsibleAgentEmail: string;
    responsibleAgentId: string;
    taskDue?: Date;
    taskStart?: Date;
    ticketId?: number;
    hasAttachments: boolean;
    helpLink: string;
    helpTitle: string;
    helpBookId?: number;
    helpId?: number;
    internalCommunicationToId?: number;
    hasInternalCommunication: boolean;
    remoteContentSavedFileId?: number;
    originalCCs: string;
    originalSender: string;
    originalSenderName: string;
    originalSubject: string;
    originalReceiver: string;
    supportEmailAddress?: string;
    originalReceiverName: string;
    globalMessageId: string;
    seenRightNow: boolean;
    customerHasSeen?: boolean;
    customerHasSeenAt?: Date;
    scheduledSendOn?: Date;
    recommendedUserForTicket: SupportOpenAIExecution;
    collapsed: boolean;
    isQueryExecution: boolean;
    codexTaskId?: string;
    codexTaskLastSeenOn?: Date;
    codexTaskWorkedOn?: Date;
    supportAiThreadId?: number;
    supportAiRunId?: number;
    sentByEmail: string;
    sentAsEmail: string;
}

// ../../OnixWeb.Domain/Dtos/NewSupportTicketDto.cs
export interface NewSupportTicketDto extends HasUniqueClientId {
    userId: string;
    status: SupportStatusEnum;
    dateDue?: Date;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    type: string;
    title: string;
    description: string;
    contactCompanyContactId?: number;
    contactCompanyCompanyId?: number;
    contactEmailId?: number;
    supportGroupId?: number;
    projectId?: number;
    notifyUsers: string[];
    CC: string[];
    wasSplitFromMessageId?: number;
}

// ../../OnixWeb.Domain/Dtos/DatalabMappingQueueRowDto.cs
export interface DatalabMappingQueueRowDto {
    companyId: number;
    companyName?: string;
    linkId?: number;
    status?: CompanyDatalabReferenceLinkStatusEnum;
    isManual: boolean;
    suggestedScore?: number;
    suggestedReason?: string;
    lastSuggestedAt?: Date;
    reviewedById?: string;
    reviewedAt?: Date;
    referenceCompanyId?: number;
    referenceCompanyName?: string;
    referenceCompanyDetailUrl?: string;
    referenceCompanyRemoteKey?: string;
    referenceCompanyLastSyncedAt?: Date;
    latestRunId?: number;
    latestRunStatus?: DatalabReleaseLockdownRunStatusEnum;
    latestRunStartedOn?: Date;
    latestRunCompletedOn?: Date;
    latestRunProcessedPopupCount?: number;
    latestRunDeletedEntryCount?: number;
    latestRunSaveTriggered?: boolean;
    latestRunSummaryLog?: string;
    latestRunErrorText?: string;
}

// ../../OnixWeb.Domain/Dtos/OkUpdateWorkOrderResult.cs
export interface OkUpdateWorkOrderResult {
    acKey: string;
}

// ../../OnixWeb.Domain/Dtos/CompanyMeshCentralDeviceRouteUpsertDto.cs
export interface CompanyMeshCentralDeviceRouteUpsertDto {
    companyId: number;
    companyMeshCentralGroupMappingId: number;
    meshCentralDeviceId: string;
    name?: string;
    routeType: MeshCentralDeviceRouteTypeEnum;
    remotePort: number;
}

// ../../OnixWeb.Domain/Dtos/CostBearerWorkerWorkHoursDto.cs
export interface CostBearerWorkerWorkHoursDto {
    workerId: string;
    workerName: string;
    totalMinutes: number;
    entries: CostBearerWorkHourEntryDto[];
}

// ../../OnixWeb.Domain/Dtos/AiSupportOptions.cs
export interface AiSupportOptions {
    apiKey?: string;
    threadItemsEnabled: boolean;
    streamingEnabled: boolean;
    codexThreadUiEnabled: boolean;
    naturalAssistantOutputEnabled: boolean;
}

// ../../OnixWeb.Domain/Dtos/UserChangesForCompanyInPeriodDto.cs
export interface UserChangesForCompanyInPeriodDto {
    companySettings: CompanySettings;
    newUsers: ApplicationUser[];
    deletedUsers: ApplicationUser[];
    restoredUsers: ApplicationUser[];
    period: string;
}

// ../../OnixWeb.Domain/Dtos/CountryDto.cs
export interface CountryDto {
}

// ../../OnixWeb.Domain/Dtos/WikiEntryCreateDto.cs
export interface WikiEntryCreateDto {
    id?: number;
    title: string;
    content: string;
    tagIds: number[];
    categoryId?: number;
}

// ../../OnixWeb.Domain/Dtos/WakaTimeSyncRangeDto.cs
export interface WakaTimeSyncRangeDto {
    dateFrom: Date;
    dateTo: Date;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeTemplateUpsertDto.cs
export interface DocumentTypeTemplateUpsertDto {
    name: string;
    description?: string;
    isPartial: boolean;
    includedProperties?: string[];
    fromDocumentTypeId?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiToolCallDto.cs
export interface SupportAiToolCallDto {
    id: number;
    runId: number;
    eventSequence: number;
    toolName: string;
    status: SupportAiToolCallStatusEnum;
    displaySummary: string;
    argumentsJson?: string;
    resultJson?: string;
    startedOn?: Date;
    completedOn?: Date;
    error?: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerUsersDto.cs
export interface TeamViewerUsersDtoUser {
    id: string;
    name: string;
    onlineState: string;
    permissions: string;
    active: boolean;
    logSessions: boolean;
    showCommentWindow: boolean;
    customQuicksupportId: string;
    customQuickjoinId: string;
    email: string;
    lastAccessDate: Date;
    activatedLicenseId: string;
    activatedLicenseName: string;
    activatedSubLicenseName: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerUsersDto.cs
export interface TeamViewerUsersDto {
    users: TeamViewerUsersDtoUser[];
}

// ../../OnixWeb.Domain/Dtos/SubjectDto.cs
export interface SubjectDto{
    id: number;
    shortName: string;
    longName: string;
    address: string;
    countryId?: number;
    contactName: string;
    phone: string;
    mail: string;
    VATIDPrefix: string;
    VATID: string;
}

// ../../OnixWeb.Domain/Dtos/MeshCentralDeviceRouteRelayDescriptorDto.cs
export interface MeshCentralDeviceRouteRelayDescriptorDto {
    target: MeshCentralDeviceRouteRelayTargetDto;
    meshCentralRelayWebSocketUrl: string;
}

// ../../OnixWeb.Domain/Dtos/CreateSupportAiThreadCommentDto.cs
export interface CreateSupportAiThreadCommentDto {
    text: string;
    uniqueClientId?: string;
}

// ../../OnixWeb.Domain/Dtos/WorkRecordFinalizingUserDto.cs
export interface WorkRecordFinalizingUserDto {
    userId: string;
    name: string;
    finalized: boolean;
    periodId: number;
    worker: string;
    readyToFinalize: boolean;
}

// ../../OnixWeb.Domain/Dtos/TravelWarrantDuplicateDto.cs
export interface TravelWarrantDuplicateDto {
    id: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMessageDisplayContentDto.cs
export interface SupportMessageDisplayContentDto {
    messageId: number;
    ticketId?: number;
    remoteContentSavedFileId?: number;
    contentSource: string;
    content: string;
    hasHiddenSignature: boolean;
    hasExpandableEmailParts: boolean;
}

// ../../OnixWeb.Domain/Dtos/UpdateWorkOrderDto.cs
export interface UpdateWorkOrderDto {
    acKey: string;
    anFieldNA?: number;
    anFieldNB?: number;
    acDoc1: string;
    acDoc2: string;
    acNote: string;
    acContactPrsn: string;
    acContactPrsn3: string;
    UID?: string;
    otherAcWorkers?: string[];
    documentType?: number;
    acDoc1Date?: Date;
    acDoc2Date?: Date;
    receiver: string;
    acFieldSF?: string;
}

// ../../OnixWeb.Domain/Dtos/WikiEntryCategorySortedDto.cs
export interface WikiEntryCategorySortedDto {
    subjectId: number;
    sort: WikiEntryCategorySortedDtoSortEnum;
    objectId: number;
}

// ../../OnixWeb.Domain/Dtos/WikiEntryCategorySortedDto.cs
export enum WikiEntryCategorySortedDtoSortEnum {
    Inside = 0,
    After = 1,
    Before = 2,
}

// ../../OnixWeb.Domain/Dtos/TasksSearchDto.cs
export interface TasksSearchDto {
    ticketId?: number;
    projectId?: number;
    companyId?: number;
    isDone?: boolean;
    descending: boolean;
    delegated: boolean;
    userId: string;
    dateFilterCustomRange: DateFilterCustomRange;
    dateFilterType?: DateFilterType;
    orderBy?: TasksSearchDtoOrderByEnum;
    page: number;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemReturnDto.cs
export interface MarservisWorkOrderItemReturnDto {
    id: number;
    workOrderId: string;
    user: MarservisWorkOrderItemReturnDtoUserDto;
    userId: string;
    billableTime: number;
    deadlineDate?: Date;
    note: string;
    itemId?: number;
    item?: MarservisWorkOrderItemReturnDtoItemDto;
    status: MarservisWorkOrderItemStatusEnum;
    totalHours: number[];
    itemGroupId?: number;
    itemGroup?: MarservisWorkOrderItemReturnDtoItemGroupDto;
    hasUserNotes: boolean;
    hasUserFiles: boolean;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderImageDto.cs
export interface TrimWorkOrderImageQuery {
    acPicture: number[];
    acLnkKey: string;
    anKey?: number;
    acName: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderOverviewSearch.cs
export interface MarservisWorkOrderOverviewSearch {
    dateFilter?: DateFilterType;
    dateCustomRange?: DateFilterCustomRange;
    workDateFilter?: DateFilterType;
    workDateCustomRange?: DateFilterCustomRange;
    subjectId?: number;
    projectId?: number;
    usernameSearch: string;
    itemGroupId?: number;
    orderBy?: string;
    orderDescending?: boolean;
}

// ../../OnixWeb.Domain/Dtos/WorkSpecDto.cs
export interface TrimWorkSpecQuery {
    acNote2: string;
}

// ../../OnixWeb.Domain/Dtos/OnixInfoAdditionalTHeSetSubjDataSubjDto.cs
export interface OnixInfoAdditionalTHeSetSubjDataSubjDto extends OnixInfoAdditionalTHeSetSubjData {
    subjectAcName2: string;
    subjectAcBuyerTypeFull: string;
    subjectPantheonVersion: string;
    monthlyPayments: THeSetSubjPriceItem[];
    subjectAcActive: string;
    hasHostingType: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportAiRunSummaryDto.cs
export interface SupportAiRunSummaryDto {
    id: number;
    ticketId?: number;
    threadId?: number;
    continuedFromRunId?: number;
    status: SupportAiRunStatusEnum;
    pauseReason?: SupportAiRunPauseReason;
    currentPhase: SupportAiRunPhaseEnum;
    lastEventSequence: number;
    createdOn?: Date;
    startedOn?: Date;
    completedOn?: Date;
    cancelRequestedOn?: Date;
    conclusionSummary?: string;
    lastError?: string;
    canContinue: boolean;
    target?: SupportAiRunTargetDto;
    investigationTransport?: SupportAiInvestigationTransportDto;
}

// ../../OnixWeb.Domain/Dtos/FiscalizationMonitoringDto.cs
export interface FiscalizationMonitoringDto {
    id: string;
    fiscalizationQueueEntryId?: number;
    kind: string;
    documentTypeId: number;
    acKey?: string;
    zki?: string;
    jir?: string;
    fiscalized: boolean;
    fiscalizationError?: string;
    systemError?: string;
    state?: EInvoiceQueueState;
    stage?: EInvoiceStage;
    documentTypeUserId?: string;
    documentTypeUserName?: string;
    documentTypeUserFirstName?: string;
    documentTypeUserLastName?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketSimilarDto.cs
export interface SupportTicketSimilarDto {
    id: number;
    title: string;
    status: SupportStatusEnum;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    company?: string;
    companyId?: number;
    contact?: string;
    contactId?: number;
    project?: string;
    projectId?: number;
    user?: string;
    temporaryOwner?: string;
    createdOn?: Date;
    modifiedOn?: Date;
    score: number;
    isResolved: boolean;
    matchReasons: string[];
}

// ../../OnixWeb.Domain/Dtos/SupportMessageNextWorkStartDto.cs
export interface SupportMessageNextWorkStartDto {
    nextWorkStartUtc?: Date;
}

// ../../OnixWeb.Domain/Dtos/SupportAiMessageAttachmentDto.cs
export interface SupportAiMessageAttachmentDto {
    id: number;
    name: string;
    contentType?: string;
    sizeBytes?: number;
    serverPath?: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingWorkOrderMaterialDto.cs
export interface SubmittingWorkOrderMaterialViewModel {
    acIdent: string;
    quantity: number;
    note: string;
    acKey: string;
    acSerialNo: string;
    anNo?: number;
    acName: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerGroupsDtoGroupReturn.cs
export interface TeamViewerGroupsDtoGroupReturn {
    id: string;
    name: string;
    sharedWith: TeamViewerGroupsDtoSharedWithReturn[];
}

// ../../OnixWeb.Domain/Dtos/MainServerCompanyOverviewDto.cs
export interface MainServerCompanyOverviewDto {
    companySettingsId: number;
    companySettingsName: string;
    companyPantheonName: string;
    externalId: string;
    activeUserCount: number;
    activeUserNames: string[];
    mainServerUrl: string;
    supportCompanyId?: number;
    supportCompanyName: string;
    supportCompanyNotOurCustomer?: boolean;
}

// ../../OnixWeb.Domain/Dtos/BookStackResponseWrapper.cs
export interface BookStackResponseWrapper<T> {
    data: T;
}

// ../../OnixWeb.Domain/Dtos/AddTOpFileDto.cs
export interface AddTOpFileDto {
    content: number[];
    acKey: string;
    fileName: string;
    fileCategory: string;
    tOpFileGroupId?: number;
    note: string;
}

// ../../OnixWeb.Domain/Dtos/SupportFilterQuery.cs
export interface DateFilterCustomRange {
    from?: Date;
    to?: Date;
}

// ../../OnixWeb.Domain/Dtos/SupportFilterQuery.cs
export interface ApplicationUserOnlyId {
    id?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportFilterQuery.cs
export interface SupportFilterQuery {
    agentQueryType?: string;
    createdOn?: DateFilterType;
    createdOnRange?: DateFilterCustomRange;
    modifiedOn?: DateFilterType;
    modifiedOnRange?: DateFilterCustomRange;
    dateDue?: DateFilterType;
    dateDueRange?: DateFilterCustomRange;
    contactId?: number;
    statuses?: SupportStatusEnum[];
    priority?: SupportPriorityEnum;
    source?: SupportSourceEnum;
    type?: string;
    agentId?: string;
    temporaryAgentId?: string;
    orderBy?: string;
    orderDescending?: boolean;
    companyId?: number;
    projectId?: number;
    supportGroupId?: number;
    multipleAgents?: ApplicationUserOnlyId[];
    multipleTemporaryAgents?: ApplicationUserOnlyId[];
    page?: number;
    filterType?: SupportTicketFilterTypeEnum;
}

// ../../OnixWeb.Domain/Dtos/SupportFilterQuery.cs
export enum DateFilterType {
    Today = 0,
    Yesterday = 1,
    ThisWeek = 2,
    ThisMonth = 3,
    LastMonth = 4,
    CustomRange = 5,
    UntilToday = 6,
}

// ../../OnixWeb.Domain/Dtos/THeMoveDto.cs
export interface THeMoveDto extends THeMove {
}

// ../../OnixWeb.Domain/Dtos/MobileSupportTicketDto.cs
export interface MobileSupportTicketDto {
    id: number;
    title: string;
    unread: number;
    createdOn?: Date;
    firstMessage: string;
}

// ../../OnixWeb.Domain/Dtos/MobileUserCustomMessageDto.cs
export interface MobileUserCustomMessageDto {
    title: string;
    message: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerOAuth2TokenDto.cs
export interface TeamViewerOAuth2TokenDto {
    grantType: string;
    code: string;
    redirectUri: string;
    clientId: string;
    scope: string;
    refreshToken: string;
    username: string;
    password: string;
    clientSecret: string;
    codeVerifier: string;
}

// ../../OnixWeb.Domain/Dtos/AdminUsersGroupsDto.cs
export interface AdminUsersGroupsDto {
    startIndex: number;
    count: number;
    key: string;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/ProjectDto.cs
export interface ProjectDto {
    id?: number;
    name: string;
    description: string;
    dueDate: Date;
    finished: boolean;
    billable: boolean;
    invoice: boolean;
    subjectId?: number;
    model: string;
    HINNumber: string;
    engineModel: string;
    engineSerialNumber: string;
    transmissionModel: string;
    transmissionSerialNumber: string;
}

// ../../OnixWeb.Domain/Dtos/TimeZoneDto.cs
export interface TimeZoneDto {
    id: string;
    displayName: string;
}

// ../../OnixWeb.Domain/Dtos/SignedDocumentEmailRecoveryDtos.cs
export interface SignedDocumentEmailRecoveryRequestDto {
    legacyJobId: string;
    rowGuid: string;
}

// ../../OnixWeb.Domain/Dtos/SignedDocumentEmailRecoveryDtos.cs
export interface SignedDocumentEmailRecoveryResultDto {
    recoveryJobId: string;
    fingerprint: string;
    matchingLegacyJobIds: string[];
}

// ../../OnixWeb.Domain/Dtos/ItemReturnDto.cs
export interface ItemReturnDto {
    id: number;
    code: string;
    name: string;
    departmentId?: number;
    itemGroupId?: number;
    department: Department;
    itemGroupItems: ItemReturnItemGroupItemDto[];
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringCache {
    fileCacheCount: string;
    fileCacheMemoryUsage: string;
    fileCacheHits: string;
    fileCacheMisses: string;
    totalFilesCached: string;
    outputCacheCount: string;
    outputCacheMemoryUsage: string;
    outputCacheHits: string;
    outputCacheMisses: string;
    uriCacheCount: string;
    uriCacheHits: string;
    uriCacheMisses: string;
    totalUrisCached: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringCpu {
    percentUsage: string;
    threads: string;
    processes: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringDisk {
    ioWriteOperationsSec: string;
    ioReadOperationsSec: string;
    pageFaultsSec: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringMemory {
    handles: string;
    privateBytes: string;
    privateWorkingSet: string;
    systemInUse: string;
    installed: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringNetwork {
    bytesSentSec: string;
    bytesRecvSec: string;
    connectionAttemptsSec: string;
    totalBytesSent: string;
    totalBytesRecv: string;
    totalConnectionAttempts: string;
    currentConnections: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringRequests {
    active: string;
    perSec: string;
    total: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringRoot {
    id: string;
    uptime: string;
    network: IISWebSiteMonitoringNetwork;
    requests: IISWebSiteMonitoringRequests;
    memory: IISWebSiteMonitoringMemory;
    cpu: IISWebSiteMonitoringCpu;
    disk: IISWebSiteMonitoringDisk;
    cache: IISWebSiteMonitoringCache;
    website: IISWebSiteMonitoringWebsite;
}

// ../../OnixWeb.Domain/Dtos/IISWebSiteMonitoring.cs
export interface IISWebSiteMonitoringWebsite {
    name: string;
    id: string;
    status: string;
}

// ../../OnixWeb.Domain/Dtos/SupportDailyMetricDetailsDto.cs
export interface SupportDailyMetricDetailsDto {
    day: Date;
    resolvedTicketsExact: boolean;
    exactResolutionMetricsStartedOn?: Date;
    newTickets: SupportDailyMetricTicketDto[];
    resolvedTickets: SupportDailyMetricTicketDto[];
    unresolvedTickets: SupportDailyMetricTicketDto[];
}

// ../../OnixWeb.Domain/Dtos/MarservisLocalWorkOrderReturnSubjectDto.cs
export interface MarservisLocalWorkOrderReturnSubjectDto {
    shortName: string;
    longName: string;
    id: number;
}

// ../../OnixWeb.Domain/Dtos/UpdateTMnFileDto.cs
export interface UpdateTMnFileDto {
    tMnDocumentId: number;
    fileName: string;
    fileSize?: number;
    fileContent: number[];
}

// ../../OnixWeb.Domain/Dtos/ExternalAuthDtos.cs
export interface ExternalAuthStartResultDto {
    url: string;
}

// ../../OnixWeb.Domain/Dtos/ExternalAuthDtos.cs
export interface ExternalAuthTicketDto {
    ticket: string;
    expiresAt: Date;
}

// ../../OnixWeb.Domain/Dtos/ExternalAuthDtos.cs
export interface ExternalAuthAccountChoiceDto {
    userId: string;
    userName?: string;
    companySettingsId?: number;
    companyName?: string;
}

// ../../OnixWeb.Domain/Dtos/ExternalAuthDtos.cs
export interface ExternalAuthExchangeResultDto {
    token?: string;
    accountChoices: ExternalAuthAccountChoiceDto[];
    requiresAccountSelection: boolean;
    portalRegistrationTicket?: string;
    portalRegistrationEmail?: string;
    portalRegistrationDisplayName?: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisMaterialReturnDto.cs
export interface MarservisMaterialReturnDto extends MarservisMaterialDto {
    id: number;
}

// ../../OnixWeb.Domain/Dtos/CompanySQLDto.cs
export interface CompanySQLDto {
    query: string;
    companyId: number;
}

// ../../OnixWeb.Domain/Dtos/THeOrderDto.cs
export interface THeOrderDto extends THeOrder {
    acDocType: string;
    adDate?: Date;
    acDoc2: string;
    acDoc1: string;
}

// ../../OnixWeb.Domain/Dtos/CompanySqlTaskUpsertDto.cs
export interface CompanySqlTaskUpsertDto {
    name: string;
    companyId: number;
    sqlText: string;
    connectionString: string;
    enabled: boolean;
    maxRuns?: number;
    schedule: CompanySqlTaskScheduleDto;
}

// ../../OnixWeb.Domain/Dtos/AnalysisCurrencyTotal.cs
export interface AnalysisCurrencyTotal {
    currency: string;
    totalCredit: number;
    credit: number;
    totalCreditInCurrency: number;
    creditInCurrency: number;
    totalDebit: number;
    debit: number;
    totalDebitInCurrency: number;
    debitInCurrency: number;
    value: number;
    valueInCurrency: number;
}

// ../../OnixWeb.Domain/Dtos/UnreadTicketDto.cs
export interface UnreadTicketDto {
    title: string;
    id?: number;
    contact: string;
    content: string;
    date?: Date;
    userId: string;
    user: string;
    messageId: number;
    agentId?: string;
    agent: string;
    type: string;
    isTaskDone: boolean;
    isTask: boolean;
    remoteContentSavedFileId?: number;
    taskStart: Date;
}

// ../../OnixWeb.Domain/Dtos/MarservisLocalWorkOrderReturnProjectDtoSubjectDto.cs
export interface MarservisLocalWorkOrderReturnProjectDtoSubjectDto {
    shortName: string;
}

// ../../OnixWeb.Domain/Dtos/GrantBobAiCompanyDbDto.cs
export interface GrantBobAiCompanyDbDto {
    companyId: number;
    databaseName: string;
    reason?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketSingleDtoTodoDto.cs
export interface SupportTicketSingleDtoTodoDto {
    id: number;
    note: string;
    notified: boolean;
    dateTime: Date;
    user: string;
    userEmail: string;
    userId: string;
    ticketId: number;
}

// ../../OnixWeb.Domain/Dtos/THeMoveDailyIncomeDto.cs
export interface THeMoveDailyIncomeDto {
    anForPay: number;
    payMethodName: string;
}

// ../../OnixWeb.Domain/Dtos/THeMoveDailyIncomeDto.cs
export interface THeMoveDailyIncomeSummaryDto {
    fromDoc?: number;
    toDoc?: number;
    fromDate?: Date;
    toDate?: Date;
    items: THeMoveDailyIncomeDto[];
}

// ../../OnixWeb.Domain/Dtos/SupportAiRunTargetDto.cs
export interface SupportAiRunTargetDto {
    ticketCompanyId?: number;
    ticketCompanyName?: string;
    investigationCompanyId?: number;
    investigationCompanyName?: string;
    databaseSourceCompanyId?: number;
    databaseSourceCompanyName?: string;
    investigationDatabaseName?: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingWorkOrderEndDto.cs
export interface SubmittingWorkOrderEndViewModel {
    acKey: string;
    location: LocationStructure;
    endingMileage: number;
    startingMileage: number;
    signatory: string;
    acDoc1: string;
    acDoc2: string;
    signature: number[];
    note: string;
    contact: string;
    acDoc1Date?: Date;
    acDoc2Date?: Date;
    acFieldSF?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpSqlQueryDto.cs
export interface SupportMcpSqlQueryDto {
    companyId: number;
    query: string;
}

// ../../OnixWeb.Domain/Dtos/ItemReturnItemGroupItemItemGroupDto.cs
export interface ItemReturnItemGroupItemItemGroupDto {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationReturnDto.cs
export interface OnixClrInstallationReturnDto extends OnixClrInstallation {
    companyName: string;
}

// ../../OnixWeb.Domain/Dtos/TravelWarrantItemDto.cs
export interface TravelWarrantItemDto extends HasUniqueClientId {
    id?: number;
    travelWarrantId: string;
    date?: Date;
    costTypeId?: number;
    note: string;
    value?: number;
    currencyId?: number;
    conversion?: number;
    hasBackingInvoice: boolean;
    notForPayment: boolean;
}

// ../../OnixWeb.Domain/Dtos/EmailSettingsDto.cs
export interface EmailSettingsDto {
    host: string;
    checkPorts: number[];
    username: string;
    password: string;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketSingleDtoMessageDtoAttachmentDto.cs
export interface SupportTicketSingleDtoMessageDtoAttachmentDto {
    id: number;
    name: string;
    serverPath: string;
}

// ../../OnixWeb.Domain/Dtos/UnreadSupportTicketMessagesDto.cs
export interface UnreadSupportTicketMessagesDto {
    userId: string;
    companySettingsId?: number;
    count: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiDatabaseGrantDto.cs
export interface SupportAiDatabaseGrantDto {
    id: number;
    threadId: number;
    companyId: number;
    companyName?: string;
    databaseName: string;
    grantedByUserId: string;
    grantedOn: Date;
    reason?: string;
}

// ../../OnixWeb.Domain/Dtos/IISWebServers.cs
export interface IISWebServersRoot {
    websites: IISWebServersWebsite[];
}

// ../../OnixWeb.Domain/Dtos/IISWebServers.cs
export interface IISWebServersWebsite {
    name: string;
    id: string;
    status: string;
}

// ../../OnixWeb.Domain/Dtos/ExcelFilesForImport.cs
export interface ExcelSheetForImport {
    name: string;
    forImport: boolean;
    importTableName: string;
    headerOption: HeaderOption;
    manualHeaderData: string[];
    data: string[][];
}

// ../../OnixWeb.Domain/Dtos/ExcelFilesForImport.cs
export interface ExcelFileForImport {
    fileName: string;
    forImport: boolean;
    forLocale: string;
    sheets: ExcelSheetForImport[];
}

// ../../OnixWeb.Domain/Dtos/ExcelFilesForImport.cs
export interface ExcelFilesForImport {
    files: ExcelFileForImport[];
}

// ../../OnixWeb.Domain/Dtos/ExcelFilesForImport.cs
export interface ExcelFileSettings {
    fileName: string;
    locale: string;
    isCsv: boolean;
    csvSettings?: ExcelFileCsvSettings;
}

// ../../OnixWeb.Domain/Dtos/ExcelFilesForImport.cs
export interface ExcelFileCsvSettings {
    newLine: NewLineEnum;
    allowComments: boolean;
    comment: string;
    delimiter: DelimiterEnum;
    escape: string;
    ignoreBlankLines: boolean;
    ignoreReferences: boolean;
    includePrivateMembers: boolean;
    quote: string;
    trim: boolean;
}

// ../../OnixWeb.Domain/Dtos/ExcelFilesForImport.cs
export enum HeaderOption {
    None = 0,
    FirstRow = 1,
    Manual = 2,
}

// ../../OnixWeb.Domain/Dtos/CreateSupportAiTurnDto.cs
export interface CreateSupportAiTurnDto {
    message: string;
    attachmentIds: number[];
}

// ../../OnixWeb.Domain/Dtos/SupportTicketBranchDto.cs
export interface SupportTicketBranchDto {
    id: number;
    sourceMessageId: number;
    sourceTicketId?: number;
    relatedTicketId: number;
    relatedTicketTitle: string;
    relatedTicketStatus: SupportStatusEnum;
    relatedTicketPriority: SupportPriorityEnum;
    relatedTicketSource: SupportSourceEnum;
    relatedTicketContact: string;
    relatedTicketCompany: string;
    relatedTicketUser: string;
    relatedTicketTemporaryOwner: string;
    relatedTicketCreatedOn?: Date;
    relatedTicketModifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/TMnDocumentWithStatus.cs
export interface TMnDocumentWithStatus {
    document: TMnDocument;
    status: TPaSetDocTypeStat;
}

// ../../OnixWeb.Domain/Dtos/MaintenanceWindowNoticeDtos.cs
export interface CreateMaintenanceWindowNoticeDto {
    campaignId: string;
    message: string;
    start: string;
    end: string;
}

// ../../OnixWeb.Domain/Dtos/MaintenanceWindowNoticeDtos.cs
export interface MaintenanceWindowNoticeResultDto {
    noticeId: number;
    campaignId: string;
    startUtc: Date;
    endUtc: Date;
    targetedUsers: number;
    preparedUsers: number;
    attemptedUsers: number;
    uncertainUsers: number;
    submittedUsers: number;
    incompleteUsers: number;
    state: string;
}

// ../../OnixWeb.Domain/Dtos/AddSubjectDto.cs
export interface AddSubjectDto {
    acSubject: string;
    acName2: string;
    acPin: string;
    acAddress?: string;
    acPost?: string;
    acBuyer: string;
    acSupplier: string;
    anClerk?: number;
    acSkis?: string;
    docId?: number;
    acWayOfSale?: string;
    acPayMethod?: string;
}

// ../../OnixWeb.Domain/Dtos/AresUpdateQueueDto.cs
export interface AresUpdateStages {
}

// ../../OnixWeb.Domain/Dtos/AresUpdateQueueDto.cs
export interface AresUpdateQueueDto {
    queuedAt: string;
    jobs: AresUpdateQueuedJobDto[];
}

// ../../OnixWeb.Domain/Dtos/AresUpdateQueueDto.cs
export interface AresUpdateQueuedJobDto {
    companyId: number;
    companyName: string;
    databaseName: string;
    jobId: string;
}

// ../../OnixWeb.Domain/Dtos/AresUpdateQueueDto.cs
export interface AresUpdateStatusRequestDto {
    jobs: AresUpdateQueuedJobDto[];
    jobIds: string[];
}

// ../../OnixWeb.Domain/Dtos/AresUpdateQueueDto.cs
export interface AresUpdateStatusDto {
    jobs: AresUpdateJobStatusDto[];
    isFinished: boolean;
    hasFailures: boolean;
}

// ../../OnixWeb.Domain/Dtos/AresUpdateQueueDto.cs
export interface AresUpdateJobStatusDto {
    companyId: number;
    companyName: string;
    databaseName: string;
    jobId: string;
    state: string;
    stage: string;
    stageText: string;
    currentGroupName: string;
    currentGroupIndex?: number;
    totalGroupCount?: number;
    updatedAt?: string;
    isFinished: boolean;
    isFailed: boolean;
    reason: string;
}

// ../../OnixWeb.Domain/Dtos/AresUpdateQueueDto.cs
export interface AresUpdateProgressDto {
    companyId: number;
    companyName: string;
    databaseName: string;
    stage: string;
    stageText: string;
    currentGroupName: string;
    currentGroupIndex?: number;
    totalGroupCount?: number;
    updatedAt?: string;
}

// ../../OnixWeb.Domain/Dtos/PromotionalContactDto.cs
export interface PromotionalContactDto {
    id: number;
    fullName: string;
    note: string;
    isPromotionalEmailRecipient: boolean;
    deactivated: boolean;
    isMaintenance: boolean;
    isSpam: boolean;
    isIBackup: boolean;
    emails: string[];
    companies: PromotionalContactCompanyDto[];
    lastActivity?: Date;
}

// ../../OnixWeb.Domain/Dtos/PromotionalContactDto.cs
export interface PromotionalContactCompanyDto {
    id: number;
    name: string;
    buyerType: string;
}

// ../../OnixWeb.Domain/Dtos/PromotionalContactDto.cs
export interface SetPromotionalRecipientsDto {
    contactIds: number[];
    isPromotionalEmailRecipient: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpTicketsResponseDto.cs
export interface SupportMcpTicketsResponseDto {
    page: number;
    pageSize: number;
    totalCount: number;
    items: SupportTicketDto[];
}

// ../../OnixWeb.Domain/Dtos/MarservisLocalWorkOrderReturnProjectDto.cs
export interface MarservisLocalWorkOrderReturnProjectDto {
    name: string;
    subject: MarservisLocalWorkOrderReturnProjectDtoSubjectDto;
    id: number;
}

// ../../OnixWeb.Domain/Dtos/ExpenseBearerDto.cs
export interface ExpenseBearerDto {
    active: boolean;
    allowance: number;
    bearer: string;
    consignee: string;
    country: string;
    currency: string;
    group: string;
    id: number;
    name: string;
    pantheonId: string;
    place: string;
    receiver: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiDatabaseGrantRequestDto.cs
export interface SupportAiDatabaseGrantRequestDto {
    companyId?: number;
    companyName?: string;
    databaseNameHint?: string;
    whyNeeded: string;
}

// ../../OnixWeb.Domain/Dtos/SubjectAPIDto.cs
export interface SubjectAPIDto{
    subjectCode: string;
    subjectName: string;
    subjectShortName: string;
    address: string;
    post: string;
    city: string;
    country: string;
    phone: string;
    OIB: string;
    VATIDPrex: string;
    VATID: string;
    wayOfSale: SubjectSellTypeEnum;
    active: boolean;
    buyer: boolean;
    supplier: boolean;
}

// ../../OnixWeb.Domain/Dtos/HasUniqueClientId.cs
export interface HasUniqueClientId {
    uniqueClientId: string;
}

// ../../OnixWeb.Domain/Dtos/ItemReturnItemGroupItemDto.cs
export interface ItemReturnItemGroupItemDto {
    id: number;
    itemGroup: ItemReturnItemGroupItemItemGroupDto;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerGroupsDtoSharedWithReturn.cs
export interface TeamViewerGroupsDtoSharedWithReturn {
    alias: string;
    userId: string;
}

// ../../OnixWeb.Domain/Dtos/CompanyMeshCentralGroupMappingReturnDto.cs
export interface CompanyMeshCentralGroupMappingReturnDto {
    id: number;
    companyId: number;
    companyName?: string;
    meshCentralGroupId: string;
    meshCentralGroupName: string;
    meshCentralServerDeviceId?: string;
    meshCentralServerDeviceName?: string;
    mssqlPort?: number;
    lastSeenAt?: Date;
    isStale: boolean;
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/MovePDFDto.cs
export interface MovePDFViewModel {
    move: THeMove;
    param: TPaSysParam;
}

// ../../OnixWeb.Domain/Dtos/AllActiveAccountsDtoAccountDto.cs
export interface AllActiveAccountsDtoAccountDto {
    id: number;
    type: AccountType;
    code: string;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/CompanyMergePreviewDto.cs
export interface CompanyMergeFieldActions {
}

// ../../OnixWeb.Domain/Dtos/CompanyMergePreviewDto.cs
export interface CompanyMergePreviewDto {
    sourceCompanyId: number;
    sourceCompanyName: string;
    targetCompanyId: number;
    targetCompanyName: string;
    hasConflicts: boolean;
    fields: CompanyMergeFieldPreviewDto[];
    relatedItems: CompanyMergeRelatedItemDto[];
}

// ../../OnixWeb.Domain/Dtos/CompanyMergePreviewDto.cs
export interface CompanyMergeFieldPreviewDto {
    key: string;
    label: string;
    sourceValue: string;
    targetValue: string;
    hasConflict: boolean;
    requiresSelection: boolean;
    defaultAction: string;
    allowedActions: string[];
}

// ../../OnixWeb.Domain/Dtos/CompanyMergePreviewDto.cs
export interface CompanyMergeRelatedItemDto {
    key: string;
    label: string;
    sourceCount: number;
    targetCount: number;
    outcome: string;
}

// ../../OnixWeb.Domain/Dtos/CompanyMergePreviewDto.cs
export interface CompanyMergeFieldResolutionDto {
    key: string;
    action: string;
}

// ../../OnixWeb.Domain/Dtos/CompanyMergePreviewDto.cs
export interface CompanyMergeResolvedRequestDto {
    fromCompanyId: number;
    toCompanyId: number;
    fieldResolutions: CompanyMergeFieldResolutionDto[];
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemWorkMaterialReturnDto.cs
export interface MarservisWorkOrderItemWorkMaterialReturnDto {
    id: number;
    materialId: number;
    materialName: string;
    unitOfMeasure: string;
    quantity: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMessageEditDto.cs
export interface SupportMessageEditDto extends SupportMessageDto {
    id: number;
}

// ../../OnixWeb.Domain/Dtos/BookStackAddPage.cs
export interface BookStackAddPage {
    bookId: number;
    name: string;
    html: string;
}

// ../../OnixWeb.Domain/Dtos/WakaTimeAvailableProjectDto.cs
export interface WakaTimeAvailableProjectDto {
    name: string;
    hasRepository: boolean;
}

// ../../OnixWeb.Domain/Dtos/EditSupportTicketDto.cs
export interface EditSupportTicketDto {
    userId: string;
    temporaryOwnerId: string;
    status: SupportStatusEnum;
    dateDue?: Date;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    type: string;
    title: string;
    description: string;
    contactCompanyCompanyId?: number;
    contactCompanyContactId?: number;
    contactEmailId?: number;
    projectId?: number;
}

// ../../OnixWeb.Domain/Dtos/MeshCentralGroupSuggestionDto.cs
export interface MeshCentralGroupSuggestionDto extends MeshCentralGroupDto {
    score: number;
    reason: string;
}

// ../../OnixWeb.Domain/Dtos/THeSetItemCalculated.cs
export interface THeStockSetItemCalculated extends THeSetItem {
    anStockMinusAnReservedSum: number;
}

// ../../OnixWeb.Domain/Dtos/THeSetItemCalculated.cs
export interface THeSetItemCalculated extends THeSetItem {
    anStockMinusAnReservedSum?: number;
    price: number;
}

// ../../OnixWeb.Domain/Dtos/TMnFileUploadResponseDto.cs
export interface TMnFileUploadResponseDto {
    anQid: number;
    anDocumentQid: number;
    acFileGuid: string;
    acFileName: string;
    adTimeIns?: Date;
    anUserIns?: number;
    adTimeChg?: Date;
    anUserChg?: number;
    anFileSize?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketLatestMessageDto.cs
export interface SupportTicketLatestMessageDto {
    createdOn?: Date;
    textContent: string;
    inbound: boolean;
    private: boolean;
    sentAs: SupportTicketLatestMessageDtoUserDto;
    sentBy: SupportTicketLatestMessageDtoUserDto;
    customer: string;
    id: number;
    htmlContent: string;
    remoteContentSavedFileId?: number;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeSyncOptionsDto.cs
export interface DocumentTypeSyncOptionsDto {
    documentTypesScope: DocumentTypeSyncDocumentTypesScopeEnum;
    selectedDocumentTypes: string[];
    optionsScope: DocumentTypeSyncOptionsScopeEnum;
    selectedOptions: string[];
    usersScope: DocumentTypeSyncUsersScopeEnum;
    selectedUsers: string[];
    createIfNotExists: boolean;
}

// ../../OnixWeb.Domain/Dtos/UserInfoViewModelV4UserInfoDto.cs
export interface UserInfoViewModelV4UserInfoDto {
    database: string;
    companyName: string;
    anDocKeyLenNumber: number;
    pantheonUser: string;
    worker: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemWorkDto.cs
export interface MarservisWorkOrderItemWorkDto extends HasUniqueClientId {
    id?: number;
    workOrderItemId?: number;
    time?: number;
    date?: Date;
    cause: string;
    remedy: string;
    note: string;
    materials: string;
    materialUsages?: MarservisWorkOrderItemWorkMaterialInputDto[];
}

// ../../OnixWeb.Domain/Dtos/MobileSettingsDto.cs
export interface MobileSettingsDto {
    bluetoothPrinterName: string;
    bluetoothPrinterType: string;
    bluetoothPrinterPaperWidth?: number;
    useDarkTheme: boolean;
    userId: string;
    useListViewOnPickers: boolean;
    useTabletMode?: boolean;
    useOnlyShortcuts: boolean;
    useDocumentTypeCodesInTitles?: boolean;
    bluetoothPrinterBoldMode?: boolean;
    bluetoothPrinterPrintSpeed?: number;
    useWiderColumns?: boolean;
    a4PrinterURL?: string;
    language?: string;
    thermalPrinterPrintVerticalPDF417?: boolean;
}

// ../../OnixWeb.Domain/Dtos/ChangeDetailsDto.cs
export interface ChangeDetailsDto {
    userName: string;
    email: string;
}

// ../../OnixWeb.Domain/Dtos/AdminUserDto.cs
export interface AdminUserViewModel {
    user: ApplicationUser;
    userRoles: string[];
    availableRoles: string[];
    databases: string[];
    pantheonConnected: boolean;
    userPantheonDocumentTypes: TPaSetDocType[];
    userPantheonContacts: THeSetSubjContact[];
    userPantheonParameters: TPaSysParamSys[];
    alternativeUser: ApplicationUser;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpMessageAttachmentDtos.cs
export interface SupportMcpMessageAttachmentsResponseDto {
    messageId: number;
    ticketId?: number;
    totalCount: number;
    attachments: SupportMcpMessageAttachmentDto[];
}

// ../../OnixWeb.Domain/Dtos/SupportMcpMessageAttachmentDtos.cs
export interface SupportMcpMessageAttachmentDto {
    attachmentId: number;
    name: string;
    contentType?: string;
    contentDisposition?: string;
    cid?: string;
    isInline: boolean;
    isPublic: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpMessageAttachmentDtos.cs
export interface SupportMcpAttachmentContentResponseDto {
    messageId: number;
    ticketId?: number;
    attachmentId: number;
    name: string;
    contentType?: string;
    contentDisposition?: string;
    cid?: string;
    isInline: boolean;
    isPublic: boolean;
    totalBytes: number;
    returnedBytes: number;
    maxBytes: number;
    truncated: boolean;
    textContent?: string;
    textContentLength?: number;
    base64Content?: string;
}

// ../../OnixWeb.Domain/Dtos/CostBearerWorkerHoursDto.cs
export interface CostBearerWorkerHoursDto {
    userId: string;
    totalMinutes: number;
    totalWorkRecords: number;
}

// ../../OnixWeb.Domain/Dtos/FiscalizationQueueEntryListDto.cs
export interface FiscalizationQueueEntryListDto {
    id: number;
    documentTypeId: number;
    acKey: string;
    UID: string;
    ZKI: string;
    jir: string;
    fiscalInternalNumber: string;
    fiscalSequenceNumber?: number;
    fiscalYear?: number;
    fiscalBaseAmount?: number;
    fiscalTotal?: number;
    fiscalizationError: string;
    systemError: string;
    fiscalized: boolean;
    XML: string;
    requestData: string;
    alreadyTriedFiscalizing: boolean;
    documentTypeUserId: string;
    documentTypeUserName: string;
    documentTypeUserFirstName: string;
    documentTypeUserLastName: string;
}

// ../../OnixWeb.Domain/Dtos/TicketPresenceDto.cs
export interface TicketPresenceUserDto {
    userId: string;
    fullName?: string;
    email?: string;
    lastSeenUtc: Date;
}

// ../../OnixWeb.Domain/Dtos/TicketPresenceDto.cs
export interface TicketPresenceDto {
    ticketId: number;
    users: TicketPresenceUserDto[];
}

// ../../OnixWeb.Domain/Dtos/TicketPresenceDto.cs
export interface TicketMessageCreatedDto {
    ticketId: number;
    messageId: number;
    sentById?: string;
    createdOnUtc: Date;
}

// ../../OnixWeb.Domain/Dtos/BookStackPagesListPage.cs
export interface BookStackPagesListPage {
    id: number;
    bookId: number;
    chapterId: number;
    name: string;
    slug: string;
    priority: number;
    draft: boolean;
    template: boolean;
    createdAt: string;
    updatedAt: string;
    createdBy: number;
    updatedBy: number;
    ownedBy: number;
}

// ../../OnixWeb.Domain/Dtos/UpdatingWorkOrderWorkSpecDto.cs
export interface UpdatingWorkOrderWorkSpecViewModel extends SubmittingWorkOrderWorkSpecViewModel {
    anNo: number;
}

// ../../OnixWeb.Domain/Dtos/OrderPDFViewModel.cs
export interface OrderPDFViewModel {
    order: THeOrder;
    param: TPaSysParam;
}

// ../../OnixWeb.Domain/Dtos/CompanyRunbookNoteDto.cs
export interface CompanyRunbookNoteDto extends HasUniqueClientId {
    id?: number;
    companyId: number;
    title: string;
    content: string;
    tags: string;
}

// ../../OnixWeb.Domain/Dtos/KeyValuePair.cs
export interface KeyValuePair {
    key: string;
    value: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiTriageDto.cs
export interface SupportAiTriageDto {
    summary: string;
    casePackId?: string;
    investigationGoal: string;
    reasoning: string;
    recommendedToolNames: string[];
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemReturnDtoProjectDto.cs
export interface MarservisWorkOrderItemReturnDtoProjectDto {
    name: string;
    dueDate: Date;
    id: number;
}

// ../../OnixWeb.Domain/Dtos/PagedResultDto.cs
export interface PagedResult<T> {
    totalItems: number;
    items: T[];
    page: number;
    count: number;
    totalPages: number;
    lastPage: boolean;
}

// ../../OnixWeb.Domain/Dtos/MainDatabaseSetupDmsUsersDto.cs
export interface MainDatabaseSetupDmsUsersDto {
    dmsObjectsExist: boolean;
    opdmsExists: boolean;
    pantheonUsers: MainDatabaseSetupPantheonUserDto[];
}

// ../../OnixWeb.Domain/Dtos/MainDatabaseSetupDmsUsersDto.cs
export interface MainDatabaseSetupPantheonUserDto {
    acUserId: string;
    acTitle: string;
}

// ../../OnixWeb.Domain/Dtos/SavingWorkHoursDto.cs
export interface SavingWorkHours {
    id: number;
    workRecordId?: number;
    day: number;
    workHours: number;
    workMinutes: number;
    startTime?: number;
    note: string;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderMoveDto.cs
export interface TrimMove {
    acReceiver: string;
}

// ../../OnixWeb.Domain/Dtos/ConfirmAccountEmailDto.cs
export interface ConfirmAccountEmailDto {
    userId: string;
    token: string;
}

// ../../OnixWeb.Domain/Dtos/CompanySettingsSingleReturnDto.cs
export interface CompanySettingsSingleReturnDto {
    id: number;
    onixPhoneEInvoiceEnabled?: boolean;
    eInvoiceIssuerVatRegistered?: boolean;
    connectionName: string;
    supportEmailAddress: string;
    supportEmailPassword: string;
    supportRedirectAllToSender: boolean;
    supportAutoReplyOnNewTicket: boolean;
    supportAutoReplyOnNewTicketSubject?: string;
    supportAutoReplyOnNewTicketBody?: string;
    wooCommerceKey: string;
    wooCommerceSecret: string;
    wooCommerceLocation: string;
    timeZone: string;
    culture: string;
    pantheonAnDocKeyLenNumber: number;
    pantheonCompanyName: string;
    pantheonAcCompanyPrtTextA: string;
    pantheonAcCompanyPrtTextB: string;
    companyDocumentsEmail: string;
    teamViewerScriptKey: string;
    teamViewerClientId: string;
    teamViewerClientSecret: string;
    teamViewerGroupId: string;
    meshCentralServerUrl?: string;
    meshCentralUsername?: string;
    meshCentralPassword?: string;
    datalabSyncEnabled: boolean;
    datalabUsername?: string;
    datalabPassword?: string;
    datalabBaseUrl?: string;
    datalabReferencePartnerQuery: string;
    bookStackUrl: string;
    additionalBottomTextOnPrint: string;
    workOrderItemsAdditionalReportData: OnixPhoneAdditionalReportData;
    fiscCertPassword: string;
    hasPrivateFiscCert: boolean;
    companyStamp: number[];
    useSecondaryCurrency: boolean;
    companyOutboundEmail: string;
    companyOutboundEmailHost: string;
    companyOutboundEmailPassword: string;
    companyOutboundEmailPort: number;
    companyOutboundEmailUseSSL: boolean;
    companyOutboundEmailUseTLS: boolean;
    companyOutboundEmailDisplayName: string;
    companyOutboundEmailUser: string;
    companySQLConnectionString: string;
    tenant?: OnixTenant;
    pantheonAlsoUseNDigitBarcodes?: number;
    testingFiscalisation?: boolean;
    companyGS1Prefix?: string;
    pantheonCompanyImage: number[];
    pantheonCompanyOnixPhoneSmallImage?: number[];
    alternateMainServerPrefix: string;
    workOrderWorkerPickerIncludesInactiveWorkers: boolean;
    aiSupportApiKey?: string;
    aiSupportTriageModel?: string;
    aiSupportInvestigationModel?: string;
    aiSupportReasoningEffort?: string;
    aiSupportVerbosity?: string;
    aiSupportRunBudgetMode: AiSupportRunBudgetMode;
    aiSupportMaxToolRounds?: number;
    aiSupportMaxInputTokensPerTurn?: number;
    aiSupportMaxOutputTokensPerTurn?: number;
    aiSupportDefaultTimeoutMinutes?: number;
}

// ../../OnixWeb.Domain/Dtos/PantheonSessionAttachDto.cs
export interface PantheonSessionAttachDto {
    ticketId: number;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceSettingsDto.cs
export interface EInvoiceSettingsDto {
    onixPhoneEInvoiceEnabled: boolean;
    eInvoiceIssuerVatRegistered?: boolean;
}

// ../../OnixWeb.Domain/Dtos/CurrencyDto.cs
export interface CurrencyDto {
    code: string;
    id: number;
    longName: string;
    name: string;
    pantheonId: string;
    unit: number;
}

// ../../OnixWeb.Domain/Dtos/ConnectionQuery.cs
export interface ConnectionQueryDto {
    connectionString: string;
    query: string;
    ticketId?: number;
    runOnAllDatabases: boolean;
    skipAlreadyExecutedDatabases: boolean;
    confirmDangerousExecution: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportAiRunConfigurationDto.cs
export interface SupportAiRunConfigurationDto {
    triageModel: string;
    investigationModel: string;
    reasoningEffort: string;
    verbosity: string;
    runBudgetMode: AiSupportRunBudgetMode;
    maxToolRounds: number;
    maxInputTokensPerTurn: number;
    maxOutputTokensPerTurn: number;
    defaultTimeoutMinutes: number;
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderMoveIdentDto.cs
export interface TrimMoveIdent {
    acIdent: string;
}

// ../../OnixWeb.Domain/Dtos/WorkOrderStateDto.cs
export interface WorkOrderStateViewModel {
    workSpec: TrimWorkOrderSpecQuery[];
    workMove: TrimWorkOrderQuery;
    workMaterial: TrimWorkOrderMaterialQuery[];
    workServices: TrimWorkOrderServiceQuery[];
    workImages: TrimWorkOrderImageQuery[];
    workReceptions: TrimWorkOrderReceptionQuery[];
    workReclamations: TrimWorkOrderReclamationQuery[];
}

// ../../OnixWeb.Domain/Dtos/NewMobileTicketDto.cs
export interface NewMobileTicketDto {
    ticketId?: number;
    message: string;
}

// ../../OnixWeb.Domain/Dtos/AddTHeSetSubjContactAddressDto.cs
export interface AddTHeSetSubjContactAddressDto {
    acSubject: string;
    anNo: number;
    acType: string;
    acPhone: string;
    acNote: string;
}

// ../../OnixWeb.Domain/Dtos/PasswordRecoveryDtos.cs
export interface PasswordRecoveryRequestDto {
    userNameOrEmail: string;
}

// ../../OnixWeb.Domain/Dtos/PasswordRecoveryDtos.cs
export interface PasswordRecoveryResetDto {
    userId: string;
    token: string;
    newPassword: string;
}

// ../../OnixWeb.Domain/Dtos/QueryDataDto.cs
export interface QueryData {
    paging: PagingModel;
    query: QueryStructure;
    orderBy: string;
    orderDescending: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketDtoTimeLogDto.cs
export interface SupportTicketDtoTimeLogDto {
    id: number;
    agent: string;
    agentEmail: string;
    agentId: string;
    billable: boolean;
    invoice: boolean;
    exportedOn?: Date;
    workOutsideWorkingHours: boolean;
    date: Date;
    note: string;
    technicalNote: string;
    time: number;
    billableTime: number;
    type: string;
    ticketId?: number;
    teamViewerSessionId: string;
    ciscoPhoneSessionId: string;
    projectPhase: string;
    uniqueClientId?: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerSessionReturnDto.cs
export interface TeamViewerSessionReturnDto {
    id: string;
    userId: string;
    username: string;
    deviceId: string;
    deviceName: string;
    groupId: string;
    groupName: string;
    startDate: Date;
    endDate: Date;
    currency: string;
    billingState: string;
    contactId: string;
    duration: number;
    supportTicket: SupportTicket;
    supportTicketId?: number;
    supportTicketTimeLog: SupportTicketTimeLog;
    supportTicketTimeLogId?: number;
    user: ApplicationUser;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentInstallationStepPointDto.cs
export interface AresDeploymentInstallationStepPointDto {
    id: number;
    isInvoicedToAccounting: boolean;
    accountingCompanyId?: number;
    accountingCompanyName?: string;
    companyId?: number;
    companyName?: string;
    deploymentGroupName?: string;
    sumType?: InvoiceSumType;
    variableName?: string;
    duration?: number;
    modifiedOn?: Date;
    description?: string;
    resetsOnInvoicing?: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAiTimeLogDto.cs
export interface SupportMcpAiTimeLogCheckpointStatuses {
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAiTimeLogDto.cs
export interface SupportMcpAiTimeLogRequestDto {
    workedProject?: string;
    codexTaskId: string;
    cumulativeDurationMs: number;
    snapshotAtUtc: Date;
    note: string;
    technicalNote: string;
    messageId?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAiTimeLogDto.cs
export interface SupportMcpCreateAiTimeLogDto extends SupportMcpAiTimeLogRequestDto {
    previewFingerprint: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAiTimeLogDto.cs
export interface SupportMcpAiTimeLogCheckpointDto {
    timeLogId: number;
    ticketId: number;
    cumulativeDurationMs: number;
    snapshotAtUtc: Date;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAiTimeLogDto.cs
export interface SupportMcpAiTimeLogDto {
    workedProject?: string;
    previousProjectId?: number;
    projectId?: number;
    project?: string;
    timeLogId?: number;
    ticketId: number;
    messageId?: number;
    agentId: string;
    agent: string;
    date: Date;
    codexTaskId: string;
    cumulativeDurationMs: number;
    previousCheckpoint?: SupportMcpAiTimeLogCheckpointDto;
    canCreate: boolean;
    checkpointStatus: string;
    durationMs: number;
    loggedMinutes: number;
    time: number;
    billableTime: number;
    billable: boolean;
    invoice: boolean;
    workOutsideWorkingHours: boolean;
    type: string;
    note: string;
    technicalNote: string;
    previewFingerprint: string;
    created: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpAiTimeLogDto.cs
export interface SupportMcpAiTimeLogCreateResultDto {
    previewMatched: boolean;
    timeLog: SupportMcpAiTimeLogDto;
}

// ../../OnixWeb.Domain/Dtos/DayAndWorkRecordDto.cs
export interface DayAndWorkRecordDto {
    workRecordId?: number;
    day: number;
}

// ../../OnixWeb.Domain/Dtos/ToggleTravelWarrantStatusDto.cs
export interface ToggleTravelWarrantStatusDto {
    id: string;
    status: TravelWarrantStatus;
    forPeriod?: Date;
}

// ../../OnixWeb.Domain/Dtos/OkWorkOrderDto.cs
export interface OkWorkOrderAcKeyResult {
    acKey: string;
}

// ../../OnixWeb.Domain/Dtos/OkWorkOrderDto.cs
export interface OkWorkOrderAnKeyResult extends OkWorkOrderAcKeyResult {
    anKey: number;
}

// ../../OnixWeb.Domain/Dtos/OkWorkOrderDto.cs
export interface OkWorkOrderAnNoResult extends OkWorkOrderAcKeyResult {
    anNo: number;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpMessageSearchResponseDto.cs
export interface SupportMcpMessageSearchResponseDto {
    query: string;
    limit: number;
    items: SupportMcpMessageSearchResultDto[];
}

// ../../OnixWeb.Domain/Dtos/SupportMcpMessageSearchResponseDto.cs
export interface SupportMcpMessageSearchResultDto {
    messageId: number;
    ticketId?: number;
    ticketTitle?: string;
    createdOn?: Date;
    sentByName?: string;
    sentByEmail?: string;
    inbound: boolean;
    isTask: boolean;
    isTaskDone: boolean;
    originalSender?: string;
    originalSubject?: string;
    preview?: string;
}

// ../../OnixWeb.Domain/Dtos/CreateGenericDocumentFromAnotherDto.cs
export interface CreateGenericDocumentFromAnotherDto {
    originPantheonAcKey?: string;
    originPantheonAcKeyList?: string[];
    items?: CreateGenericDocumentFromAnotherItemDto[];
    updateExisting?: boolean;
    pantheonAcDept?: string;
}

// ../../OnixWeb.Domain/Dtos/ByteArrayDto.cs
export interface ByteArrayDto {
    data: number[];
}

// ../../OnixWeb.Domain/Dtos/GroupedMessages.cs
export interface GroupedMessages {
    title: string;
    ticketId: number;
    userId: string;
    user: string;
    agentId: string;
    agent: string;
    messages: UnreadTicketDto[];
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemReturnDtoSubjectDto.cs
export interface MarservisWorkOrderItemReturnDtoSubjectDto {
    shortName: string;
    longName: string;
    id: number;
}

// ../../OnixWeb.Domain/Dtos/SaveMultipleWorkHoursDto.cs
export interface SaveMultipleWorkHoursDto {
    id: number;
    dayAndWorkRecordDtos: DayAndWorkRecordDto[];
    workHours: number;
    workMinutes: number;
    startTime?: number;
    note: string;
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationsInsightsDto.cs
export interface OnixClrInstallationsInsightsDto {
    generatedOnUtc: Date;
    unmappedInstallations: OnixClrUnmappedInstallationDto[];
    nonPublicAresUsageIssues: OnixClrNonPublicUsageIssueDto[];
    companyDatabasesNotAllowed: OnixClrCompanyDatabaseNotAllowedDto[];
    usageWithoutMapping: OnixClrUsageWithoutMappingDto[];
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationsInsightsDto.cs
export interface OnixClrRecommendedCompanyDto {
    companyId: number;
    companyName: string;
    score: number;
    reason: string;
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationsInsightsDto.cs
export interface OnixClrUnmappedInstallationDto {
    onixClrInstallationId: number;
    machineUID: string;
    server: string;
    database: string;
    instance: string;
    edition: string;
    version: string;
    allowed?: boolean;
    lastReportedOn?: Date;
    lastUsageSeenUtc?: Date;
    recommendation: OnixClrRecommendedCompanyDto;
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationsInsightsDto.cs
export interface OnixClrNonPublicUsageIssueDto {
    onixClrInstallationId: number;
    machineUID: string;
    server: string;
    database: string;
    companyId?: number;
    companyName: string;
    allowed?: boolean;
    aresDeploymentGroupId: string;
    aresDeploymentGroupName: string;
    totalCount: number;
    firstSeenUtc: Date;
    lastSeenUtc: Date;
    installationAllowed: boolean;
    companyMappedToAresGroup: boolean;
    issueReason: string;
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationsInsightsDto.cs
export interface OnixClrCompanyDatabaseNotAllowedDto {
    onixClrInstallationId: number;
    machineUID: string;
    server: string;
    database: string;
    companyId: number;
    companyName: string;
    allowed?: boolean;
    lastReportedOn?: Date;
    lastUsageSeenUtc?: Date;
}

// ../../OnixWeb.Domain/Dtos/OnixClrInstallationsInsightsDto.cs
export interface OnixClrUsageWithoutMappingDto {
    onixClrInstallationId: number;
    machineUID: string;
    server: string;
    database: string;
    totalCount: number;
    firstSeenUtc: Date;
    lastSeenUtc: Date;
    actionCount: number;
    actions: string;
    recommendation: OnixClrRecommendedCompanyDto;
}

// ../../OnixWeb.Domain/Dtos/CostBearerHoursPerWorkerDto.cs
export interface CostBearerHoursPerWorkerDto {
    costBearer: string;
    totalMinutes: number;
    totalWorkRecords: number;
    workerHours: CostBearerWorkerHoursDto[];
}

// ../../OnixWeb.Domain/Dtos/ItemDto.cs
export interface ItemDto {
    id: number;
    code: string;
    name: string;
    departmentId?: number;
    itemGroupId?: number;
}

// ../../OnixWeb.Domain/Dtos/CreateTicketAndTimeLogResultDto.cs
export interface CreateTicketAndTimeLogResultDto {
    ticketId: number;
    timeLogId: number;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketSingleDto.cs
export interface SupportTicketSingleDto {
    companySettingsId?: number;
    user: string;
    userEmail: string;
    userId: string;
    temporaryOwner: string;
    temporaryOwnerEmail: string;
    temporaryOwnerId: string;
    supportGroupId?: number;
    supportGroup: string;
    contact: string;
    contactId?: number;
    email: string;
    company: string;
    companyId?: number;
    priority: SupportPriorityEnum;
    source: SupportSourceEnum;
    status: SupportStatusEnum;
    dateDue?: Date;
    id: number;
    title: string;
    reportedByApplicationUserId?: string;
    reportedByApplicationUser: string;
    isPrimaryEmail?: boolean;
    reportedByApplicationUserDatabase: string;
    contactEmailId?: number;
    project: string;
    projectId?: number;
    projectBillable: boolean;
    projectInvoice: boolean;
    projectSubjectShortName?: string;
    companyPantheonStatus: string;
    companyPantheonBuyerType: string;
    companyPantheonBuyerTypeName: string;
    companyPantheonAcSubject: string;
    showProjectFeatures: boolean;
    offerTypeDefault: boolean;
    offerNumber?: string;
    phoneNumbers: string[];
    companyPantheonId: string;
    companyConnectionString?: string;
    pantheonVersion?: string;
    pantheonVersionFormatted?: string;
    hasHostingType: boolean;
}

// ../../OnixWeb.Domain/Dtos/PantheonMeshCentralRelayDescriptorDto.cs
export interface PantheonMeshCentralRelayDescriptorDto {
    target: PantheonMeshCentralRelayTargetDto;
    meshCentralRelayWebSocketUrl: string;
}

// ../../OnixWeb.Domain/Dtos/ClassifyTMnDocumentDto.cs
export interface ClassifyTMnDocumentDto {
    note?: string;
    metadata?: Record<string, string>;
    rememberSubjectClassificationMapping?: boolean;
    subjectClassificationAcSubject?: string;
    reclassifySubjectDocuments?: boolean;
}

// ../../OnixWeb.Domain/Dtos/ProblemSubmissionTicketIntakeDto.cs
export interface ProblemSubmissionTicketIntakeDto {
    sourceKey: string;
    sourceSavedFileId?: number;
    sourceCompanySettingsId?: number;
    sourceConnectionName: string;
    sourceCompanyName: string;
    sourceExternalId: string;
    sourceUploadedByUserId: string;
    sourceUploadedByUserName: string;
    sourceUploadedByUserEmail: string;
    fileName: string;
    contentType: string;
    contentDisposition: string;
    description: string;
    data: number[];
    submittedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadPresentationPageDto.cs
export interface SupportAiThreadPresentationPageDto {
    items: SupportAiThreadPresentationDto[];
    page: number;
    pageSize: number;
    totalCount: number;
}

// ../../OnixWeb.Domain/Dtos/CostBearerWorkHoursDto.cs
export interface CostBearerWorkHoursDto {
    costBearer: string;
    costBearerName?: string;
    year?: number;
    month?: number;
    totalMinutes: number;
    workers: CostBearerWorkerWorkHoursDto[];
}

// ../../OnixWeb.Domain/Dtos/OmniSearchResultResultDto.cs
export interface OmniSearchResultResultDto {
    id: any;
    title: string;
    description: string;
    detailId: any;
    type: OmniSearchResourceEnum;
}

// ../../OnixWeb.Domain/Dtos/MarservisItemGroupMaterialDto.cs
export interface MarservisItemGroupMaterialDto {
    itemGroupId: number;
    materialId: number;
}

// ../../OnixWeb.Domain/Dtos/ActiveUserDefinition.cs
export interface ActiveUserDefinition {
    activeAt: Date;
    mobileVersion: string;
    platform: string;
    deviceId: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMessageDto.cs
export interface SupportMessageDto {
    supportTicketId?: number;
    isNote: boolean;
    title: string;
    content: string;
    notifyUsers: string[];
    CCEmails: string[];
    isTask: boolean;
    taskStart?: Date;
    taskDue: Date;
    responsibleAgentId?: string;
    uniqueClientId: string;
    isTaskDone?: boolean;
    originalSubject?: string;
    sendAtNextWorkStart: boolean;
}

// ../../OnixWeb.Domain/Dtos/WorkRecordCostTypeDto.cs
export interface WorkRecordCostTypeDto {
    id?: number;
    costType: string;
    active: boolean;
    pantheonCostType: string;
    pantheonName: string;
    pantheonCostGroup: string;
    pantheonCostGroupName: string;
}

// ../../OnixWeb.Domain/Dtos/AddApplicationPacketToCompanyDto.cs
export interface AddApplicationPacketToCompanyDto {
    packet?: ApplicationPacketEnum;
    companySettingsId: number;
}

// ../../OnixWeb.Domain/Dtos/MeshCentralDeviceRouteRelayTargetDto.cs
export interface MeshCentralDeviceRouteRelayTargetDto {
    routeId: number;
    companyId: number;
    isAvailable: boolean;
    blockedReason?: string;
    companyMeshCentralGroupMappingId: number;
    meshCentralGroupId: string;
    meshCentralGroupName: string;
    meshCentralDeviceId: string;
    meshCentralDeviceName: string;
    name?: string;
    routeType: MeshCentralDeviceRouteTypeEnum;
    remotePort: number;
}

// ../../OnixWeb.Domain/Dtos/SavingWorkRecordDto.cs
export interface SavingWorkRecordDto {
    day: number;
    costBearer: string;
    workRecordCostTypeId?: number;
    workRecordPeriodId: number;
}

// ../../OnixWeb.Domain/Dtos/MobileSupportMessageDto.cs
export interface MobileSupportMessageDto {
    id: number;
    userSeen: boolean;
    seen: boolean;
    inbound: boolean;
    content: string;
    createdOn?: Date;
    ticketId: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiTurnDto.cs
export interface SupportAiTurnDto {
    id: number;
    threadId?: number;
    status: SupportAiTurnStatus;
    createdOn?: Date;
    startedOn?: Date;
    completedOn?: Date;
    cancelRequestedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/DatalabAssignManualReferenceDto.cs
export interface DatalabAssignManualReferenceDto {
    datalabReferenceCompanyId: number;
}

// ../../OnixWeb.Domain/Dtos/OmniSearchResultDto.cs
export type OmniSearchResultDto =  {
    [key in OmniSearchResourceEnum]: OmniSearchResultResultDto[];
}

// ../../OnixWeb.Domain/Dtos/UserInfoDtoV3.cs
export interface UserInfoViewModelV3Dto {
    userName: string;
    userRoles: string[];
    userInfo: UserInfoViewModelV3UserInfoDto;
    applicationPackets: ApplicationPacketEnum[];
    deleted: boolean;
    language: string;
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    alternativeUsers: UserInfoViewModelV3AlternativeUserDto[];
    alternativeUserId?: string;
    alternativeUserCompanyName: string;
}

// ../../OnixWeb.Domain/Dtos/CompanyAiSupportSettingsDto.cs
export interface CompanyAiSupportSettingsDto {
    aiSupportApiKey?: string;
    aiSupportTriageModel?: string;
    aiSupportInvestigationModel?: string;
    aiSupportReasoningEffort?: string;
    aiSupportVerbosity?: string;
    aiSupportRunBudgetMode: AiSupportRunBudgetMode;
    aiSupportMaxToolRounds?: number;
    aiSupportMaxInputTokensPerTurn?: number;
    aiSupportMaxOutputTokensPerTurn?: number;
    aiSupportDefaultTimeoutMinutes?: number;
}

// ../../OnixWeb.Domain/Dtos/AiSupportRetrievalSnippetDto.cs
export interface AiSupportRetrievalSnippetDto {
    id: number;
    sourceKind: string;
    scopeType: SupportAiKnowledgeScopeType;
    companyId?: number;
    companyName?: string;
    title: string;
    summary: string;
    tags?: string;
    triggerTerms?: string;
    issueFamily?: string;
    moduleOrProcess?: string;
    sourceKnowledgeEntryId?: number;
    sourceRunId?: number;
}

// ../../OnixWeb.Domain/Dtos/THeSetItemPagedDto.cs
export interface THeSetItemPagedDto {
    acFieldsA: string;
    acClassif: string;
    search: string;
    acSetOfItem: string;
    acWarehouse: string;
    minStock?: number;
    showOnlyInStock?: boolean;
    ignoreWarehouse?: boolean;
    sortField?: THeSetItemPagedSortField;
    sortDescending?: boolean;
    onlyWithCustomerContractPrices: string;
    articleSearchShowOnlyWhereAcClassifIsIn: string;
    docTypeId?: number;
    customContractPriceFilter?: boolean;
    acSubject?: string;
    alwaysShowTheseAcSetOfItem?: string;
}

// ../../OnixWeb.Domain/Dtos/AdminUsersTenantReturnDto.cs
export interface AdminUsersTenantReturnDto {
    lastTokenRefresh: Date;
    lastLogin: Date;
    isDeleted: boolean;
    firstName: string;
    lastName: string;
    language: string;
    companySettingsId?: number;
    alternativeUserId?: string;
    responsibleUserId?: string;
    accountingUserId?: string;
    timeZone: string;
    culture: string;
    companySettings: AdminUsersTenantCompanyReturnDto;
    userName: string;
    id: string;
    email: string;
    lastPlatform: string;
    lastVersion: string;
    roles: string[];
    pushedAppKey: string;
    pushedAppSecret: string;
    pushedTargetType: string;
    teamViewerID: string;
    teamViewerSyncEnabled: boolean;
    wakaApiBaseUrl?: string;
    wakaApiKey?: string;
    wakaSyncEnabled: boolean;
    wakaLastSyncAt?: Date;
    wakaLastSyncError?: string;
    bookStackTokenId: string;
    bookStackTokenSecret: string;
    visualAttributesOverview: string;
    lastRequestSource: string;
    ciscoPhoneAdminPath: string;
    useNewDocumentFlow: boolean;
    alternativeUser?: AdminUsersTenantUserReturnDto;
    userAccessHash: string;
    permanentLoginToken: string;
    migratedToNewServer?: boolean;
    isDMSReferenceUser: boolean;
    excludeFromDmsBilling: boolean;
}

// ../../OnixWeb.Domain/Dtos/CreateSupportAiCompanyThreadDto.cs
export interface CreateSupportAiCompanyThreadDto {
    prompt?: string;
    investigationDatabaseName?: string;
    responseMode?: SupportAiThreadResponseMode;
}

// ../../OnixWeb.Domain/Dtos/SubjectReturnDtoCountry.cs
export interface SubjectReturnDtoCountry {
    id?: number;
    name: string;
    currency: string;
}

// ../../OnixWeb.Domain/Dtos/EInvoiceDocumentStatusDto.cs
export interface EInvoiceDocumentStatusDto {
    state: EInvoiceQueueState;
    stage: EInvoiceStage;
    exchange: EInvoiceExchangeOutcome;
    fiscalization: EInvoiceFiscalizationOutcome;
    hasFailure: boolean;
    reasonCode?: string;
}

// ../../OnixWeb.Domain/Dtos/THeOrderItemDto.cs
export interface THeOrderItemDto extends THeOrderItem {
    acIdent: string;
    anQty: number;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeTemplateReturnDto.cs
export interface DocumentTypeTemplateReturnDto {
    id: number;
    name: string;
    description?: string;
    isPartial: boolean;
    includedProperties?: string[];
    type?: string;
    functionality?: DocumentFunctionalityEnum;
    sourceDocumentTypeId?: number;
    companySettingsId?: number;
    createdByUserId?: string;
    createdOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/LoginDto.cs
export interface LoginModel {
    userNameOrEmail: string;
    password: string;
    takeLicense?: boolean;
}

// ../../OnixWeb.Domain/Dtos/InstallAresGroupForAccountingCompanyDatabaseDto.cs
export interface InstallAresGroupForAccountingCompanyDatabaseRequestDto {
    accountingCompanyId: number;
    databaseName: string;
    companyName: string;
    sourceMappingId?: number;
    aresDeploymentGroupId?: number;
    deploymentEnvironment?: AresDeploymentEnvironment;
}

// ../../OnixWeb.Domain/Dtos/InstallAresGroupForAccountingCompanyDatabaseDto.cs
export interface InstallAresGroupForAccountingCompanyDatabaseResponseDto {
    companyId: number;
    companyName: string;
    mappingId: number;
    aresDeploymentGroupId: number;
    aresDeploymentGroupName: string;
    deploymentEnvironment: AresDeploymentEnvironment;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadSnapshotDto.cs
export interface SupportAiThreadSnapshotDto {
    thread: SupportAiThreadSummaryDto;
    currentTurn?: SupportAiTurnDto;
    items: SupportAiThreadItemDto[];
    lastSequence: number;
}

// ../../OnixWeb.Domain/Dtos/TimeRangeEntry.cs
export interface TimeRangeEntry {
    taskStart?: Date;
    taskDue?: Date;
}

// ../../OnixWeb.Domain/Dtos/AddTMnDocumentDto.cs
export interface AddTMnDocumentDto {
    note: string;
    title: string;
    subject: string;
    anClassifIcationQid?: number;
    anStorageQid?: number;
    anMailBoxQid?: number;
    acStatus?: string;
    metadata?: Record<string, string>;
}

// ../../OnixWeb.Domain/Dtos/IISBaseRequest.cs
export interface IISBaseRequestRoot {
    hostName: string;
}

// ../../OnixWeb.Domain/Dtos/THeSetItemDto.cs
export interface DimeglioItem {
    acIdent: string;
    acName: string;
    anRtPrice: number;
    anStockMinusAnReservedSum?: number;
    acUm: string;
    acNote: string;
    acCode: string;
}

// ../../OnixWeb.Domain/Dtos/ApplicationUserDto.cs
export interface ApplicationUserDto {
    id: string;
    firstName: string;
    lastName: string;
    userName: string;
}

// ../../OnixWeb.Domain/Dtos/ClientServerConfigurationDto.cs
export interface ClientServerStatusDto {
    serverName: string;
    serverIP: string;
    pingTime: Date;
    workHoursCheckError?: string;
    notificationEmail?: string;
    hasHostAssignment: boolean;
    hostOnline?: boolean;
    hostCheckedOn?: Date;
    hostCheckError?: string;
    clientServerAlert: boolean;
}

// ../../OnixWeb.Domain/Dtos/ClientServerConfigurationDto.cs
export interface ClientServerConfigurationDto {
    serverName: string;
    isAvailable: boolean;
    message?: string;
    modules: ClientServerModuleConfigurationDto[];
}

// ../../OnixWeb.Domain/Dtos/ClientServerConfigurationDto.cs
export interface ClientServerModuleConfigurationDto {
    key: string;
    name: string;
    purpose: string;
    state: string;
    schedules: ClientServerConfigurationScheduleDto[];
    details: ClientServerConfigurationDetailDto[];
}

// ../../OnixWeb.Domain/Dtos/ClientServerConfigurationDto.cs
export interface ClientServerConfigurationScheduleDto {
    name: string;
    description: string;
}

// ../../OnixWeb.Domain/Dtos/ClientServerConfigurationDto.cs
export interface ClientServerConfigurationDetailDto {
    label: string;
    value: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAbsenceDto.cs
export interface SupportAbsenceDto {
    id: number;
    userId: string;
    user: ApplicationUser;
    dateFrom: Date;
    dateTo: Date;
    type: SupportAbsenceTypeEnum;
    title: string;
    note: string;
    isHalfDay: boolean;
    halfDayPeriod: SupportAbsenceHalfDayPeriodEnum;
    timeFrom?: number;
    timeTo?: number;
}

// ../../OnixWeb.Domain/Dtos/CreateSupportAiKnowledgeEntryDto.cs
export interface CreateSupportAiKnowledgeEntryDto {
    title?: string;
    content?: string;
    tags?: string;
    triggerTerms?: string;
    active: boolean;
}

// ../../OnixWeb.Domain/Dtos/McpApiKeyDtos.cs
export interface McpApiKeyDto {
    id: number;
    kind: McpApiKeyKind;
    name: string;
    keyPrefix: string;
    permissions: string[];
    createdAt: Date;
    expiresAt?: Date;
    lastUsedAt?: Date;
    revokedAt?: Date;
    isActive: boolean;
}

// ../../OnixWeb.Domain/Dtos/McpApiKeyDtos.cs
export interface McpApiKeyEntitlementsDto {
    canCreateSupportKey: boolean;
    canCreateOnixServerKey: boolean;
    supportPermissions: string[];
    onixServerPermissions: string[];
}

// ../../OnixWeb.Domain/Dtos/McpApiKeyDtos.cs
export interface CreateMcpApiKeyDto {
    kind: McpApiKeyKind;
    name: string;
    expiresInDays?: number;
    permissions: string[];
}

// ../../OnixWeb.Domain/Dtos/McpApiKeyDtos.cs
export interface CreatedMcpApiKeyDto {
    key: string;
    apiKey: McpApiKeyDto;
}

// ../../OnixWeb.Domain/Dtos/MailgunEventLogDto.cs
export interface MailgunEventLogDto {
    timestamp: Date;
    event: string;
    recipient: string;
    subject?: string;
    messageId?: string;
    tags: string[];
    severity?: string;
    deliveryStatus?: string;
    deliveryCode?: number;
    url?: string;
}

// ../../OnixWeb.Domain/Dtos/MailgunEventLogDto.cs
export interface MailgunEventsResponseDto {
    items: MailgunEventLogDto[];
    nextUrl?: string;
    previousUrl?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpCompanyAiKnowledgeSearchResponseDto.cs
export interface SupportMcpCompanyAiKnowledgeSearchResponseDto {
    companyId: number;
    companyName: string;
    query?: string;
    limit: number;
    items: SupportAiKnowledgeEntryDto[];
}

// ../../OnixWeb.Domain/Dtos/TrimWorkOrderDto.cs
export interface TrimWorkOrderQuery {
    acKey: string;
    acNote: string;
    acContactPrsn: string;
    acContactPrsn3: string;
    adFieldDA?: Date;
    acFieldSA: string;
    acFieldSF: string;
    acIssuer: string;
    acPrsn3: string;
    adTimeIns?: Date;
    anFieldNA?: number;
    anFieldNB?: number;
    anClerkAcName: string;
    anClerkAcSurname: string;
    anClerk?: number;
    adDate?: Date;
    signature: number[];
    acDept: string;
    acDoc1: string;
    acDoc2: string;
    acVerifyStatus: string;
    acDocType: string;
    bearerName: string;
    bearerAddress: string;
    bearerPost: string;
    bearerPIN: string;
    bearerPostName: string;
    customerName: string;
    customerAddress: string;
    customerPost: string;
    customerPIN: string;
    customerPostName: string;
    adDateDoc1?: Date;
    adDateDoc2?: Date;
    receiverName?: string;
    receiverAddress?: string;
    receiverPost?: string;
    receiverPIN?: string;
    receiverPostName?: string;
    acContactPrsnEmail?: string;
    acContactPrsn3Email?: string;
    workOrderTotal?: number;
    acCurrency?: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupRolloutDto.cs
export interface AresDeploymentGroupRolloutSnapshotDto {
    id: number;
    versionNo: number;
    name: string;
    sourceHash: string;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupRolloutDto.cs
export interface AresDeploymentGroupRolloutCompanyDto {
    companyId: number;
    companyName: string;
    deploymentEnvironment: AresDeploymentEnvironment;
    isProtected: boolean;
    isMainDeploymentDatabase: boolean;
    isMainTestingDatabase: boolean;
}

// ../../OnixWeb.Domain/Dtos/AresDeploymentGroupRolloutDto.cs
export interface AresDeploymentGroupRolloutSummaryDto {
    groupId: number;
    groupName: string;
    productionSnapshot: AresDeploymentGroupRolloutSnapshotDto;
    stagingSnapshot: AresDeploymentGroupRolloutSnapshotDto;
    productionCompanies: AresDeploymentGroupRolloutCompanyDto[];
    stagingCompanies: AresDeploymentGroupRolloutCompanyDto[];
    testingCompanies: AresDeploymentGroupRolloutCompanyDto[];
    resetCandidates: AresDeploymentGroupRolloutCompanyDto[];
    protectedCompanies: AresDeploymentGroupRolloutCompanyDto[];
}

// ../../OnixWeb.Domain/Dtos/InitializeCompanyDto.cs
export interface InitializeCompanyDto {
    grunfCompanyId: string;
    connectionString: string;
    alternateMainServerPrefix?: string;
    dmsPantheonUserId?: string;
    createEmptyApiUser: boolean;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemReturnDtoItemDto.cs
export interface MarservisWorkOrderItemReturnDtoItemDto {
    id: number;
    name: string;
    code: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingLURInvoiceViewModel.cs
export interface SubmittingLURInvoiceCustomer {
    acSubject: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingLURInvoiceViewModel.cs
export interface SubmittingLURInvoiceItem {
    quantity: number;
    anRebate: number;
    rebate1: number;
    rebate2: number;
    rebate3: number;
    acIdent: string;
    acNote: string;
    anPrice: number;
    boatLength: number;
    numberOfDays: number;
}

// ../../OnixWeb.Domain/Dtos/SubmittingLURInvoiceViewModel.cs
export interface SubmittingLURInvoiceViewModel {
    date: Date;
    note?: string;
    customer: SubmittingLURInvoiceCustomer;
    moveItems: SubmittingLURInvoiceItem[];
    documentType: string;
    berth?: string;
    boatName?: string;
    payMethod: string;
    department: string;
    printTime?: Date;
    boatLength?: number;
    UID?: string;
}

// ../../OnixWeb.Domain/Dtos/AnswerSupportAiQuestionDto.cs
export interface AnswerSupportAiQuestionDto {
    answer?: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemWorkMaterialInputDto.cs
export interface MarservisWorkOrderItemWorkMaterialInputDto {
    materialId: number;
    quantity: number;
}

// ../../OnixWeb.Domain/Dtos/UpdateUserDto.cs
export interface UpdateUserDto {
    firstName: string;
    lastName: string;
}

// ../../OnixWeb.Domain/Dtos/CompanyPreparednessDto.cs
export interface CompanyPreparednessDto {
    needsMoveAcPhoneUIDColumn: boolean;
    needsOrderAcPhoneUIDColumn: boolean;
    needsTopFilesToBeInOnixPhoneFSGroup: boolean;
    needsMoveItemTable: boolean;
    needsMoveSignatureColumn: boolean;
    needsFilesTable: boolean;
    needsFilesAcKeyColumn: boolean;
    needsFilesFileCategoryColumn: boolean;
    needsFilesFileNameColumn: boolean;
    needsDocsAcPictureColumn: boolean;
    needsPdfImageDocType: boolean;
    needsPdfImageReplacementDocType: boolean;
    needsOrderOldStatusColumn: boolean;
    needsTHeSetItemExtItemSubjPackageQuantityColumn: boolean;
    needsGS1AIsTable: boolean;
    needsGS1AIsData: boolean;
    needsGS1SerialNumberMappingColumn: boolean;
    needsGS1SerialFieldFormatColumn: boolean;
    needsGS1SerialFieldTypeColumn: boolean;
    needsGS1SerialFieldMaskColumn: boolean;
    needsFileStream: boolean;
    needsFileStreamTopFilesMigration: boolean;
    needsFileStreamFileGroup: boolean;
    needsFileStreamFile: boolean;
    needsTopFileGroups: boolean;
    needsTopFilesAcKeyNullable: boolean;
    needsTopFilesNote: boolean;
    needsTopFilesAnUserId: boolean;
    needsTMnFileStreamingContent: boolean;
    needsOxScans: boolean;
    needsSpBatchSearchContrctPriceJson: boolean;
}

// ../../OnixWeb.Domain/Dtos/CompanyMeshCentralDeviceRouteReturnDto.cs
export interface CompanyMeshCentralDeviceRouteReturnDto {
    id: number;
    companyId: number;
    companyName?: string;
    companyMeshCentralGroupMappingId: number;
    meshCentralGroupId: string;
    meshCentralGroupName: string;
    meshCentralDeviceId: string;
    meshCentralDeviceName: string;
    name?: string;
    routeType: MeshCentralDeviceRouteTypeEnum;
    remotePort: number;
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/SynchronizationStatusDto.cs
export interface SynchronizationStatusDto {
    lastGlobalSync?: Date;
    lastCompanyChangeSync?: Date;
    isRunning: boolean;
    syncType: string;
    syncJobs: Record<string, string>;
}

// ../../OnixWeb.Domain/Dtos/TravelKilometersDto.cs
export interface TravelKilometersDto {
    currency: string;
    id: number;
    kilometers?: number;
    price?: number;
}

// ../../OnixWeb.Domain/Dtos/EuroSettings.cs
export interface EuroSettings {
    exchangeRate: number;
    forMainCurrency: string;
    outText: string;
    secondaryCurrency: string;
}

// ../../OnixWeb.Domain/Dtos/SupportSettingsDto.cs
export interface SupportSettingsDto {
    email: string;
    password: string;
    recirectAll: boolean;
    supportAutoReplyOnNewTicket: boolean;
    supportAutoReplyOnNewTicketSubject?: string;
    supportAutoReplyOnNewTicketBody?: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiTechnicalDetailsDto.cs
export interface SupportAiTechnicalDetailsDto {
    currentRun?: SupportAiRunDetailDto;
    runs: SupportAiRunSummaryDto[];
    events: SupportAiRunEventDto[];
    toolCalls: SupportAiToolCallDto[];
    checkpoints: SupportAiRunCheckpointDto[];
    threadBudget?: SupportAiThreadBudgetStateDto;
}

// ../../OnixWeb.Domain/Dtos/SupportMcpMessageContentResponseDto.cs
export interface SupportMcpMessageContentResponseDto {
    messageId: number;
    ticketId?: number;
    remoteContentSavedFileId?: number;
    contentSource: string;
    content: string;
    contentLength: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiRootCauseHypothesisDto.cs
export interface SupportAiRootCauseHypothesisDto {
    title: string;
    details: string;
    confidence?: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadItemDeltaDto.cs
export interface SupportAiThreadItemDeltaDto {
    threadId: number;
    itemId: number;
    revision: number;
    streamSequence: number;
    kind: SupportAiThreadItemDeltaKind;
    delta: string;
}

// ../../OnixWeb.Domain/Dtos/KanbanDataDto.cs
export interface KanbanDataDto {
    items: KanbanDataDtoItem[];
    statuses: Record<string, string>;
}

// ../../OnixWeb.Domain/Dtos/NotifyCompanyTHeOrderModel.cs
export interface NotifyCompanyTHeOrderModel {
    pdf: OrderPDFViewModel;
}

// ../../OnixWeb.Domain/Dtos/ProjectReturnDto.cs
export interface ProjectReturnDto {
    id: number;
    description: string;
    finished: boolean;
    billable: boolean;
    invoice: boolean;
    name: string;
    subject: ProjectReturnDtoSubject;
    dueDate: Date;
    subjectId?: number;
    createdOn?: Date;
    model: string;
    HINNumber: string;
    engineModel: string;
    engineSerialNumber: string;
    transmissionModel: string;
    transmissionSerialNumber: string;
}

// ../../OnixWeb.Domain/Dtos/CErrorDto.cs
export interface CErrorDto {
    cError: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackAddPageResponse.cs
export interface BookStackAddPageResponseCreatedBy {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackAddPageResponse.cs
export interface BookStackAddPageResponseUpdatedBy {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackAddPageResponse.cs
export interface BookStackAddPageResponseOwnedBy {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/BookStackAddPageResponse.cs
export interface BookStackAddPageResponseTag {
    name: string;
    value: string;
    order: number;
}

// ../../OnixWeb.Domain/Dtos/BookStackAddPageResponse.cs
export interface BookStackAddPageResponse {
    id: number;
    bookId: number;
    chapterId: number;
    name: string;
    slug: string;
    html: string;
    priority: number;
    createdAt: string;
    updatedAt: string;
    createdBy: BookStackAddPageResponseCreatedBy;
    updatedBy: BookStackAddPageResponseUpdatedBy;
    ownedBy: BookStackAddPageResponseOwnedBy;
    draft: boolean;
    markdown: string;
    revisionCount: number;
    template: boolean;
    tags: BookStackAddPageResponseTag[];
}

// ../../OnixWeb.Domain/Dtos/SupportMcpUpdateCompanyAiKnowledgeEntryDto.cs
export interface SupportMcpUpdateCompanyAiKnowledgeEntryDto {
    expectedModifiedOn: Date;
    title?: string;
    content?: string;
    tags?: string;
    triggerTerms?: string;
}

// ../../OnixWeb.Domain/Dtos/AnalysisTotalsPerAccountDto.cs
export interface AnalysisTotalsPerAccountDto {
    account: string;
    value: AnalysisCurrencyTotal[];
    name: string;
    id: number;
}

// ../../OnixWeb.Domain/Dtos/PermanentLoginTokensPDFModel.cs
export interface PermanentLoginTokensPDFModel {
    users: ApplicationUser[];
}

// ../../OnixWeb.Domain/Dtos/BulkEmailMailgunDto.cs
export interface BulkEmailMailgunDto {
    uniqueClientId: string;
    to: string[];
    cc: string[];
    bcc: string[];
    subject: string;
    html: string;
    tag: string;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketTodoDto.cs
export interface SupportTicketTodoDto{
    id?: number;
    ticketId?: number;
    dateTime: Date;
    note: string;
    userId: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingOrderCustomer {
    acSubject: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingOrderItem {
    quantity: number;
    anRebate: number;
    rebate2: number;
    rebate3: number;
    acIdent: string;
    acNote: string;
    anPrice: number;
    rebate1: number;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingOrderViewModel {
    date: Date;
    note: string;
    description: string;
    customer: SubmittingOrderCustomer;
    orderItems: SubmittingOrderItem[];
    documentType: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingMoveCustomer {
    acSubject: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingMoveItem {
    quantity: number;
    anRebate: number;
    rebate1: number;
    rebate2: number;
    rebate3: number;
    acIdent: string;
    acNote: string;
    anPrice: number;
    anPackQuantity: number;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingMoveViewModel {
    existingAcKey: string;
    date: Date;
    note: string;
    description: string;
    customer: SubmittingMoveCustomer;
    moveItems: SubmittingMoveItem[];
    documentType: string;
    printTime?: Date;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingWoexViewModel {
    existingAcKey: string;
    date: Date;
    note: string;
    description: string;
    customer: SubmittingWoexCustomer;
    moveItems: SubmittingWoexItem[];
    documentType: string;
    printTime?: Date;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingWoexCustomer {
    acSubject: string;
}

// ../../OnixWeb.Domain/Dtos/SubmittingOrderDto.cs
export interface SubmittingWoexItem {
    quantity: number;
    anRebate: number;
    rebate1: number;
    rebate2: number;
    rebate3: number;
    acIdent: string;
    acNote: string;
    anPrice: number;
    anPackQuantity: number;
}

// ../../OnixWeb.Domain/Dtos/ProjectReturnDtoSubject.cs
export interface ProjectReturnDtoSubject {
    id: number;
    shortName: string;
    longName: string;
    VATIDPrefix: string;
    VATID: string;
    createdOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderitemReturnDtoItemGroupDto.cs
export interface MarservisWorkOrderItemReturnDtoItemGroupDto {
    id: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/NewVersionDto.cs
export interface NewVersionDto {
    version: string;
    platform: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadQuestionDto.cs
export interface SupportAiThreadQuestionDto {
    id: number;
    threadId: number;
    askedByRunId: number;
    status: SupportAiThreadQuestionStatus;
    question: string;
    whyNeeded: string;
    answer?: string;
    answeredByUserId?: string;
    answeredOn?: Date;
    createdOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/OnixPhoneUserTaskQueueDto.cs
export interface OnixPhoneUserTaskQueueDto extends OnixPhoneUserTaskQueue {
    toAll: boolean;
}

// ../../OnixWeb.Domain/Dtos/DocumentTypeTemplateApplyDto.cs
export interface DocumentTypeTemplateApplyDto {
    targetDocumentTypeId: number;
}

// ../../OnixWeb.Domain/Dtos/SupportAiThreadPresentationDto.cs
export interface SupportAiThreadPresentationDto {
    threadId: number;
    title: string;
    preview: string;
    status: string;
    needsAttention: boolean;
    lastVisibleActivityOn: Date;
    responseMode: SupportAiThreadResponseMode;
    canContinue: boolean;
    canResume: boolean;
    threadStatus: SupportAiThreadStatus;
    activeDatabaseGrant?: SupportAiDatabaseGrantDto;
    pendingDatabaseGrantRequest?: SupportAiDatabaseGrantRequestDto;
}

// ../../OnixWeb.Domain/Dtos/GlitchTipReportDtos.cs
export interface GlitchTipUserReportsDto {
    projectKey: string;
    projectName: string;
    isConfigured: boolean;
    configurationMessage?: string;
    errorMessage?: string;
    reports: GlitchTipReportDto[];
}

// ../../OnixWeb.Domain/Dtos/GlitchTipReportDtos.cs
export interface GlitchTipReportDto {
    id: string;
    shortId?: string;
    title: string;
    culprit?: string;
    level?: string;
    status?: string;
    count: number;
    userCount: number;
    firstSeen?: Date;
    lastSeen?: Date;
    permalink?: string;
    projectSlug?: string;
    projectName?: string;
    matchedBy: string[];
}

// ../../OnixWeb.Domain/Dtos/AnalysisTotalsPerCustomerDto.cs
export interface AnalysisTotalsPerCustomerDto {
    customer: string;
    value: AnalysisCurrencyTotal[];
    customerName: string;
}

// ../../OnixWeb.Domain/Dtos/WebDocumentTHeMoveModel.cs
export interface WebDocumentTHeMoveModel {
    move: THeMove;
    param: TPaSysParam;
    docType: TPaSetDocType;
    withoutHeader?: boolean;
    padding?: number;
    hidePrices?: boolean;
    opDocType: DocumentType;
    extendedLayout?: boolean;
    contactEmail?: string;
    fiscal?: WebDocumentFiscalPrint;
}

// ../../OnixWeb.Domain/Dtos/WebDocumentTHeMoveModel.cs
export interface WebDocumentFiscalPrint {
    number?: string;
    zki?: string;
    jir?: string;
    operator?: string;
    issuedAt?: string;
    qrPngBase64?: string;
}

// ../../OnixWeb.Domain/Dtos/VersionNumber.cs
export interface VersionNumber{
    major: number;
    minor: number;
    hotfix: number;
}

// ../../OnixWeb.Domain/Dtos/UpdateTMnDocumentDto.cs
export interface UpdateTMnDocumentDto {
    note: string;
    title: string;
    subject: string;
    anClassifIcationQid?: number;
    anStorageQid?: number;
    anMailBoxQid?: number;
    metadata?: Record<string, string>;
    acStatus?: string;
}

// ../../OnixWeb.Domain/Dtos/ApplicationUserSavedFileDto.cs
export interface ApplicationUserSavedFileDto {
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    hasAccess: boolean;
}

// ../../OnixWeb.Domain/Dtos/ContactPhoneDto.cs
export interface ContactPhoneDto {
    id?: number;
    phoneNumber: string;
    contactId: number;
}

// ../../OnixWeb.Domain/Dtos/UpdateTOpFileDto.cs
export interface UpdateTOpFileDto {
    note: string;
    tOpFileGroupId?: number;
}

// ../../OnixWeb.Domain/Dtos/ContactEmailDto.cs
export interface ContactEmailDto {
    id?: number;
    email: string;
    isPrimary: boolean;
    contactId: number;
}

// ../../OnixWeb.Domain/Dtos/CompanyMergeCandidateDto.cs
export interface CompanyMergeCandidateDto {
    id: number;
    name: string;
    description: string;
    notOurCustomer: boolean;
}

// ../../OnixWeb.Domain/Dtos/LinkSupportCompanyDto.cs
export interface LinkSupportCompanyDto {
    companyId: number;
    companySettingsId: number;
}

// ../../OnixWeb.Domain/Dtos/ApplicationUserTenantDto.cs
export interface ApplicationUserTenantDto {
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    lastTokenRefresh: Date;
    lastLogin: Date;
    isDeleted: boolean;
    userName: string;
    email: string;
    pantheonUser?: PantheonUserDto;
}

// ../../OnixWeb.Domain/Dtos/SupportAiReplyDto.cs
export interface SupportAiReplyDto {
    summary: string;
    technicalDetails?: string;
    suggestedNextActions: string[];
}

// ../../OnixWeb.Domain/Dtos/TeamViewerGroupsDto.cs
export interface TeamViewerGroupsDtoSharedWith {
    userid: string;
    name: string;
    alias: string;
    permissions: string;
    pending: boolean;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerGroupsDto.cs
export interface TeamViewerGroupsDtoOwner {
    userid: string;
    name: string;
    alias: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerGroupsDto.cs
export interface TeamViewerGroupsDtoGroup {
    id: string;
    name: string;
    sharedWith: TeamViewerGroupsDtoSharedWith[];
    owner: TeamViewerGroupsDtoOwner;
    permissions: string;
    policyId: string;
}

// ../../OnixWeb.Domain/Dtos/TeamViewerGroupsDto.cs
export interface TeamViewerGroupsDto {
    groups: TeamViewerGroupsDtoGroup[];
}

// ../../OnixWeb.Domain/Dtos/SupportAiRunEventDto.cs
export interface SupportAiRunEventDto {
    id: number;
    runId: number;
    sequence: number;
    eventType: SupportAiRunEventTypeEnum;
    phase: SupportAiRunPhaseEnum;
    title: string;
    message: string;
    createdOn?: Date;
    toolCallId?: number;
    payloadJson?: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisLocalWorkOrderDto.cs
export interface MarservisLocalWorkOrderDto extends HasUniqueClientId {
    id: string;
    date?: Date;
    projectId?: number;
    dateEnd?: Date;
    note: string;
    status: MarservisWorkOrderStatusEnum;
    location: string;
}

// ../../OnixWeb.Domain/Dtos/AdminUsersTenantDto.cs
export interface AdminUsersTenantDto {
    firstName: string;
    lastName: string;
    companySettingsId?: number;
    userName: string;
    id: string;
    email: string;
    pushedAppKey: string;
    pushedAppSecret: string;
    pushedTargetType: string;
    newPassword?: string;
    teamViewerID: string;
    teamViewerSyncEnabled: boolean;
    wakaApiBaseUrl?: string;
    wakaApiKey?: string;
    wakaSyncEnabled: boolean;
    bookStackTokenId: string;
    bookStackTokenSecret: string;
    isDeleted: boolean;
    ciscoPhoneAdminPath: string;
    useNewDocumentFlow: boolean;
    alternativeUserId?: string;
    userAccessHash?: string;
    permanentLoginToken?: string;
    pantheonContact?: number;
    migratedToNewServer?: boolean;
    responsibleUserId?: string;
    accountingUserId?: string;
    isDMSReferenceUser: boolean;
    excludeFromDmsBilling: boolean;
}

// ../../OnixWeb.Domain/Dtos/SupportSignatureDto.cs
export interface SupportSignatureDto {
    signature: string;
}

// ../../OnixWeb.Domain/Dtos/OnixDmsBillingReportDtos.cs
export interface OnixDmsBillingReportFilterDto {
    year: number;
    month: number;
}

// ../../OnixWeb.Domain/Dtos/OnixDmsBillingReportDtos.cs
export interface OnixDmsBillingReportDto {
    year: number;
    month: number;
    generatedOnUtc: Date;
    zbirno: OnixDmsBillingReportZbirnoRowDto[];
    zbirnoRacunovodstvo: OnixDmsBillingReportAccountingRowDto[];
    sourceIssues: OnixDmsBillingReportSourceIssueDto[];
}

// ../../OnixWeb.Domain/Dtos/OnixDmsBillingReportDtos.cs
export interface OnixDmsBillingReportZbirnoRowDto {
    accountingCompanyId?: number;
    accountingCompanyName: string;
    companyId?: number;
    companyName: string;
    database: string;
    onixPhoneDmsUsage: number;
    dmsPantheonUsage: number;
    pantheonDocumentCount: number;
    lastPantheonActivityUtc?: Date;
}

// ../../OnixWeb.Domain/Dtos/OnixDmsBillingReportDtos.cs
export interface OnixDmsBillingReportAccountingRowDto {
    accountingCompanyId?: number;
    accountingCompanyName: string;
    databaseCount: number;
    databases: string;
    onixPhoneDmsUsage: number;
    dmsPantheonUsage: number;
    pantheonDocumentCount: number;
    lastPantheonActivityUtc?: Date;
}

// ../../OnixWeb.Domain/Dtos/OnixDmsBillingReportDtos.cs
export interface OnixDmsBillingReportSourceIssueDto {
    source: string;
    message: string;
    companyId?: number;
    companyName: string;
    database: string;
}

// ../../OnixWeb.Domain/Dtos/MarservisWorkOrderItemReturnDtoUserDto.cs
export interface MarservisWorkOrderItemReturnDtoUserDto {
    fullName: string;
    id: string;
}

// ../../OnixWeb.Domain/Dtos/SupportTicketOfferNumberDto.cs
export interface SupportTicketOfferNumberDto {
    offerNumber?: string;
}

// ../../OnixWeb.Domain/Dtos/DatalabReleaseLockdownRunDto.cs
export interface DatalabReleaseLockdownRunDto {
    id: number;
    companyId: number;
    companyName?: string;
    jobId?: string;
    status: DatalabReleaseLockdownRunStatusEnum;
    triggeredById?: string;
    startedOn?: Date;
    completedOn?: Date;
    processedPopupCount: number;
    deletedEntryCount: number;
    saveTriggered: boolean;
    summaryLog?: string;
    errorText?: string;
    createdOn?: Date;
    modifiedOn?: Date;
}

// ../../OnixWeb.Domain/Dtos/WebDocumentTHeOrderModel.cs
export interface WebDocumentTHeOrderModel {
    order: THeOrder;
    param: TPaSysParam;
    docType: TPaSetDocType;
    withoutHeader?: boolean;
    padding?: number;
    hidePrices?: boolean;
    opDocType: DocumentType;
    extendedLayout?: boolean;
    contactEmail?: string;
}

// ../../OnixWeb.Domain/Dtos/MainServerCompanyState.cs
export interface MainServerCompanyState {
    userCount: number;
    companySettingsName: string;
    companySettingsId: number;
    companyPantheonName: string;
    externalId: string;
    mainServerUrl: string;
    userNames: string[];
}

// ../../OnixWeb.Domain/Dtos/UserInfoV3UserInfoDto.cs
export interface UserInfoViewModelV3UserInfoDto {
    database: string;
    companyName: string;
    anDocKeyLenNumber: number;
    documentTypes: TPaSetDocType[];
    userWarehouse: string;
    pantheonUserWarehouse: TPaSetDocType;
    pantheonUser: THrPrsn;
    pantheonDepartment: string;
    warehouses: Record<string, TPaSetDocType[]>;
}

// ../../OnixWeb.Domain/Dtos/CompanyNameDto.cs
export interface CompanyName {
    name: string;
}

// ../../OnixWeb.Domain/Dtos/SupportAbsenceCalendarDto.cs
export interface SupportAbsenceCalendarDto {
    id: number;
    userId: string;
    userDisplayName: string;
    dateFrom: Date;
    dateTo: Date;
    type: SupportAbsenceTypeEnum;
    title: string;
    note: string;
    isHalfDay: boolean;
    halfDayPeriod: SupportAbsenceHalfDayPeriodEnum;
    timeFrom?: number;
    timeTo?: number;
    colorKey: string;
}

// ../../OnixWeb.Domain/Dtos/MeshCentralDeviceDto.cs
export interface MeshCentralDeviceDto {
    id: string;
    name: string;
    meshCentralGroupId?: string;
    meshCentralGroupName?: string;
    host?: string;
    ipAddress?: string;
    osDescription?: string;
    isConnected: boolean;
    isAgentConnected?: boolean;
    isPowered: boolean;
}

// ../../OnixWeb.Domain/Dtos/DatalabReferenceCompanySyncResultDto.cs
export interface DatalabReferenceCompanySyncResultDto {
    companySettingsId: number;
    fetchedCount: number;
    createdCount: number;
    updatedCount: number;
    totalCachedCount: number;
    pendingSuggestionsRefreshed: number;
    syncedAt: Date;
}

// ../../OnixWeb.Domain/Dtos/MobileSupportTicketWithMessagesDto.cs
export interface MobileSupportTicketWithMessagesDto extends MobileSupportTicketDto {
    messages: MobileSupportMessageDto[];
}

// ../../OnixWeb.Domain/Dtos/KeyValueStorageChangeLog.cs
export interface KeyValueStorageChangeLog {
    added: OnixPhoneKeyValueStorage[];
    updated: OnixPhoneKeyValueStorage[];
    deleted: string[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupPairingCodeDto {
    code: string;
    expiresAtUtc: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupInstallerInfoDto {
    available: boolean;
    version?: string;
    message?: string;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupCompanyDto {
    enabled: boolean;
    configurationProblem?: string;
    installer: SqlBackupInstallerInfoDto;
    agents: SqlBackupAgentDto[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupAgentDto {
    id: string;
    companyId: number;
    companyName: string;
    machineName: string;
    sqlInstance: string;
    sqlVersion: string;
    sqlError?: string;
    version: string;
    updateAvailable: boolean;
    backupFolder: string;
    backupFolderFreeMb?: number;
    createdAtUtc: Date;
    lastSeenUtc?: Date;
    online: boolean;
    backupsEnabled: boolean;
    dailyTime: string;
    keepLocalCopies: number;
    autoSelectNewDatabases: boolean;
    health: SqlBackupHealthEnum;
    healthMessage?: string;
    databases: SqlBackupDatabaseDto[];
    pendingCommands: SqlBackupPendingCommandDto[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupDatabaseDto {
    name: string;
    sizeMb: number;
    recoveryModel: string;
    state: string;
    present: boolean;
    selected: boolean;
    isPantheon?: boolean;
    lastSuccessUtc?: Date;
    lastSuccessSizeBytes?: number;
    lastFailureUtc?: Date;
    lastFailureError?: string;
    running: boolean;
    health: SqlBackupHealthEnum;
    healthMessage?: string;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupAgentUpdatesDto {
    latestVersion?: string;
    outdated: number;
    ready: number;
    offline: number;
    alreadyPending: number;
    queued: number;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupPendingCommandDto {
    id: string;
    type: string;
    database?: string;
    createdAtUtc: Date;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupRunDto {
    id: string;
    agentId: string;
    machineName: string;
    database: string;
    kind: string;
    trigger: string;
    status: string;
    startedAtUtc: Date;
    finishedAtUtc?: Date;
    error?: string;
    databaseBackupSizeBytes?: number;
    encryptedSizeBytes?: number;
    downloadable: boolean;
    localCopyPresent: boolean;
    targetDatabase?: string;
    backupSeconds?: number;
    encryptSeconds?: number;
    uploadSeconds?: number;
    uploadedBytes?: number;
    uploadRetries?: number;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupSettingsUpdateDto {
    backupsEnabled: boolean;
    dailyTime: string;
    keepLocalCopies: number;
    autoSelectNewDatabases?: boolean;
    selectedDatabases: string[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupRestoreRequestDto {
    runId: string;
    targetDatabase: string;
    replaceExisting: boolean;
    agentId?: string;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupReportDto {
    reportDate: string;
    windowStartUtc: Date;
    windowEndUtc: Date;
    companies: number;
    companiesWithProblems: number;
    servers: number;
    databasesSelected: number;
    databasesBackedUp: number;
    databasesNotBackedUp: number;
    failedRuns: number;
    totalDatabaseSizeMb: number;
    totalBackupSizeBytes: number;
    storedSizeBytes: number;
    bracketChanges: number;
    newDatabases: number;
    companyReports: SqlBackupCompanyReportDto[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupCompanyReportDto {
    companyId: number;
    companyName: string;
    health: SqlBackupHealthEnum;
    problems: string[];
    databasesSelected: number;
    databasesBackedUp: number;
    databasesNotBackedUp: number;
    failedRuns: number;
    totalDatabaseSizeMb: number;
    totalBackupSizeBytes: number;
    storedSizeBytes: number;
    sizeBracket?: string;
    previousSizeBracket?: string;
    bracketChanged: boolean;
    newDatabases: SqlBackupNewDatabaseReportDto[];
    servers: SqlBackupServerReportDto[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupNewDatabaseReportDto {
    machineName: string;
    name: string;
    discoveredAtUtc: Date;
    selected: boolean;
    isPantheon?: boolean;
    outcome: string;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupServerReportDto {
    agentId: string;
    machineName: string;
    sqlInstance: string;
    version: string;
    online: boolean;
    lastSeenUtc?: Date;
    backupsEnabled: boolean;
    dailyTime: string;
    health: SqlBackupHealthEnum;
    problem?: string;
    databases: SqlBackupDatabaseReportDto[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupDatabaseReportDto {
    name: string;
    sizeMb: number;
    selected: boolean;
    present: boolean;
    backedUp: boolean;
    health: SqlBackupHealthEnum;
    problem?: string;
    lastSuccessUtc?: Date;
    lastSuccessSizeBytes?: number;
    runs: SqlBackupReportRunDto[];
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export interface SqlBackupReportRunDto {
    id: string;
    startedAtUtc: Date;
    finishedAtUtc?: Date;
    status: string;
    trigger: string;
    sizeBytes?: number;
    error?: string;
}

// ../../OnixWeb.Domain/Dtos/SqlBackup/SqlBackupDtos.cs
export enum SqlBackupHealthEnum {
    Ok = 0,
    Warning = 1,
    Problem = 2,
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalServiceKeyDtos.cs
export interface PortalServiceKeyDto {
    id: number;
    kind: PortalServiceKeyKind;
    name: string;
    keyPrefix: string;
    companySettingsId?: number;
    createdAt: Date;
    expiresAt?: Date;
    lastUsedAt?: Date;
    revokedAt?: Date;
    isActive: boolean;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalServiceKeyDtos.cs
export interface CreatePortalServiceKeyDto {
    kind: PortalServiceKeyKind;
    name: string;
    companySettingsId?: number;
    expiresInDays?: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalServiceKeyDtos.cs
export interface CreatedPortalServiceKeyDto {
    key: string;
    serviceKey: PortalServiceKeyDto;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalAccountDtos.cs
export interface PortalSignInStartDto {
    challengeId: string;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalAccountDtos.cs
export interface PortalSignInResultDto {
    token?: string;
    registrationTicket?: string;
    email?: string;
    displayName?: string;
    requiresRegistration: boolean;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalAccountDtos.cs
export interface PortalConfigDto {
    enabled: boolean;
    showEntryPoints: boolean;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalAccountDtos.cs
export interface PortalMeDto {
    email: string;
    displayName?: string;
    portalOnly: boolean;
    companyScope: boolean;
    linkedContacts: PortalLinkedContactDto[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalAccountDtos.cs
export interface PortalLinkedContactDto {
    contactId: number;
    displayName: string;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalScopeDto {
    contactIds: number[];
    grunfCompanyIds: number[];
    tenantAdmin: boolean;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalResolveEmailRequest {
    email: string;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalResolveEmailResponse {
    contacts: PortalResolvedContactDto[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalResolvedContactDto {
    contactId: number;
    contactEmailId: number;
    displayName: string;
    companies: PortalResolvedCompanyDto[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalResolvedCompanyDto {
    grunfCompanyId: number;
    name: string;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalTicketsRequest {
    scope: PortalScopeDto;
    status: PortalTicketStatusFilter;
    skip: number;
    take: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalTicketsResponse {
    items: PortalTicketSummaryDto[];
    total: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalTicketSummaryDto {
    id: number;
    title: string;
    status: PortalTicketStatus;
    createdOn?: Date;
    lastActivityOn?: Date;
    lastPublicMessageId?: number;
    preview?: string;
    companyName?: string;
    contactName?: string;
    unread: boolean;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalTicketRequest {
    scope: PortalScopeDto;
    ticketId: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalTicketThreadDto {
    ticket: PortalTicketSummaryDto;
    messages: PortalMessageDto[];
    inlineSavedFileIds: number[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalMessageDto {
    id: number;
    direction: PortalMessageDirection;
    authorDisplayName: string;
    sentOn?: Date;
    safeHtml: string;
    plainText: string;
    attachments: PortalAttachmentDto[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalAttachmentDto {
    id: number;
    name: string;
    contentType?: string;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalMessageOriginalRequest {
    scope: PortalScopeDto;
    ticketId: number;
    messageId: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalMessageOriginalDto {
    id: number;
    safeHtml: string;
    plainText: string;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalAttachmentRequest {
    scope: PortalScopeDto;
    ticketId: number;
    savedFileId: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalChainChangedRequest {
    emails: string[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalSeenRequest {
    scope: PortalScopeDto;
    ticketId: number;
    lastSeenMessageId: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalSeenResponse {
    lastSeenMessageId: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalReplyRequest {
    scope: PortalScopeDto;
    ticketId: number;
    text: string;
    attachmentIds: number[];
    senderContactEmailIds: number[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalCreateTicketRequest {
    scope: PortalScopeDto;
    contactId: number;
    subject: string;
    text: string;
    attachmentIds: number[];
    senderContactEmailIds: number[];
    sourceKey?: string;
    problemSubmission?: ProblemSubmissionTicketIntakeDto;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalWriteResultDto {
    ticketId: number;
    messageId: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalUploadResponse {
    savedFileIds: number[];
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalUploadDto {
    id: string;
    name: string;
    contentType: string;
    size: number;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalEmailPreferencesRequest {
    email: string;
    emailCopiesEnabled?: boolean;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalEmailPreferencesDto {
    available: boolean;
    emailCopiesEnabled: boolean;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export interface PortalMessageCallbackRequest {
    grunfContactIds: number[];
    grunfCompanyId?: number;
    ticketId: number;
    messageId: number;
    title?: string;
    preview?: string;
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export enum PortalTicketStatus {
    InProgress = 0,
    WaitingForCustomer = 1,
    Resolved = 2,
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export enum PortalTicketStatusFilter {
    Open = 0,
    Closed = 1,
    All = 2,
}

// ../../OnixWeb.Domain/Dtos/Portal/PortalDtos.cs
export enum PortalMessageDirection {
    Inbound = 0,
    Outbound = 1,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadItemDeltaKind.cs
export enum SupportAiThreadItemDeltaKind {
    BodyAppend = 1,
    SummaryAppend = 2,
    ToolArgumentsAppend = 3,
}

// ../../OnixWeb.Domain/Enums/OnixRoleEnum.cs
export enum OnixRoleEnum {
    Admin = 0,
    Tenant = 1,
    User = 2,
    Tester = 3,
    EnvironmentTester = 4,
    Developer = 5,
    GrunfSupport = 6,
    Portal = 7,
}

// ../../OnixWeb.Domain/Enums/SupportTicketFilterTypeEnum.cs
export enum SupportTicketFilterTypeEnum {
    OLDER_THAN_2_MONTHS = 0,
    CUSTOMER_RESPONDED_AND_WAITING = 1,
    UNFINISHED_TASKS = 2,
    DELEGATED_TO_ME = 3,
    WAITING_FOR = 4,
    UNREAD_MESSAGES = 5,
    UNFINISHED_TICKETS = 6,
    UNASSIGNED_TICKETS = 7,
}

// ../../OnixWeb.Domain/Enums/DocumentTypeEnum.cs
export enum DocumentTypeEnum {
    Order = 0,
    WorkOrder = 1,
    Move = 2,
}

// ../../OnixWeb.Domain/Enums/CRUDEndpoint.cs
export enum CrudEndpoint {
    Get = 0,
    Post = 1,
    Put = 2,
    Delete = 3,
    Duplicate = 4,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadScopeType.cs
export enum SupportAiThreadScopeType {
    Ticket = 1,
    Company = 2,
    General = 3,
}

// ../../OnixWeb.Domain/Enums/Areas.cs
export interface Areas {
}

// ../../OnixWeb.Domain/Enums/MobilePlatformEnum.cs
export enum MobilePlatformEnum {
    Android = 1,
    Ios = 2,
    Windows = 3,
    Other = 4,
}

// ../../OnixWeb.Domain/Enums/ClientEnum.cs
export enum ClientEnum {
    Donar = 0,
    AdrianaNautica = 1,
    Onix = 2,
    Mushrooms = 3,
    Trim = 4,
    Dimeglio = 5,
    Protech = 6,
    Cortina = 7,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadItemKind.cs
export enum SupportAiThreadItemKind {
    UserMessage = 1,
    AssistantMessage = 2,
    ReasoningSummary = 3,
    ToolCall = 4,
    ApprovalRequest = 5,
    ApprovalDecision = 6,
    Question = 7,
    Artifact = 8,
    SystemNotice = 9,
}

// ../../OnixWeb.Domain/Enums/SupportAiToolAccessLevel.cs
export enum SupportAiToolAccessLevel {
    Open = 1,
    ThreadGrantRequired = 2,
}

// ../../OnixWeb.Domain/Enums/CompanyEmailForwardContext.cs
export enum CompanyEmailForwardContextEnum {
    AfterSavingSignedPDF = 0,
    AfterSavingDocument = 1,
}

// ../../OnixWeb.Domain/Enums/OnixTenant.cs
export enum OnixTenant {
    None = 0,
    Cortina = 1,
    Dimeglio = 2,
    Mushrooms = 3,
    Cak = 4,
    Danieli = 5,
    Tapess = 6,
    Eikonstudio = 7,
    Euronewpack = 8,
    KastavGrupa = 9,
    Kompakt = 10,
    Linea = 11,
    LuckaUpravaRovinj = 12,
    Marservis = 13,
    Montraker = 14,
    Onix = 15,
    Orcus = 16,
    Oso = 17,
    Protech = 18,
    RitosaTrgovine = 19,
    Sistema = 20,
    SkladProfili = 21,
    Sklad = 22,
    TehnolineObrt = 23,
    TehnolineTelekom = 24,
    Trim = 25,
}

// ../../OnixWeb.Domain/Enums/TasksSearchDtoOrderByEnum.cs
export enum TasksSearchDtoOrderByEnum {
    Ticket = 0,
    Company = 1,
    Project = 2,
    CreatedOn = 3,
    ModifiedOn = 4,
    DueDate = 5,
}

// ../../OnixWeb.Domain/Enums/DocumentFunctionalityEnum.cs
export enum DocumentFunctionalityEnum {
    WorkOrdersReception = 0,
    WorkOrdersOperative = 1,
    Orders = 2,
    DeliveryNotes = 3,
    Approvals = 4,
    DeliveryNotesControl = 5,
    DeliveryNotesFromOrder = 6,
    InvoiceDeliveryNotes = 7,
    LURInvoice = 8,
    MarservisUserWorkOrders = 9,
    FixedAssets = 10,
    Inventory = 11,
    WarehouseReceipt = 12,
    WorkFlowTasks = 13,
    BaseWorkOrders = 14,
    Invoices = 15,
    DetachedOfflineDocuments = 16,
    PriceChangeRecords = 17,
    FISBarcodeScanning = 18,
    TMNDocumentsDirect = 19,
    Transfer = 20,
    Woex = 21,
    TMNDocumentsWeb = 22,
    TMNDocumentsClassificationQueue = 23,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadPresentationFilter.cs
export enum SupportAiThreadPresentationFilter {
    Open = 1,
    NeedsAttention = 2,
    Archived = 3,
}

// ../../OnixWeb.Domain/Enums/WorkOrderStatusEnum.cs
export enum MarservisWorkOrderStatusEnum {
    NotDone = 0,
    Done = 1,
    Invoiced = 2,
    InProgress = 3,
}

// ../../OnixWeb.Domain/Enums/SubjectSellTypeEnum.cs
export enum SubjectSellTypeEnum {
    R1 = 0,
    EndCustomer = 1,
    EU = 2,
    OutsideTheEU = 3,
}

// ../../OnixWeb.Domain/Enums/SupportAiToolCallStatusEnum.cs
export enum SupportAiToolCallStatusEnum {
    Running = 0,
    Completed = 1,
    Failed = 2,
    Blocked = 3,
}

// ../../OnixWeb.Domain/Enums/CachingKeysEnum.cs
export enum CachingKeysEnum {
    WORK_ORDER_MOVE = 0,
    WORK_ORDER_MATERIALS = 1,
    WORK_ORDER_SERVICES = 2,
    WORK_ORDER_WORKSPECS = 3,
    WORK_ORDER_IMAGES = 4,
    WORK_ORDER_RECEPTIONS = 5,
    WORK_ORDER_RECLAMATIONS = 6,
}

// ../../OnixWeb.Domain/Enums/ExternalAuthFlowKind.cs
export enum ExternalAuthFlowKind {
    Login = 1,
    Link = 2,
}

// ../../OnixWeb.Domain/Enums/THfWoexPagedSortField.cs
export enum THfWoexPagedSortField {
    AcKey = 0,
    AcDocType = 1,
    AcDept = 2,
    AcReceiver = 3,
    AcStatus = 4,
    AdDate = 5,
    AdSchedStartTime = 6,
    AdSchedEndTime = 7,
    AcIdent = 8,
    AcConsignee = 9,
    AcNote = 10,
    AcScrapIdent = 11,
    AdWofinishDate = 12,
    AnPriority = 13,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadItemStatus.cs
export enum SupportAiThreadItemStatus {
    Pending = 1,
    InProgress = 2,
    Completed = 3,
    Failed = 4,
    Blocked = 5,
    Declined = 6,
    Cancelled = 7,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadItemRole.cs
export enum SupportAiThreadItemRole {
    User = 1,
    Assistant = 2,
    System = 3,
}

// ../../OnixWeb.Domain/Enums/LabelDefinitionLocationEnum.cs
export enum LabelDefinitionLocationEnum {
    WarehouseOverview = 0,
}

// ../../OnixWeb.Domain/Enums/OpenAISystemEnum.cs
export enum OpenAISystemEnum {
    OnixSupport = 0,
    Default = 1,
}

// ../../OnixWeb.Domain/Enums/PortalVerificationMethod.cs
export enum PortalVerificationMethod {
    EmailCode = 0,
    Microsoft = 1,
    Google = 2,
    Apple = 3,
}

// ../../OnixWeb.Domain/Enums/WakaTimeAuthorKind.cs
export enum WakaTimeAuthorKind {
    Username = 0,
    Email = 1,
    Name = 2,
}

// ../../OnixWeb.Domain/Enums/AiSupportRunBudgetMode.cs
export enum AiSupportRunBudgetMode {
    Bounded = 0,
    RunUntilTerminal = 1,
}

// ../../OnixWeb.Domain/Enums/SupportAiVisibleMessageAuthorKind.cs
export enum SupportAiVisibleMessageAuthorKind {
    Ai = 1,
    User = 2,
    System = 3,
}

// ../../OnixWeb.Domain/Enums/ApplicationPacketEnum.cs
export enum ApplicationPacketEnum {
    WorkRecords = 0,
    TravelWarrants = 1,
    UserSynchronization = 2,
    BusinessAnalytics = 3,
    Support = 5,
    Documents = 7,
    Declarations = 8,
    WooCommerce = 9,
    MarservisWorkOrders = 10,
    SettingsSynchronization = 11,
    WebDocuments = 12,
    ActivityReports = 13,
    OnixPhoneDocumentsOverview = 14,
    DynDnsHealthcheck = 15,
    TravelWarrants2 = 16,
    PantheonSubjectsSync = 17,
    WorkRecords2 = 18,
    DMSNotifications = 19,
}

// ../../OnixWeb.Domain/Enums/SupportAiKnowledgeScopeType.cs
export enum SupportAiKnowledgeScopeType {
    Global = 1,
    Company = 2,
}

// ../../OnixWeb.Domain/Enums/SupportAiVisibleMessageKind.cs
export enum SupportAiVisibleMessageKind {
    Status = 1,
    Question = 2,
    Conclusion = 3,
    UserComment = 4,
    Resume = 5,
    Error = 6,
    Reply = 7,
    DatabaseGrantRequest = 8,
}

// ../../OnixWeb.Domain/Enums/PantheonLicense.cs
export enum PantheonLicense {
    RT = 0,
    LX = 1,
    LT = 2,
    LT3 = 3,
    RE = 4,
    SE = 5,
    ME = 6,
    MF = 7,
}

// ../../OnixWeb.Domain/Enums/SupportAiKnowledgeReviewStatus.cs
export enum SupportAiKnowledgeReviewStatus {
    Approved = 1,
    Draft = 2,
    Rejected = 3,
}

// ../../OnixWeb.Domain/Enums/PantheonDocType.cs
export enum PantheonDocType {
    the_order = 0,
    the_move = 1,
}

// ../../OnixWeb.Domain/Enums/NewLineEnum.cs
export enum NewLineEnum {
    Crlf = 0,
    Lf = 1,
    Cr = 2,
}

// ../../OnixWeb.Domain/Enums/DeploymentGroupStepTriggerType.cs
export enum DeploymentGroupStepTriggerType {
    OnInstall = 0,
}

// ../../OnixWeb.Domain/Enums/OpenAIMessageType.cs
export enum OpenAIMessageType {
    User = 0,
    ChatBot = 1,
}

// ../../OnixWeb.Domain/Enums/PantheonDocumentDirectionEnum.cs
export enum PantheonDocumentDirectionEnum {
    In = 0,
    Out = 1,
}

// ../../OnixWeb.Domain/Enums/AresDeploymentEnvironment.cs
export enum AresDeploymentEnvironment {
    Production = 0,
    Staging = 1,
    Testing = 2,
}

// ../../OnixWeb.Domain/Enums/MeshCentralDeviceRouteTypeEnum.cs
export enum MeshCentralDeviceRouteTypeEnum {
    Http = 0,
    Https = 1,
    Rdp = 2,
    Mssql = 3,
}

// ../../OnixWeb.Domain/Enums/SupportAbsenceTypeEnum.cs
export enum SupportAbsenceTypeEnum {
    Vacation = 0,
    DayOff = 1,
    SickLeave = 2,
    Trip = 3,
    Planned = 3,
    Other = 4,
}

// ../../OnixWeb.Domain/Enums/CardPaymentProvider.cs
export enum CardPaymentProvider {
    None = 0,
    SoftPOS7PayErste = 1,
}

// ../../OnixWeb.Domain/Enums/PortalServiceKeyKind.cs
export enum PortalServiceKeyKind {
    Service = 0,
    Callback = 1,
}

// ../../OnixWeb.Domain/Enums/ArbitraryFieldLocationEnum.cs
export enum ArbitraryFieldLocationEnum {
    NewDocumentItemPackageQuantity = 0,
    NewDocumentItemListAfterPrice = 1,
    NewDocumentItemListAfterQuantity = 2,
    NewDocumentItemItemListAfterPrice = 3,
    NewDocumentItemReplacement = 4,
    THeMoveListItemReplacement = 5,
    THeOrderListItemReplacement = 6,
    THeMoveListItemAfterPrice = 7,
    THeOrderListItemAfterPrice = 8,
    ArticlePickerItemListItemAfterPrice = 9,
    PDFAnClerk = 10,
    FilterExistingOrderDocumentsBasedOnScannedModifierCharacter = 11,
    FilterExistingMoveDocumentsBasedOnScannedModifierCharacter = 12,
    NewDocumentCustomerError = 13,
    OnAddNewDocumentItemShowError = 14,
    OnAddNewDocumentItemShowWarning = 15,
    OnSubmitDocumentShowError = 16,
    OnSubmitDocumentShowWarning = 17,
    AfterHeaderCustomerAnalysis = 18,
    AdditionalDocumentEntryField = 19,
    AdditionalPDFHeaderField = 20,
    AfterHeaderDocumentAnalysis = 21,
}

// ../../OnixWeb.Domain/Enums/TMnImageSize.cs
export enum TMnImageSize {
    Full = 0,
    Small = 1,
    Thumbnail = 2,
}

// ../../OnixWeb.Domain/Enums/OnixPhoneFunctionalityActivityActionEnum.cs
export enum OnixPhoneFunctionalityActivityActionEnum {
    HeadCreated = 0,
    HeadUpdated = 1,
    ItemAdded = 2,
    ItemUpdated = 3,
    ItemDeleted = 4,
    Signed = 5,
    Verified = 6,
    DmsDocumentCreated = 7,
    DmsDocumentUpdated = 8,
    DmsDocumentDeleted = 9,
    DmsDocumentReclassified = 10,
    DmsDocumentConfirmed = 11,
    DmsDocumentRejected = 12,
    DmsFileAdded = 13,
    DmsFileUpdated = 14,
    DmsFileDeleted = 15,
    DmsXmlItemUpdated = 16,
    WorkOrderStarted = 17,
    WorkOrderUpdated = 18,
    WorkOrderEnded = 19,
    WorkOrderUnlocked = 20,
    WorkOrderDuplicated = 21,
    WorkOrderImageAdded = 22,
    WorkOrderImageUpdated = 23,
    WorkOrderImageDeleted = 24,
    WorkOrderMaterialAdded = 25,
    WorkOrderMaterialUpdated = 26,
    WorkOrderMaterialDeleted = 27,
    WorkOrderReceptionAdded = 28,
    WorkOrderReceptionUpdated = 29,
    WorkOrderReceptionDeleted = 30,
    WorkOrderReclamationAdded = 31,
    WorkOrderReclamationUpdated = 32,
    WorkOrderReclamationDeleted = 33,
    WorkOrderServiceAdded = 34,
    WorkOrderServiceUpdated = 35,
    WorkOrderServiceDeleted = 36,
    WorkOrderSpecAdded = 37,
    WorkOrderSpecUpdated = 38,
    WorkOrderSpecDeleted = 39,
    FieldUpdated = 40,
    MarservisWorkCreated = 41,
    MarservisWorkUpdated = 42,
    MarservisWorkDeleted = 43,
    MarservisItemStatusToggled = 44,
    MarservisItemItemFinishedToggled = 45,
}

// ../../OnixWeb.Domain/Enums/SupportAiTurnStatus.cs
export enum SupportAiTurnStatus {
    Queued = 1,
    InProgress = 2,
    WaitingForApproval = 3,
    WaitingForUser = 4,
    Completed = 5,
    Failed = 6,
    Cancelled = 7,
}

// ../../OnixWeb.Domain/Enums/DocumentPairFunctionalityEnum.cs
export enum DocumentPairFunctionalityEnum {
    Picking = 0,
    Copy = 1,
}

// ../../OnixWeb.Domain/Enums/SupportStatusEnum.cs
export enum SupportStatusEnum {
    Open = 0,
    Closed = 1,
    Pending = 2,
    Resolved = 3,
    ForReview = 4,
    InProgress = 5,
    Maintenance = 6,
    Spam = 7,
    IBackup = 8,
    WaitingForOffer = 9,
    PantheonUpgrade = 10,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadQuestionStatus.cs
export enum SupportAiThreadQuestionStatus {
    Open = 1,
    Answered = 2,
    Dismissed = 3,
}

// ../../OnixWeb.Domain/Enums/McpApiKeyKind.cs
export enum McpApiKeyKind {
    Support = 0,
    OnixServer = 1,
}

// ../../OnixWeb.Domain/Enums/WorkOrderItemStatusEnum.cs
export enum MarservisWorkOrderItemStatusEnum {
    NotDone = 0,
    Done = 1,
    InProgress = 2,
}

// ../../OnixWeb.Domain/Enums/SupportOpenAIExecutionContextEnum.cs
export enum SupportOpenAIExecutionContextEnum {
    DetermineRecommendedUserForTicket = 0,
}

// ../../OnixWeb.Domain/Enums/SupportAiRunPhaseEnum.cs
export enum SupportAiRunPhaseEnum {
    Queue = 0,
    PrepareCase = 1,
    ReadTicket = 2,
    SimulateSafeToolCalls = 3,
    AssembleEvidence = 4,
    Conclude = 5,
    Complete = 6,
    Triage = 7,
    Investigate = 8,
}

// ../../OnixWeb.Domain/Enums/SupportAiKnowledgeSourceType.cs
export enum SupportAiKnowledgeSourceType {
    ManualFact = 1,
    MemoryDraft = 2,
}

// ../../OnixWeb.Domain/Enums/SupportTicketActionKind.cs
export enum SupportTicketActionKind {
    Continue = 0,
    Wait = 1,
    RequestReview = 2,
    Finish = 3,
    ReviewAccepted = 4,
    ReviewChangesRequested = 5,
}

// ../../OnixWeb.Domain/Enums/SupportTicketActionKind.cs
export enum SupportWorkOutcome {
    Continuing = 0,
    Prepared = 1,
    Implemented = 2,
    Delivered = 3,
    Verified = 4,
    CustomerCommunicated = 5,
    Accepted = 6,
    Finished = 7,
}

// ../../OnixWeb.Domain/Enums/SupportPriorityEnum.cs
export enum SupportPriorityEnum {
    Low = 0,
    Medium = 1,
    High = 2,
    Urgent = 3,
}

// ../../OnixWeb.Domain/Enums/SupportAiRunStatusEnum.cs
export enum SupportAiRunStatusEnum {
    Queued = 0,
    Running = 1,
    Completed = 2,
    Failed = 3,
    Cancelled = 4,
    AwaitingContinuation = 5,
    WaitingForUser = 6,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadStatus.cs
export enum SupportAiThreadStatus {
    Active = 1,
    WaitingForUser = 2,
    AwaitingContinuation = 3,
    Completed = 4,
    Archived = 5,
}

// ../../OnixWeb.Domain/Enums/OnixPhoneUserTaskEnum.cs
export enum OnixPhoneUserTaskEnum {
    UploadSQLiteDatabase = 0,
    ShowMessageToUser = 1,
    ExecuteSQLiteSQL = 2,
    UpdateUserSettings = 3,
}

// ../../OnixWeb.Domain/Enums/WakaTimeWorklogSourceType.cs
export enum WakaTimeWorklogSourceType {
    Commit = 0,
    Remainder = 1,
    Activity = 2,
    CodexTask = 3,
}

// ../../OnixWeb.Domain/Enums/InstallationVariableType.cs
export enum InstallationVariableType {
    String = 0,
    Integer = 1,
    Boolean = 2,
    DateTime = 3,
    Float = 4,
}

// ../../OnixWeb.Domain/Enums/THeSetItemPagedSortField.cs
export enum THeSetItemPagedSortField {
    AcIdent = 0,
    AcName = 1,
    AcNote = 2,
    AcSetOfItem = 3,
    AcClassif = 4,
    AcClassif2 = 5,
    AcSupplier = 6,
    AcDept = 7,
}

// ../../OnixWeb.Domain/Enums/DocumentTypeSyncUsersScopeEnum.cs
export enum DocumentTypeSyncUsersScopeEnum {
    ThisUser = 0,
    AllUsers = 1,
    SelectedUsers = 2,
    AllUsersExceptSelected = 3,
}

// ../../OnixWeb.Domain/Enums/THeOrderPagedSortField.cs
export enum THeOrderPagedSortField {
    AcKey = 0,
    AcNote = 1,
    AdDate = 2,
    AcDocType = 3,
    AcDoc1 = 4,
    AcDoc2 = 5,
    AcConsignee = 6,
    AcStatus = 7,
    AcDelivery = 8,
    AdDateValid = 9,
    AdDeliveryDeadline = 10,
    AnClerk = 11,
    AcDept = 12,
    AdDateDoc1 = 13,
    AdDateDoc2 = 14,
    AcContactPrsn = 15,
    AcContactPrsn3 = 16,
    AnDeliveryDays = 17,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadResponseMode.cs
export enum SupportAiThreadResponseMode {
    Auto = 0,
    Plain = 1,
    Technical = 2,
}

// ../../OnixWeb.Domain/Enums/CompanyDatalabReferenceLinkStatusEnum.cs
export enum CompanyDatalabReferenceLinkStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

// ../../OnixWeb.Domain/Enums/SqlTaskScheduleMode.cs
export enum SqlTaskScheduleMode {
    Once = 0,
    Minutes = 1,
    Hourly = 2,
    Daily = 3,
    Weekly = 4,
    Monthly = 5,
    Custom = 6,
}

// ../../OnixWeb.Domain/Enums/SupportAbsenceHalfDayPeriodEnum.cs
export enum SupportAbsenceHalfDayPeriodEnum {
    Unspecified = 0,
    Morning = 1,
    Afternoon = 2,
}

// ../../OnixWeb.Domain/Enums/AresDeploymentExecutionPhase.cs
export enum AresDeploymentExecutionPhase {
    Standard = 0,
    Bootstrap = 1,
    SqlExecution = 2,
    TestRefreshSetup = 3,
    TestSuite = 4,
    TestTeardown = 5,
}

// ../../OnixWeb.Domain/Enums/DocumentTypeSyncOptionsScopeEnum.cs
export enum DocumentTypeSyncOptionsScopeEnum {
    AllOptions = 0,
    SelectedOptions = 1,
}

// ../../OnixWeb.Domain/Enums/SupportAiInvestigationTransportTypeEnum.cs
export enum SupportAiInvestigationTransportTypeEnum {
    Direct = 1,
    MeshCentralSqlRelay = 2,
}

// ../../OnixWeb.Domain/Enums/PantheonDocumentTable.cs
export enum PantheonDocumentTable {
    THeMove = 0,
    THeOrder = 1,
}

// ../../OnixWeb.Domain/Enums/DocumentTypeSyncDocumentTypesScopeEnum.cs
export enum DocumentTypeSyncDocumentTypesScopeEnum {
    SameType = 0,
    AllTypes = 1,
    SelectedTypes = 2,
}

// ../../OnixWeb.Domain/Enums/SupportAiRunPauseReason.cs
export enum SupportAiRunPauseReason {
    BudgetExhausted = 1,
    ContinuationLimitReached = 2,
    FollowUpRequired = 3,
    ApprovalRequired = 4,
    TransientFailure = 5,
    OperatorPaused = 6,
}

// ../../OnixWeb.Domain/Enums/THeMovePagedSortField.cs
export enum THeMovePagedSortField {
    AcKey = 0,
    AcReceiver = 1,
    AcPrsn3 = 2,
    AcIssuer = 3,
    AcDept = 4,
    AcDeptOut = 5,
    AdDate = 6,
    AcDelivery = 7,
    AcVerifyStatus = 8,
    AcContactPrsn = 9,
    AcContactPrsn3 = 10,
    AcDoc1 = 11,
    AdDateDoc1 = 12,
    AcDoc2 = 13,
    AdDateDoc2 = 14,
    AcDocType = 15,
    AcNote = 16,
    AnClerk = 17,
}

// ../../OnixWeb.Domain/Enums/WorkOrderFunctionality.cs
export enum WorkOrderFunctionality {
    Head = 0,
    Reception = 1,
    Specifications = 2,
    Services = 3,
    Materials = 4,
    Reclamations = 5,
    Images = 6,
}

// ../../OnixWeb.Domain/Enums/InvoiceSumType.cs
export enum InvoiceSumType {
    Count = 0,
    DurationSum = 1,
}

// ../../OnixWeb.Domain/Enums/DelimiterEnum.cs
export enum DelimiterEnum {
    Comma = 0,
    Semicolon = 1,
    Tab = 2,
    Space = 3,
}

// ../../OnixWeb.Domain/Enums/SupportAiCheckpointReason.cs
export enum SupportAiCheckpointReason {
    PeriodicCompaction = 1,
    BudgetPause = 2,
    FollowUpPause = 3,
    ExplicitResume = 4,
    TransientFailure = 5,
}

// ../../OnixWeb.Domain/Enums/ArbitraryFieldEntryType.cs
export enum ArbitraryFieldEntryType {
    ftString = 0,
    ftInteger = 1,
    ftDate = 2,
    ftCurrency = 3,
    ftBoolean = 4,
}

// ../../OnixWeb.Domain/Enums/TravelWarrantStatus.cs
export enum TravelWarrantStatus {
    OPEN = 0,
    SENT_TO_PANTHEON = 1,
    CLOSED = 2,
    SENT_TO_FINALIZE = 3,
}

// ../../OnixWeb.Domain/Enums/SupportAiRunEventTypeEnum.cs
export enum SupportAiRunEventTypeEnum {
    Created = 0,
    StatusChanged = 1,
    PhaseChanged = 2,
    Note = 3,
    ToolCallStarted = 4,
    ToolCallCompleted = 5,
    ConclusionReady = 6,
    CancelRequested = 7,
    Cancelled = 8,
    Completed = 9,
    Failed = 10,
    TriageCompleted = 11,
    ToolCallBlocked = 12,
    ToolCallFailed = 13,
    PausedForBudget = 14,
    Continued = 15,
    QuestionAsked = 16,
    QuestionAnswered = 17,
    ResumedFromQuestion = 18,
    ReplyReady = 19,
    DatabaseGrantRequested = 20,
}

// ../../OnixWeb.Domain/Enums/BluetoothDeviceTypeEnum.cs
export enum BluetoothDeviceTypeEnum {
    None = 0,
    BluetoothLowEnergy = 1,
    BluetoothRegular = 2,
}

// ../../OnixWeb.Domain/Enums/ExternalAuthProvider.cs
export enum ExternalAuthProvider {
    Microsoft = 1,
    Google = 2,
    Apple = 3,
}

// ../../OnixWeb.Domain/Enums/AccountType.cs
export enum AccountType {
    Money = 0,
    Customer = 1,
    Supplier = 2,
}

// ../../OnixWeb.Domain/Enums/SupportAiThreadItemPhase.cs
export enum SupportAiThreadItemPhase {
    Commentary = 1,
    FinalAnswer = 2,
}

// ../../OnixWeb.Domain/Enums/WebAppEnums.cs
export enum WebThemePreference {
    System = 0,
    Light = 1,
    Dark = 2,
}

// ../../OnixWeb.Domain/Enums/WebAppEnums.cs
export enum WebSidebarMode {
    Auto = 0,
    Manual = 1,
}

// ../../OnixWeb.Domain/Enums/DatalabReleaseLockdownRunStatusEnum.cs
export enum DatalabReleaseLockdownRunStatusEnum {
    Queued = 1,
    Running = 2,
    Succeeded = 3,
    Failed = 4,
}

// ../../OnixWeb.Domain/Enums/OmniSearchResourceEnum.cs
export enum OmniSearchResourceEnum {
    Users = 0,
    CompanySettings = 1,
    Projects = 2,
    TicketMessages = 3,
    Tickets = 4,
    Contacts = 5,
    Workers = 6,
    Companies = 7,
    OpenTasks = 8,
    MyOpenTasks = 9,
    GeneralOpenTickets = 10,
    MyOpenTickets = 11,
    OutsideCompanies = 12,
}

// ../../OnixWeb.Domain/Enums/SupportSourceEnum.cs
export enum SupportSourceEnum {
    Email = 0,
    Phone = 1,
    OnixPhone = 2,
    System = 3,
    Portal = 4,
}
